/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const tdx_request = $root.tdx_request = (() => {

    /**
     * Namespace tdx_request.
     * @exports tdx_request
     * @namespace
     */
    const tdx_request = {};

    tdx_request.ListLogsFromQuery = (function() {

        /**
         * Properties of a ListLogsFromQuery.
         * @memberof tdx_request
         * @interface IListLogsFromQuery
         * @property {string|null} [query] ListLogsFromQuery query
         * @property {string|null} [pin] ListLogsFromQuery pin
         * @property {Uint8Array|null} [data] ListLogsFromQuery data
         * @property {Uint8Array|null} [pageToken] ListLogsFromQuery pageToken
         * @property {number|null} [pageSize] ListLogsFromQuery pageSize
         */

        /**
         * Constructs a new ListLogsFromQuery.
         * @memberof tdx_request
         * @classdesc Represents a ListLogsFromQuery.
         * @implements IListLogsFromQuery
         * @constructor
         * @param {tdx_request.IListLogsFromQuery=} [properties] Properties to set
         */
        function ListLogsFromQuery(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListLogsFromQuery query.
         * @member {string} query
         * @memberof tdx_request.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.query = "";

        /**
         * ListLogsFromQuery pin.
         * @member {string} pin
         * @memberof tdx_request.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.pin = "";

        /**
         * ListLogsFromQuery data.
         * @member {Uint8Array} data
         * @memberof tdx_request.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.data = $util.newBuffer([]);

        /**
         * ListLogsFromQuery pageToken.
         * @member {Uint8Array} pageToken
         * @memberof tdx_request.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.pageToken = $util.newBuffer([]);

        /**
         * ListLogsFromQuery pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof tdx_request.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ListLogsFromQuery _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof tdx_request.ListLogsFromQuery
         * @instance
         */
        Object.defineProperty(ListLogsFromQuery.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListLogsFromQuery instance using the specified properties.
         * @function create
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {tdx_request.IListLogsFromQuery=} [properties] Properties to set
         * @returns {tdx_request.ListLogsFromQuery} ListLogsFromQuery instance
         */
        ListLogsFromQuery.create = function create(properties) {
            return new ListLogsFromQuery(properties);
        };

        /**
         * Encodes the specified ListLogsFromQuery message. Does not implicitly {@link tdx_request.ListLogsFromQuery.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {tdx_request.IListLogsFromQuery} message ListLogsFromQuery message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLogsFromQuery.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.query);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.pageToken);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.pageSize);
            return writer;
        };

        /**
         * Encodes the specified ListLogsFromQuery message, length delimited. Does not implicitly {@link tdx_request.ListLogsFromQuery.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {tdx_request.IListLogsFromQuery} message ListLogsFromQuery message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLogsFromQuery.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListLogsFromQuery message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.ListLogsFromQuery} ListLogsFromQuery
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLogsFromQuery.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.ListLogsFromQuery();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.query = reader.string();
                        break;
                    }
                case 2: {
                        message.pin = reader.string();
                        break;
                    }
                case 3: {
                        message.data = reader.bytes();
                        break;
                    }
                case 4: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 5: {
                        message.pageSize = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListLogsFromQuery message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.ListLogsFromQuery} ListLogsFromQuery
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLogsFromQuery.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListLogsFromQuery message.
         * @function verify
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListLogsFromQuery.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.query != null && message.hasOwnProperty("query"))
                if (!$util.isString(message.query))
                    return "query: string expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            }
            return null;
        };

        /**
         * Creates a ListLogsFromQuery message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.ListLogsFromQuery} ListLogsFromQuery
         */
        ListLogsFromQuery.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.ListLogsFromQuery)
                return object;
            let message = new $root.tdx_request.ListLogsFromQuery();
            if (object.query != null)
                message.query = String(object.query);
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.pageSize != null)
                message.pageSize = object.pageSize >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListLogsFromQuery message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {tdx_request.ListLogsFromQuery} message ListLogsFromQuery
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListLogsFromQuery.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.query = "";
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if (options.bytes === String)
                    object.pageToken = "";
                else {
                    object.pageToken = [];
                    if (options.bytes !== Array)
                        object.pageToken = $util.newBuffer(object.pageToken);
                }
            }
            if (message.query != null && message.hasOwnProperty("query"))
                object.query = message.query;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                object.pageSize = message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            return object;
        };

        /**
         * Converts this ListLogsFromQuery to JSON.
         * @function toJSON
         * @memberof tdx_request.ListLogsFromQuery
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListLogsFromQuery.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListLogsFromQuery
         * @function getTypeUrl
         * @memberof tdx_request.ListLogsFromQuery
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListLogsFromQuery.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.ListLogsFromQuery";
        };

        return ListLogsFromQuery;
    })();

    tdx_request.GetAuditLog = (function() {

        /**
         * Properties of a GetAuditLog.
         * @memberof tdx_request
         * @interface IGetAuditLog
         * @property {string|null} [name] GetAuditLog name
         * @property {string|null} [pin] GetAuditLog pin
         * @property {Uint8Array|null} [data] GetAuditLog data
         */

        /**
         * Constructs a new GetAuditLog.
         * @memberof tdx_request
         * @classdesc Represents a GetAuditLog.
         * @implements IGetAuditLog
         * @constructor
         * @param {tdx_request.IGetAuditLog=} [properties] Properties to set
         */
        function GetAuditLog(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetAuditLog name.
         * @member {string} name
         * @memberof tdx_request.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.name = "";

        /**
         * GetAuditLog pin.
         * @member {string} pin
         * @memberof tdx_request.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.pin = "";

        /**
         * GetAuditLog data.
         * @member {Uint8Array} data
         * @memberof tdx_request.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.data = $util.newBuffer([]);

        /**
         * Creates a new GetAuditLog instance using the specified properties.
         * @function create
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {tdx_request.IGetAuditLog=} [properties] Properties to set
         * @returns {tdx_request.GetAuditLog} GetAuditLog instance
         */
        GetAuditLog.create = function create(properties) {
            return new GetAuditLog(properties);
        };

        /**
         * Encodes the specified GetAuditLog message. Does not implicitly {@link tdx_request.GetAuditLog.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {tdx_request.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified GetAuditLog message, length delimited. Does not implicitly {@link tdx_request.GetAuditLog.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {tdx_request.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.GetAuditLog();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        message.pin = reader.string();
                        break;
                    }
                case 4: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAuditLog message.
         * @function verify
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAuditLog.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            return null;
        };

        /**
         * Creates a GetAuditLog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.GetAuditLog} GetAuditLog
         */
        GetAuditLog.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.GetAuditLog)
                return object;
            let message = new $root.tdx_request.GetAuditLog();
            if (object.name != null)
                message.name = String(object.name);
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a GetAuditLog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {tdx_request.GetAuditLog} message GetAuditLog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAuditLog.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this GetAuditLog to JSON.
         * @function toJSON
         * @memberof tdx_request.GetAuditLog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAuditLog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetAuditLog
         * @function getTypeUrl
         * @memberof tdx_request.GetAuditLog
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetAuditLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.GetAuditLog";
        };

        return GetAuditLog;
    })();

    tdx_request.PageTokenLogs = (function() {

        /**
         * Properties of a PageTokenLogs.
         * @memberof tdx_request
         * @interface IPageTokenLogs
         * @property {string|null} [lastLogFileName] PageTokenLogs lastLogFileName
         * @property {number|Long|null} [creationTime] PageTokenLogs creationTime
         * @property {number|null} [pageSize] PageTokenLogs pageSize
         */

        /**
         * Constructs a new PageTokenLogs.
         * @memberof tdx_request
         * @classdesc Represents a PageTokenLogs.
         * @implements IPageTokenLogs
         * @constructor
         * @param {tdx_request.IPageTokenLogs=} [properties] Properties to set
         */
        function PageTokenLogs(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PageTokenLogs lastLogFileName.
         * @member {string} lastLogFileName
         * @memberof tdx_request.PageTokenLogs
         * @instance
         */
        PageTokenLogs.prototype.lastLogFileName = "";

        /**
         * PageTokenLogs creationTime.
         * @member {number|Long} creationTime
         * @memberof tdx_request.PageTokenLogs
         * @instance
         */
        PageTokenLogs.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PageTokenLogs pageSize.
         * @member {number} pageSize
         * @memberof tdx_request.PageTokenLogs
         * @instance
         */
        PageTokenLogs.prototype.pageSize = 0;

        /**
         * Creates a new PageTokenLogs instance using the specified properties.
         * @function create
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {tdx_request.IPageTokenLogs=} [properties] Properties to set
         * @returns {tdx_request.PageTokenLogs} PageTokenLogs instance
         */
        PageTokenLogs.create = function create(properties) {
            return new PageTokenLogs(properties);
        };

        /**
         * Encodes the specified PageTokenLogs message. Does not implicitly {@link tdx_request.PageTokenLogs.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {tdx_request.IPageTokenLogs} message PageTokenLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageTokenLogs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lastLogFileName != null && Object.hasOwnProperty.call(message, "lastLogFileName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.lastLogFileName);
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.creationTime);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.pageSize);
            return writer;
        };

        /**
         * Encodes the specified PageTokenLogs message, length delimited. Does not implicitly {@link tdx_request.PageTokenLogs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {tdx_request.IPageTokenLogs} message PageTokenLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageTokenLogs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PageTokenLogs message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.PageTokenLogs} PageTokenLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageTokenLogs.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.PageTokenLogs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lastLogFileName = reader.string();
                        break;
                    }
                case 2: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                case 3: {
                        message.pageSize = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PageTokenLogs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.PageTokenLogs} PageTokenLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageTokenLogs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PageTokenLogs message.
         * @function verify
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PageTokenLogs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lastLogFileName != null && message.hasOwnProperty("lastLogFileName"))
                if (!$util.isString(message.lastLogFileName))
                    return "lastLogFileName: string expected";
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            return null;
        };

        /**
         * Creates a PageTokenLogs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.PageTokenLogs} PageTokenLogs
         */
        PageTokenLogs.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.PageTokenLogs)
                return object;
            let message = new $root.tdx_request.PageTokenLogs();
            if (object.lastLogFileName != null)
                message.lastLogFileName = String(object.lastLogFileName);
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            if (object.pageSize != null)
                message.pageSize = object.pageSize >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a PageTokenLogs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {tdx_request.PageTokenLogs} message PageTokenLogs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PageTokenLogs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.lastLogFileName = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                object.pageSize = 0;
            }
            if (message.lastLogFileName != null && message.hasOwnProperty("lastLogFileName"))
                object.lastLogFileName = message.lastLogFileName;
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                object.pageSize = message.pageSize;
            return object;
        };

        /**
         * Converts this PageTokenLogs to JSON.
         * @function toJSON
         * @memberof tdx_request.PageTokenLogs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PageTokenLogs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PageTokenLogs
         * @function getTypeUrl
         * @memberof tdx_request.PageTokenLogs
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PageTokenLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.PageTokenLogs";
        };

        return PageTokenLogs;
    })();

    tdx_request.GetLedgerRange = (function() {

        /**
         * Properties of a GetLedgerRange.
         * @memberof tdx_request
         * @interface IGetLedgerRange
         * @property {number|Long|null} [startTime] GetLedgerRange startTime
         * @property {number|Long|null} [endTime] GetLedgerRange endTime
         * @property {Uint8Array|null} [pageTokenLogs] GetLedgerRange pageTokenLogs
         * @property {string|null} [pin] GetLedgerRange pin
         * @property {Uint8Array|null} [data] GetLedgerRange data
         * @property {number|null} [pageSize] GetLedgerRange pageSize
         */

        /**
         * Constructs a new GetLedgerRange.
         * @memberof tdx_request
         * @classdesc Represents a GetLedgerRange.
         * @implements IGetLedgerRange
         * @constructor
         * @param {tdx_request.IGetLedgerRange=} [properties] Properties to set
         */
        function GetLedgerRange(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLedgerRange startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetLedgerRange endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetLedgerRange pageTokenLogs.
         * @member {Uint8Array} pageTokenLogs
         * @memberof tdx_request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.pageTokenLogs = $util.newBuffer([]);

        /**
         * GetLedgerRange pin.
         * @member {string} pin
         * @memberof tdx_request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.pin = "";

        /**
         * GetLedgerRange data.
         * @member {Uint8Array} data
         * @memberof tdx_request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.data = $util.newBuffer([]);

        /**
         * GetLedgerRange pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof tdx_request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GetLedgerRange _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof tdx_request.GetLedgerRange
         * @instance
         */
        Object.defineProperty(GetLedgerRange.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetLedgerRange instance using the specified properties.
         * @function create
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {tdx_request.IGetLedgerRange=} [properties] Properties to set
         * @returns {tdx_request.GetLedgerRange} GetLedgerRange instance
         */
        GetLedgerRange.create = function create(properties) {
            return new GetLedgerRange(properties);
        };

        /**
         * Encodes the specified GetLedgerRange message. Does not implicitly {@link tdx_request.GetLedgerRange.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {tdx_request.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.endTime);
            if (message.pageTokenLogs != null && Object.hasOwnProperty.call(message, "pageTokenLogs"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.pageTokenLogs);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.data);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.pageSize);
            return writer;
        };

        /**
         * Encodes the specified GetLedgerRange message, length delimited. Does not implicitly {@link tdx_request.GetLedgerRange.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {tdx_request.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.GetLedgerRange();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 2: {
                        message.endTime = reader.uint64();
                        break;
                    }
                case 3: {
                        message.pageTokenLogs = reader.bytes();
                        break;
                    }
                case 4: {
                        message.pin = reader.string();
                        break;
                    }
                case 5: {
                        message.data = reader.bytes();
                        break;
                    }
                case 6: {
                        message.pageSize = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLedgerRange message.
         * @function verify
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLedgerRange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            if (message.pageTokenLogs != null && message.hasOwnProperty("pageTokenLogs"))
                if (!(message.pageTokenLogs && typeof message.pageTokenLogs.length === "number" || $util.isString(message.pageTokenLogs)))
                    return "pageTokenLogs: buffer expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            }
            return null;
        };

        /**
         * Creates a GetLedgerRange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.GetLedgerRange} GetLedgerRange
         */
        GetLedgerRange.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.GetLedgerRange)
                return object;
            let message = new $root.tdx_request.GetLedgerRange();
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            if (object.pageTokenLogs != null)
                if (typeof object.pageTokenLogs === "string")
                    $util.base64.decode(object.pageTokenLogs, message.pageTokenLogs = $util.newBuffer($util.base64.length(object.pageTokenLogs)), 0);
                else if (object.pageTokenLogs.length >= 0)
                    message.pageTokenLogs = object.pageTokenLogs;
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.pageSize != null)
                message.pageSize = object.pageSize >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetLedgerRange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {tdx_request.GetLedgerRange} message GetLedgerRange
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLedgerRange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.pageTokenLogs = "";
                else {
                    object.pageTokenLogs = [];
                    if (options.bytes !== Array)
                        object.pageTokenLogs = $util.newBuffer(object.pageTokenLogs);
                }
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            if (message.pageTokenLogs != null && message.hasOwnProperty("pageTokenLogs"))
                object.pageTokenLogs = options.bytes === String ? $util.base64.encode(message.pageTokenLogs, 0, message.pageTokenLogs.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageTokenLogs) : message.pageTokenLogs;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                object.pageSize = message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            return object;
        };

        /**
         * Converts this GetLedgerRange to JSON.
         * @function toJSON
         * @memberof tdx_request.GetLedgerRange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLedgerRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLedgerRange
         * @function getTypeUrl
         * @memberof tdx_request.GetLedgerRange
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLedgerRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.GetLedgerRange";
        };

        return GetLedgerRange;
    })();

    /**
     * List_Type enum.
     * @name tdx_request.List_Type
     * @enum {number}
     * @property {number} List_Category=0 List_Category value
     * @property {number} List_SubCategory=1 List_SubCategory value
     * @property {number} List_Alerts=2 List_Alerts value
     */
    tdx_request.List_Type = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "List_Category"] = 0;
        values[valuesById[1] = "List_SubCategory"] = 1;
        values[valuesById[2] = "List_Alerts"] = 2;
        return values;
    })();

    /**
     * Delete_Type enum.
     * @name tdx_request.Delete_Type
     * @enum {number}
     * @property {number} Delete_Category=0 Delete_Category value
     * @property {number} Delete_SubCategory=1 Delete_SubCategory value
     * @property {number} Delete_Alert=2 Delete_Alert value
     */
    tdx_request.Delete_Type = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Delete_Category"] = 0;
        values[valuesById[1] = "Delete_SubCategory"] = 1;
        values[valuesById[2] = "Delete_Alert"] = 2;
        return values;
    })();

    /**
     * Update_Type enum.
     * @name tdx_request.Update_Type
     * @enum {number}
     * @property {number} Update_Category=0 Update_Category value
     * @property {number} Update_SubCategory=1 Update_SubCategory value
     * @property {number} Update_Alert=2 Update_Alert value
     */
    tdx_request.Update_Type = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Update_Category"] = 0;
        values[valuesById[1] = "Update_SubCategory"] = 1;
        values[valuesById[2] = "Update_Alert"] = 2;
        return values;
    })();

    /**
     * Add_Type enum.
     * @name tdx_request.Add_Type
     * @enum {number}
     * @property {number} Add_Category=0 Add_Category value
     * @property {number} Add_SubCategory=1 Add_SubCategory value
     * @property {number} Add_Alert=2 Add_Alert value
     */
    tdx_request.Add_Type = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Add_Category"] = 0;
        values[valuesById[1] = "Add_SubCategory"] = 1;
        values[valuesById[2] = "Add_Alert"] = 2;
        return values;
    })();

    tdx_request.CreateAlert = (function() {

        /**
         * Properties of a CreateAlert.
         * @memberof tdx_request
         * @interface ICreateAlert
         * @property {Uint8Array|null} [data] CreateAlert data
         * @property {string|null} [pin] CreateAlert pin
         * @property {string|null} [alert] CreateAlert alert
         * @property {string|null} [category] CreateAlert category
         * @property {string|null} [subCategory] CreateAlert subCategory
         * @property {tdx_request.Add_Type|null} [addType] CreateAlert addType
         */

        /**
         * Constructs a new CreateAlert.
         * @memberof tdx_request
         * @classdesc Represents a CreateAlert.
         * @implements ICreateAlert
         * @constructor
         * @param {tdx_request.ICreateAlert=} [properties] Properties to set
         */
        function CreateAlert(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateAlert data.
         * @member {Uint8Array} data
         * @memberof tdx_request.CreateAlert
         * @instance
         */
        CreateAlert.prototype.data = $util.newBuffer([]);

        /**
         * CreateAlert pin.
         * @member {string} pin
         * @memberof tdx_request.CreateAlert
         * @instance
         */
        CreateAlert.prototype.pin = "";

        /**
         * CreateAlert alert.
         * @member {string} alert
         * @memberof tdx_request.CreateAlert
         * @instance
         */
        CreateAlert.prototype.alert = "";

        /**
         * CreateAlert category.
         * @member {string} category
         * @memberof tdx_request.CreateAlert
         * @instance
         */
        CreateAlert.prototype.category = "";

        /**
         * CreateAlert subCategory.
         * @member {string} subCategory
         * @memberof tdx_request.CreateAlert
         * @instance
         */
        CreateAlert.prototype.subCategory = "";

        /**
         * CreateAlert addType.
         * @member {tdx_request.Add_Type} addType
         * @memberof tdx_request.CreateAlert
         * @instance
         */
        CreateAlert.prototype.addType = 0;

        /**
         * Creates a new CreateAlert instance using the specified properties.
         * @function create
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {tdx_request.ICreateAlert=} [properties] Properties to set
         * @returns {tdx_request.CreateAlert} CreateAlert instance
         */
        CreateAlert.create = function create(properties) {
            return new CreateAlert(properties);
        };

        /**
         * Encodes the specified CreateAlert message. Does not implicitly {@link tdx_request.CreateAlert.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {tdx_request.ICreateAlert} message CreateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAlert.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.pin);
            if (message.alert != null && Object.hasOwnProperty.call(message, "alert"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.alert);
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.category);
            if (message.subCategory != null && Object.hasOwnProperty.call(message, "subCategory"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.subCategory);
            if (message.addType != null && Object.hasOwnProperty.call(message, "addType"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.addType);
            return writer;
        };

        /**
         * Encodes the specified CreateAlert message, length delimited. Does not implicitly {@link tdx_request.CreateAlert.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {tdx_request.ICreateAlert} message CreateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAlert.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateAlert message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.CreateAlert} CreateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAlert.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.CreateAlert();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.data = reader.bytes();
                        break;
                    }
                case 2: {
                        message.pin = reader.string();
                        break;
                    }
                case 3: {
                        message.alert = reader.string();
                        break;
                    }
                case 4: {
                        message.category = reader.string();
                        break;
                    }
                case 5: {
                        message.subCategory = reader.string();
                        break;
                    }
                case 6: {
                        message.addType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateAlert message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.CreateAlert} CreateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAlert.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateAlert message.
         * @function verify
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateAlert.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.alert != null && message.hasOwnProperty("alert"))
                if (!$util.isString(message.alert))
                    return "alert: string expected";
            if (message.category != null && message.hasOwnProperty("category"))
                if (!$util.isString(message.category))
                    return "category: string expected";
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                if (!$util.isString(message.subCategory))
                    return "subCategory: string expected";
            if (message.addType != null && message.hasOwnProperty("addType"))
                switch (message.addType) {
                default:
                    return "addType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a CreateAlert message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.CreateAlert} CreateAlert
         */
        CreateAlert.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.CreateAlert)
                return object;
            let message = new $root.tdx_request.CreateAlert();
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.alert != null)
                message.alert = String(object.alert);
            if (object.category != null)
                message.category = String(object.category);
            if (object.subCategory != null)
                message.subCategory = String(object.subCategory);
            switch (object.addType) {
            default:
                if (typeof object.addType === "number") {
                    message.addType = object.addType;
                    break;
                }
                break;
            case "Add_Category":
            case 0:
                message.addType = 0;
                break;
            case "Add_SubCategory":
            case 1:
                message.addType = 1;
                break;
            case "Add_Alert":
            case 2:
                message.addType = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a CreateAlert message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {tdx_request.CreateAlert} message CreateAlert
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateAlert.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.pin = "";
                object.alert = "";
                object.category = "";
                object.subCategory = "";
                object.addType = options.enums === String ? "Add_Category" : 0;
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.alert != null && message.hasOwnProperty("alert"))
                object.alert = message.alert;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = message.category;
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                object.subCategory = message.subCategory;
            if (message.addType != null && message.hasOwnProperty("addType"))
                object.addType = options.enums === String ? $root.tdx_request.Add_Type[message.addType] === undefined ? message.addType : $root.tdx_request.Add_Type[message.addType] : message.addType;
            return object;
        };

        /**
         * Converts this CreateAlert to JSON.
         * @function toJSON
         * @memberof tdx_request.CreateAlert
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateAlert.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateAlert
         * @function getTypeUrl
         * @memberof tdx_request.CreateAlert
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateAlert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.CreateAlert";
        };

        return CreateAlert;
    })();

    tdx_request.DeleteAlert = (function() {

        /**
         * Properties of a DeleteAlert.
         * @memberof tdx_request
         * @interface IDeleteAlert
         * @property {Uint8Array|null} [data] DeleteAlert data
         * @property {string|null} [pin] DeleteAlert pin
         * @property {string|null} [category] DeleteAlert category
         * @property {string|null} [subCategory] DeleteAlert subCategory
         * @property {string|null} [alert] DeleteAlert alert
         * @property {tdx_request.Delete_Type|null} [deleteType] DeleteAlert deleteType
         */

        /**
         * Constructs a new DeleteAlert.
         * @memberof tdx_request
         * @classdesc Represents a DeleteAlert.
         * @implements IDeleteAlert
         * @constructor
         * @param {tdx_request.IDeleteAlert=} [properties] Properties to set
         */
        function DeleteAlert(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteAlert data.
         * @member {Uint8Array} data
         * @memberof tdx_request.DeleteAlert
         * @instance
         */
        DeleteAlert.prototype.data = $util.newBuffer([]);

        /**
         * DeleteAlert pin.
         * @member {string} pin
         * @memberof tdx_request.DeleteAlert
         * @instance
         */
        DeleteAlert.prototype.pin = "";

        /**
         * DeleteAlert category.
         * @member {string} category
         * @memberof tdx_request.DeleteAlert
         * @instance
         */
        DeleteAlert.prototype.category = "";

        /**
         * DeleteAlert subCategory.
         * @member {string} subCategory
         * @memberof tdx_request.DeleteAlert
         * @instance
         */
        DeleteAlert.prototype.subCategory = "";

        /**
         * DeleteAlert alert.
         * @member {string} alert
         * @memberof tdx_request.DeleteAlert
         * @instance
         */
        DeleteAlert.prototype.alert = "";

        /**
         * DeleteAlert deleteType.
         * @member {tdx_request.Delete_Type} deleteType
         * @memberof tdx_request.DeleteAlert
         * @instance
         */
        DeleteAlert.prototype.deleteType = 0;

        /**
         * Creates a new DeleteAlert instance using the specified properties.
         * @function create
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {tdx_request.IDeleteAlert=} [properties] Properties to set
         * @returns {tdx_request.DeleteAlert} DeleteAlert instance
         */
        DeleteAlert.create = function create(properties) {
            return new DeleteAlert(properties);
        };

        /**
         * Encodes the specified DeleteAlert message. Does not implicitly {@link tdx_request.DeleteAlert.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {tdx_request.IDeleteAlert} message DeleteAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAlert.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.pin);
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.category);
            if (message.subCategory != null && Object.hasOwnProperty.call(message, "subCategory"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.subCategory);
            if (message.alert != null && Object.hasOwnProperty.call(message, "alert"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.alert);
            if (message.deleteType != null && Object.hasOwnProperty.call(message, "deleteType"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.deleteType);
            return writer;
        };

        /**
         * Encodes the specified DeleteAlert message, length delimited. Does not implicitly {@link tdx_request.DeleteAlert.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {tdx_request.IDeleteAlert} message DeleteAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAlert.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteAlert message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.DeleteAlert} DeleteAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAlert.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.DeleteAlert();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.data = reader.bytes();
                        break;
                    }
                case 2: {
                        message.pin = reader.string();
                        break;
                    }
                case 3: {
                        message.category = reader.string();
                        break;
                    }
                case 4: {
                        message.subCategory = reader.string();
                        break;
                    }
                case 5: {
                        message.alert = reader.string();
                        break;
                    }
                case 6: {
                        message.deleteType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteAlert message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.DeleteAlert} DeleteAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAlert.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteAlert message.
         * @function verify
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteAlert.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.category != null && message.hasOwnProperty("category"))
                if (!$util.isString(message.category))
                    return "category: string expected";
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                if (!$util.isString(message.subCategory))
                    return "subCategory: string expected";
            if (message.alert != null && message.hasOwnProperty("alert"))
                if (!$util.isString(message.alert))
                    return "alert: string expected";
            if (message.deleteType != null && message.hasOwnProperty("deleteType"))
                switch (message.deleteType) {
                default:
                    return "deleteType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a DeleteAlert message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.DeleteAlert} DeleteAlert
         */
        DeleteAlert.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.DeleteAlert)
                return object;
            let message = new $root.tdx_request.DeleteAlert();
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.category != null)
                message.category = String(object.category);
            if (object.subCategory != null)
                message.subCategory = String(object.subCategory);
            if (object.alert != null)
                message.alert = String(object.alert);
            switch (object.deleteType) {
            default:
                if (typeof object.deleteType === "number") {
                    message.deleteType = object.deleteType;
                    break;
                }
                break;
            case "Delete_Category":
            case 0:
                message.deleteType = 0;
                break;
            case "Delete_SubCategory":
            case 1:
                message.deleteType = 1;
                break;
            case "Delete_Alert":
            case 2:
                message.deleteType = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a DeleteAlert message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {tdx_request.DeleteAlert} message DeleteAlert
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteAlert.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.pin = "";
                object.category = "";
                object.subCategory = "";
                object.alert = "";
                object.deleteType = options.enums === String ? "Delete_Category" : 0;
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = message.category;
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                object.subCategory = message.subCategory;
            if (message.alert != null && message.hasOwnProperty("alert"))
                object.alert = message.alert;
            if (message.deleteType != null && message.hasOwnProperty("deleteType"))
                object.deleteType = options.enums === String ? $root.tdx_request.Delete_Type[message.deleteType] === undefined ? message.deleteType : $root.tdx_request.Delete_Type[message.deleteType] : message.deleteType;
            return object;
        };

        /**
         * Converts this DeleteAlert to JSON.
         * @function toJSON
         * @memberof tdx_request.DeleteAlert
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteAlert.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteAlert
         * @function getTypeUrl
         * @memberof tdx_request.DeleteAlert
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteAlert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.DeleteAlert";
        };

        return DeleteAlert;
    })();

    tdx_request.ListAlerts = (function() {

        /**
         * Properties of a ListAlerts.
         * @memberof tdx_request
         * @interface IListAlerts
         * @property {Uint8Array|null} [data] ListAlerts data
         * @property {string|null} [pin] ListAlerts pin
         * @property {tdx_request.List_Type|null} [listType] ListAlerts listType
         * @property {string|null} [category] ListAlerts category
         * @property {string|null} [subCategory] ListAlerts subCategory
         */

        /**
         * Constructs a new ListAlerts.
         * @memberof tdx_request
         * @classdesc Represents a ListAlerts.
         * @implements IListAlerts
         * @constructor
         * @param {tdx_request.IListAlerts=} [properties] Properties to set
         */
        function ListAlerts(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListAlerts data.
         * @member {Uint8Array} data
         * @memberof tdx_request.ListAlerts
         * @instance
         */
        ListAlerts.prototype.data = $util.newBuffer([]);

        /**
         * ListAlerts pin.
         * @member {string} pin
         * @memberof tdx_request.ListAlerts
         * @instance
         */
        ListAlerts.prototype.pin = "";

        /**
         * ListAlerts listType.
         * @member {tdx_request.List_Type} listType
         * @memberof tdx_request.ListAlerts
         * @instance
         */
        ListAlerts.prototype.listType = 0;

        /**
         * ListAlerts category.
         * @member {string} category
         * @memberof tdx_request.ListAlerts
         * @instance
         */
        ListAlerts.prototype.category = "";

        /**
         * ListAlerts subCategory.
         * @member {string} subCategory
         * @memberof tdx_request.ListAlerts
         * @instance
         */
        ListAlerts.prototype.subCategory = "";

        /**
         * Creates a new ListAlerts instance using the specified properties.
         * @function create
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {tdx_request.IListAlerts=} [properties] Properties to set
         * @returns {tdx_request.ListAlerts} ListAlerts instance
         */
        ListAlerts.create = function create(properties) {
            return new ListAlerts(properties);
        };

        /**
         * Encodes the specified ListAlerts message. Does not implicitly {@link tdx_request.ListAlerts.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {tdx_request.IListAlerts} message ListAlerts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListAlerts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.pin);
            if (message.listType != null && Object.hasOwnProperty.call(message, "listType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.listType);
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.category);
            if (message.subCategory != null && Object.hasOwnProperty.call(message, "subCategory"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.subCategory);
            return writer;
        };

        /**
         * Encodes the specified ListAlerts message, length delimited. Does not implicitly {@link tdx_request.ListAlerts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {tdx_request.IListAlerts} message ListAlerts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListAlerts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListAlerts message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.ListAlerts} ListAlerts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListAlerts.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.ListAlerts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.data = reader.bytes();
                        break;
                    }
                case 2: {
                        message.pin = reader.string();
                        break;
                    }
                case 3: {
                        message.listType = reader.int32();
                        break;
                    }
                case 4: {
                        message.category = reader.string();
                        break;
                    }
                case 5: {
                        message.subCategory = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListAlerts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.ListAlerts} ListAlerts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListAlerts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListAlerts message.
         * @function verify
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListAlerts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.listType != null && message.hasOwnProperty("listType"))
                switch (message.listType) {
                default:
                    return "listType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.category != null && message.hasOwnProperty("category"))
                if (!$util.isString(message.category))
                    return "category: string expected";
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                if (!$util.isString(message.subCategory))
                    return "subCategory: string expected";
            return null;
        };

        /**
         * Creates a ListAlerts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.ListAlerts} ListAlerts
         */
        ListAlerts.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.ListAlerts)
                return object;
            let message = new $root.tdx_request.ListAlerts();
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.pin != null)
                message.pin = String(object.pin);
            switch (object.listType) {
            default:
                if (typeof object.listType === "number") {
                    message.listType = object.listType;
                    break;
                }
                break;
            case "List_Category":
            case 0:
                message.listType = 0;
                break;
            case "List_SubCategory":
            case 1:
                message.listType = 1;
                break;
            case "List_Alerts":
            case 2:
                message.listType = 2;
                break;
            }
            if (object.category != null)
                message.category = String(object.category);
            if (object.subCategory != null)
                message.subCategory = String(object.subCategory);
            return message;
        };

        /**
         * Creates a plain object from a ListAlerts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {tdx_request.ListAlerts} message ListAlerts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListAlerts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.pin = "";
                object.listType = options.enums === String ? "List_Category" : 0;
                object.category = "";
                object.subCategory = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.listType != null && message.hasOwnProperty("listType"))
                object.listType = options.enums === String ? $root.tdx_request.List_Type[message.listType] === undefined ? message.listType : $root.tdx_request.List_Type[message.listType] : message.listType;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = message.category;
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                object.subCategory = message.subCategory;
            return object;
        };

        /**
         * Converts this ListAlerts to JSON.
         * @function toJSON
         * @memberof tdx_request.ListAlerts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListAlerts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListAlerts
         * @function getTypeUrl
         * @memberof tdx_request.ListAlerts
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListAlerts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.ListAlerts";
        };

        return ListAlerts;
    })();

    tdx_request.UpdateAlert = (function() {

        /**
         * Properties of an UpdateAlert.
         * @memberof tdx_request
         * @interface IUpdateAlert
         * @property {Uint8Array|null} [data] UpdateAlert data
         * @property {string|null} [pin] UpdateAlert pin
         * @property {tdx_request.Update_Type|null} [updateType] UpdateAlert updateType
         * @property {string|null} [category] UpdateAlert category
         * @property {string|null} [alert] UpdateAlert alert
         * @property {string|null} [subCategory] UpdateAlert subCategory
         * @property {boolean|null} [pause] UpdateAlert pause
         * @property {boolean|null} [resume] UpdateAlert resume
         */

        /**
         * Constructs a new UpdateAlert.
         * @memberof tdx_request
         * @classdesc Represents an UpdateAlert.
         * @implements IUpdateAlert
         * @constructor
         * @param {tdx_request.IUpdateAlert=} [properties] Properties to set
         */
        function UpdateAlert(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateAlert data.
         * @member {Uint8Array} data
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.data = $util.newBuffer([]);

        /**
         * UpdateAlert pin.
         * @member {string} pin
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.pin = "";

        /**
         * UpdateAlert updateType.
         * @member {tdx_request.Update_Type} updateType
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.updateType = 0;

        /**
         * UpdateAlert category.
         * @member {string} category
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.category = "";

        /**
         * UpdateAlert alert.
         * @member {string} alert
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.alert = "";

        /**
         * UpdateAlert subCategory.
         * @member {string} subCategory
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.subCategory = "";

        /**
         * UpdateAlert pause.
         * @member {boolean} pause
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.pause = false;

        /**
         * UpdateAlert resume.
         * @member {boolean} resume
         * @memberof tdx_request.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.resume = false;

        /**
         * Creates a new UpdateAlert instance using the specified properties.
         * @function create
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {tdx_request.IUpdateAlert=} [properties] Properties to set
         * @returns {tdx_request.UpdateAlert} UpdateAlert instance
         */
        UpdateAlert.create = function create(properties) {
            return new UpdateAlert(properties);
        };

        /**
         * Encodes the specified UpdateAlert message. Does not implicitly {@link tdx_request.UpdateAlert.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {tdx_request.IUpdateAlert} message UpdateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAlert.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.pin);
            if (message.updateType != null && Object.hasOwnProperty.call(message, "updateType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.updateType);
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.category);
            if (message.subCategory != null && Object.hasOwnProperty.call(message, "subCategory"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.subCategory);
            if (message.pause != null && Object.hasOwnProperty.call(message, "pause"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.pause);
            if (message.resume != null && Object.hasOwnProperty.call(message, "resume"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.resume);
            if (message.alert != null && Object.hasOwnProperty.call(message, "alert"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.alert);
            return writer;
        };

        /**
         * Encodes the specified UpdateAlert message, length delimited. Does not implicitly {@link tdx_request.UpdateAlert.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {tdx_request.IUpdateAlert} message UpdateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAlert.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateAlert message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.UpdateAlert} UpdateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAlert.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.UpdateAlert();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.data = reader.bytes();
                        break;
                    }
                case 2: {
                        message.pin = reader.string();
                        break;
                    }
                case 3: {
                        message.updateType = reader.int32();
                        break;
                    }
                case 4: {
                        message.category = reader.string();
                        break;
                    }
                case 8: {
                        message.alert = reader.string();
                        break;
                    }
                case 5: {
                        message.subCategory = reader.string();
                        break;
                    }
                case 6: {
                        message.pause = reader.bool();
                        break;
                    }
                case 7: {
                        message.resume = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateAlert message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.UpdateAlert} UpdateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAlert.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateAlert message.
         * @function verify
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateAlert.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.updateType != null && message.hasOwnProperty("updateType"))
                switch (message.updateType) {
                default:
                    return "updateType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.category != null && message.hasOwnProperty("category"))
                if (!$util.isString(message.category))
                    return "category: string expected";
            if (message.alert != null && message.hasOwnProperty("alert"))
                if (!$util.isString(message.alert))
                    return "alert: string expected";
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                if (!$util.isString(message.subCategory))
                    return "subCategory: string expected";
            if (message.pause != null && message.hasOwnProperty("pause"))
                if (typeof message.pause !== "boolean")
                    return "pause: boolean expected";
            if (message.resume != null && message.hasOwnProperty("resume"))
                if (typeof message.resume !== "boolean")
                    return "resume: boolean expected";
            return null;
        };

        /**
         * Creates an UpdateAlert message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.UpdateAlert} UpdateAlert
         */
        UpdateAlert.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.UpdateAlert)
                return object;
            let message = new $root.tdx_request.UpdateAlert();
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.pin != null)
                message.pin = String(object.pin);
            switch (object.updateType) {
            default:
                if (typeof object.updateType === "number") {
                    message.updateType = object.updateType;
                    break;
                }
                break;
            case "Update_Category":
            case 0:
                message.updateType = 0;
                break;
            case "Update_SubCategory":
            case 1:
                message.updateType = 1;
                break;
            case "Update_Alert":
            case 2:
                message.updateType = 2;
                break;
            }
            if (object.category != null)
                message.category = String(object.category);
            if (object.alert != null)
                message.alert = String(object.alert);
            if (object.subCategory != null)
                message.subCategory = String(object.subCategory);
            if (object.pause != null)
                message.pause = Boolean(object.pause);
            if (object.resume != null)
                message.resume = Boolean(object.resume);
            return message;
        };

        /**
         * Creates a plain object from an UpdateAlert message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {tdx_request.UpdateAlert} message UpdateAlert
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateAlert.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.pin = "";
                object.updateType = options.enums === String ? "Update_Category" : 0;
                object.category = "";
                object.subCategory = "";
                object.pause = false;
                object.resume = false;
                object.alert = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.updateType != null && message.hasOwnProperty("updateType"))
                object.updateType = options.enums === String ? $root.tdx_request.Update_Type[message.updateType] === undefined ? message.updateType : $root.tdx_request.Update_Type[message.updateType] : message.updateType;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = message.category;
            if (message.subCategory != null && message.hasOwnProperty("subCategory"))
                object.subCategory = message.subCategory;
            if (message.pause != null && message.hasOwnProperty("pause"))
                object.pause = message.pause;
            if (message.resume != null && message.hasOwnProperty("resume"))
                object.resume = message.resume;
            if (message.alert != null && message.hasOwnProperty("alert"))
                object.alert = message.alert;
            return object;
        };

        /**
         * Converts this UpdateAlert to JSON.
         * @function toJSON
         * @memberof tdx_request.UpdateAlert
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateAlert.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateAlert
         * @function getTypeUrl
         * @memberof tdx_request.UpdateAlert
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateAlert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.UpdateAlert";
        };

        return UpdateAlert;
    })();

    tdx_request.GetConsistencyProof = (function() {

        /**
         * Properties of a GetConsistencyProof.
         * @memberof tdx_request
         * @interface IGetConsistencyProof
         * @property {string|null} [pin] GetConsistencyProof pin
         * @property {Uint8Array|null} [data] GetConsistencyProof data
         * @property {string|null} [logFileName] GetConsistencyProof logFileName
         */

        /**
         * Constructs a new GetConsistencyProof.
         * @memberof tdx_request
         * @classdesc Represents a GetConsistencyProof.
         * @implements IGetConsistencyProof
         * @constructor
         * @param {tdx_request.IGetConsistencyProof=} [properties] Properties to set
         */
        function GetConsistencyProof(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetConsistencyProof pin.
         * @member {string} pin
         * @memberof tdx_request.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.pin = "";

        /**
         * GetConsistencyProof data.
         * @member {Uint8Array} data
         * @memberof tdx_request.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.data = $util.newBuffer([]);

        /**
         * GetConsistencyProof logFileName.
         * @member {string} logFileName
         * @memberof tdx_request.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.logFileName = "";

        /**
         * Creates a new GetConsistencyProof instance using the specified properties.
         * @function create
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {tdx_request.IGetConsistencyProof=} [properties] Properties to set
         * @returns {tdx_request.GetConsistencyProof} GetConsistencyProof instance
         */
        GetConsistencyProof.create = function create(properties) {
            return new GetConsistencyProof(properties);
        };

        /**
         * Encodes the specified GetConsistencyProof message. Does not implicitly {@link tdx_request.GetConsistencyProof.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {tdx_request.IGetConsistencyProof} message GetConsistencyProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetConsistencyProof.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.logFileName != null && Object.hasOwnProperty.call(message, "logFileName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.logFileName);
            return writer;
        };

        /**
         * Encodes the specified GetConsistencyProof message, length delimited. Does not implicitly {@link tdx_request.GetConsistencyProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {tdx_request.IGetConsistencyProof} message GetConsistencyProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetConsistencyProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetConsistencyProof message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.GetConsistencyProof} GetConsistencyProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetConsistencyProof.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.GetConsistencyProof();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.logFileName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetConsistencyProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.GetConsistencyProof} GetConsistencyProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetConsistencyProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetConsistencyProof message.
         * @function verify
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetConsistencyProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.logFileName != null && message.hasOwnProperty("logFileName"))
                if (!$util.isString(message.logFileName))
                    return "logFileName: string expected";
            return null;
        };

        /**
         * Creates a GetConsistencyProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.GetConsistencyProof} GetConsistencyProof
         */
        GetConsistencyProof.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.GetConsistencyProof)
                return object;
            let message = new $root.tdx_request.GetConsistencyProof();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.logFileName != null)
                message.logFileName = String(object.logFileName);
            return message;
        };

        /**
         * Creates a plain object from a GetConsistencyProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {tdx_request.GetConsistencyProof} message GetConsistencyProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetConsistencyProof.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.logFileName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.logFileName != null && message.hasOwnProperty("logFileName"))
                object.logFileName = message.logFileName;
            return object;
        };

        /**
         * Converts this GetConsistencyProof to JSON.
         * @function toJSON
         * @memberof tdx_request.GetConsistencyProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetConsistencyProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetConsistencyProof
         * @function getTypeUrl
         * @memberof tdx_request.GetConsistencyProof
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetConsistencyProof.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.GetConsistencyProof";
        };

        return GetConsistencyProof;
    })();

    tdx_request.GetInclusionProof = (function() {

        /**
         * Properties of a GetInclusionProof.
         * @memberof tdx_request
         * @interface IGetInclusionProof
         * @property {string|null} [pin] GetInclusionProof pin
         * @property {Uint8Array|null} [data] GetInclusionProof data
         * @property {string|null} [logFileName] GetInclusionProof logFileName
         */

        /**
         * Constructs a new GetInclusionProof.
         * @memberof tdx_request
         * @classdesc Represents a GetInclusionProof.
         * @implements IGetInclusionProof
         * @constructor
         * @param {tdx_request.IGetInclusionProof=} [properties] Properties to set
         */
        function GetInclusionProof(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetInclusionProof pin.
         * @member {string} pin
         * @memberof tdx_request.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.pin = "";

        /**
         * GetInclusionProof data.
         * @member {Uint8Array} data
         * @memberof tdx_request.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.data = $util.newBuffer([]);

        /**
         * GetInclusionProof logFileName.
         * @member {string} logFileName
         * @memberof tdx_request.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.logFileName = "";

        /**
         * Creates a new GetInclusionProof instance using the specified properties.
         * @function create
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {tdx_request.IGetInclusionProof=} [properties] Properties to set
         * @returns {tdx_request.GetInclusionProof} GetInclusionProof instance
         */
        GetInclusionProof.create = function create(properties) {
            return new GetInclusionProof(properties);
        };

        /**
         * Encodes the specified GetInclusionProof message. Does not implicitly {@link tdx_request.GetInclusionProof.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {tdx_request.IGetInclusionProof} message GetInclusionProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetInclusionProof.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.logFileName != null && Object.hasOwnProperty.call(message, "logFileName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.logFileName);
            return writer;
        };

        /**
         * Encodes the specified GetInclusionProof message, length delimited. Does not implicitly {@link tdx_request.GetInclusionProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {tdx_request.IGetInclusionProof} message GetInclusionProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetInclusionProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetInclusionProof message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.GetInclusionProof} GetInclusionProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetInclusionProof.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.GetInclusionProof();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.logFileName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetInclusionProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.GetInclusionProof} GetInclusionProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetInclusionProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetInclusionProof message.
         * @function verify
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetInclusionProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.logFileName != null && message.hasOwnProperty("logFileName"))
                if (!$util.isString(message.logFileName))
                    return "logFileName: string expected";
            return null;
        };

        /**
         * Creates a GetInclusionProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.GetInclusionProof} GetInclusionProof
         */
        GetInclusionProof.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.GetInclusionProof)
                return object;
            let message = new $root.tdx_request.GetInclusionProof();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.logFileName != null)
                message.logFileName = String(object.logFileName);
            return message;
        };

        /**
         * Creates a plain object from a GetInclusionProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {tdx_request.GetInclusionProof} message GetInclusionProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetInclusionProof.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.logFileName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.logFileName != null && message.hasOwnProperty("logFileName"))
                object.logFileName = message.logFileName;
            return object;
        };

        /**
         * Converts this GetInclusionProof to JSON.
         * @function toJSON
         * @memberof tdx_request.GetInclusionProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetInclusionProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetInclusionProof
         * @function getTypeUrl
         * @memberof tdx_request.GetInclusionProof
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetInclusionProof.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.GetInclusionProof";
        };

        return GetInclusionProof;
    })();

    tdx_request.AuditLogEntry = (function() {

        /**
         * Properties of an AuditLogEntry.
         * @memberof tdx_request
         * @interface IAuditLogEntry
         * @property {number|Long|null} [timestamp] AuditLogEntry timestamp
         * @property {string|null} [connectedFrom] AuditLogEntry connectedFrom
         * @property {string|null} [user] AuditLogEntry user
         * @property {string|null} [operation] AuditLogEntry operation
         * @property {Uint8Array|null} [subject] AuditLogEntry subject
         * @property {string|null} [message] AuditLogEntry message
         * @property {string|null} [container] AuditLogEntry container
         * @property {number|Long|null} [serveTime] AuditLogEntry serveTime
         * @property {number|Long|null} [latency] AuditLogEntry latency
         * @property {string|null} [permissionGrantedBy] AuditLogEntry permissionGrantedBy
         * @property {Uint8Array|null} [hmacEmail] AuditLogEntry hmacEmail
         * @property {Uint8Array|null} [objectUuid] AuditLogEntry objectUuid
         * @property {Uint8Array|null} [storageUuid] AuditLogEntry storageUuid
         * @property {boolean|null} [success] AuditLogEntry success
         */

        /**
         * Constructs a new AuditLogEntry.
         * @memberof tdx_request
         * @classdesc Represents an AuditLogEntry.
         * @implements IAuditLogEntry
         * @constructor
         * @param {tdx_request.IAuditLogEntry=} [properties] Properties to set
         */
        function AuditLogEntry(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AuditLogEntry timestamp.
         * @member {number|Long} timestamp
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AuditLogEntry connectedFrom.
         * @member {string} connectedFrom
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.connectedFrom = "";

        /**
         * AuditLogEntry user.
         * @member {string} user
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.user = "";

        /**
         * AuditLogEntry operation.
         * @member {string} operation
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.operation = "";

        /**
         * AuditLogEntry subject.
         * @member {Uint8Array} subject
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.subject = $util.newBuffer([]);

        /**
         * AuditLogEntry message.
         * @member {string} message
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.message = "";

        /**
         * AuditLogEntry container.
         * @member {string} container
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.container = "";

        /**
         * AuditLogEntry serveTime.
         * @member {number|Long} serveTime
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.serveTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AuditLogEntry latency.
         * @member {number|Long} latency
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.latency = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AuditLogEntry permissionGrantedBy.
         * @member {string} permissionGrantedBy
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.permissionGrantedBy = "";

        /**
         * AuditLogEntry hmacEmail.
         * @member {Uint8Array} hmacEmail
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.hmacEmail = $util.newBuffer([]);

        /**
         * AuditLogEntry objectUuid.
         * @member {Uint8Array} objectUuid
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.objectUuid = $util.newBuffer([]);

        /**
         * AuditLogEntry storageUuid.
         * @member {Uint8Array} storageUuid
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.storageUuid = $util.newBuffer([]);

        /**
         * AuditLogEntry success.
         * @member {boolean} success
         * @memberof tdx_request.AuditLogEntry
         * @instance
         */
        AuditLogEntry.prototype.success = false;

        /**
         * Creates a new AuditLogEntry instance using the specified properties.
         * @function create
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {tdx_request.IAuditLogEntry=} [properties] Properties to set
         * @returns {tdx_request.AuditLogEntry} AuditLogEntry instance
         */
        AuditLogEntry.create = function create(properties) {
            return new AuditLogEntry(properties);
        };

        /**
         * Encodes the specified AuditLogEntry message. Does not implicitly {@link tdx_request.AuditLogEntry.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {tdx_request.IAuditLogEntry} message AuditLogEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLogEntry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
            if (message.connectedFrom != null && Object.hasOwnProperty.call(message, "connectedFrom"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.connectedFrom);
            if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.user);
            if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.operation);
            if (message.subject != null && Object.hasOwnProperty.call(message, "subject"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.subject);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.message);
            if (message.container != null && Object.hasOwnProperty.call(message, "container"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.container);
            if (message.serveTime != null && Object.hasOwnProperty.call(message, "serveTime"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.serveTime);
            if (message.latency != null && Object.hasOwnProperty.call(message, "latency"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.latency);
            if (message.permissionGrantedBy != null && Object.hasOwnProperty.call(message, "permissionGrantedBy"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.permissionGrantedBy);
            if (message.hmacEmail != null && Object.hasOwnProperty.call(message, "hmacEmail"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.hmacEmail);
            if (message.objectUuid != null && Object.hasOwnProperty.call(message, "objectUuid"))
                writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.objectUuid);
            if (message.storageUuid != null && Object.hasOwnProperty.call(message, "storageUuid"))
                writer.uint32(/* id 13, wireType 2 =*/106).bytes(message.storageUuid);
            if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.success);
            return writer;
        };

        /**
         * Encodes the specified AuditLogEntry message, length delimited. Does not implicitly {@link tdx_request.AuditLogEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {tdx_request.IAuditLogEntry} message AuditLogEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLogEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AuditLogEntry message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.AuditLogEntry} AuditLogEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLogEntry.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.AuditLogEntry();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 2: {
                        message.connectedFrom = reader.string();
                        break;
                    }
                case 3: {
                        message.user = reader.string();
                        break;
                    }
                case 4: {
                        message.operation = reader.string();
                        break;
                    }
                case 5: {
                        message.subject = reader.bytes();
                        break;
                    }
                case 6: {
                        message.message = reader.string();
                        break;
                    }
                case 7: {
                        message.container = reader.string();
                        break;
                    }
                case 8: {
                        message.serveTime = reader.int64();
                        break;
                    }
                case 9: {
                        message.latency = reader.int64();
                        break;
                    }
                case 10: {
                        message.permissionGrantedBy = reader.string();
                        break;
                    }
                case 11: {
                        message.hmacEmail = reader.bytes();
                        break;
                    }
                case 12: {
                        message.objectUuid = reader.bytes();
                        break;
                    }
                case 13: {
                        message.storageUuid = reader.bytes();
                        break;
                    }
                case 14: {
                        message.success = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AuditLogEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.AuditLogEntry} AuditLogEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLogEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AuditLogEntry message.
         * @function verify
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AuditLogEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.connectedFrom != null && message.hasOwnProperty("connectedFrom"))
                if (!$util.isString(message.connectedFrom))
                    return "connectedFrom: string expected";
            if (message.user != null && message.hasOwnProperty("user"))
                if (!$util.isString(message.user))
                    return "user: string expected";
            if (message.operation != null && message.hasOwnProperty("operation"))
                if (!$util.isString(message.operation))
                    return "operation: string expected";
            if (message.subject != null && message.hasOwnProperty("subject"))
                if (!(message.subject && typeof message.subject.length === "number" || $util.isString(message.subject)))
                    return "subject: buffer expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.container != null && message.hasOwnProperty("container"))
                if (!$util.isString(message.container))
                    return "container: string expected";
            if (message.serveTime != null && message.hasOwnProperty("serveTime"))
                if (!$util.isInteger(message.serveTime) && !(message.serveTime && $util.isInteger(message.serveTime.low) && $util.isInteger(message.serveTime.high)))
                    return "serveTime: integer|Long expected";
            if (message.latency != null && message.hasOwnProperty("latency"))
                if (!$util.isInteger(message.latency) && !(message.latency && $util.isInteger(message.latency.low) && $util.isInteger(message.latency.high)))
                    return "latency: integer|Long expected";
            if (message.permissionGrantedBy != null && message.hasOwnProperty("permissionGrantedBy"))
                if (!$util.isString(message.permissionGrantedBy))
                    return "permissionGrantedBy: string expected";
            if (message.hmacEmail != null && message.hasOwnProperty("hmacEmail"))
                if (!(message.hmacEmail && typeof message.hmacEmail.length === "number" || $util.isString(message.hmacEmail)))
                    return "hmacEmail: buffer expected";
            if (message.objectUuid != null && message.hasOwnProperty("objectUuid"))
                if (!(message.objectUuid && typeof message.objectUuid.length === "number" || $util.isString(message.objectUuid)))
                    return "objectUuid: buffer expected";
            if (message.storageUuid != null && message.hasOwnProperty("storageUuid"))
                if (!(message.storageUuid && typeof message.storageUuid.length === "number" || $util.isString(message.storageUuid)))
                    return "storageUuid: buffer expected";
            if (message.success != null && message.hasOwnProperty("success"))
                if (typeof message.success !== "boolean")
                    return "success: boolean expected";
            return null;
        };

        /**
         * Creates an AuditLogEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.AuditLogEntry} AuditLogEntry
         */
        AuditLogEntry.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.AuditLogEntry)
                return object;
            let message = new $root.tdx_request.AuditLogEntry();
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.connectedFrom != null)
                message.connectedFrom = String(object.connectedFrom);
            if (object.user != null)
                message.user = String(object.user);
            if (object.operation != null)
                message.operation = String(object.operation);
            if (object.subject != null)
                if (typeof object.subject === "string")
                    $util.base64.decode(object.subject, message.subject = $util.newBuffer($util.base64.length(object.subject)), 0);
                else if (object.subject.length >= 0)
                    message.subject = object.subject;
            if (object.message != null)
                message.message = String(object.message);
            if (object.container != null)
                message.container = String(object.container);
            if (object.serveTime != null)
                if ($util.Long)
                    (message.serveTime = $util.Long.fromValue(object.serveTime)).unsigned = false;
                else if (typeof object.serveTime === "string")
                    message.serveTime = parseInt(object.serveTime, 10);
                else if (typeof object.serveTime === "number")
                    message.serveTime = object.serveTime;
                else if (typeof object.serveTime === "object")
                    message.serveTime = new $util.LongBits(object.serveTime.low >>> 0, object.serveTime.high >>> 0).toNumber();
            if (object.latency != null)
                if ($util.Long)
                    (message.latency = $util.Long.fromValue(object.latency)).unsigned = false;
                else if (typeof object.latency === "string")
                    message.latency = parseInt(object.latency, 10);
                else if (typeof object.latency === "number")
                    message.latency = object.latency;
                else if (typeof object.latency === "object")
                    message.latency = new $util.LongBits(object.latency.low >>> 0, object.latency.high >>> 0).toNumber();
            if (object.permissionGrantedBy != null)
                message.permissionGrantedBy = String(object.permissionGrantedBy);
            if (object.hmacEmail != null)
                if (typeof object.hmacEmail === "string")
                    $util.base64.decode(object.hmacEmail, message.hmacEmail = $util.newBuffer($util.base64.length(object.hmacEmail)), 0);
                else if (object.hmacEmail.length >= 0)
                    message.hmacEmail = object.hmacEmail;
            if (object.objectUuid != null)
                if (typeof object.objectUuid === "string")
                    $util.base64.decode(object.objectUuid, message.objectUuid = $util.newBuffer($util.base64.length(object.objectUuid)), 0);
                else if (object.objectUuid.length >= 0)
                    message.objectUuid = object.objectUuid;
            if (object.storageUuid != null)
                if (typeof object.storageUuid === "string")
                    $util.base64.decode(object.storageUuid, message.storageUuid = $util.newBuffer($util.base64.length(object.storageUuid)), 0);
                else if (object.storageUuid.length >= 0)
                    message.storageUuid = object.storageUuid;
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from an AuditLogEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {tdx_request.AuditLogEntry} message AuditLogEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AuditLogEntry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                object.connectedFrom = "";
                object.user = "";
                object.operation = "";
                if (options.bytes === String)
                    object.subject = "";
                else {
                    object.subject = [];
                    if (options.bytes !== Array)
                        object.subject = $util.newBuffer(object.subject);
                }
                object.message = "";
                object.container = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.serveTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.serveTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.latency = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.latency = options.longs === String ? "0" : 0;
                object.permissionGrantedBy = "";
                if (options.bytes === String)
                    object.hmacEmail = "";
                else {
                    object.hmacEmail = [];
                    if (options.bytes !== Array)
                        object.hmacEmail = $util.newBuffer(object.hmacEmail);
                }
                if (options.bytes === String)
                    object.objectUuid = "";
                else {
                    object.objectUuid = [];
                    if (options.bytes !== Array)
                        object.objectUuid = $util.newBuffer(object.objectUuid);
                }
                if (options.bytes === String)
                    object.storageUuid = "";
                else {
                    object.storageUuid = [];
                    if (options.bytes !== Array)
                        object.storageUuid = $util.newBuffer(object.storageUuid);
                }
                object.success = false;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.connectedFrom != null && message.hasOwnProperty("connectedFrom"))
                object.connectedFrom = message.connectedFrom;
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.operation != null && message.hasOwnProperty("operation"))
                object.operation = message.operation;
            if (message.subject != null && message.hasOwnProperty("subject"))
                object.subject = options.bytes === String ? $util.base64.encode(message.subject, 0, message.subject.length) : options.bytes === Array ? Array.prototype.slice.call(message.subject) : message.subject;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.container != null && message.hasOwnProperty("container"))
                object.container = message.container;
            if (message.serveTime != null && message.hasOwnProperty("serveTime"))
                if (typeof message.serveTime === "number")
                    object.serveTime = options.longs === String ? String(message.serveTime) : message.serveTime;
                else
                    object.serveTime = options.longs === String ? $util.Long.prototype.toString.call(message.serveTime) : options.longs === Number ? new $util.LongBits(message.serveTime.low >>> 0, message.serveTime.high >>> 0).toNumber() : message.serveTime;
            if (message.latency != null && message.hasOwnProperty("latency"))
                if (typeof message.latency === "number")
                    object.latency = options.longs === String ? String(message.latency) : message.latency;
                else
                    object.latency = options.longs === String ? $util.Long.prototype.toString.call(message.latency) : options.longs === Number ? new $util.LongBits(message.latency.low >>> 0, message.latency.high >>> 0).toNumber() : message.latency;
            if (message.permissionGrantedBy != null && message.hasOwnProperty("permissionGrantedBy"))
                object.permissionGrantedBy = message.permissionGrantedBy;
            if (message.hmacEmail != null && message.hasOwnProperty("hmacEmail"))
                object.hmacEmail = options.bytes === String ? $util.base64.encode(message.hmacEmail, 0, message.hmacEmail.length) : options.bytes === Array ? Array.prototype.slice.call(message.hmacEmail) : message.hmacEmail;
            if (message.objectUuid != null && message.hasOwnProperty("objectUuid"))
                object.objectUuid = options.bytes === String ? $util.base64.encode(message.objectUuid, 0, message.objectUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.objectUuid) : message.objectUuid;
            if (message.storageUuid != null && message.hasOwnProperty("storageUuid"))
                object.storageUuid = options.bytes === String ? $util.base64.encode(message.storageUuid, 0, message.storageUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.storageUuid) : message.storageUuid;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this AuditLogEntry to JSON.
         * @function toJSON
         * @memberof tdx_request.AuditLogEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AuditLogEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AuditLogEntry
         * @function getTypeUrl
         * @memberof tdx_request.AuditLogEntry
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AuditLogEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.AuditLogEntry";
        };

        return AuditLogEntry;
    })();

    tdx_request.StartConversion = (function() {

        /**
         * Properties of a StartConversion.
         * @memberof tdx_request
         * @interface IStartConversion
         * @property {string|null} [pin] StartConversion pin
         * @property {Uint8Array|null} [data] StartConversion data
         * @property {string|null} [fileFullPath] StartConversion fileFullPath
         * @property {number|null} [typeOfPath] StartConversion typeOfPath
         * @property {string|null} [destType] StartConversion destType
         */

        /**
         * Constructs a new StartConversion.
         * @memberof tdx_request
         * @classdesc Represents a StartConversion.
         * @implements IStartConversion
         * @constructor
         * @param {tdx_request.IStartConversion=} [properties] Properties to set
         */
        function StartConversion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StartConversion pin.
         * @member {string} pin
         * @memberof tdx_request.StartConversion
         * @instance
         */
        StartConversion.prototype.pin = "";

        /**
         * StartConversion data.
         * @member {Uint8Array} data
         * @memberof tdx_request.StartConversion
         * @instance
         */
        StartConversion.prototype.data = $util.newBuffer([]);

        /**
         * StartConversion fileFullPath.
         * @member {string} fileFullPath
         * @memberof tdx_request.StartConversion
         * @instance
         */
        StartConversion.prototype.fileFullPath = "";

        /**
         * StartConversion typeOfPath.
         * @member {number} typeOfPath
         * @memberof tdx_request.StartConversion
         * @instance
         */
        StartConversion.prototype.typeOfPath = 0;

        /**
         * StartConversion destType.
         * @member {string} destType
         * @memberof tdx_request.StartConversion
         * @instance
         */
        StartConversion.prototype.destType = "";

        /**
         * Creates a new StartConversion instance using the specified properties.
         * @function create
         * @memberof tdx_request.StartConversion
         * @static
         * @param {tdx_request.IStartConversion=} [properties] Properties to set
         * @returns {tdx_request.StartConversion} StartConversion instance
         */
        StartConversion.create = function create(properties) {
            return new StartConversion(properties);
        };

        /**
         * Encodes the specified StartConversion message. Does not implicitly {@link tdx_request.StartConversion.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.StartConversion
         * @static
         * @param {tdx_request.IStartConversion} message StartConversion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartConversion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileFullPath != null && Object.hasOwnProperty.call(message, "fileFullPath"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileFullPath);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.typeOfPath);
            if (message.destType != null && Object.hasOwnProperty.call(message, "destType"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.destType);
            return writer;
        };

        /**
         * Encodes the specified StartConversion message, length delimited. Does not implicitly {@link tdx_request.StartConversion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.StartConversion
         * @static
         * @param {tdx_request.IStartConversion} message StartConversion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartConversion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartConversion message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.StartConversion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.StartConversion} StartConversion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartConversion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.StartConversion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileFullPath = reader.string();
                        break;
                    }
                case 4: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 5: {
                        message.destType = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartConversion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.StartConversion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.StartConversion} StartConversion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartConversion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartConversion message.
         * @function verify
         * @memberof tdx_request.StartConversion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartConversion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                if (!$util.isString(message.fileFullPath))
                    return "fileFullPath: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                if (!$util.isInteger(message.typeOfPath))
                    return "typeOfPath: integer expected";
            if (message.destType != null && message.hasOwnProperty("destType"))
                if (!$util.isString(message.destType))
                    return "destType: string expected";
            return null;
        };

        /**
         * Creates a StartConversion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.StartConversion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.StartConversion} StartConversion
         */
        StartConversion.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.StartConversion)
                return object;
            let message = new $root.tdx_request.StartConversion();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileFullPath != null)
                message.fileFullPath = String(object.fileFullPath);
            if (object.typeOfPath != null)
                message.typeOfPath = object.typeOfPath | 0;
            if (object.destType != null)
                message.destType = String(object.destType);
            return message;
        };

        /**
         * Creates a plain object from a StartConversion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.StartConversion
         * @static
         * @param {tdx_request.StartConversion} message StartConversion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartConversion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileFullPath = "";
                object.typeOfPath = 0;
                object.destType = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                object.fileFullPath = message.fileFullPath;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = message.typeOfPath;
            if (message.destType != null && message.hasOwnProperty("destType"))
                object.destType = message.destType;
            return object;
        };

        /**
         * Converts this StartConversion to JSON.
         * @function toJSON
         * @memberof tdx_request.StartConversion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartConversion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StartConversion
         * @function getTypeUrl
         * @memberof tdx_request.StartConversion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StartConversion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.StartConversion";
        };

        return StartConversion;
    })();

    tdx_request.FileDetails = (function() {

        /**
         * Properties of a FileDetails.
         * @memberof tdx_request
         * @interface IFileDetails
         * @property {string|null} [pin] FileDetails pin
         * @property {Uint8Array|null} [data] FileDetails data
         * @property {string|null} [fileId] FileDetails fileId
         * @property {number|Long|null} [startTime] FileDetails startTime
         * @property {number|Long|null} [endTime] FileDetails endTime
         */

        /**
         * Constructs a new FileDetails.
         * @memberof tdx_request
         * @classdesc Represents a FileDetails.
         * @implements IFileDetails
         * @constructor
         * @param {tdx_request.IFileDetails=} [properties] Properties to set
         */
        function FileDetails(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileDetails pin.
         * @member {string} pin
         * @memberof tdx_request.FileDetails
         * @instance
         */
        FileDetails.prototype.pin = "";

        /**
         * FileDetails data.
         * @member {Uint8Array} data
         * @memberof tdx_request.FileDetails
         * @instance
         */
        FileDetails.prototype.data = $util.newBuffer([]);

        /**
         * FileDetails fileId.
         * @member {string} fileId
         * @memberof tdx_request.FileDetails
         * @instance
         */
        FileDetails.prototype.fileId = "";

        /**
         * FileDetails startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.FileDetails
         * @instance
         */
        FileDetails.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * FileDetails endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.FileDetails
         * @instance
         */
        FileDetails.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FileDetails instance using the specified properties.
         * @function create
         * @memberof tdx_request.FileDetails
         * @static
         * @param {tdx_request.IFileDetails=} [properties] Properties to set
         * @returns {tdx_request.FileDetails} FileDetails instance
         */
        FileDetails.create = function create(properties) {
            return new FileDetails(properties);
        };

        /**
         * Encodes the specified FileDetails message. Does not implicitly {@link tdx_request.FileDetails.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.FileDetails
         * @static
         * @param {tdx_request.IFileDetails} message FileDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified FileDetails message, length delimited. Does not implicitly {@link tdx_request.FileDetails.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.FileDetails
         * @static
         * @param {tdx_request.IFileDetails} message FileDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileDetails message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.FileDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.FileDetails} FileDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDetails.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.FileDetails();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileDetails message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.FileDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.FileDetails} FileDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileDetails message.
         * @function verify
         * @memberof tdx_request.FileDetails
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a FileDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.FileDetails
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.FileDetails} FileDetails
         */
        FileDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.FileDetails)
                return object;
            let message = new $root.tdx_request.FileDetails();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FileDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.FileDetails
         * @static
         * @param {tdx_request.FileDetails} message FileDetails
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this FileDetails to JSON.
         * @function toJSON
         * @memberof tdx_request.FileDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileDetails
         * @function getTypeUrl
         * @memberof tdx_request.FileDetails
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.FileDetails";
        };

        return FileDetails;
    })();

    tdx_request.FileSummary = (function() {

        /**
         * Properties of a FileSummary.
         * @memberof tdx_request
         * @interface IFileSummary
         * @property {string|null} [pin] FileSummary pin
         * @property {Uint8Array|null} [data] FileSummary data
         * @property {string|null} [fileId] FileSummary fileId
         * @property {number|Long|null} [startTime] FileSummary startTime
         * @property {number|Long|null} [endTime] FileSummary endTime
         */

        /**
         * Constructs a new FileSummary.
         * @memberof tdx_request
         * @classdesc Represents a FileSummary.
         * @implements IFileSummary
         * @constructor
         * @param {tdx_request.IFileSummary=} [properties] Properties to set
         */
        function FileSummary(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileSummary pin.
         * @member {string} pin
         * @memberof tdx_request.FileSummary
         * @instance
         */
        FileSummary.prototype.pin = "";

        /**
         * FileSummary data.
         * @member {Uint8Array} data
         * @memberof tdx_request.FileSummary
         * @instance
         */
        FileSummary.prototype.data = $util.newBuffer([]);

        /**
         * FileSummary fileId.
         * @member {string} fileId
         * @memberof tdx_request.FileSummary
         * @instance
         */
        FileSummary.prototype.fileId = "";

        /**
         * FileSummary startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.FileSummary
         * @instance
         */
        FileSummary.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * FileSummary endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.FileSummary
         * @instance
         */
        FileSummary.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FileSummary instance using the specified properties.
         * @function create
         * @memberof tdx_request.FileSummary
         * @static
         * @param {tdx_request.IFileSummary=} [properties] Properties to set
         * @returns {tdx_request.FileSummary} FileSummary instance
         */
        FileSummary.create = function create(properties) {
            return new FileSummary(properties);
        };

        /**
         * Encodes the specified FileSummary message. Does not implicitly {@link tdx_request.FileSummary.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.FileSummary
         * @static
         * @param {tdx_request.IFileSummary} message FileSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileSummary.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified FileSummary message, length delimited. Does not implicitly {@link tdx_request.FileSummary.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.FileSummary
         * @static
         * @param {tdx_request.IFileSummary} message FileSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileSummary.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileSummary message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.FileSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.FileSummary} FileSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileSummary.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.FileSummary();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileSummary message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.FileSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.FileSummary} FileSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileSummary.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileSummary message.
         * @function verify
         * @memberof tdx_request.FileSummary
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileSummary.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a FileSummary message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.FileSummary
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.FileSummary} FileSummary
         */
        FileSummary.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.FileSummary)
                return object;
            let message = new $root.tdx_request.FileSummary();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FileSummary message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.FileSummary
         * @static
         * @param {tdx_request.FileSummary} message FileSummary
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileSummary.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this FileSummary to JSON.
         * @function toJSON
         * @memberof tdx_request.FileSummary
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileSummary.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileSummary
         * @function getTypeUrl
         * @memberof tdx_request.FileSummary
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileSummary.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.FileSummary";
        };

        return FileSummary;
    })();

    tdx_request.LifecycleEvents = (function() {

        /**
         * Properties of a LifecycleEvents.
         * @memberof tdx_request
         * @interface ILifecycleEvents
         * @property {string|null} [pin] LifecycleEvents pin
         * @property {Uint8Array|null} [data] LifecycleEvents data
         * @property {string|null} [fileId] LifecycleEvents fileId
         * @property {number|Long|null} [startTime] LifecycleEvents startTime
         * @property {number|Long|null} [endTime] LifecycleEvents endTime
         * @property {number|null} [limit] LifecycleEvents limit
         * @property {number|null} [offset] LifecycleEvents offset
         */

        /**
         * Constructs a new LifecycleEvents.
         * @memberof tdx_request
         * @classdesc Represents a LifecycleEvents.
         * @implements ILifecycleEvents
         * @constructor
         * @param {tdx_request.ILifecycleEvents=} [properties] Properties to set
         */
        function LifecycleEvents(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LifecycleEvents pin.
         * @member {string} pin
         * @memberof tdx_request.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.pin = "";

        /**
         * LifecycleEvents data.
         * @member {Uint8Array} data
         * @memberof tdx_request.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.data = $util.newBuffer([]);

        /**
         * LifecycleEvents fileId.
         * @member {string} fileId
         * @memberof tdx_request.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.fileId = "";

        /**
         * LifecycleEvents startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * LifecycleEvents endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * LifecycleEvents limit.
         * @member {number} limit
         * @memberof tdx_request.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.limit = 0;

        /**
         * LifecycleEvents offset.
         * @member {number} offset
         * @memberof tdx_request.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.offset = 0;

        /**
         * Creates a new LifecycleEvents instance using the specified properties.
         * @function create
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {tdx_request.ILifecycleEvents=} [properties] Properties to set
         * @returns {tdx_request.LifecycleEvents} LifecycleEvents instance
         */
        LifecycleEvents.create = function create(properties) {
            return new LifecycleEvents(properties);
        };

        /**
         * Encodes the specified LifecycleEvents message. Does not implicitly {@link tdx_request.LifecycleEvents.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {tdx_request.ILifecycleEvents} message LifecycleEvents message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LifecycleEvents.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.limit);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.offset);
            return writer;
        };

        /**
         * Encodes the specified LifecycleEvents message, length delimited. Does not implicitly {@link tdx_request.LifecycleEvents.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {tdx_request.ILifecycleEvents} message LifecycleEvents message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LifecycleEvents.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LifecycleEvents message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.LifecycleEvents} LifecycleEvents
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LifecycleEvents.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.LifecycleEvents();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                case 6: {
                        message.limit = reader.uint32();
                        break;
                    }
                case 7: {
                        message.offset = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LifecycleEvents message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.LifecycleEvents} LifecycleEvents
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LifecycleEvents.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LifecycleEvents message.
         * @function verify
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LifecycleEvents.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (!$util.isInteger(message.limit))
                    return "limit: integer expected";
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (!$util.isInteger(message.offset))
                    return "offset: integer expected";
            return null;
        };

        /**
         * Creates a LifecycleEvents message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.LifecycleEvents} LifecycleEvents
         */
        LifecycleEvents.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.LifecycleEvents)
                return object;
            let message = new $root.tdx_request.LifecycleEvents();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            if (object.limit != null)
                message.limit = object.limit >>> 0;
            if (object.offset != null)
                message.offset = object.offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a LifecycleEvents message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {tdx_request.LifecycleEvents} message LifecycleEvents
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LifecycleEvents.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
                object.limit = 0;
                object.offset = 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            return object;
        };

        /**
         * Converts this LifecycleEvents to JSON.
         * @function toJSON
         * @memberof tdx_request.LifecycleEvents
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LifecycleEvents.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LifecycleEvents
         * @function getTypeUrl
         * @memberof tdx_request.LifecycleEvents
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LifecycleEvents.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.LifecycleEvents";
        };

        return LifecycleEvents;
    })();

    tdx_request.VersionHistory = (function() {

        /**
         * Properties of a VersionHistory.
         * @memberof tdx_request
         * @interface IVersionHistory
         * @property {string|null} [pin] VersionHistory pin
         * @property {Uint8Array|null} [data] VersionHistory data
         * @property {string|null} [fileId] VersionHistory fileId
         * @property {number|Long|null} [startTime] VersionHistory startTime
         * @property {number|Long|null} [endTime] VersionHistory endTime
         */

        /**
         * Constructs a new VersionHistory.
         * @memberof tdx_request
         * @classdesc Represents a VersionHistory.
         * @implements IVersionHistory
         * @constructor
         * @param {tdx_request.IVersionHistory=} [properties] Properties to set
         */
        function VersionHistory(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VersionHistory pin.
         * @member {string} pin
         * @memberof tdx_request.VersionHistory
         * @instance
         */
        VersionHistory.prototype.pin = "";

        /**
         * VersionHistory data.
         * @member {Uint8Array} data
         * @memberof tdx_request.VersionHistory
         * @instance
         */
        VersionHistory.prototype.data = $util.newBuffer([]);

        /**
         * VersionHistory fileId.
         * @member {string} fileId
         * @memberof tdx_request.VersionHistory
         * @instance
         */
        VersionHistory.prototype.fileId = "";

        /**
         * VersionHistory startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.VersionHistory
         * @instance
         */
        VersionHistory.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * VersionHistory endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.VersionHistory
         * @instance
         */
        VersionHistory.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new VersionHistory instance using the specified properties.
         * @function create
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {tdx_request.IVersionHistory=} [properties] Properties to set
         * @returns {tdx_request.VersionHistory} VersionHistory instance
         */
        VersionHistory.create = function create(properties) {
            return new VersionHistory(properties);
        };

        /**
         * Encodes the specified VersionHistory message. Does not implicitly {@link tdx_request.VersionHistory.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {tdx_request.IVersionHistory} message VersionHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VersionHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified VersionHistory message, length delimited. Does not implicitly {@link tdx_request.VersionHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {tdx_request.IVersionHistory} message VersionHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VersionHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VersionHistory message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.VersionHistory} VersionHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VersionHistory.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.VersionHistory();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VersionHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.VersionHistory} VersionHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VersionHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VersionHistory message.
         * @function verify
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VersionHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a VersionHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.VersionHistory} VersionHistory
         */
        VersionHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.VersionHistory)
                return object;
            let message = new $root.tdx_request.VersionHistory();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a VersionHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {tdx_request.VersionHistory} message VersionHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VersionHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this VersionHistory to JSON.
         * @function toJSON
         * @memberof tdx_request.VersionHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VersionHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VersionHistory
         * @function getTypeUrl
         * @memberof tdx_request.VersionHistory
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VersionHistory.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.VersionHistory";
        };

        return VersionHistory;
    })();

    tdx_request.Shares = (function() {

        /**
         * Properties of a Shares.
         * @memberof tdx_request
         * @interface IShares
         * @property {string|null} [pin] Shares pin
         * @property {Uint8Array|null} [data] Shares data
         * @property {string|null} [fileId] Shares fileId
         * @property {number|Long|null} [startTime] Shares startTime
         * @property {number|Long|null} [endTime] Shares endTime
         */

        /**
         * Constructs a new Shares.
         * @memberof tdx_request
         * @classdesc Represents a Shares.
         * @implements IShares
         * @constructor
         * @param {tdx_request.IShares=} [properties] Properties to set
         */
        function Shares(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Shares pin.
         * @member {string} pin
         * @memberof tdx_request.Shares
         * @instance
         */
        Shares.prototype.pin = "";

        /**
         * Shares data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Shares
         * @instance
         */
        Shares.prototype.data = $util.newBuffer([]);

        /**
         * Shares fileId.
         * @member {string} fileId
         * @memberof tdx_request.Shares
         * @instance
         */
        Shares.prototype.fileId = "";

        /**
         * Shares startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.Shares
         * @instance
         */
        Shares.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Shares endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.Shares
         * @instance
         */
        Shares.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Shares instance using the specified properties.
         * @function create
         * @memberof tdx_request.Shares
         * @static
         * @param {tdx_request.IShares=} [properties] Properties to set
         * @returns {tdx_request.Shares} Shares instance
         */
        Shares.create = function create(properties) {
            return new Shares(properties);
        };

        /**
         * Encodes the specified Shares message. Does not implicitly {@link tdx_request.Shares.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Shares
         * @static
         * @param {tdx_request.IShares} message Shares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Shares.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified Shares message, length delimited. Does not implicitly {@link tdx_request.Shares.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Shares
         * @static
         * @param {tdx_request.IShares} message Shares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Shares.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Shares message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Shares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Shares} Shares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Shares.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Shares();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Shares message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Shares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Shares} Shares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Shares.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Shares message.
         * @function verify
         * @memberof tdx_request.Shares
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Shares.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a Shares message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Shares
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Shares} Shares
         */
        Shares.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Shares)
                return object;
            let message = new $root.tdx_request.Shares();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Shares message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Shares
         * @static
         * @param {tdx_request.Shares} message Shares
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Shares.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this Shares to JSON.
         * @function toJSON
         * @memberof tdx_request.Shares
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Shares.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Shares
         * @function getTypeUrl
         * @memberof tdx_request.Shares
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Shares.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Shares";
        };

        return Shares;
    })();

    tdx_request.PathHistory = (function() {

        /**
         * Properties of a PathHistory.
         * @memberof tdx_request
         * @interface IPathHistory
         * @property {string|null} [pin] PathHistory pin
         * @property {Uint8Array|null} [data] PathHistory data
         * @property {string|null} [fileId] PathHistory fileId
         * @property {number|Long|null} [startTime] PathHistory startTime
         * @property {number|Long|null} [endTime] PathHistory endTime
         */

        /**
         * Constructs a new PathHistory.
         * @memberof tdx_request
         * @classdesc Represents a PathHistory.
         * @implements IPathHistory
         * @constructor
         * @param {tdx_request.IPathHistory=} [properties] Properties to set
         */
        function PathHistory(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PathHistory pin.
         * @member {string} pin
         * @memberof tdx_request.PathHistory
         * @instance
         */
        PathHistory.prototype.pin = "";

        /**
         * PathHistory data.
         * @member {Uint8Array} data
         * @memberof tdx_request.PathHistory
         * @instance
         */
        PathHistory.prototype.data = $util.newBuffer([]);

        /**
         * PathHistory fileId.
         * @member {string} fileId
         * @memberof tdx_request.PathHistory
         * @instance
         */
        PathHistory.prototype.fileId = "";

        /**
         * PathHistory startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.PathHistory
         * @instance
         */
        PathHistory.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PathHistory endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.PathHistory
         * @instance
         */
        PathHistory.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new PathHistory instance using the specified properties.
         * @function create
         * @memberof tdx_request.PathHistory
         * @static
         * @param {tdx_request.IPathHistory=} [properties] Properties to set
         * @returns {tdx_request.PathHistory} PathHistory instance
         */
        PathHistory.create = function create(properties) {
            return new PathHistory(properties);
        };

        /**
         * Encodes the specified PathHistory message. Does not implicitly {@link tdx_request.PathHistory.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.PathHistory
         * @static
         * @param {tdx_request.IPathHistory} message PathHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PathHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified PathHistory message, length delimited. Does not implicitly {@link tdx_request.PathHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.PathHistory
         * @static
         * @param {tdx_request.IPathHistory} message PathHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PathHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PathHistory message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.PathHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.PathHistory} PathHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PathHistory.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.PathHistory();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PathHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.PathHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.PathHistory} PathHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PathHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PathHistory message.
         * @function verify
         * @memberof tdx_request.PathHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PathHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a PathHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.PathHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.PathHistory} PathHistory
         */
        PathHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.PathHistory)
                return object;
            let message = new $root.tdx_request.PathHistory();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a PathHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.PathHistory
         * @static
         * @param {tdx_request.PathHistory} message PathHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PathHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this PathHistory to JSON.
         * @function toJSON
         * @memberof tdx_request.PathHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PathHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PathHistory
         * @function getTypeUrl
         * @memberof tdx_request.PathHistory
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PathHistory.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.PathHistory";
        };

        return PathHistory;
    })();

    tdx_request.ActorStats = (function() {

        /**
         * Properties of an ActorStats.
         * @memberof tdx_request
         * @interface IActorStats
         * @property {string|null} [pin] ActorStats pin
         * @property {Uint8Array|null} [data] ActorStats data
         * @property {string|null} [fileId] ActorStats fileId
         * @property {number|Long|null} [startTime] ActorStats startTime
         * @property {number|Long|null} [endTime] ActorStats endTime
         */

        /**
         * Constructs a new ActorStats.
         * @memberof tdx_request
         * @classdesc Represents an ActorStats.
         * @implements IActorStats
         * @constructor
         * @param {tdx_request.IActorStats=} [properties] Properties to set
         */
        function ActorStats(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ActorStats pin.
         * @member {string} pin
         * @memberof tdx_request.ActorStats
         * @instance
         */
        ActorStats.prototype.pin = "";

        /**
         * ActorStats data.
         * @member {Uint8Array} data
         * @memberof tdx_request.ActorStats
         * @instance
         */
        ActorStats.prototype.data = $util.newBuffer([]);

        /**
         * ActorStats fileId.
         * @member {string} fileId
         * @memberof tdx_request.ActorStats
         * @instance
         */
        ActorStats.prototype.fileId = "";

        /**
         * ActorStats startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.ActorStats
         * @instance
         */
        ActorStats.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ActorStats endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.ActorStats
         * @instance
         */
        ActorStats.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ActorStats instance using the specified properties.
         * @function create
         * @memberof tdx_request.ActorStats
         * @static
         * @param {tdx_request.IActorStats=} [properties] Properties to set
         * @returns {tdx_request.ActorStats} ActorStats instance
         */
        ActorStats.create = function create(properties) {
            return new ActorStats(properties);
        };

        /**
         * Encodes the specified ActorStats message. Does not implicitly {@link tdx_request.ActorStats.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.ActorStats
         * @static
         * @param {tdx_request.IActorStats} message ActorStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActorStats.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified ActorStats message, length delimited. Does not implicitly {@link tdx_request.ActorStats.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.ActorStats
         * @static
         * @param {tdx_request.IActorStats} message ActorStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActorStats.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ActorStats message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.ActorStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.ActorStats} ActorStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActorStats.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.ActorStats();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ActorStats message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.ActorStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.ActorStats} ActorStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActorStats.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ActorStats message.
         * @function verify
         * @memberof tdx_request.ActorStats
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ActorStats.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates an ActorStats message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.ActorStats
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.ActorStats} ActorStats
         */
        ActorStats.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.ActorStats)
                return object;
            let message = new $root.tdx_request.ActorStats();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an ActorStats message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.ActorStats
         * @static
         * @param {tdx_request.ActorStats} message ActorStats
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ActorStats.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this ActorStats to JSON.
         * @function toJSON
         * @memberof tdx_request.ActorStats
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ActorStats.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ActorStats
         * @function getTypeUrl
         * @memberof tdx_request.ActorStats
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ActorStats.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.ActorStats";
        };

        return ActorStats;
    })();

    tdx_request.CountryStats = (function() {

        /**
         * Properties of a CountryStats.
         * @memberof tdx_request
         * @interface ICountryStats
         * @property {string|null} [pin] CountryStats pin
         * @property {Uint8Array|null} [data] CountryStats data
         * @property {string|null} [fileId] CountryStats fileId
         * @property {number|Long|null} [startTime] CountryStats startTime
         * @property {number|Long|null} [endTime] CountryStats endTime
         */

        /**
         * Constructs a new CountryStats.
         * @memberof tdx_request
         * @classdesc Represents a CountryStats.
         * @implements ICountryStats
         * @constructor
         * @param {tdx_request.ICountryStats=} [properties] Properties to set
         */
        function CountryStats(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CountryStats pin.
         * @member {string} pin
         * @memberof tdx_request.CountryStats
         * @instance
         */
        CountryStats.prototype.pin = "";

        /**
         * CountryStats data.
         * @member {Uint8Array} data
         * @memberof tdx_request.CountryStats
         * @instance
         */
        CountryStats.prototype.data = $util.newBuffer([]);

        /**
         * CountryStats fileId.
         * @member {string} fileId
         * @memberof tdx_request.CountryStats
         * @instance
         */
        CountryStats.prototype.fileId = "";

        /**
         * CountryStats startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.CountryStats
         * @instance
         */
        CountryStats.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CountryStats endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.CountryStats
         * @instance
         */
        CountryStats.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CountryStats instance using the specified properties.
         * @function create
         * @memberof tdx_request.CountryStats
         * @static
         * @param {tdx_request.ICountryStats=} [properties] Properties to set
         * @returns {tdx_request.CountryStats} CountryStats instance
         */
        CountryStats.create = function create(properties) {
            return new CountryStats(properties);
        };

        /**
         * Encodes the specified CountryStats message. Does not implicitly {@link tdx_request.CountryStats.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.CountryStats
         * @static
         * @param {tdx_request.ICountryStats} message CountryStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CountryStats.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileId);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified CountryStats message, length delimited. Does not implicitly {@link tdx_request.CountryStats.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.CountryStats
         * @static
         * @param {tdx_request.ICountryStats} message CountryStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CountryStats.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CountryStats message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.CountryStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.CountryStats} CountryStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CountryStats.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.CountryStats();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileId = reader.string();
                        break;
                    }
                case 4: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CountryStats message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.CountryStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.CountryStats} CountryStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CountryStats.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CountryStats message.
         * @function verify
         * @memberof tdx_request.CountryStats
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CountryStats.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a CountryStats message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.CountryStats
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.CountryStats} CountryStats
         */
        CountryStats.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.CountryStats)
                return object;
            let message = new $root.tdx_request.CountryStats();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CountryStats message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.CountryStats
         * @static
         * @param {tdx_request.CountryStats} message CountryStats
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CountryStats.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this CountryStats to JSON.
         * @function toJSON
         * @memberof tdx_request.CountryStats
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CountryStats.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CountryStats
         * @function getTypeUrl
         * @memberof tdx_request.CountryStats
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CountryStats.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.CountryStats";
        };

        return CountryStats;
    })();

    tdx_request.GetChunkFromYSentinel = (function() {

        /**
         * Properties of a GetChunkFromYSentinel.
         * @memberof tdx_request
         * @interface IGetChunkFromYSentinel
         * @property {string|null} [pin] GetChunkFromYSentinel pin
         * @property {Uint8Array|null} [data] GetChunkFromYSentinel data
         * @property {string|null} [fileName] GetChunkFromYSentinel fileName
         * @property {number|Long|null} [offset] GetChunkFromYSentinel offset
         */

        /**
         * Constructs a new GetChunkFromYSentinel.
         * @memberof tdx_request
         * @classdesc Represents a GetChunkFromYSentinel.
         * @implements IGetChunkFromYSentinel
         * @constructor
         * @param {tdx_request.IGetChunkFromYSentinel=} [properties] Properties to set
         */
        function GetChunkFromYSentinel(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetChunkFromYSentinel pin.
         * @member {string} pin
         * @memberof tdx_request.GetChunkFromYSentinel
         * @instance
         */
        GetChunkFromYSentinel.prototype.pin = "";

        /**
         * GetChunkFromYSentinel data.
         * @member {Uint8Array} data
         * @memberof tdx_request.GetChunkFromYSentinel
         * @instance
         */
        GetChunkFromYSentinel.prototype.data = $util.newBuffer([]);

        /**
         * GetChunkFromYSentinel fileName.
         * @member {string} fileName
         * @memberof tdx_request.GetChunkFromYSentinel
         * @instance
         */
        GetChunkFromYSentinel.prototype.fileName = "";

        /**
         * GetChunkFromYSentinel offset.
         * @member {number|Long} offset
         * @memberof tdx_request.GetChunkFromYSentinel
         * @instance
         */
        GetChunkFromYSentinel.prototype.offset = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetChunkFromYSentinel instance using the specified properties.
         * @function create
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {tdx_request.IGetChunkFromYSentinel=} [properties] Properties to set
         * @returns {tdx_request.GetChunkFromYSentinel} GetChunkFromYSentinel instance
         */
        GetChunkFromYSentinel.create = function create(properties) {
            return new GetChunkFromYSentinel(properties);
        };

        /**
         * Encodes the specified GetChunkFromYSentinel message. Does not implicitly {@link tdx_request.GetChunkFromYSentinel.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {tdx_request.IGetChunkFromYSentinel} message GetChunkFromYSentinel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunkFromYSentinel.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileName);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.offset);
            return writer;
        };

        /**
         * Encodes the specified GetChunkFromYSentinel message, length delimited. Does not implicitly {@link tdx_request.GetChunkFromYSentinel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {tdx_request.IGetChunkFromYSentinel} message GetChunkFromYSentinel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunkFromYSentinel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetChunkFromYSentinel message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.GetChunkFromYSentinel} GetChunkFromYSentinel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunkFromYSentinel.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.GetChunkFromYSentinel();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileName = reader.string();
                        break;
                    }
                case 4: {
                        message.offset = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetChunkFromYSentinel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.GetChunkFromYSentinel} GetChunkFromYSentinel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunkFromYSentinel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetChunkFromYSentinel message.
         * @function verify
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetChunkFromYSentinel.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (!$util.isInteger(message.offset) && !(message.offset && $util.isInteger(message.offset.low) && $util.isInteger(message.offset.high)))
                    return "offset: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetChunkFromYSentinel message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.GetChunkFromYSentinel} GetChunkFromYSentinel
         */
        GetChunkFromYSentinel.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.GetChunkFromYSentinel)
                return object;
            let message = new $root.tdx_request.GetChunkFromYSentinel();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.offset != null)
                if ($util.Long)
                    (message.offset = $util.Long.fromValue(object.offset)).unsigned = true;
                else if (typeof object.offset === "string")
                    message.offset = parseInt(object.offset, 10);
                else if (typeof object.offset === "number")
                    message.offset = object.offset;
                else if (typeof object.offset === "object")
                    message.offset = new $util.LongBits(object.offset.low >>> 0, object.offset.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetChunkFromYSentinel message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {tdx_request.GetChunkFromYSentinel} message GetChunkFromYSentinel
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetChunkFromYSentinel.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.fileName = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.offset = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.offset = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (typeof message.offset === "number")
                    object.offset = options.longs === String ? String(message.offset) : message.offset;
                else
                    object.offset = options.longs === String ? $util.Long.prototype.toString.call(message.offset) : options.longs === Number ? new $util.LongBits(message.offset.low >>> 0, message.offset.high >>> 0).toNumber(true) : message.offset;
            return object;
        };

        /**
         * Converts this GetChunkFromYSentinel to JSON.
         * @function toJSON
         * @memberof tdx_request.GetChunkFromYSentinel
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetChunkFromYSentinel.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetChunkFromYSentinel
         * @function getTypeUrl
         * @memberof tdx_request.GetChunkFromYSentinel
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetChunkFromYSentinel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.GetChunkFromYSentinel";
        };

        return GetChunkFromYSentinel;
    })();

    tdx_request.ListFilesForDashboard = (function() {

        /**
         * Properties of a ListFilesForDashboard.
         * @memberof tdx_request
         * @interface IListFilesForDashboard
         * @property {string|null} [pin] ListFilesForDashboard pin
         * @property {Uint8Array|null} [data] ListFilesForDashboard data
         * @property {number|Long|null} [startTime] ListFilesForDashboard startTime
         * @property {number|Long|null} [endTime] ListFilesForDashboard endTime
         * @property {string|null} [query] ListFilesForDashboard query
         * @property {string|null} [ownerEmail] ListFilesForDashboard ownerEmail
         * @property {string|null} [sharedTeam] ListFilesForDashboard sharedTeam
         * @property {Array.<string>|null} [fileTypes] ListFilesForDashboard fileTypes
         * @property {number|null} [minSizeMb] ListFilesForDashboard minSizeMb
         * @property {number|null} [maxSizeMb] ListFilesForDashboard maxSizeMb
         * @property {number|Long|null} [modifiedFrom] ListFilesForDashboard modifiedFrom
         * @property {number|Long|null} [modifiedTo] ListFilesForDashboard modifiedTo
         */

        /**
         * Constructs a new ListFilesForDashboard.
         * @memberof tdx_request
         * @classdesc Represents a ListFilesForDashboard.
         * @implements IListFilesForDashboard
         * @constructor
         * @param {tdx_request.IListFilesForDashboard=} [properties] Properties to set
         */
        function ListFilesForDashboard(properties) {
            this.fileTypes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFilesForDashboard pin.
         * @member {string} pin
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.pin = "";

        /**
         * ListFilesForDashboard data.
         * @member {Uint8Array} data
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.data = $util.newBuffer([]);

        /**
         * ListFilesForDashboard startTime.
         * @member {number|Long} startTime
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListFilesForDashboard endTime.
         * @member {number|Long} endTime
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListFilesForDashboard query.
         * @member {string} query
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.query = "";

        /**
         * ListFilesForDashboard ownerEmail.
         * @member {string} ownerEmail
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.ownerEmail = "";

        /**
         * ListFilesForDashboard sharedTeam.
         * @member {string} sharedTeam
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.sharedTeam = "";

        /**
         * ListFilesForDashboard fileTypes.
         * @member {Array.<string>} fileTypes
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.fileTypes = $util.emptyArray;

        /**
         * ListFilesForDashboard minSizeMb.
         * @member {number} minSizeMb
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.minSizeMb = 0;

        /**
         * ListFilesForDashboard maxSizeMb.
         * @member {number} maxSizeMb
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.maxSizeMb = 0;

        /**
         * ListFilesForDashboard modifiedFrom.
         * @member {number|Long} modifiedFrom
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.modifiedFrom = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ListFilesForDashboard modifiedTo.
         * @member {number|Long} modifiedTo
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.modifiedTo = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ListFilesForDashboard instance using the specified properties.
         * @function create
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {tdx_request.IListFilesForDashboard=} [properties] Properties to set
         * @returns {tdx_request.ListFilesForDashboard} ListFilesForDashboard instance
         */
        ListFilesForDashboard.create = function create(properties) {
            return new ListFilesForDashboard(properties);
        };

        /**
         * Encodes the specified ListFilesForDashboard message. Does not implicitly {@link tdx_request.ListFilesForDashboard.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {tdx_request.IListFilesForDashboard} message ListFilesForDashboard message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFilesForDashboard.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.endTime);
            if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.query);
            if (message.ownerEmail != null && Object.hasOwnProperty.call(message, "ownerEmail"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.ownerEmail);
            if (message.sharedTeam != null && Object.hasOwnProperty.call(message, "sharedTeam"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.sharedTeam);
            if (message.fileTypes != null && message.fileTypes.length)
                for (let i = 0; i < message.fileTypes.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.fileTypes[i]);
            if (message.minSizeMb != null && Object.hasOwnProperty.call(message, "minSizeMb"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.minSizeMb);
            if (message.maxSizeMb != null && Object.hasOwnProperty.call(message, "maxSizeMb"))
                writer.uint32(/* id 10, wireType 1 =*/81).double(message.maxSizeMb);
            if (message.modifiedFrom != null && Object.hasOwnProperty.call(message, "modifiedFrom"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.modifiedFrom);
            if (message.modifiedTo != null && Object.hasOwnProperty.call(message, "modifiedTo"))
                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.modifiedTo);
            return writer;
        };

        /**
         * Encodes the specified ListFilesForDashboard message, length delimited. Does not implicitly {@link tdx_request.ListFilesForDashboard.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {tdx_request.IListFilesForDashboard} message ListFilesForDashboard message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFilesForDashboard.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListFilesForDashboard message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.ListFilesForDashboard} ListFilesForDashboard
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFilesForDashboard.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.ListFilesForDashboard();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.endTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.query = reader.string();
                        break;
                    }
                case 6: {
                        message.ownerEmail = reader.string();
                        break;
                    }
                case 7: {
                        message.sharedTeam = reader.string();
                        break;
                    }
                case 8: {
                        if (!(message.fileTypes && message.fileTypes.length))
                            message.fileTypes = [];
                        message.fileTypes.push(reader.string());
                        break;
                    }
                case 9: {
                        message.minSizeMb = reader.double();
                        break;
                    }
                case 10: {
                        message.maxSizeMb = reader.double();
                        break;
                    }
                case 11: {
                        message.modifiedFrom = reader.int64();
                        break;
                    }
                case 12: {
                        message.modifiedTo = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListFilesForDashboard message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.ListFilesForDashboard} ListFilesForDashboard
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFilesForDashboard.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListFilesForDashboard message.
         * @function verify
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListFilesForDashboard.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            if (message.query != null && message.hasOwnProperty("query"))
                if (!$util.isString(message.query))
                    return "query: string expected";
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                if (!$util.isString(message.ownerEmail))
                    return "ownerEmail: string expected";
            if (message.sharedTeam != null && message.hasOwnProperty("sharedTeam"))
                if (!$util.isString(message.sharedTeam))
                    return "sharedTeam: string expected";
            if (message.fileTypes != null && message.hasOwnProperty("fileTypes")) {
                if (!Array.isArray(message.fileTypes))
                    return "fileTypes: array expected";
                for (let i = 0; i < message.fileTypes.length; ++i)
                    if (!$util.isString(message.fileTypes[i]))
                        return "fileTypes: string[] expected";
            }
            if (message.minSizeMb != null && message.hasOwnProperty("minSizeMb"))
                if (typeof message.minSizeMb !== "number")
                    return "minSizeMb: number expected";
            if (message.maxSizeMb != null && message.hasOwnProperty("maxSizeMb"))
                if (typeof message.maxSizeMb !== "number")
                    return "maxSizeMb: number expected";
            if (message.modifiedFrom != null && message.hasOwnProperty("modifiedFrom"))
                if (!$util.isInteger(message.modifiedFrom) && !(message.modifiedFrom && $util.isInteger(message.modifiedFrom.low) && $util.isInteger(message.modifiedFrom.high)))
                    return "modifiedFrom: integer|Long expected";
            if (message.modifiedTo != null && message.hasOwnProperty("modifiedTo"))
                if (!$util.isInteger(message.modifiedTo) && !(message.modifiedTo && $util.isInteger(message.modifiedTo.low) && $util.isInteger(message.modifiedTo.high)))
                    return "modifiedTo: integer|Long expected";
            return null;
        };

        /**
         * Creates a ListFilesForDashboard message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.ListFilesForDashboard} ListFilesForDashboard
         */
        ListFilesForDashboard.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.ListFilesForDashboard)
                return object;
            let message = new $root.tdx_request.ListFilesForDashboard();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            if (object.query != null)
                message.query = String(object.query);
            if (object.ownerEmail != null)
                message.ownerEmail = String(object.ownerEmail);
            if (object.sharedTeam != null)
                message.sharedTeam = String(object.sharedTeam);
            if (object.fileTypes) {
                if (!Array.isArray(object.fileTypes))
                    throw TypeError(".tdx_request.ListFilesForDashboard.fileTypes: array expected");
                message.fileTypes = [];
                for (let i = 0; i < object.fileTypes.length; ++i)
                    message.fileTypes[i] = String(object.fileTypes[i]);
            }
            if (object.minSizeMb != null)
                message.minSizeMb = Number(object.minSizeMb);
            if (object.maxSizeMb != null)
                message.maxSizeMb = Number(object.maxSizeMb);
            if (object.modifiedFrom != null)
                if ($util.Long)
                    (message.modifiedFrom = $util.Long.fromValue(object.modifiedFrom)).unsigned = false;
                else if (typeof object.modifiedFrom === "string")
                    message.modifiedFrom = parseInt(object.modifiedFrom, 10);
                else if (typeof object.modifiedFrom === "number")
                    message.modifiedFrom = object.modifiedFrom;
                else if (typeof object.modifiedFrom === "object")
                    message.modifiedFrom = new $util.LongBits(object.modifiedFrom.low >>> 0, object.modifiedFrom.high >>> 0).toNumber();
            if (object.modifiedTo != null)
                if ($util.Long)
                    (message.modifiedTo = $util.Long.fromValue(object.modifiedTo)).unsigned = false;
                else if (typeof object.modifiedTo === "string")
                    message.modifiedTo = parseInt(object.modifiedTo, 10);
                else if (typeof object.modifiedTo === "number")
                    message.modifiedTo = object.modifiedTo;
                else if (typeof object.modifiedTo === "object")
                    message.modifiedTo = new $util.LongBits(object.modifiedTo.low >>> 0, object.modifiedTo.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a ListFilesForDashboard message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {tdx_request.ListFilesForDashboard} message ListFilesForDashboard
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFilesForDashboard.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.fileTypes = [];
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
                object.query = "";
                object.ownerEmail = "";
                object.sharedTeam = "";
                object.minSizeMb = 0;
                object.maxSizeMb = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.modifiedFrom = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.modifiedFrom = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.modifiedTo = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.modifiedTo = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            if (message.query != null && message.hasOwnProperty("query"))
                object.query = message.query;
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                object.ownerEmail = message.ownerEmail;
            if (message.sharedTeam != null && message.hasOwnProperty("sharedTeam"))
                object.sharedTeam = message.sharedTeam;
            if (message.fileTypes && message.fileTypes.length) {
                object.fileTypes = [];
                for (let j = 0; j < message.fileTypes.length; ++j)
                    object.fileTypes[j] = message.fileTypes[j];
            }
            if (message.minSizeMb != null && message.hasOwnProperty("minSizeMb"))
                object.minSizeMb = options.json && !isFinite(message.minSizeMb) ? String(message.minSizeMb) : message.minSizeMb;
            if (message.maxSizeMb != null && message.hasOwnProperty("maxSizeMb"))
                object.maxSizeMb = options.json && !isFinite(message.maxSizeMb) ? String(message.maxSizeMb) : message.maxSizeMb;
            if (message.modifiedFrom != null && message.hasOwnProperty("modifiedFrom"))
                if (typeof message.modifiedFrom === "number")
                    object.modifiedFrom = options.longs === String ? String(message.modifiedFrom) : message.modifiedFrom;
                else
                    object.modifiedFrom = options.longs === String ? $util.Long.prototype.toString.call(message.modifiedFrom) : options.longs === Number ? new $util.LongBits(message.modifiedFrom.low >>> 0, message.modifiedFrom.high >>> 0).toNumber() : message.modifiedFrom;
            if (message.modifiedTo != null && message.hasOwnProperty("modifiedTo"))
                if (typeof message.modifiedTo === "number")
                    object.modifiedTo = options.longs === String ? String(message.modifiedTo) : message.modifiedTo;
                else
                    object.modifiedTo = options.longs === String ? $util.Long.prototype.toString.call(message.modifiedTo) : options.longs === Number ? new $util.LongBits(message.modifiedTo.low >>> 0, message.modifiedTo.high >>> 0).toNumber() : message.modifiedTo;
            return object;
        };

        /**
         * Converts this ListFilesForDashboard to JSON.
         * @function toJSON
         * @memberof tdx_request.ListFilesForDashboard
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFilesForDashboard.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListFilesForDashboard
         * @function getTypeUrl
         * @memberof tdx_request.ListFilesForDashboard
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListFilesForDashboard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.ListFilesForDashboard";
        };

        return ListFilesForDashboard;
    })();

    tdx_request.TopMovers = (function() {

        /**
         * Properties of a TopMovers.
         * @memberof tdx_request
         * @interface ITopMovers
         * @property {string|null} [pin] TopMovers pin
         * @property {Uint8Array|null} [data] TopMovers data
         * @property {number|Long|null} [startDate] TopMovers startDate
         * @property {number|Long|null} [endDate] TopMovers endDate
         */

        /**
         * Constructs a new TopMovers.
         * @memberof tdx_request
         * @classdesc Represents a TopMovers.
         * @implements ITopMovers
         * @constructor
         * @param {tdx_request.ITopMovers=} [properties] Properties to set
         */
        function TopMovers(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TopMovers pin.
         * @member {string} pin
         * @memberof tdx_request.TopMovers
         * @instance
         */
        TopMovers.prototype.pin = "";

        /**
         * TopMovers data.
         * @member {Uint8Array} data
         * @memberof tdx_request.TopMovers
         * @instance
         */
        TopMovers.prototype.data = $util.newBuffer([]);

        /**
         * TopMovers startDate.
         * @member {number|Long} startDate
         * @memberof tdx_request.TopMovers
         * @instance
         */
        TopMovers.prototype.startDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * TopMovers endDate.
         * @member {number|Long} endDate
         * @memberof tdx_request.TopMovers
         * @instance
         */
        TopMovers.prototype.endDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new TopMovers instance using the specified properties.
         * @function create
         * @memberof tdx_request.TopMovers
         * @static
         * @param {tdx_request.ITopMovers=} [properties] Properties to set
         * @returns {tdx_request.TopMovers} TopMovers instance
         */
        TopMovers.create = function create(properties) {
            return new TopMovers(properties);
        };

        /**
         * Encodes the specified TopMovers message. Does not implicitly {@link tdx_request.TopMovers.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.TopMovers
         * @static
         * @param {tdx_request.ITopMovers} message TopMovers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopMovers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.startDate);
            if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.endDate);
            return writer;
        };

        /**
         * Encodes the specified TopMovers message, length delimited. Does not implicitly {@link tdx_request.TopMovers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.TopMovers
         * @static
         * @param {tdx_request.ITopMovers} message TopMovers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopMovers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TopMovers message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.TopMovers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.TopMovers} TopMovers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopMovers.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.TopMovers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.startDate = reader.uint64();
                        break;
                    }
                case 4: {
                        message.endDate = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TopMovers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.TopMovers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.TopMovers} TopMovers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopMovers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TopMovers message.
         * @function verify
         * @memberof tdx_request.TopMovers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TopMovers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.startDate != null && message.hasOwnProperty("startDate"))
                if (!$util.isInteger(message.startDate) && !(message.startDate && $util.isInteger(message.startDate.low) && $util.isInteger(message.startDate.high)))
                    return "startDate: integer|Long expected";
            if (message.endDate != null && message.hasOwnProperty("endDate"))
                if (!$util.isInteger(message.endDate) && !(message.endDate && $util.isInteger(message.endDate.low) && $util.isInteger(message.endDate.high)))
                    return "endDate: integer|Long expected";
            return null;
        };

        /**
         * Creates a TopMovers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.TopMovers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.TopMovers} TopMovers
         */
        TopMovers.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.TopMovers)
                return object;
            let message = new $root.tdx_request.TopMovers();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.startDate != null)
                if ($util.Long)
                    (message.startDate = $util.Long.fromValue(object.startDate)).unsigned = true;
                else if (typeof object.startDate === "string")
                    message.startDate = parseInt(object.startDate, 10);
                else if (typeof object.startDate === "number")
                    message.startDate = object.startDate;
                else if (typeof object.startDate === "object")
                    message.startDate = new $util.LongBits(object.startDate.low >>> 0, object.startDate.high >>> 0).toNumber(true);
            if (object.endDate != null)
                if ($util.Long)
                    (message.endDate = $util.Long.fromValue(object.endDate)).unsigned = true;
                else if (typeof object.endDate === "string")
                    message.endDate = parseInt(object.endDate, 10);
                else if (typeof object.endDate === "number")
                    message.endDate = object.endDate;
                else if (typeof object.endDate === "object")
                    message.endDate = new $util.LongBits(object.endDate.low >>> 0, object.endDate.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a TopMovers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.TopMovers
         * @static
         * @param {tdx_request.TopMovers} message TopMovers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TopMovers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startDate = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endDate = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.startDate != null && message.hasOwnProperty("startDate"))
                if (typeof message.startDate === "number")
                    object.startDate = options.longs === String ? String(message.startDate) : message.startDate;
                else
                    object.startDate = options.longs === String ? $util.Long.prototype.toString.call(message.startDate) : options.longs === Number ? new $util.LongBits(message.startDate.low >>> 0, message.startDate.high >>> 0).toNumber(true) : message.startDate;
            if (message.endDate != null && message.hasOwnProperty("endDate"))
                if (typeof message.endDate === "number")
                    object.endDate = options.longs === String ? String(message.endDate) : message.endDate;
                else
                    object.endDate = options.longs === String ? $util.Long.prototype.toString.call(message.endDate) : options.longs === Number ? new $util.LongBits(message.endDate.low >>> 0, message.endDate.high >>> 0).toNumber(true) : message.endDate;
            return object;
        };

        /**
         * Converts this TopMovers to JSON.
         * @function toJSON
         * @memberof tdx_request.TopMovers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TopMovers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TopMovers
         * @function getTypeUrl
         * @memberof tdx_request.TopMovers
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TopMovers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.TopMovers";
        };

        return TopMovers;
    })();

    tdx_request.OperationCountOverTime = (function() {

        /**
         * Properties of an OperationCountOverTime.
         * @memberof tdx_request
         * @interface IOperationCountOverTime
         * @property {string|null} [pin] OperationCountOverTime pin
         * @property {Uint8Array|null} [data] OperationCountOverTime data
         * @property {number|Long|null} [startDate] OperationCountOverTime startDate
         * @property {number|Long|null} [endDate] OperationCountOverTime endDate
         */

        /**
         * Constructs a new OperationCountOverTime.
         * @memberof tdx_request
         * @classdesc Represents an OperationCountOverTime.
         * @implements IOperationCountOverTime
         * @constructor
         * @param {tdx_request.IOperationCountOverTime=} [properties] Properties to set
         */
        function OperationCountOverTime(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OperationCountOverTime pin.
         * @member {string} pin
         * @memberof tdx_request.OperationCountOverTime
         * @instance
         */
        OperationCountOverTime.prototype.pin = "";

        /**
         * OperationCountOverTime data.
         * @member {Uint8Array} data
         * @memberof tdx_request.OperationCountOverTime
         * @instance
         */
        OperationCountOverTime.prototype.data = $util.newBuffer([]);

        /**
         * OperationCountOverTime startDate.
         * @member {number|Long} startDate
         * @memberof tdx_request.OperationCountOverTime
         * @instance
         */
        OperationCountOverTime.prototype.startDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * OperationCountOverTime endDate.
         * @member {number|Long} endDate
         * @memberof tdx_request.OperationCountOverTime
         * @instance
         */
        OperationCountOverTime.prototype.endDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new OperationCountOverTime instance using the specified properties.
         * @function create
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {tdx_request.IOperationCountOverTime=} [properties] Properties to set
         * @returns {tdx_request.OperationCountOverTime} OperationCountOverTime instance
         */
        OperationCountOverTime.create = function create(properties) {
            return new OperationCountOverTime(properties);
        };

        /**
         * Encodes the specified OperationCountOverTime message. Does not implicitly {@link tdx_request.OperationCountOverTime.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {tdx_request.IOperationCountOverTime} message OperationCountOverTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperationCountOverTime.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.startDate);
            if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.endDate);
            return writer;
        };

        /**
         * Encodes the specified OperationCountOverTime message, length delimited. Does not implicitly {@link tdx_request.OperationCountOverTime.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {tdx_request.IOperationCountOverTime} message OperationCountOverTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperationCountOverTime.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OperationCountOverTime message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.OperationCountOverTime} OperationCountOverTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperationCountOverTime.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.OperationCountOverTime();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.startDate = reader.uint64();
                        break;
                    }
                case 4: {
                        message.endDate = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OperationCountOverTime message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.OperationCountOverTime} OperationCountOverTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperationCountOverTime.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OperationCountOverTime message.
         * @function verify
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OperationCountOverTime.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.startDate != null && message.hasOwnProperty("startDate"))
                if (!$util.isInteger(message.startDate) && !(message.startDate && $util.isInteger(message.startDate.low) && $util.isInteger(message.startDate.high)))
                    return "startDate: integer|Long expected";
            if (message.endDate != null && message.hasOwnProperty("endDate"))
                if (!$util.isInteger(message.endDate) && !(message.endDate && $util.isInteger(message.endDate.low) && $util.isInteger(message.endDate.high)))
                    return "endDate: integer|Long expected";
            return null;
        };

        /**
         * Creates an OperationCountOverTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.OperationCountOverTime} OperationCountOverTime
         */
        OperationCountOverTime.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.OperationCountOverTime)
                return object;
            let message = new $root.tdx_request.OperationCountOverTime();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.startDate != null)
                if ($util.Long)
                    (message.startDate = $util.Long.fromValue(object.startDate)).unsigned = true;
                else if (typeof object.startDate === "string")
                    message.startDate = parseInt(object.startDate, 10);
                else if (typeof object.startDate === "number")
                    message.startDate = object.startDate;
                else if (typeof object.startDate === "object")
                    message.startDate = new $util.LongBits(object.startDate.low >>> 0, object.startDate.high >>> 0).toNumber(true);
            if (object.endDate != null)
                if ($util.Long)
                    (message.endDate = $util.Long.fromValue(object.endDate)).unsigned = true;
                else if (typeof object.endDate === "string")
                    message.endDate = parseInt(object.endDate, 10);
                else if (typeof object.endDate === "number")
                    message.endDate = object.endDate;
                else if (typeof object.endDate === "object")
                    message.endDate = new $util.LongBits(object.endDate.low >>> 0, object.endDate.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an OperationCountOverTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {tdx_request.OperationCountOverTime} message OperationCountOverTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OperationCountOverTime.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startDate = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endDate = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.startDate != null && message.hasOwnProperty("startDate"))
                if (typeof message.startDate === "number")
                    object.startDate = options.longs === String ? String(message.startDate) : message.startDate;
                else
                    object.startDate = options.longs === String ? $util.Long.prototype.toString.call(message.startDate) : options.longs === Number ? new $util.LongBits(message.startDate.low >>> 0, message.startDate.high >>> 0).toNumber(true) : message.startDate;
            if (message.endDate != null && message.hasOwnProperty("endDate"))
                if (typeof message.endDate === "number")
                    object.endDate = options.longs === String ? String(message.endDate) : message.endDate;
                else
                    object.endDate = options.longs === String ? $util.Long.prototype.toString.call(message.endDate) : options.longs === Number ? new $util.LongBits(message.endDate.low >>> 0, message.endDate.high >>> 0).toNumber(true) : message.endDate;
            return object;
        };

        /**
         * Converts this OperationCountOverTime to JSON.
         * @function toJSON
         * @memberof tdx_request.OperationCountOverTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OperationCountOverTime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OperationCountOverTime
         * @function getTypeUrl
         * @memberof tdx_request.OperationCountOverTime
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OperationCountOverTime.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.OperationCountOverTime";
        };

        return OperationCountOverTime;
    })();

    tdx_request.StorageDistribution = (function() {

        /**
         * Properties of a StorageDistribution.
         * @memberof tdx_request
         * @interface IStorageDistribution
         * @property {string|null} [pin] StorageDistribution pin
         * @property {Uint8Array|null} [data] StorageDistribution data
         * @property {number|Long|null} [fromTime] StorageDistribution fromTime
         * @property {number|Long|null} [toTime] StorageDistribution toTime
         */

        /**
         * Constructs a new StorageDistribution.
         * @memberof tdx_request
         * @classdesc Represents a StorageDistribution.
         * @implements IStorageDistribution
         * @constructor
         * @param {tdx_request.IStorageDistribution=} [properties] Properties to set
         */
        function StorageDistribution(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StorageDistribution pin.
         * @member {string} pin
         * @memberof tdx_request.StorageDistribution
         * @instance
         */
        StorageDistribution.prototype.pin = "";

        /**
         * StorageDistribution data.
         * @member {Uint8Array} data
         * @memberof tdx_request.StorageDistribution
         * @instance
         */
        StorageDistribution.prototype.data = $util.newBuffer([]);

        /**
         * StorageDistribution fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.StorageDistribution
         * @instance
         */
        StorageDistribution.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StorageDistribution toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.StorageDistribution
         * @instance
         */
        StorageDistribution.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new StorageDistribution instance using the specified properties.
         * @function create
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {tdx_request.IStorageDistribution=} [properties] Properties to set
         * @returns {tdx_request.StorageDistribution} StorageDistribution instance
         */
        StorageDistribution.create = function create(properties) {
            return new StorageDistribution(properties);
        };

        /**
         * Encodes the specified StorageDistribution message. Does not implicitly {@link tdx_request.StorageDistribution.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {tdx_request.IStorageDistribution} message StorageDistribution message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageDistribution.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            return writer;
        };

        /**
         * Encodes the specified StorageDistribution message, length delimited. Does not implicitly {@link tdx_request.StorageDistribution.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {tdx_request.IStorageDistribution} message StorageDistribution message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageDistribution.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StorageDistribution message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.StorageDistribution} StorageDistribution
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageDistribution.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.StorageDistribution();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StorageDistribution message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.StorageDistribution} StorageDistribution
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageDistribution.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StorageDistribution message.
         * @function verify
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StorageDistribution.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a StorageDistribution message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.StorageDistribution} StorageDistribution
         */
        StorageDistribution.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.StorageDistribution)
                return object;
            let message = new $root.tdx_request.StorageDistribution();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a StorageDistribution message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {tdx_request.StorageDistribution} message StorageDistribution
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StorageDistribution.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            return object;
        };

        /**
         * Converts this StorageDistribution to JSON.
         * @function toJSON
         * @memberof tdx_request.StorageDistribution
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StorageDistribution.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StorageDistribution
         * @function getTypeUrl
         * @memberof tdx_request.StorageDistribution
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StorageDistribution.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.StorageDistribution";
        };

        return StorageDistribution;
    })();

    tdx_request.AccessByLocation = (function() {

        /**
         * Properties of an AccessByLocation.
         * @memberof tdx_request
         * @interface IAccessByLocation
         * @property {string|null} [pin] AccessByLocation pin
         * @property {Uint8Array|null} [data] AccessByLocation data
         * @property {number|Long|null} [fromTime] AccessByLocation fromTime
         * @property {number|Long|null} [toTime] AccessByLocation toTime
         */

        /**
         * Constructs a new AccessByLocation.
         * @memberof tdx_request
         * @classdesc Represents an AccessByLocation.
         * @implements IAccessByLocation
         * @constructor
         * @param {tdx_request.IAccessByLocation=} [properties] Properties to set
         */
        function AccessByLocation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AccessByLocation pin.
         * @member {string} pin
         * @memberof tdx_request.AccessByLocation
         * @instance
         */
        AccessByLocation.prototype.pin = "";

        /**
         * AccessByLocation data.
         * @member {Uint8Array} data
         * @memberof tdx_request.AccessByLocation
         * @instance
         */
        AccessByLocation.prototype.data = $util.newBuffer([]);

        /**
         * AccessByLocation fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.AccessByLocation
         * @instance
         */
        AccessByLocation.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AccessByLocation toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.AccessByLocation
         * @instance
         */
        AccessByLocation.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new AccessByLocation instance using the specified properties.
         * @function create
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {tdx_request.IAccessByLocation=} [properties] Properties to set
         * @returns {tdx_request.AccessByLocation} AccessByLocation instance
         */
        AccessByLocation.create = function create(properties) {
            return new AccessByLocation(properties);
        };

        /**
         * Encodes the specified AccessByLocation message. Does not implicitly {@link tdx_request.AccessByLocation.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {tdx_request.IAccessByLocation} message AccessByLocation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AccessByLocation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            return writer;
        };

        /**
         * Encodes the specified AccessByLocation message, length delimited. Does not implicitly {@link tdx_request.AccessByLocation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {tdx_request.IAccessByLocation} message AccessByLocation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AccessByLocation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AccessByLocation message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.AccessByLocation} AccessByLocation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AccessByLocation.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.AccessByLocation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AccessByLocation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.AccessByLocation} AccessByLocation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AccessByLocation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AccessByLocation message.
         * @function verify
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AccessByLocation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            return null;
        };

        /**
         * Creates an AccessByLocation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.AccessByLocation} AccessByLocation
         */
        AccessByLocation.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.AccessByLocation)
                return object;
            let message = new $root.tdx_request.AccessByLocation();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an AccessByLocation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {tdx_request.AccessByLocation} message AccessByLocation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AccessByLocation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            return object;
        };

        /**
         * Converts this AccessByLocation to JSON.
         * @function toJSON
         * @memberof tdx_request.AccessByLocation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AccessByLocation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AccessByLocation
         * @function getTypeUrl
         * @memberof tdx_request.AccessByLocation
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AccessByLocation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.AccessByLocation";
        };

        return AccessByLocation;
    })();

    tdx_request.ExternalShareTopUsers = (function() {

        /**
         * Properties of an ExternalShareTopUsers.
         * @memberof tdx_request
         * @interface IExternalShareTopUsers
         * @property {string|null} [pin] ExternalShareTopUsers pin
         * @property {Uint8Array|null} [data] ExternalShareTopUsers data
         * @property {number|Long|null} [fromTime] ExternalShareTopUsers fromTime
         * @property {number|Long|null} [toTime] ExternalShareTopUsers toTime
         */

        /**
         * Constructs a new ExternalShareTopUsers.
         * @memberof tdx_request
         * @classdesc Represents an ExternalShareTopUsers.
         * @implements IExternalShareTopUsers
         * @constructor
         * @param {tdx_request.IExternalShareTopUsers=} [properties] Properties to set
         */
        function ExternalShareTopUsers(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExternalShareTopUsers pin.
         * @member {string} pin
         * @memberof tdx_request.ExternalShareTopUsers
         * @instance
         */
        ExternalShareTopUsers.prototype.pin = "";

        /**
         * ExternalShareTopUsers data.
         * @member {Uint8Array} data
         * @memberof tdx_request.ExternalShareTopUsers
         * @instance
         */
        ExternalShareTopUsers.prototype.data = $util.newBuffer([]);

        /**
         * ExternalShareTopUsers fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.ExternalShareTopUsers
         * @instance
         */
        ExternalShareTopUsers.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ExternalShareTopUsers toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.ExternalShareTopUsers
         * @instance
         */
        ExternalShareTopUsers.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ExternalShareTopUsers instance using the specified properties.
         * @function create
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {tdx_request.IExternalShareTopUsers=} [properties] Properties to set
         * @returns {tdx_request.ExternalShareTopUsers} ExternalShareTopUsers instance
         */
        ExternalShareTopUsers.create = function create(properties) {
            return new ExternalShareTopUsers(properties);
        };

        /**
         * Encodes the specified ExternalShareTopUsers message. Does not implicitly {@link tdx_request.ExternalShareTopUsers.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {tdx_request.IExternalShareTopUsers} message ExternalShareTopUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalShareTopUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            return writer;
        };

        /**
         * Encodes the specified ExternalShareTopUsers message, length delimited. Does not implicitly {@link tdx_request.ExternalShareTopUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {tdx_request.IExternalShareTopUsers} message ExternalShareTopUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalShareTopUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExternalShareTopUsers message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.ExternalShareTopUsers} ExternalShareTopUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalShareTopUsers.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.ExternalShareTopUsers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExternalShareTopUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.ExternalShareTopUsers} ExternalShareTopUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalShareTopUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExternalShareTopUsers message.
         * @function verify
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExternalShareTopUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            return null;
        };

        /**
         * Creates an ExternalShareTopUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.ExternalShareTopUsers} ExternalShareTopUsers
         */
        ExternalShareTopUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.ExternalShareTopUsers)
                return object;
            let message = new $root.tdx_request.ExternalShareTopUsers();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an ExternalShareTopUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {tdx_request.ExternalShareTopUsers} message ExternalShareTopUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExternalShareTopUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            return object;
        };

        /**
         * Converts this ExternalShareTopUsers to JSON.
         * @function toJSON
         * @memberof tdx_request.ExternalShareTopUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExternalShareTopUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ExternalShareTopUsers
         * @function getTypeUrl
         * @memberof tdx_request.ExternalShareTopUsers
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ExternalShareTopUsers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.ExternalShareTopUsers";
        };

        return ExternalShareTopUsers;
    })();

    tdx_request.CollaborationFlow = (function() {

        /**
         * Properties of a CollaborationFlow.
         * @memberof tdx_request
         * @interface ICollaborationFlow
         * @property {string|null} [pin] CollaborationFlow pin
         * @property {Uint8Array|null} [data] CollaborationFlow data
         * @property {number|Long|null} [fromTime] CollaborationFlow fromTime
         * @property {number|Long|null} [toTime] CollaborationFlow toTime
         */

        /**
         * Constructs a new CollaborationFlow.
         * @memberof tdx_request
         * @classdesc Represents a CollaborationFlow.
         * @implements ICollaborationFlow
         * @constructor
         * @param {tdx_request.ICollaborationFlow=} [properties] Properties to set
         */
        function CollaborationFlow(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CollaborationFlow pin.
         * @member {string} pin
         * @memberof tdx_request.CollaborationFlow
         * @instance
         */
        CollaborationFlow.prototype.pin = "";

        /**
         * CollaborationFlow data.
         * @member {Uint8Array} data
         * @memberof tdx_request.CollaborationFlow
         * @instance
         */
        CollaborationFlow.prototype.data = $util.newBuffer([]);

        /**
         * CollaborationFlow fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.CollaborationFlow
         * @instance
         */
        CollaborationFlow.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CollaborationFlow toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.CollaborationFlow
         * @instance
         */
        CollaborationFlow.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CollaborationFlow instance using the specified properties.
         * @function create
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {tdx_request.ICollaborationFlow=} [properties] Properties to set
         * @returns {tdx_request.CollaborationFlow} CollaborationFlow instance
         */
        CollaborationFlow.create = function create(properties) {
            return new CollaborationFlow(properties);
        };

        /**
         * Encodes the specified CollaborationFlow message. Does not implicitly {@link tdx_request.CollaborationFlow.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {tdx_request.ICollaborationFlow} message CollaborationFlow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CollaborationFlow.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            return writer;
        };

        /**
         * Encodes the specified CollaborationFlow message, length delimited. Does not implicitly {@link tdx_request.CollaborationFlow.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {tdx_request.ICollaborationFlow} message CollaborationFlow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CollaborationFlow.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CollaborationFlow message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.CollaborationFlow} CollaborationFlow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CollaborationFlow.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.CollaborationFlow();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CollaborationFlow message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.CollaborationFlow} CollaborationFlow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CollaborationFlow.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CollaborationFlow message.
         * @function verify
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CollaborationFlow.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a CollaborationFlow message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.CollaborationFlow} CollaborationFlow
         */
        CollaborationFlow.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.CollaborationFlow)
                return object;
            let message = new $root.tdx_request.CollaborationFlow();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CollaborationFlow message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {tdx_request.CollaborationFlow} message CollaborationFlow
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CollaborationFlow.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            return object;
        };

        /**
         * Converts this CollaborationFlow to JSON.
         * @function toJSON
         * @memberof tdx_request.CollaborationFlow
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CollaborationFlow.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CollaborationFlow
         * @function getTypeUrl
         * @memberof tdx_request.CollaborationFlow
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CollaborationFlow.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.CollaborationFlow";
        };

        return CollaborationFlow;
    })();

    tdx_request.Overview_OffHoursRatio = (function() {

        /**
         * Properties of an Overview_OffHoursRatio.
         * @memberof tdx_request
         * @interface IOverview_OffHoursRatio
         * @property {string|null} [pin] Overview_OffHoursRatio pin
         * @property {Uint8Array|null} [data] Overview_OffHoursRatio data
         * @property {number|Long|null} [fromTime] Overview_OffHoursRatio fromTime
         * @property {number|Long|null} [toTime] Overview_OffHoursRatio toTime
         */

        /**
         * Constructs a new Overview_OffHoursRatio.
         * @memberof tdx_request
         * @classdesc Represents an Overview_OffHoursRatio.
         * @implements IOverview_OffHoursRatio
         * @constructor
         * @param {tdx_request.IOverview_OffHoursRatio=} [properties] Properties to set
         */
        function Overview_OffHoursRatio(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Overview_OffHoursRatio pin.
         * @member {string} pin
         * @memberof tdx_request.Overview_OffHoursRatio
         * @instance
         */
        Overview_OffHoursRatio.prototype.pin = "";

        /**
         * Overview_OffHoursRatio data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Overview_OffHoursRatio
         * @instance
         */
        Overview_OffHoursRatio.prototype.data = $util.newBuffer([]);

        /**
         * Overview_OffHoursRatio fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.Overview_OffHoursRatio
         * @instance
         */
        Overview_OffHoursRatio.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Overview_OffHoursRatio toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.Overview_OffHoursRatio
         * @instance
         */
        Overview_OffHoursRatio.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Overview_OffHoursRatio instance using the specified properties.
         * @function create
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {tdx_request.IOverview_OffHoursRatio=} [properties] Properties to set
         * @returns {tdx_request.Overview_OffHoursRatio} Overview_OffHoursRatio instance
         */
        Overview_OffHoursRatio.create = function create(properties) {
            return new Overview_OffHoursRatio(properties);
        };

        /**
         * Encodes the specified Overview_OffHoursRatio message. Does not implicitly {@link tdx_request.Overview_OffHoursRatio.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {tdx_request.IOverview_OffHoursRatio} message Overview_OffHoursRatio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Overview_OffHoursRatio.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            return writer;
        };

        /**
         * Encodes the specified Overview_OffHoursRatio message, length delimited. Does not implicitly {@link tdx_request.Overview_OffHoursRatio.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {tdx_request.IOverview_OffHoursRatio} message Overview_OffHoursRatio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Overview_OffHoursRatio.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Overview_OffHoursRatio message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Overview_OffHoursRatio} Overview_OffHoursRatio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Overview_OffHoursRatio.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Overview_OffHoursRatio();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Overview_OffHoursRatio message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Overview_OffHoursRatio} Overview_OffHoursRatio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Overview_OffHoursRatio.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Overview_OffHoursRatio message.
         * @function verify
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Overview_OffHoursRatio.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            return null;
        };

        /**
         * Creates an Overview_OffHoursRatio message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Overview_OffHoursRatio} Overview_OffHoursRatio
         */
        Overview_OffHoursRatio.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Overview_OffHoursRatio)
                return object;
            let message = new $root.tdx_request.Overview_OffHoursRatio();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an Overview_OffHoursRatio message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {tdx_request.Overview_OffHoursRatio} message Overview_OffHoursRatio
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Overview_OffHoursRatio.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            return object;
        };

        /**
         * Converts this Overview_OffHoursRatio to JSON.
         * @function toJSON
         * @memberof tdx_request.Overview_OffHoursRatio
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Overview_OffHoursRatio.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Overview_OffHoursRatio
         * @function getTypeUrl
         * @memberof tdx_request.Overview_OffHoursRatio
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Overview_OffHoursRatio.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Overview_OffHoursRatio";
        };

        return Overview_OffHoursRatio;
    })();

    tdx_request.GetRemovedUsersFromLogs = (function() {

        /**
         * Properties of a GetRemovedUsersFromLogs.
         * @memberof tdx_request
         * @interface IGetRemovedUsersFromLogs
         * @property {string|null} [pin] GetRemovedUsersFromLogs pin
         * @property {Uint8Array|null} [data] GetRemovedUsersFromLogs data
         * @property {number|Long|null} [fromTime] GetRemovedUsersFromLogs fromTime
         * @property {number|Long|null} [toTime] GetRemovedUsersFromLogs toTime
         */

        /**
         * Constructs a new GetRemovedUsersFromLogs.
         * @memberof tdx_request
         * @classdesc Represents a GetRemovedUsersFromLogs.
         * @implements IGetRemovedUsersFromLogs
         * @constructor
         * @param {tdx_request.IGetRemovedUsersFromLogs=} [properties] Properties to set
         */
        function GetRemovedUsersFromLogs(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRemovedUsersFromLogs pin.
         * @member {string} pin
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @instance
         */
        GetRemovedUsersFromLogs.prototype.pin = "";

        /**
         * GetRemovedUsersFromLogs data.
         * @member {Uint8Array} data
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @instance
         */
        GetRemovedUsersFromLogs.prototype.data = $util.newBuffer([]);

        /**
         * GetRemovedUsersFromLogs fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @instance
         */
        GetRemovedUsersFromLogs.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetRemovedUsersFromLogs toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @instance
         */
        GetRemovedUsersFromLogs.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetRemovedUsersFromLogs instance using the specified properties.
         * @function create
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_request.IGetRemovedUsersFromLogs=} [properties] Properties to set
         * @returns {tdx_request.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs instance
         */
        GetRemovedUsersFromLogs.create = function create(properties) {
            return new GetRemovedUsersFromLogs(properties);
        };

        /**
         * Encodes the specified GetRemovedUsersFromLogs message. Does not implicitly {@link tdx_request.GetRemovedUsersFromLogs.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_request.IGetRemovedUsersFromLogs} message GetRemovedUsersFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedUsersFromLogs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            return writer;
        };

        /**
         * Encodes the specified GetRemovedUsersFromLogs message, length delimited. Does not implicitly {@link tdx_request.GetRemovedUsersFromLogs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_request.IGetRemovedUsersFromLogs} message GetRemovedUsersFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedUsersFromLogs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRemovedUsersFromLogs message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedUsersFromLogs.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.GetRemovedUsersFromLogs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRemovedUsersFromLogs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedUsersFromLogs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRemovedUsersFromLogs message.
         * @function verify
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRemovedUsersFromLogs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetRemovedUsersFromLogs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs
         */
        GetRemovedUsersFromLogs.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.GetRemovedUsersFromLogs)
                return object;
            let message = new $root.tdx_request.GetRemovedUsersFromLogs();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetRemovedUsersFromLogs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_request.GetRemovedUsersFromLogs} message GetRemovedUsersFromLogs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRemovedUsersFromLogs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            return object;
        };

        /**
         * Converts this GetRemovedUsersFromLogs to JSON.
         * @function toJSON
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRemovedUsersFromLogs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRemovedUsersFromLogs
         * @function getTypeUrl
         * @memberof tdx_request.GetRemovedUsersFromLogs
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRemovedUsersFromLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.GetRemovedUsersFromLogs";
        };

        return GetRemovedUsersFromLogs;
    })();

    tdx_request.GetRemovedTeamsFromLogs = (function() {

        /**
         * Properties of a GetRemovedTeamsFromLogs.
         * @memberof tdx_request
         * @interface IGetRemovedTeamsFromLogs
         * @property {string|null} [pin] GetRemovedTeamsFromLogs pin
         * @property {Uint8Array|null} [data] GetRemovedTeamsFromLogs data
         * @property {number|Long|null} [fromTime] GetRemovedTeamsFromLogs fromTime
         * @property {number|Long|null} [toTime] GetRemovedTeamsFromLogs toTime
         */

        /**
         * Constructs a new GetRemovedTeamsFromLogs.
         * @memberof tdx_request
         * @classdesc Represents a GetRemovedTeamsFromLogs.
         * @implements IGetRemovedTeamsFromLogs
         * @constructor
         * @param {tdx_request.IGetRemovedTeamsFromLogs=} [properties] Properties to set
         */
        function GetRemovedTeamsFromLogs(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRemovedTeamsFromLogs pin.
         * @member {string} pin
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @instance
         */
        GetRemovedTeamsFromLogs.prototype.pin = "";

        /**
         * GetRemovedTeamsFromLogs data.
         * @member {Uint8Array} data
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @instance
         */
        GetRemovedTeamsFromLogs.prototype.data = $util.newBuffer([]);

        /**
         * GetRemovedTeamsFromLogs fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @instance
         */
        GetRemovedTeamsFromLogs.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetRemovedTeamsFromLogs toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @instance
         */
        GetRemovedTeamsFromLogs.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetRemovedTeamsFromLogs instance using the specified properties.
         * @function create
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_request.IGetRemovedTeamsFromLogs=} [properties] Properties to set
         * @returns {tdx_request.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs instance
         */
        GetRemovedTeamsFromLogs.create = function create(properties) {
            return new GetRemovedTeamsFromLogs(properties);
        };

        /**
         * Encodes the specified GetRemovedTeamsFromLogs message. Does not implicitly {@link tdx_request.GetRemovedTeamsFromLogs.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_request.IGetRemovedTeamsFromLogs} message GetRemovedTeamsFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedTeamsFromLogs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            return writer;
        };

        /**
         * Encodes the specified GetRemovedTeamsFromLogs message, length delimited. Does not implicitly {@link tdx_request.GetRemovedTeamsFromLogs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_request.IGetRemovedTeamsFromLogs} message GetRemovedTeamsFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedTeamsFromLogs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRemovedTeamsFromLogs message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedTeamsFromLogs.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.GetRemovedTeamsFromLogs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRemovedTeamsFromLogs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedTeamsFromLogs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRemovedTeamsFromLogs message.
         * @function verify
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRemovedTeamsFromLogs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetRemovedTeamsFromLogs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs
         */
        GetRemovedTeamsFromLogs.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.GetRemovedTeamsFromLogs)
                return object;
            let message = new $root.tdx_request.GetRemovedTeamsFromLogs();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetRemovedTeamsFromLogs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_request.GetRemovedTeamsFromLogs} message GetRemovedTeamsFromLogs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRemovedTeamsFromLogs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            return object;
        };

        /**
         * Converts this GetRemovedTeamsFromLogs to JSON.
         * @function toJSON
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRemovedTeamsFromLogs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRemovedTeamsFromLogs
         * @function getTypeUrl
         * @memberof tdx_request.GetRemovedTeamsFromLogs
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRemovedTeamsFromLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.GetRemovedTeamsFromLogs";
        };

        return GetRemovedTeamsFromLogs;
    })();

    tdx_request.User_ActivityTimeline = (function() {

        /**
         * Properties of a User_ActivityTimeline.
         * @memberof tdx_request
         * @interface IUser_ActivityTimeline
         * @property {string|null} [pin] User_ActivityTimeline pin
         * @property {Uint8Array|null} [data] User_ActivityTimeline data
         * @property {number|Long|null} [fromTime] User_ActivityTimeline fromTime
         * @property {number|Long|null} [toTime] User_ActivityTimeline toTime
         * @property {string|null} [email] User_ActivityTimeline email
         */

        /**
         * Constructs a new User_ActivityTimeline.
         * @memberof tdx_request
         * @classdesc Represents a User_ActivityTimeline.
         * @implements IUser_ActivityTimeline
         * @constructor
         * @param {tdx_request.IUser_ActivityTimeline=} [properties] Properties to set
         */
        function User_ActivityTimeline(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_ActivityTimeline pin.
         * @member {string} pin
         * @memberof tdx_request.User_ActivityTimeline
         * @instance
         */
        User_ActivityTimeline.prototype.pin = "";

        /**
         * User_ActivityTimeline data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_ActivityTimeline
         * @instance
         */
        User_ActivityTimeline.prototype.data = $util.newBuffer([]);

        /**
         * User_ActivityTimeline fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_ActivityTimeline
         * @instance
         */
        User_ActivityTimeline.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_ActivityTimeline toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_ActivityTimeline
         * @instance
         */
        User_ActivityTimeline.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_ActivityTimeline email.
         * @member {string} email
         * @memberof tdx_request.User_ActivityTimeline
         * @instance
         */
        User_ActivityTimeline.prototype.email = "";

        /**
         * Creates a new User_ActivityTimeline instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {tdx_request.IUser_ActivityTimeline=} [properties] Properties to set
         * @returns {tdx_request.User_ActivityTimeline} User_ActivityTimeline instance
         */
        User_ActivityTimeline.create = function create(properties) {
            return new User_ActivityTimeline(properties);
        };

        /**
         * Encodes the specified User_ActivityTimeline message. Does not implicitly {@link tdx_request.User_ActivityTimeline.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {tdx_request.IUser_ActivityTimeline} message User_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_ActivityTimeline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_ActivityTimeline message, length delimited. Does not implicitly {@link tdx_request.User_ActivityTimeline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {tdx_request.IUser_ActivityTimeline} message User_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_ActivityTimeline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_ActivityTimeline message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_ActivityTimeline} User_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_ActivityTimeline.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_ActivityTimeline();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_ActivityTimeline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_ActivityTimeline} User_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_ActivityTimeline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_ActivityTimeline message.
         * @function verify
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_ActivityTimeline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_ActivityTimeline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_ActivityTimeline} User_ActivityTimeline
         */
        User_ActivityTimeline.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_ActivityTimeline)
                return object;
            let message = new $root.tdx_request.User_ActivityTimeline();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_ActivityTimeline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {tdx_request.User_ActivityTimeline} message User_ActivityTimeline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_ActivityTimeline.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_ActivityTimeline to JSON.
         * @function toJSON
         * @memberof tdx_request.User_ActivityTimeline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_ActivityTimeline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_ActivityTimeline
         * @function getTypeUrl
         * @memberof tdx_request.User_ActivityTimeline
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_ActivityTimeline.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_ActivityTimeline";
        };

        return User_ActivityTimeline;
    })();

    tdx_request.User_CountriesAccessedFrom = (function() {

        /**
         * Properties of a User_CountriesAccessedFrom.
         * @memberof tdx_request
         * @interface IUser_CountriesAccessedFrom
         * @property {string|null} [pin] User_CountriesAccessedFrom pin
         * @property {Uint8Array|null} [data] User_CountriesAccessedFrom data
         * @property {number|Long|null} [fromTime] User_CountriesAccessedFrom fromTime
         * @property {number|Long|null} [toTime] User_CountriesAccessedFrom toTime
         * @property {string|null} [email] User_CountriesAccessedFrom email
         */

        /**
         * Constructs a new User_CountriesAccessedFrom.
         * @memberof tdx_request
         * @classdesc Represents a User_CountriesAccessedFrom.
         * @implements IUser_CountriesAccessedFrom
         * @constructor
         * @param {tdx_request.IUser_CountriesAccessedFrom=} [properties] Properties to set
         */
        function User_CountriesAccessedFrom(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_CountriesAccessedFrom pin.
         * @member {string} pin
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @instance
         */
        User_CountriesAccessedFrom.prototype.pin = "";

        /**
         * User_CountriesAccessedFrom data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @instance
         */
        User_CountriesAccessedFrom.prototype.data = $util.newBuffer([]);

        /**
         * User_CountriesAccessedFrom fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @instance
         */
        User_CountriesAccessedFrom.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_CountriesAccessedFrom toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @instance
         */
        User_CountriesAccessedFrom.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_CountriesAccessedFrom email.
         * @member {string} email
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @instance
         */
        User_CountriesAccessedFrom.prototype.email = "";

        /**
         * Creates a new User_CountriesAccessedFrom instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {tdx_request.IUser_CountriesAccessedFrom=} [properties] Properties to set
         * @returns {tdx_request.User_CountriesAccessedFrom} User_CountriesAccessedFrom instance
         */
        User_CountriesAccessedFrom.create = function create(properties) {
            return new User_CountriesAccessedFrom(properties);
        };

        /**
         * Encodes the specified User_CountriesAccessedFrom message. Does not implicitly {@link tdx_request.User_CountriesAccessedFrom.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {tdx_request.IUser_CountriesAccessedFrom} message User_CountriesAccessedFrom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_CountriesAccessedFrom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_CountriesAccessedFrom message, length delimited. Does not implicitly {@link tdx_request.User_CountriesAccessedFrom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {tdx_request.IUser_CountriesAccessedFrom} message User_CountriesAccessedFrom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_CountriesAccessedFrom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_CountriesAccessedFrom message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_CountriesAccessedFrom} User_CountriesAccessedFrom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_CountriesAccessedFrom.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_CountriesAccessedFrom();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_CountriesAccessedFrom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_CountriesAccessedFrom} User_CountriesAccessedFrom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_CountriesAccessedFrom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_CountriesAccessedFrom message.
         * @function verify
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_CountriesAccessedFrom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_CountriesAccessedFrom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_CountriesAccessedFrom} User_CountriesAccessedFrom
         */
        User_CountriesAccessedFrom.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_CountriesAccessedFrom)
                return object;
            let message = new $root.tdx_request.User_CountriesAccessedFrom();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_CountriesAccessedFrom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {tdx_request.User_CountriesAccessedFrom} message User_CountriesAccessedFrom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_CountriesAccessedFrom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_CountriesAccessedFrom to JSON.
         * @function toJSON
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_CountriesAccessedFrom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_CountriesAccessedFrom
         * @function getTypeUrl
         * @memberof tdx_request.User_CountriesAccessedFrom
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_CountriesAccessedFrom.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_CountriesAccessedFrom";
        };

        return User_CountriesAccessedFrom;
    })();

    tdx_request.User_OpCount = (function() {

        /**
         * Properties of a User_OpCount.
         * @memberof tdx_request
         * @interface IUser_OpCount
         * @property {string|null} [pin] User_OpCount pin
         * @property {Uint8Array|null} [data] User_OpCount data
         * @property {number|Long|null} [fromTime] User_OpCount fromTime
         * @property {number|Long|null} [toTime] User_OpCount toTime
         * @property {string|null} [email] User_OpCount email
         */

        /**
         * Constructs a new User_OpCount.
         * @memberof tdx_request
         * @classdesc Represents a User_OpCount.
         * @implements IUser_OpCount
         * @constructor
         * @param {tdx_request.IUser_OpCount=} [properties] Properties to set
         */
        function User_OpCount(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_OpCount pin.
         * @member {string} pin
         * @memberof tdx_request.User_OpCount
         * @instance
         */
        User_OpCount.prototype.pin = "";

        /**
         * User_OpCount data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_OpCount
         * @instance
         */
        User_OpCount.prototype.data = $util.newBuffer([]);

        /**
         * User_OpCount fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_OpCount
         * @instance
         */
        User_OpCount.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_OpCount toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_OpCount
         * @instance
         */
        User_OpCount.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_OpCount email.
         * @member {string} email
         * @memberof tdx_request.User_OpCount
         * @instance
         */
        User_OpCount.prototype.email = "";

        /**
         * Creates a new User_OpCount instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {tdx_request.IUser_OpCount=} [properties] Properties to set
         * @returns {tdx_request.User_OpCount} User_OpCount instance
         */
        User_OpCount.create = function create(properties) {
            return new User_OpCount(properties);
        };

        /**
         * Encodes the specified User_OpCount message. Does not implicitly {@link tdx_request.User_OpCount.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {tdx_request.IUser_OpCount} message User_OpCount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_OpCount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_OpCount message, length delimited. Does not implicitly {@link tdx_request.User_OpCount.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {tdx_request.IUser_OpCount} message User_OpCount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_OpCount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_OpCount message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_OpCount} User_OpCount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_OpCount.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_OpCount();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_OpCount message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_OpCount} User_OpCount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_OpCount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_OpCount message.
         * @function verify
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_OpCount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_OpCount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_OpCount} User_OpCount
         */
        User_OpCount.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_OpCount)
                return object;
            let message = new $root.tdx_request.User_OpCount();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_OpCount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {tdx_request.User_OpCount} message User_OpCount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_OpCount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_OpCount to JSON.
         * @function toJSON
         * @memberof tdx_request.User_OpCount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_OpCount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_OpCount
         * @function getTypeUrl
         * @memberof tdx_request.User_OpCount
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_OpCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_OpCount";
        };

        return User_OpCount;
    })();

    tdx_request.User_WriteActivity = (function() {

        /**
         * Properties of a User_WriteActivity.
         * @memberof tdx_request
         * @interface IUser_WriteActivity
         * @property {string|null} [pin] User_WriteActivity pin
         * @property {Uint8Array|null} [data] User_WriteActivity data
         * @property {number|Long|null} [fromTime] User_WriteActivity fromTime
         * @property {number|Long|null} [toTime] User_WriteActivity toTime
         * @property {string|null} [email] User_WriteActivity email
         */

        /**
         * Constructs a new User_WriteActivity.
         * @memberof tdx_request
         * @classdesc Represents a User_WriteActivity.
         * @implements IUser_WriteActivity
         * @constructor
         * @param {tdx_request.IUser_WriteActivity=} [properties] Properties to set
         */
        function User_WriteActivity(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_WriteActivity pin.
         * @member {string} pin
         * @memberof tdx_request.User_WriteActivity
         * @instance
         */
        User_WriteActivity.prototype.pin = "";

        /**
         * User_WriteActivity data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_WriteActivity
         * @instance
         */
        User_WriteActivity.prototype.data = $util.newBuffer([]);

        /**
         * User_WriteActivity fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_WriteActivity
         * @instance
         */
        User_WriteActivity.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_WriteActivity toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_WriteActivity
         * @instance
         */
        User_WriteActivity.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_WriteActivity email.
         * @member {string} email
         * @memberof tdx_request.User_WriteActivity
         * @instance
         */
        User_WriteActivity.prototype.email = "";

        /**
         * Creates a new User_WriteActivity instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {tdx_request.IUser_WriteActivity=} [properties] Properties to set
         * @returns {tdx_request.User_WriteActivity} User_WriteActivity instance
         */
        User_WriteActivity.create = function create(properties) {
            return new User_WriteActivity(properties);
        };

        /**
         * Encodes the specified User_WriteActivity message. Does not implicitly {@link tdx_request.User_WriteActivity.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {tdx_request.IUser_WriteActivity} message User_WriteActivity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_WriteActivity.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_WriteActivity message, length delimited. Does not implicitly {@link tdx_request.User_WriteActivity.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {tdx_request.IUser_WriteActivity} message User_WriteActivity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_WriteActivity.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_WriteActivity message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_WriteActivity} User_WriteActivity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_WriteActivity.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_WriteActivity();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_WriteActivity message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_WriteActivity} User_WriteActivity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_WriteActivity.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_WriteActivity message.
         * @function verify
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_WriteActivity.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_WriteActivity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_WriteActivity} User_WriteActivity
         */
        User_WriteActivity.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_WriteActivity)
                return object;
            let message = new $root.tdx_request.User_WriteActivity();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_WriteActivity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {tdx_request.User_WriteActivity} message User_WriteActivity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_WriteActivity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_WriteActivity to JSON.
         * @function toJSON
         * @memberof tdx_request.User_WriteActivity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_WriteActivity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_WriteActivity
         * @function getTypeUrl
         * @memberof tdx_request.User_WriteActivity
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_WriteActivity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_WriteActivity";
        };

        return User_WriteActivity;
    })();

    tdx_request.User_StorageBreakdown = (function() {

        /**
         * Properties of a User_StorageBreakdown.
         * @memberof tdx_request
         * @interface IUser_StorageBreakdown
         * @property {string|null} [pin] User_StorageBreakdown pin
         * @property {Uint8Array|null} [data] User_StorageBreakdown data
         * @property {number|Long|null} [fromTime] User_StorageBreakdown fromTime
         * @property {number|Long|null} [toTime] User_StorageBreakdown toTime
         * @property {string|null} [email] User_StorageBreakdown email
         */

        /**
         * Constructs a new User_StorageBreakdown.
         * @memberof tdx_request
         * @classdesc Represents a User_StorageBreakdown.
         * @implements IUser_StorageBreakdown
         * @constructor
         * @param {tdx_request.IUser_StorageBreakdown=} [properties] Properties to set
         */
        function User_StorageBreakdown(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_StorageBreakdown pin.
         * @member {string} pin
         * @memberof tdx_request.User_StorageBreakdown
         * @instance
         */
        User_StorageBreakdown.prototype.pin = "";

        /**
         * User_StorageBreakdown data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_StorageBreakdown
         * @instance
         */
        User_StorageBreakdown.prototype.data = $util.newBuffer([]);

        /**
         * User_StorageBreakdown fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_StorageBreakdown
         * @instance
         */
        User_StorageBreakdown.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_StorageBreakdown toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_StorageBreakdown
         * @instance
         */
        User_StorageBreakdown.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_StorageBreakdown email.
         * @member {string} email
         * @memberof tdx_request.User_StorageBreakdown
         * @instance
         */
        User_StorageBreakdown.prototype.email = "";

        /**
         * Creates a new User_StorageBreakdown instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {tdx_request.IUser_StorageBreakdown=} [properties] Properties to set
         * @returns {tdx_request.User_StorageBreakdown} User_StorageBreakdown instance
         */
        User_StorageBreakdown.create = function create(properties) {
            return new User_StorageBreakdown(properties);
        };

        /**
         * Encodes the specified User_StorageBreakdown message. Does not implicitly {@link tdx_request.User_StorageBreakdown.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {tdx_request.IUser_StorageBreakdown} message User_StorageBreakdown message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_StorageBreakdown.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_StorageBreakdown message, length delimited. Does not implicitly {@link tdx_request.User_StorageBreakdown.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {tdx_request.IUser_StorageBreakdown} message User_StorageBreakdown message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_StorageBreakdown.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_StorageBreakdown message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_StorageBreakdown} User_StorageBreakdown
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_StorageBreakdown.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_StorageBreakdown();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_StorageBreakdown message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_StorageBreakdown} User_StorageBreakdown
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_StorageBreakdown.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_StorageBreakdown message.
         * @function verify
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_StorageBreakdown.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_StorageBreakdown message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_StorageBreakdown} User_StorageBreakdown
         */
        User_StorageBreakdown.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_StorageBreakdown)
                return object;
            let message = new $root.tdx_request.User_StorageBreakdown();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_StorageBreakdown message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {tdx_request.User_StorageBreakdown} message User_StorageBreakdown
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_StorageBreakdown.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_StorageBreakdown to JSON.
         * @function toJSON
         * @memberof tdx_request.User_StorageBreakdown
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_StorageBreakdown.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_StorageBreakdown
         * @function getTypeUrl
         * @memberof tdx_request.User_StorageBreakdown
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_StorageBreakdown.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_StorageBreakdown";
        };

        return User_StorageBreakdown;
    })();

    tdx_request.User_FilesTouched = (function() {

        /**
         * Properties of a User_FilesTouched.
         * @memberof tdx_request
         * @interface IUser_FilesTouched
         * @property {string|null} [pin] User_FilesTouched pin
         * @property {Uint8Array|null} [data] User_FilesTouched data
         * @property {number|Long|null} [fromTime] User_FilesTouched fromTime
         * @property {number|Long|null} [toTime] User_FilesTouched toTime
         * @property {string|null} [email] User_FilesTouched email
         */

        /**
         * Constructs a new User_FilesTouched.
         * @memberof tdx_request
         * @classdesc Represents a User_FilesTouched.
         * @implements IUser_FilesTouched
         * @constructor
         * @param {tdx_request.IUser_FilesTouched=} [properties] Properties to set
         */
        function User_FilesTouched(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_FilesTouched pin.
         * @member {string} pin
         * @memberof tdx_request.User_FilesTouched
         * @instance
         */
        User_FilesTouched.prototype.pin = "";

        /**
         * User_FilesTouched data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_FilesTouched
         * @instance
         */
        User_FilesTouched.prototype.data = $util.newBuffer([]);

        /**
         * User_FilesTouched fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_FilesTouched
         * @instance
         */
        User_FilesTouched.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_FilesTouched toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_FilesTouched
         * @instance
         */
        User_FilesTouched.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_FilesTouched email.
         * @member {string} email
         * @memberof tdx_request.User_FilesTouched
         * @instance
         */
        User_FilesTouched.prototype.email = "";

        /**
         * Creates a new User_FilesTouched instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {tdx_request.IUser_FilesTouched=} [properties] Properties to set
         * @returns {tdx_request.User_FilesTouched} User_FilesTouched instance
         */
        User_FilesTouched.create = function create(properties) {
            return new User_FilesTouched(properties);
        };

        /**
         * Encodes the specified User_FilesTouched message. Does not implicitly {@link tdx_request.User_FilesTouched.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {tdx_request.IUser_FilesTouched} message User_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_FilesTouched.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_FilesTouched message, length delimited. Does not implicitly {@link tdx_request.User_FilesTouched.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {tdx_request.IUser_FilesTouched} message User_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_FilesTouched.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_FilesTouched message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_FilesTouched} User_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_FilesTouched.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_FilesTouched();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_FilesTouched message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_FilesTouched} User_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_FilesTouched.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_FilesTouched message.
         * @function verify
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_FilesTouched.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_FilesTouched message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_FilesTouched} User_FilesTouched
         */
        User_FilesTouched.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_FilesTouched)
                return object;
            let message = new $root.tdx_request.User_FilesTouched();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_FilesTouched message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {tdx_request.User_FilesTouched} message User_FilesTouched
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_FilesTouched.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_FilesTouched to JSON.
         * @function toJSON
         * @memberof tdx_request.User_FilesTouched
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_FilesTouched.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_FilesTouched
         * @function getTypeUrl
         * @memberof tdx_request.User_FilesTouched
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_FilesTouched.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_FilesTouched";
        };

        return User_FilesTouched;
    })();

    tdx_request.User_SharingActions = (function() {

        /**
         * Properties of a User_SharingActions.
         * @memberof tdx_request
         * @interface IUser_SharingActions
         * @property {string|null} [pin] User_SharingActions pin
         * @property {Uint8Array|null} [data] User_SharingActions data
         * @property {number|Long|null} [fromTime] User_SharingActions fromTime
         * @property {number|Long|null} [toTime] User_SharingActions toTime
         * @property {string|null} [email] User_SharingActions email
         */

        /**
         * Constructs a new User_SharingActions.
         * @memberof tdx_request
         * @classdesc Represents a User_SharingActions.
         * @implements IUser_SharingActions
         * @constructor
         * @param {tdx_request.IUser_SharingActions=} [properties] Properties to set
         */
        function User_SharingActions(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_SharingActions pin.
         * @member {string} pin
         * @memberof tdx_request.User_SharingActions
         * @instance
         */
        User_SharingActions.prototype.pin = "";

        /**
         * User_SharingActions data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_SharingActions
         * @instance
         */
        User_SharingActions.prototype.data = $util.newBuffer([]);

        /**
         * User_SharingActions fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_SharingActions
         * @instance
         */
        User_SharingActions.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_SharingActions toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_SharingActions
         * @instance
         */
        User_SharingActions.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_SharingActions email.
         * @member {string} email
         * @memberof tdx_request.User_SharingActions
         * @instance
         */
        User_SharingActions.prototype.email = "";

        /**
         * Creates a new User_SharingActions instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {tdx_request.IUser_SharingActions=} [properties] Properties to set
         * @returns {tdx_request.User_SharingActions} User_SharingActions instance
         */
        User_SharingActions.create = function create(properties) {
            return new User_SharingActions(properties);
        };

        /**
         * Encodes the specified User_SharingActions message. Does not implicitly {@link tdx_request.User_SharingActions.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {tdx_request.IUser_SharingActions} message User_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_SharingActions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_SharingActions message, length delimited. Does not implicitly {@link tdx_request.User_SharingActions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {tdx_request.IUser_SharingActions} message User_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_SharingActions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_SharingActions message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_SharingActions} User_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_SharingActions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_SharingActions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_SharingActions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_SharingActions} User_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_SharingActions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_SharingActions message.
         * @function verify
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_SharingActions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_SharingActions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_SharingActions} User_SharingActions
         */
        User_SharingActions.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_SharingActions)
                return object;
            let message = new $root.tdx_request.User_SharingActions();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_SharingActions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {tdx_request.User_SharingActions} message User_SharingActions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_SharingActions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_SharingActions to JSON.
         * @function toJSON
         * @memberof tdx_request.User_SharingActions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_SharingActions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_SharingActions
         * @function getTypeUrl
         * @memberof tdx_request.User_SharingActions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_SharingActions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_SharingActions";
        };

        return User_SharingActions;
    })();

    tdx_request.User_DeniedAttempts = (function() {

        /**
         * Properties of a User_DeniedAttempts.
         * @memberof tdx_request
         * @interface IUser_DeniedAttempts
         * @property {string|null} [pin] User_DeniedAttempts pin
         * @property {Uint8Array|null} [data] User_DeniedAttempts data
         * @property {number|Long|null} [fromTime] User_DeniedAttempts fromTime
         * @property {number|Long|null} [toTime] User_DeniedAttempts toTime
         * @property {string|null} [email] User_DeniedAttempts email
         */

        /**
         * Constructs a new User_DeniedAttempts.
         * @memberof tdx_request
         * @classdesc Represents a User_DeniedAttempts.
         * @implements IUser_DeniedAttempts
         * @constructor
         * @param {tdx_request.IUser_DeniedAttempts=} [properties] Properties to set
         */
        function User_DeniedAttempts(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_DeniedAttempts pin.
         * @member {string} pin
         * @memberof tdx_request.User_DeniedAttempts
         * @instance
         */
        User_DeniedAttempts.prototype.pin = "";

        /**
         * User_DeniedAttempts data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_DeniedAttempts
         * @instance
         */
        User_DeniedAttempts.prototype.data = $util.newBuffer([]);

        /**
         * User_DeniedAttempts fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_DeniedAttempts
         * @instance
         */
        User_DeniedAttempts.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_DeniedAttempts toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_DeniedAttempts
         * @instance
         */
        User_DeniedAttempts.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_DeniedAttempts email.
         * @member {string} email
         * @memberof tdx_request.User_DeniedAttempts
         * @instance
         */
        User_DeniedAttempts.prototype.email = "";

        /**
         * Creates a new User_DeniedAttempts instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {tdx_request.IUser_DeniedAttempts=} [properties] Properties to set
         * @returns {tdx_request.User_DeniedAttempts} User_DeniedAttempts instance
         */
        User_DeniedAttempts.create = function create(properties) {
            return new User_DeniedAttempts(properties);
        };

        /**
         * Encodes the specified User_DeniedAttempts message. Does not implicitly {@link tdx_request.User_DeniedAttempts.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {tdx_request.IUser_DeniedAttempts} message User_DeniedAttempts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_DeniedAttempts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_DeniedAttempts message, length delimited. Does not implicitly {@link tdx_request.User_DeniedAttempts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {tdx_request.IUser_DeniedAttempts} message User_DeniedAttempts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_DeniedAttempts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_DeniedAttempts message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_DeniedAttempts} User_DeniedAttempts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_DeniedAttempts.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_DeniedAttempts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_DeniedAttempts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_DeniedAttempts} User_DeniedAttempts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_DeniedAttempts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_DeniedAttempts message.
         * @function verify
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_DeniedAttempts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_DeniedAttempts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_DeniedAttempts} User_DeniedAttempts
         */
        User_DeniedAttempts.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_DeniedAttempts)
                return object;
            let message = new $root.tdx_request.User_DeniedAttempts();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_DeniedAttempts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {tdx_request.User_DeniedAttempts} message User_DeniedAttempts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_DeniedAttempts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_DeniedAttempts to JSON.
         * @function toJSON
         * @memberof tdx_request.User_DeniedAttempts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_DeniedAttempts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_DeniedAttempts
         * @function getTypeUrl
         * @memberof tdx_request.User_DeniedAttempts
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_DeniedAttempts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_DeniedAttempts";
        };

        return User_DeniedAttempts;
    })();

    tdx_request.User_PermissionRecieved = (function() {

        /**
         * Properties of a User_PermissionRecieved.
         * @memberof tdx_request
         * @interface IUser_PermissionRecieved
         * @property {string|null} [pin] User_PermissionRecieved pin
         * @property {Uint8Array|null} [data] User_PermissionRecieved data
         * @property {number|Long|null} [fromTime] User_PermissionRecieved fromTime
         * @property {number|Long|null} [toTime] User_PermissionRecieved toTime
         * @property {string|null} [email] User_PermissionRecieved email
         */

        /**
         * Constructs a new User_PermissionRecieved.
         * @memberof tdx_request
         * @classdesc Represents a User_PermissionRecieved.
         * @implements IUser_PermissionRecieved
         * @constructor
         * @param {tdx_request.IUser_PermissionRecieved=} [properties] Properties to set
         */
        function User_PermissionRecieved(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_PermissionRecieved pin.
         * @member {string} pin
         * @memberof tdx_request.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.pin = "";

        /**
         * User_PermissionRecieved data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.data = $util.newBuffer([]);

        /**
         * User_PermissionRecieved fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_PermissionRecieved toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_PermissionRecieved email.
         * @member {string} email
         * @memberof tdx_request.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.email = "";

        /**
         * Creates a new User_PermissionRecieved instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {tdx_request.IUser_PermissionRecieved=} [properties] Properties to set
         * @returns {tdx_request.User_PermissionRecieved} User_PermissionRecieved instance
         */
        User_PermissionRecieved.create = function create(properties) {
            return new User_PermissionRecieved(properties);
        };

        /**
         * Encodes the specified User_PermissionRecieved message. Does not implicitly {@link tdx_request.User_PermissionRecieved.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {tdx_request.IUser_PermissionRecieved} message User_PermissionRecieved message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_PermissionRecieved.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_PermissionRecieved message, length delimited. Does not implicitly {@link tdx_request.User_PermissionRecieved.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {tdx_request.IUser_PermissionRecieved} message User_PermissionRecieved message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_PermissionRecieved.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_PermissionRecieved message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_PermissionRecieved} User_PermissionRecieved
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_PermissionRecieved.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_PermissionRecieved();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_PermissionRecieved message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_PermissionRecieved} User_PermissionRecieved
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_PermissionRecieved.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_PermissionRecieved message.
         * @function verify
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_PermissionRecieved.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_PermissionRecieved message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_PermissionRecieved} User_PermissionRecieved
         */
        User_PermissionRecieved.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_PermissionRecieved)
                return object;
            let message = new $root.tdx_request.User_PermissionRecieved();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_PermissionRecieved message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {tdx_request.User_PermissionRecieved} message User_PermissionRecieved
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_PermissionRecieved.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_PermissionRecieved to JSON.
         * @function toJSON
         * @memberof tdx_request.User_PermissionRecieved
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_PermissionRecieved.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_PermissionRecieved
         * @function getTypeUrl
         * @memberof tdx_request.User_PermissionRecieved
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_PermissionRecieved.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_PermissionRecieved";
        };

        return User_PermissionRecieved;
    })();

    tdx_request.User_Overview = (function() {

        /**
         * Properties of a User_Overview.
         * @memberof tdx_request
         * @interface IUser_Overview
         * @property {string|null} [pin] User_Overview pin
         * @property {Uint8Array|null} [data] User_Overview data
         * @property {number|Long|null} [fromTime] User_Overview fromTime
         * @property {number|Long|null} [toTime] User_Overview toTime
         * @property {string|null} [email] User_Overview email
         */

        /**
         * Constructs a new User_Overview.
         * @memberof tdx_request
         * @classdesc Represents a User_Overview.
         * @implements IUser_Overview
         * @constructor
         * @param {tdx_request.IUser_Overview=} [properties] Properties to set
         */
        function User_Overview(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_Overview pin.
         * @member {string} pin
         * @memberof tdx_request.User_Overview
         * @instance
         */
        User_Overview.prototype.pin = "";

        /**
         * User_Overview data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_Overview
         * @instance
         */
        User_Overview.prototype.data = $util.newBuffer([]);

        /**
         * User_Overview fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_Overview
         * @instance
         */
        User_Overview.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_Overview toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_Overview
         * @instance
         */
        User_Overview.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_Overview email.
         * @member {string} email
         * @memberof tdx_request.User_Overview
         * @instance
         */
        User_Overview.prototype.email = "";

        /**
         * Creates a new User_Overview instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_Overview
         * @static
         * @param {tdx_request.IUser_Overview=} [properties] Properties to set
         * @returns {tdx_request.User_Overview} User_Overview instance
         */
        User_Overview.create = function create(properties) {
            return new User_Overview(properties);
        };

        /**
         * Encodes the specified User_Overview message. Does not implicitly {@link tdx_request.User_Overview.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_Overview
         * @static
         * @param {tdx_request.IUser_Overview} message User_Overview message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Overview.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_Overview message, length delimited. Does not implicitly {@link tdx_request.User_Overview.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_Overview
         * @static
         * @param {tdx_request.IUser_Overview} message User_Overview message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Overview.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_Overview message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_Overview
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_Overview} User_Overview
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Overview.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_Overview();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_Overview message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_Overview
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_Overview} User_Overview
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Overview.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_Overview message.
         * @function verify
         * @memberof tdx_request.User_Overview
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_Overview.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_Overview message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_Overview
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_Overview} User_Overview
         */
        User_Overview.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_Overview)
                return object;
            let message = new $root.tdx_request.User_Overview();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_Overview message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_Overview
         * @static
         * @param {tdx_request.User_Overview} message User_Overview
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_Overview.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_Overview to JSON.
         * @function toJSON
         * @memberof tdx_request.User_Overview
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_Overview.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_Overview
         * @function getTypeUrl
         * @memberof tdx_request.User_Overview
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_Overview.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_Overview";
        };

        return User_Overview;
    })();

    tdx_request.User_Anomalies = (function() {

        /**
         * Properties of a User_Anomalies.
         * @memberof tdx_request
         * @interface IUser_Anomalies
         * @property {string|null} [pin] User_Anomalies pin
         * @property {Uint8Array|null} [data] User_Anomalies data
         * @property {number|Long|null} [fromTime] User_Anomalies fromTime
         * @property {number|Long|null} [toTime] User_Anomalies toTime
         * @property {string|null} [email] User_Anomalies email
         */

        /**
         * Constructs a new User_Anomalies.
         * @memberof tdx_request
         * @classdesc Represents a User_Anomalies.
         * @implements IUser_Anomalies
         * @constructor
         * @param {tdx_request.IUser_Anomalies=} [properties] Properties to set
         */
        function User_Anomalies(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_Anomalies pin.
         * @member {string} pin
         * @memberof tdx_request.User_Anomalies
         * @instance
         */
        User_Anomalies.prototype.pin = "";

        /**
         * User_Anomalies data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_Anomalies
         * @instance
         */
        User_Anomalies.prototype.data = $util.newBuffer([]);

        /**
         * User_Anomalies fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_Anomalies
         * @instance
         */
        User_Anomalies.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_Anomalies toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_Anomalies
         * @instance
         */
        User_Anomalies.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_Anomalies email.
         * @member {string} email
         * @memberof tdx_request.User_Anomalies
         * @instance
         */
        User_Anomalies.prototype.email = "";

        /**
         * Creates a new User_Anomalies instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {tdx_request.IUser_Anomalies=} [properties] Properties to set
         * @returns {tdx_request.User_Anomalies} User_Anomalies instance
         */
        User_Anomalies.create = function create(properties) {
            return new User_Anomalies(properties);
        };

        /**
         * Encodes the specified User_Anomalies message. Does not implicitly {@link tdx_request.User_Anomalies.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {tdx_request.IUser_Anomalies} message User_Anomalies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Anomalies.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_Anomalies message, length delimited. Does not implicitly {@link tdx_request.User_Anomalies.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {tdx_request.IUser_Anomalies} message User_Anomalies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Anomalies.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_Anomalies message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_Anomalies} User_Anomalies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Anomalies.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_Anomalies();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_Anomalies message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_Anomalies} User_Anomalies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Anomalies.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_Anomalies message.
         * @function verify
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_Anomalies.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_Anomalies message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_Anomalies} User_Anomalies
         */
        User_Anomalies.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_Anomalies)
                return object;
            let message = new $root.tdx_request.User_Anomalies();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_Anomalies message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {tdx_request.User_Anomalies} message User_Anomalies
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_Anomalies.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_Anomalies to JSON.
         * @function toJSON
         * @memberof tdx_request.User_Anomalies
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_Anomalies.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_Anomalies
         * @function getTypeUrl
         * @memberof tdx_request.User_Anomalies
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_Anomalies.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_Anomalies";
        };

        return User_Anomalies;
    })();

    tdx_request.User_TopContributingSignals = (function() {

        /**
         * Properties of a User_TopContributingSignals.
         * @memberof tdx_request
         * @interface IUser_TopContributingSignals
         * @property {string|null} [pin] User_TopContributingSignals pin
         * @property {Uint8Array|null} [data] User_TopContributingSignals data
         * @property {number|Long|null} [fromTime] User_TopContributingSignals fromTime
         * @property {number|Long|null} [toTime] User_TopContributingSignals toTime
         * @property {string|null} [email] User_TopContributingSignals email
         */

        /**
         * Constructs a new User_TopContributingSignals.
         * @memberof tdx_request
         * @classdesc Represents a User_TopContributingSignals.
         * @implements IUser_TopContributingSignals
         * @constructor
         * @param {tdx_request.IUser_TopContributingSignals=} [properties] Properties to set
         */
        function User_TopContributingSignals(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_TopContributingSignals pin.
         * @member {string} pin
         * @memberof tdx_request.User_TopContributingSignals
         * @instance
         */
        User_TopContributingSignals.prototype.pin = "";

        /**
         * User_TopContributingSignals data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_TopContributingSignals
         * @instance
         */
        User_TopContributingSignals.prototype.data = $util.newBuffer([]);

        /**
         * User_TopContributingSignals fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_TopContributingSignals
         * @instance
         */
        User_TopContributingSignals.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_TopContributingSignals toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_TopContributingSignals
         * @instance
         */
        User_TopContributingSignals.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_TopContributingSignals email.
         * @member {string} email
         * @memberof tdx_request.User_TopContributingSignals
         * @instance
         */
        User_TopContributingSignals.prototype.email = "";

        /**
         * Creates a new User_TopContributingSignals instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {tdx_request.IUser_TopContributingSignals=} [properties] Properties to set
         * @returns {tdx_request.User_TopContributingSignals} User_TopContributingSignals instance
         */
        User_TopContributingSignals.create = function create(properties) {
            return new User_TopContributingSignals(properties);
        };

        /**
         * Encodes the specified User_TopContributingSignals message. Does not implicitly {@link tdx_request.User_TopContributingSignals.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {tdx_request.IUser_TopContributingSignals} message User_TopContributingSignals message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TopContributingSignals.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_TopContributingSignals message, length delimited. Does not implicitly {@link tdx_request.User_TopContributingSignals.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {tdx_request.IUser_TopContributingSignals} message User_TopContributingSignals message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TopContributingSignals.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_TopContributingSignals message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_TopContributingSignals} User_TopContributingSignals
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TopContributingSignals.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_TopContributingSignals();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_TopContributingSignals message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_TopContributingSignals} User_TopContributingSignals
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TopContributingSignals.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_TopContributingSignals message.
         * @function verify
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_TopContributingSignals.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_TopContributingSignals message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_TopContributingSignals} User_TopContributingSignals
         */
        User_TopContributingSignals.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_TopContributingSignals)
                return object;
            let message = new $root.tdx_request.User_TopContributingSignals();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_TopContributingSignals message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {tdx_request.User_TopContributingSignals} message User_TopContributingSignals
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_TopContributingSignals.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_TopContributingSignals to JSON.
         * @function toJSON
         * @memberof tdx_request.User_TopContributingSignals
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_TopContributingSignals.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_TopContributingSignals
         * @function getTypeUrl
         * @memberof tdx_request.User_TopContributingSignals
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_TopContributingSignals.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_TopContributingSignals";
        };

        return User_TopContributingSignals;
    })();

    tdx_request.User_RiskScore = (function() {

        /**
         * Properties of a User_RiskScore.
         * @memberof tdx_request
         * @interface IUser_RiskScore
         * @property {string|null} [pin] User_RiskScore pin
         * @property {Uint8Array|null} [data] User_RiskScore data
         * @property {number|Long|null} [fromTime] User_RiskScore fromTime
         * @property {number|Long|null} [toTime] User_RiskScore toTime
         * @property {string|null} [email] User_RiskScore email
         */

        /**
         * Constructs a new User_RiskScore.
         * @memberof tdx_request
         * @classdesc Represents a User_RiskScore.
         * @implements IUser_RiskScore
         * @constructor
         * @param {tdx_request.IUser_RiskScore=} [properties] Properties to set
         */
        function User_RiskScore(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_RiskScore pin.
         * @member {string} pin
         * @memberof tdx_request.User_RiskScore
         * @instance
         */
        User_RiskScore.prototype.pin = "";

        /**
         * User_RiskScore data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_RiskScore
         * @instance
         */
        User_RiskScore.prototype.data = $util.newBuffer([]);

        /**
         * User_RiskScore fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_RiskScore
         * @instance
         */
        User_RiskScore.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_RiskScore toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_RiskScore
         * @instance
         */
        User_RiskScore.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_RiskScore email.
         * @member {string} email
         * @memberof tdx_request.User_RiskScore
         * @instance
         */
        User_RiskScore.prototype.email = "";

        /**
         * Creates a new User_RiskScore instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {tdx_request.IUser_RiskScore=} [properties] Properties to set
         * @returns {tdx_request.User_RiskScore} User_RiskScore instance
         */
        User_RiskScore.create = function create(properties) {
            return new User_RiskScore(properties);
        };

        /**
         * Encodes the specified User_RiskScore message. Does not implicitly {@link tdx_request.User_RiskScore.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {tdx_request.IUser_RiskScore} message User_RiskScore message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_RiskScore.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_RiskScore message, length delimited. Does not implicitly {@link tdx_request.User_RiskScore.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {tdx_request.IUser_RiskScore} message User_RiskScore message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_RiskScore.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_RiskScore message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_RiskScore} User_RiskScore
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_RiskScore.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_RiskScore();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_RiskScore message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_RiskScore} User_RiskScore
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_RiskScore.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_RiskScore message.
         * @function verify
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_RiskScore.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_RiskScore message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_RiskScore} User_RiskScore
         */
        User_RiskScore.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_RiskScore)
                return object;
            let message = new $root.tdx_request.User_RiskScore();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_RiskScore message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {tdx_request.User_RiskScore} message User_RiskScore
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_RiskScore.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_RiskScore to JSON.
         * @function toJSON
         * @memberof tdx_request.User_RiskScore
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_RiskScore.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_RiskScore
         * @function getTypeUrl
         * @memberof tdx_request.User_RiskScore
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_RiskScore.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_RiskScore";
        };

        return User_RiskScore;
    })();

    tdx_request.User_TimeHeatmap = (function() {

        /**
         * Properties of a User_TimeHeatmap.
         * @memberof tdx_request
         * @interface IUser_TimeHeatmap
         * @property {string|null} [pin] User_TimeHeatmap pin
         * @property {Uint8Array|null} [data] User_TimeHeatmap data
         * @property {number|Long|null} [fromTime] User_TimeHeatmap fromTime
         * @property {number|Long|null} [toTime] User_TimeHeatmap toTime
         * @property {string|null} [email] User_TimeHeatmap email
         */

        /**
         * Constructs a new User_TimeHeatmap.
         * @memberof tdx_request
         * @classdesc Represents a User_TimeHeatmap.
         * @implements IUser_TimeHeatmap
         * @constructor
         * @param {tdx_request.IUser_TimeHeatmap=} [properties] Properties to set
         */
        function User_TimeHeatmap(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_TimeHeatmap pin.
         * @member {string} pin
         * @memberof tdx_request.User_TimeHeatmap
         * @instance
         */
        User_TimeHeatmap.prototype.pin = "";

        /**
         * User_TimeHeatmap data.
         * @member {Uint8Array} data
         * @memberof tdx_request.User_TimeHeatmap
         * @instance
         */
        User_TimeHeatmap.prototype.data = $util.newBuffer([]);

        /**
         * User_TimeHeatmap fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.User_TimeHeatmap
         * @instance
         */
        User_TimeHeatmap.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_TimeHeatmap toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.User_TimeHeatmap
         * @instance
         */
        User_TimeHeatmap.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User_TimeHeatmap email.
         * @member {string} email
         * @memberof tdx_request.User_TimeHeatmap
         * @instance
         */
        User_TimeHeatmap.prototype.email = "";

        /**
         * Creates a new User_TimeHeatmap instance using the specified properties.
         * @function create
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {tdx_request.IUser_TimeHeatmap=} [properties] Properties to set
         * @returns {tdx_request.User_TimeHeatmap} User_TimeHeatmap instance
         */
        User_TimeHeatmap.create = function create(properties) {
            return new User_TimeHeatmap(properties);
        };

        /**
         * Encodes the specified User_TimeHeatmap message. Does not implicitly {@link tdx_request.User_TimeHeatmap.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {tdx_request.IUser_TimeHeatmap} message User_TimeHeatmap message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TimeHeatmap.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User_TimeHeatmap message, length delimited. Does not implicitly {@link tdx_request.User_TimeHeatmap.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {tdx_request.IUser_TimeHeatmap} message User_TimeHeatmap message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TimeHeatmap.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_TimeHeatmap message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.User_TimeHeatmap} User_TimeHeatmap
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TimeHeatmap.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.User_TimeHeatmap();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_TimeHeatmap message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.User_TimeHeatmap} User_TimeHeatmap
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TimeHeatmap.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_TimeHeatmap message.
         * @function verify
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_TimeHeatmap.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User_TimeHeatmap message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.User_TimeHeatmap} User_TimeHeatmap
         */
        User_TimeHeatmap.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.User_TimeHeatmap)
                return object;
            let message = new $root.tdx_request.User_TimeHeatmap();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User_TimeHeatmap message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {tdx_request.User_TimeHeatmap} message User_TimeHeatmap
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_TimeHeatmap.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.email = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User_TimeHeatmap to JSON.
         * @function toJSON
         * @memberof tdx_request.User_TimeHeatmap
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_TimeHeatmap.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_TimeHeatmap
         * @function getTypeUrl
         * @memberof tdx_request.User_TimeHeatmap
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_TimeHeatmap.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.User_TimeHeatmap";
        };

        return User_TimeHeatmap;
    })();

    tdx_request.Team_Members = (function() {

        /**
         * Properties of a Team_Members.
         * @memberof tdx_request
         * @interface ITeam_Members
         * @property {string|null} [pin] Team_Members pin
         * @property {Uint8Array|null} [data] Team_Members data
         * @property {number|Long|null} [fromTime] Team_Members fromTime
         * @property {number|Long|null} [toTime] Team_Members toTime
         * @property {string|null} [teamName] Team_Members teamName
         */

        /**
         * Constructs a new Team_Members.
         * @memberof tdx_request
         * @classdesc Represents a Team_Members.
         * @implements ITeam_Members
         * @constructor
         * @param {tdx_request.ITeam_Members=} [properties] Properties to set
         */
        function Team_Members(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_Members pin.
         * @member {string} pin
         * @memberof tdx_request.Team_Members
         * @instance
         */
        Team_Members.prototype.pin = "";

        /**
         * Team_Members data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Team_Members
         * @instance
         */
        Team_Members.prototype.data = $util.newBuffer([]);

        /**
         * Team_Members fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.Team_Members
         * @instance
         */
        Team_Members.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_Members toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.Team_Members
         * @instance
         */
        Team_Members.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_Members teamName.
         * @member {string} teamName
         * @memberof tdx_request.Team_Members
         * @instance
         */
        Team_Members.prototype.teamName = "";

        /**
         * Creates a new Team_Members instance using the specified properties.
         * @function create
         * @memberof tdx_request.Team_Members
         * @static
         * @param {tdx_request.ITeam_Members=} [properties] Properties to set
         * @returns {tdx_request.Team_Members} Team_Members instance
         */
        Team_Members.create = function create(properties) {
            return new Team_Members(properties);
        };

        /**
         * Encodes the specified Team_Members message. Does not implicitly {@link tdx_request.Team_Members.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Team_Members
         * @static
         * @param {tdx_request.ITeam_Members} message Team_Members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_Members.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.teamName);
            return writer;
        };

        /**
         * Encodes the specified Team_Members message, length delimited. Does not implicitly {@link tdx_request.Team_Members.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Team_Members
         * @static
         * @param {tdx_request.ITeam_Members} message Team_Members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_Members.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_Members message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Team_Members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Team_Members} Team_Members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_Members.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Team_Members();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.teamName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_Members message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Team_Members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Team_Members} Team_Members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_Members.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_Members message.
         * @function verify
         * @memberof tdx_request.Team_Members
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_Members.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                if (!$util.isString(message.teamName))
                    return "teamName: string expected";
            return null;
        };

        /**
         * Creates a Team_Members message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Team_Members
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Team_Members} Team_Members
         */
        Team_Members.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Team_Members)
                return object;
            let message = new $root.tdx_request.Team_Members();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.teamName != null)
                message.teamName = String(object.teamName);
            return message;
        };

        /**
         * Creates a plain object from a Team_Members message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Team_Members
         * @static
         * @param {tdx_request.Team_Members} message Team_Members
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_Members.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.teamName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                object.teamName = message.teamName;
            return object;
        };

        /**
         * Converts this Team_Members to JSON.
         * @function toJSON
         * @memberof tdx_request.Team_Members
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_Members.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_Members
         * @function getTypeUrl
         * @memberof tdx_request.Team_Members
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_Members.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Team_Members";
        };

        return Team_Members;
    })();

    tdx_request.Team_ActivityTimeline = (function() {

        /**
         * Properties of a Team_ActivityTimeline.
         * @memberof tdx_request
         * @interface ITeam_ActivityTimeline
         * @property {string|null} [pin] Team_ActivityTimeline pin
         * @property {Uint8Array|null} [data] Team_ActivityTimeline data
         * @property {number|Long|null} [fromTime] Team_ActivityTimeline fromTime
         * @property {number|Long|null} [toTime] Team_ActivityTimeline toTime
         * @property {string|null} [teamName] Team_ActivityTimeline teamName
         */

        /**
         * Constructs a new Team_ActivityTimeline.
         * @memberof tdx_request
         * @classdesc Represents a Team_ActivityTimeline.
         * @implements ITeam_ActivityTimeline
         * @constructor
         * @param {tdx_request.ITeam_ActivityTimeline=} [properties] Properties to set
         */
        function Team_ActivityTimeline(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_ActivityTimeline pin.
         * @member {string} pin
         * @memberof tdx_request.Team_ActivityTimeline
         * @instance
         */
        Team_ActivityTimeline.prototype.pin = "";

        /**
         * Team_ActivityTimeline data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Team_ActivityTimeline
         * @instance
         */
        Team_ActivityTimeline.prototype.data = $util.newBuffer([]);

        /**
         * Team_ActivityTimeline fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.Team_ActivityTimeline
         * @instance
         */
        Team_ActivityTimeline.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_ActivityTimeline toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.Team_ActivityTimeline
         * @instance
         */
        Team_ActivityTimeline.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_ActivityTimeline teamName.
         * @member {string} teamName
         * @memberof tdx_request.Team_ActivityTimeline
         * @instance
         */
        Team_ActivityTimeline.prototype.teamName = "";

        /**
         * Creates a new Team_ActivityTimeline instance using the specified properties.
         * @function create
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {tdx_request.ITeam_ActivityTimeline=} [properties] Properties to set
         * @returns {tdx_request.Team_ActivityTimeline} Team_ActivityTimeline instance
         */
        Team_ActivityTimeline.create = function create(properties) {
            return new Team_ActivityTimeline(properties);
        };

        /**
         * Encodes the specified Team_ActivityTimeline message. Does not implicitly {@link tdx_request.Team_ActivityTimeline.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {tdx_request.ITeam_ActivityTimeline} message Team_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_ActivityTimeline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.teamName);
            return writer;
        };

        /**
         * Encodes the specified Team_ActivityTimeline message, length delimited. Does not implicitly {@link tdx_request.Team_ActivityTimeline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {tdx_request.ITeam_ActivityTimeline} message Team_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_ActivityTimeline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_ActivityTimeline message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Team_ActivityTimeline} Team_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_ActivityTimeline.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Team_ActivityTimeline();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.teamName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_ActivityTimeline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Team_ActivityTimeline} Team_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_ActivityTimeline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_ActivityTimeline message.
         * @function verify
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_ActivityTimeline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                if (!$util.isString(message.teamName))
                    return "teamName: string expected";
            return null;
        };

        /**
         * Creates a Team_ActivityTimeline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Team_ActivityTimeline} Team_ActivityTimeline
         */
        Team_ActivityTimeline.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Team_ActivityTimeline)
                return object;
            let message = new $root.tdx_request.Team_ActivityTimeline();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.teamName != null)
                message.teamName = String(object.teamName);
            return message;
        };

        /**
         * Creates a plain object from a Team_ActivityTimeline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {tdx_request.Team_ActivityTimeline} message Team_ActivityTimeline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_ActivityTimeline.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.teamName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                object.teamName = message.teamName;
            return object;
        };

        /**
         * Converts this Team_ActivityTimeline to JSON.
         * @function toJSON
         * @memberof tdx_request.Team_ActivityTimeline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_ActivityTimeline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_ActivityTimeline
         * @function getTypeUrl
         * @memberof tdx_request.Team_ActivityTimeline
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_ActivityTimeline.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Team_ActivityTimeline";
        };

        return Team_ActivityTimeline;
    })();

    tdx_request.Team_FilesTouched = (function() {

        /**
         * Properties of a Team_FilesTouched.
         * @memberof tdx_request
         * @interface ITeam_FilesTouched
         * @property {string|null} [pin] Team_FilesTouched pin
         * @property {Uint8Array|null} [data] Team_FilesTouched data
         * @property {number|Long|null} [fromTime] Team_FilesTouched fromTime
         * @property {number|Long|null} [toTime] Team_FilesTouched toTime
         * @property {string|null} [teamName] Team_FilesTouched teamName
         */

        /**
         * Constructs a new Team_FilesTouched.
         * @memberof tdx_request
         * @classdesc Represents a Team_FilesTouched.
         * @implements ITeam_FilesTouched
         * @constructor
         * @param {tdx_request.ITeam_FilesTouched=} [properties] Properties to set
         */
        function Team_FilesTouched(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_FilesTouched pin.
         * @member {string} pin
         * @memberof tdx_request.Team_FilesTouched
         * @instance
         */
        Team_FilesTouched.prototype.pin = "";

        /**
         * Team_FilesTouched data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Team_FilesTouched
         * @instance
         */
        Team_FilesTouched.prototype.data = $util.newBuffer([]);

        /**
         * Team_FilesTouched fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.Team_FilesTouched
         * @instance
         */
        Team_FilesTouched.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_FilesTouched toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.Team_FilesTouched
         * @instance
         */
        Team_FilesTouched.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_FilesTouched teamName.
         * @member {string} teamName
         * @memberof tdx_request.Team_FilesTouched
         * @instance
         */
        Team_FilesTouched.prototype.teamName = "";

        /**
         * Creates a new Team_FilesTouched instance using the specified properties.
         * @function create
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {tdx_request.ITeam_FilesTouched=} [properties] Properties to set
         * @returns {tdx_request.Team_FilesTouched} Team_FilesTouched instance
         */
        Team_FilesTouched.create = function create(properties) {
            return new Team_FilesTouched(properties);
        };

        /**
         * Encodes the specified Team_FilesTouched message. Does not implicitly {@link tdx_request.Team_FilesTouched.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {tdx_request.ITeam_FilesTouched} message Team_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_FilesTouched.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.teamName);
            return writer;
        };

        /**
         * Encodes the specified Team_FilesTouched message, length delimited. Does not implicitly {@link tdx_request.Team_FilesTouched.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {tdx_request.ITeam_FilesTouched} message Team_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_FilesTouched.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_FilesTouched message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Team_FilesTouched} Team_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_FilesTouched.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Team_FilesTouched();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.teamName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_FilesTouched message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Team_FilesTouched} Team_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_FilesTouched.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_FilesTouched message.
         * @function verify
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_FilesTouched.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                if (!$util.isString(message.teamName))
                    return "teamName: string expected";
            return null;
        };

        /**
         * Creates a Team_FilesTouched message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Team_FilesTouched} Team_FilesTouched
         */
        Team_FilesTouched.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Team_FilesTouched)
                return object;
            let message = new $root.tdx_request.Team_FilesTouched();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.teamName != null)
                message.teamName = String(object.teamName);
            return message;
        };

        /**
         * Creates a plain object from a Team_FilesTouched message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {tdx_request.Team_FilesTouched} message Team_FilesTouched
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_FilesTouched.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.teamName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                object.teamName = message.teamName;
            return object;
        };

        /**
         * Converts this Team_FilesTouched to JSON.
         * @function toJSON
         * @memberof tdx_request.Team_FilesTouched
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_FilesTouched.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_FilesTouched
         * @function getTypeUrl
         * @memberof tdx_request.Team_FilesTouched
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_FilesTouched.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Team_FilesTouched";
        };

        return Team_FilesTouched;
    })();

    tdx_request.Team_MembershipChanges = (function() {

        /**
         * Properties of a Team_MembershipChanges.
         * @memberof tdx_request
         * @interface ITeam_MembershipChanges
         * @property {string|null} [pin] Team_MembershipChanges pin
         * @property {Uint8Array|null} [data] Team_MembershipChanges data
         * @property {number|Long|null} [fromTime] Team_MembershipChanges fromTime
         * @property {number|Long|null} [toTime] Team_MembershipChanges toTime
         * @property {string|null} [teamName] Team_MembershipChanges teamName
         */

        /**
         * Constructs a new Team_MembershipChanges.
         * @memberof tdx_request
         * @classdesc Represents a Team_MembershipChanges.
         * @implements ITeam_MembershipChanges
         * @constructor
         * @param {tdx_request.ITeam_MembershipChanges=} [properties] Properties to set
         */
        function Team_MembershipChanges(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_MembershipChanges pin.
         * @member {string} pin
         * @memberof tdx_request.Team_MembershipChanges
         * @instance
         */
        Team_MembershipChanges.prototype.pin = "";

        /**
         * Team_MembershipChanges data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Team_MembershipChanges
         * @instance
         */
        Team_MembershipChanges.prototype.data = $util.newBuffer([]);

        /**
         * Team_MembershipChanges fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.Team_MembershipChanges
         * @instance
         */
        Team_MembershipChanges.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_MembershipChanges toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.Team_MembershipChanges
         * @instance
         */
        Team_MembershipChanges.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_MembershipChanges teamName.
         * @member {string} teamName
         * @memberof tdx_request.Team_MembershipChanges
         * @instance
         */
        Team_MembershipChanges.prototype.teamName = "";

        /**
         * Creates a new Team_MembershipChanges instance using the specified properties.
         * @function create
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {tdx_request.ITeam_MembershipChanges=} [properties] Properties to set
         * @returns {tdx_request.Team_MembershipChanges} Team_MembershipChanges instance
         */
        Team_MembershipChanges.create = function create(properties) {
            return new Team_MembershipChanges(properties);
        };

        /**
         * Encodes the specified Team_MembershipChanges message. Does not implicitly {@link tdx_request.Team_MembershipChanges.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {tdx_request.ITeam_MembershipChanges} message Team_MembershipChanges message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_MembershipChanges.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.teamName);
            return writer;
        };

        /**
         * Encodes the specified Team_MembershipChanges message, length delimited. Does not implicitly {@link tdx_request.Team_MembershipChanges.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {tdx_request.ITeam_MembershipChanges} message Team_MembershipChanges message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_MembershipChanges.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_MembershipChanges message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Team_MembershipChanges} Team_MembershipChanges
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_MembershipChanges.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Team_MembershipChanges();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.teamName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_MembershipChanges message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Team_MembershipChanges} Team_MembershipChanges
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_MembershipChanges.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_MembershipChanges message.
         * @function verify
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_MembershipChanges.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                if (!$util.isString(message.teamName))
                    return "teamName: string expected";
            return null;
        };

        /**
         * Creates a Team_MembershipChanges message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Team_MembershipChanges} Team_MembershipChanges
         */
        Team_MembershipChanges.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Team_MembershipChanges)
                return object;
            let message = new $root.tdx_request.Team_MembershipChanges();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.teamName != null)
                message.teamName = String(object.teamName);
            return message;
        };

        /**
         * Creates a plain object from a Team_MembershipChanges message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {tdx_request.Team_MembershipChanges} message Team_MembershipChanges
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_MembershipChanges.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.teamName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                object.teamName = message.teamName;
            return object;
        };

        /**
         * Converts this Team_MembershipChanges to JSON.
         * @function toJSON
         * @memberof tdx_request.Team_MembershipChanges
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_MembershipChanges.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_MembershipChanges
         * @function getTypeUrl
         * @memberof tdx_request.Team_MembershipChanges
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_MembershipChanges.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Team_MembershipChanges";
        };

        return Team_MembershipChanges;
    })();

    tdx_request.Team_RoleIntersection = (function() {

        /**
         * Properties of a Team_RoleIntersection.
         * @memberof tdx_request
         * @interface ITeam_RoleIntersection
         * @property {string|null} [pin] Team_RoleIntersection pin
         * @property {Uint8Array|null} [data] Team_RoleIntersection data
         * @property {number|Long|null} [fromTime] Team_RoleIntersection fromTime
         * @property {number|Long|null} [toTime] Team_RoleIntersection toTime
         * @property {string|null} [teamName] Team_RoleIntersection teamName
         */

        /**
         * Constructs a new Team_RoleIntersection.
         * @memberof tdx_request
         * @classdesc Represents a Team_RoleIntersection.
         * @implements ITeam_RoleIntersection
         * @constructor
         * @param {tdx_request.ITeam_RoleIntersection=} [properties] Properties to set
         */
        function Team_RoleIntersection(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_RoleIntersection pin.
         * @member {string} pin
         * @memberof tdx_request.Team_RoleIntersection
         * @instance
         */
        Team_RoleIntersection.prototype.pin = "";

        /**
         * Team_RoleIntersection data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Team_RoleIntersection
         * @instance
         */
        Team_RoleIntersection.prototype.data = $util.newBuffer([]);

        /**
         * Team_RoleIntersection fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.Team_RoleIntersection
         * @instance
         */
        Team_RoleIntersection.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_RoleIntersection toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.Team_RoleIntersection
         * @instance
         */
        Team_RoleIntersection.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_RoleIntersection teamName.
         * @member {string} teamName
         * @memberof tdx_request.Team_RoleIntersection
         * @instance
         */
        Team_RoleIntersection.prototype.teamName = "";

        /**
         * Creates a new Team_RoleIntersection instance using the specified properties.
         * @function create
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {tdx_request.ITeam_RoleIntersection=} [properties] Properties to set
         * @returns {tdx_request.Team_RoleIntersection} Team_RoleIntersection instance
         */
        Team_RoleIntersection.create = function create(properties) {
            return new Team_RoleIntersection(properties);
        };

        /**
         * Encodes the specified Team_RoleIntersection message. Does not implicitly {@link tdx_request.Team_RoleIntersection.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {tdx_request.ITeam_RoleIntersection} message Team_RoleIntersection message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_RoleIntersection.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.teamName);
            return writer;
        };

        /**
         * Encodes the specified Team_RoleIntersection message, length delimited. Does not implicitly {@link tdx_request.Team_RoleIntersection.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {tdx_request.ITeam_RoleIntersection} message Team_RoleIntersection message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_RoleIntersection.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_RoleIntersection message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Team_RoleIntersection} Team_RoleIntersection
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_RoleIntersection.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Team_RoleIntersection();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.teamName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_RoleIntersection message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Team_RoleIntersection} Team_RoleIntersection
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_RoleIntersection.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_RoleIntersection message.
         * @function verify
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_RoleIntersection.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                if (!$util.isString(message.teamName))
                    return "teamName: string expected";
            return null;
        };

        /**
         * Creates a Team_RoleIntersection message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Team_RoleIntersection} Team_RoleIntersection
         */
        Team_RoleIntersection.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Team_RoleIntersection)
                return object;
            let message = new $root.tdx_request.Team_RoleIntersection();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.teamName != null)
                message.teamName = String(object.teamName);
            return message;
        };

        /**
         * Creates a plain object from a Team_RoleIntersection message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {tdx_request.Team_RoleIntersection} message Team_RoleIntersection
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_RoleIntersection.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.teamName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                object.teamName = message.teamName;
            return object;
        };

        /**
         * Converts this Team_RoleIntersection to JSON.
         * @function toJSON
         * @memberof tdx_request.Team_RoleIntersection
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_RoleIntersection.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_RoleIntersection
         * @function getTypeUrl
         * @memberof tdx_request.Team_RoleIntersection
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_RoleIntersection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Team_RoleIntersection";
        };

        return Team_RoleIntersection;
    })();

    tdx_request.Team_SharingActions = (function() {

        /**
         * Properties of a Team_SharingActions.
         * @memberof tdx_request
         * @interface ITeam_SharingActions
         * @property {string|null} [pin] Team_SharingActions pin
         * @property {Uint8Array|null} [data] Team_SharingActions data
         * @property {number|Long|null} [fromTime] Team_SharingActions fromTime
         * @property {number|Long|null} [toTime] Team_SharingActions toTime
         * @property {string|null} [teamName] Team_SharingActions teamName
         */

        /**
         * Constructs a new Team_SharingActions.
         * @memberof tdx_request
         * @classdesc Represents a Team_SharingActions.
         * @implements ITeam_SharingActions
         * @constructor
         * @param {tdx_request.ITeam_SharingActions=} [properties] Properties to set
         */
        function Team_SharingActions(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_SharingActions pin.
         * @member {string} pin
         * @memberof tdx_request.Team_SharingActions
         * @instance
         */
        Team_SharingActions.prototype.pin = "";

        /**
         * Team_SharingActions data.
         * @member {Uint8Array} data
         * @memberof tdx_request.Team_SharingActions
         * @instance
         */
        Team_SharingActions.prototype.data = $util.newBuffer([]);

        /**
         * Team_SharingActions fromTime.
         * @member {number|Long} fromTime
         * @memberof tdx_request.Team_SharingActions
         * @instance
         */
        Team_SharingActions.prototype.fromTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_SharingActions toTime.
         * @member {number|Long} toTime
         * @memberof tdx_request.Team_SharingActions
         * @instance
         */
        Team_SharingActions.prototype.toTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Team_SharingActions teamName.
         * @member {string} teamName
         * @memberof tdx_request.Team_SharingActions
         * @instance
         */
        Team_SharingActions.prototype.teamName = "";

        /**
         * Creates a new Team_SharingActions instance using the specified properties.
         * @function create
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {tdx_request.ITeam_SharingActions=} [properties] Properties to set
         * @returns {tdx_request.Team_SharingActions} Team_SharingActions instance
         */
        Team_SharingActions.create = function create(properties) {
            return new Team_SharingActions(properties);
        };

        /**
         * Encodes the specified Team_SharingActions message. Does not implicitly {@link tdx_request.Team_SharingActions.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {tdx_request.ITeam_SharingActions} message Team_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_SharingActions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.fromTime != null && Object.hasOwnProperty.call(message, "fromTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fromTime);
            if (message.toTime != null && Object.hasOwnProperty.call(message, "toTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.toTime);
            if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.teamName);
            return writer;
        };

        /**
         * Encodes the specified Team_SharingActions message, length delimited. Does not implicitly {@link tdx_request.Team_SharingActions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {tdx_request.ITeam_SharingActions} message Team_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_SharingActions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_SharingActions message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Team_SharingActions} Team_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_SharingActions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Team_SharingActions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fromTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.toTime = reader.uint64();
                        break;
                    }
                case 5: {
                        message.teamName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_SharingActions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Team_SharingActions} Team_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_SharingActions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_SharingActions message.
         * @function verify
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_SharingActions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (!$util.isInteger(message.fromTime) && !(message.fromTime && $util.isInteger(message.fromTime.low) && $util.isInteger(message.fromTime.high)))
                    return "fromTime: integer|Long expected";
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (!$util.isInteger(message.toTime) && !(message.toTime && $util.isInteger(message.toTime.low) && $util.isInteger(message.toTime.high)))
                    return "toTime: integer|Long expected";
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                if (!$util.isString(message.teamName))
                    return "teamName: string expected";
            return null;
        };

        /**
         * Creates a Team_SharingActions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Team_SharingActions} Team_SharingActions
         */
        Team_SharingActions.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Team_SharingActions)
                return object;
            let message = new $root.tdx_request.Team_SharingActions();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.fromTime != null)
                if ($util.Long)
                    (message.fromTime = $util.Long.fromValue(object.fromTime)).unsigned = true;
                else if (typeof object.fromTime === "string")
                    message.fromTime = parseInt(object.fromTime, 10);
                else if (typeof object.fromTime === "number")
                    message.fromTime = object.fromTime;
                else if (typeof object.fromTime === "object")
                    message.fromTime = new $util.LongBits(object.fromTime.low >>> 0, object.fromTime.high >>> 0).toNumber(true);
            if (object.toTime != null)
                if ($util.Long)
                    (message.toTime = $util.Long.fromValue(object.toTime)).unsigned = true;
                else if (typeof object.toTime === "string")
                    message.toTime = parseInt(object.toTime, 10);
                else if (typeof object.toTime === "number")
                    message.toTime = object.toTime;
                else if (typeof object.toTime === "object")
                    message.toTime = new $util.LongBits(object.toTime.low >>> 0, object.toTime.high >>> 0).toNumber(true);
            if (object.teamName != null)
                message.teamName = String(object.teamName);
            return message;
        };

        /**
         * Creates a plain object from a Team_SharingActions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {tdx_request.Team_SharingActions} message Team_SharingActions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_SharingActions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fromTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fromTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.toTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.toTime = options.longs === String ? "0" : 0;
                object.teamName = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.fromTime != null && message.hasOwnProperty("fromTime"))
                if (typeof message.fromTime === "number")
                    object.fromTime = options.longs === String ? String(message.fromTime) : message.fromTime;
                else
                    object.fromTime = options.longs === String ? $util.Long.prototype.toString.call(message.fromTime) : options.longs === Number ? new $util.LongBits(message.fromTime.low >>> 0, message.fromTime.high >>> 0).toNumber(true) : message.fromTime;
            if (message.toTime != null && message.hasOwnProperty("toTime"))
                if (typeof message.toTime === "number")
                    object.toTime = options.longs === String ? String(message.toTime) : message.toTime;
                else
                    object.toTime = options.longs === String ? $util.Long.prototype.toString.call(message.toTime) : options.longs === Number ? new $util.LongBits(message.toTime.low >>> 0, message.toTime.high >>> 0).toNumber(true) : message.toTime;
            if (message.teamName != null && message.hasOwnProperty("teamName"))
                object.teamName = message.teamName;
            return object;
        };

        /**
         * Converts this Team_SharingActions to JSON.
         * @function toJSON
         * @memberof tdx_request.Team_SharingActions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_SharingActions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_SharingActions
         * @function getTypeUrl
         * @memberof tdx_request.Team_SharingActions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_SharingActions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Team_SharingActions";
        };

        return Team_SharingActions;
    })();

    tdx_request.Request = (function() {

        /**
         * Properties of a Request.
         * @memberof tdx_request
         * @interface IRequest
         * @property {number|Long|null} [id] Request id
         * @property {tdx_request.IListLogsFromQuery|null} [listLogs] Request listLogs
         * @property {tdx_request.ICreateAlert|null} [crateAlert] Request crateAlert
         * @property {tdx_request.IDeleteAlert|null} [deleteAlert] Request deleteAlert
         * @property {tdx_request.IListAlerts|null} [listAlerts] Request listAlerts
         * @property {tdx_request.IUpdateAlert|null} [updateAlert] Request updateAlert
         * @property {tdx_request.IGetLedgerRange|null} [getLedgerRange] Request getLedgerRange
         * @property {tdx_request.IGetAuditLog|null} [getAuditLog] Request getAuditLog
         * @property {tdx_request.IGetConsistencyProof|null} [getConsistencyProof] Request getConsistencyProof
         * @property {tdx_request.IGetInclusionProof|null} [getInclusionProof] Request getInclusionProof
         * @property {tdx_request.IStartConversion|null} [startConversion] Request startConversion
         * @property {tdx_request.IGetChunkFromYSentinel|null} [getChunkFromYSentinel] Request getChunkFromYSentinel
         * @property {tdx_request.ITopMovers|null} [topMovers] Request topMovers
         * @property {tdx_request.IOperationCountOverTime|null} [operationCountOverTime] Request operationCountOverTime
         * @property {tdx_request.IStorageDistribution|null} [storageDistribution] Request storageDistribution
         * @property {tdx_request.IAccessByLocation|null} [accessByLocation] Request accessByLocation
         * @property {tdx_request.IExternalShareTopUsers|null} [externalShareTopUsers] Request externalShareTopUsers
         * @property {tdx_request.IOverview_OffHoursRatio|null} [overviewOffHoursRatio] Request overviewOffHoursRatio
         * @property {tdx_request.IGetRemovedUsersFromLogs|null} [getRemovedUsersFromLogs] Request getRemovedUsersFromLogs
         * @property {tdx_request.IGetRemovedTeamsFromLogs|null} [getRemovedTeamsFromLogs] Request getRemovedTeamsFromLogs
         * @property {tdx_request.IUser_ActivityTimeline|null} [user_ActivityTimeline] Request user_ActivityTimeline
         * @property {tdx_request.IUser_CountriesAccessedFrom|null} [user_CountriesAccessedFrom] Request user_CountriesAccessedFrom
         * @property {tdx_request.IUser_OpCount|null} [user_OpCount] Request user_OpCount
         * @property {tdx_request.IUser_WriteActivity|null} [user_WriteActivity] Request user_WriteActivity
         * @property {tdx_request.IUser_StorageBreakdown|null} [user_StorageBreakdown] Request user_StorageBreakdown
         * @property {tdx_request.IUser_FilesTouched|null} [user_FilesTouched] Request user_FilesTouched
         * @property {tdx_request.IUser_SharingActions|null} [user_SharingActions] Request user_SharingActions
         * @property {tdx_request.IUser_PermissionRecieved|null} [user_PermissionRecieved] Request user_PermissionRecieved
         * @property {tdx_request.IUser_DeniedAttempts|null} [user_DeniedAttempts] Request user_DeniedAttempts
         * @property {tdx_request.IUser_RiskScore|null} [user_RiskScore] Request user_RiskScore
         * @property {tdx_request.IUser_TopContributingSignals|null} [user_TopContributingSignals] Request user_TopContributingSignals
         * @property {tdx_request.IUser_Anomalies|null} [user_Anomalies] Request user_Anomalies
         * @property {tdx_request.IUser_Overview|null} [user_Overview] Request user_Overview
         * @property {tdx_request.IFileDetails|null} [fileDetails] Request fileDetails
         * @property {tdx_request.IFileSummary|null} [fileSummary] Request fileSummary
         * @property {tdx_request.ILifecycleEvents|null} [lifecycleEvents] Request lifecycleEvents
         * @property {tdx_request.IVersionHistory|null} [versionHistory] Request versionHistory
         * @property {tdx_request.IShares|null} [shares] Request shares
         * @property {tdx_request.IPathHistory|null} [pathHistory] Request pathHistory
         * @property {tdx_request.IActorStats|null} [actorStats] Request actorStats
         * @property {tdx_request.ICountryStats|null} [countryStats] Request countryStats
         * @property {tdx_request.IUser_TimeHeatmap|null} [userTimeHeatmap] Request userTimeHeatmap
         * @property {tdx_request.ITeam_Members|null} [teamMembers] Request teamMembers
         * @property {tdx_request.ITeam_ActivityTimeline|null} [teamActivityTimeline] Request teamActivityTimeline
         * @property {tdx_request.ITeam_FilesTouched|null} [teamFilesTouched] Request teamFilesTouched
         * @property {tdx_request.ITeam_MembershipChanges|null} [teamMembershipChanges] Request teamMembershipChanges
         * @property {tdx_request.ITeam_RoleIntersection|null} [teamRoleIntersection] Request teamRoleIntersection
         * @property {tdx_request.IListFilesForDashboard|null} [listFilesForDashboard] Request listFilesForDashboard
         * @property {tdx_request.ITeam_SharingActions|null} [teamSharingActions] Request teamSharingActions
         * @property {tdx_request.ICollaborationFlow|null} [collaborationFlow] Request collaborationFlow
         */

        /**
         * Constructs a new Request.
         * @memberof tdx_request
         * @classdesc Represents a Request.
         * @implements IRequest
         * @constructor
         * @param {tdx_request.IRequest=} [properties] Properties to set
         */
        function Request(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Request id.
         * @member {number|Long|null|undefined} id
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.id = null;

        /**
         * Request listLogs.
         * @member {tdx_request.IListLogsFromQuery|null|undefined} listLogs
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.listLogs = null;

        /**
         * Request crateAlert.
         * @member {tdx_request.ICreateAlert|null|undefined} crateAlert
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.crateAlert = null;

        /**
         * Request deleteAlert.
         * @member {tdx_request.IDeleteAlert|null|undefined} deleteAlert
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.deleteAlert = null;

        /**
         * Request listAlerts.
         * @member {tdx_request.IListAlerts|null|undefined} listAlerts
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.listAlerts = null;

        /**
         * Request updateAlert.
         * @member {tdx_request.IUpdateAlert|null|undefined} updateAlert
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.updateAlert = null;

        /**
         * Request getLedgerRange.
         * @member {tdx_request.IGetLedgerRange|null|undefined} getLedgerRange
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.getLedgerRange = null;

        /**
         * Request getAuditLog.
         * @member {tdx_request.IGetAuditLog|null|undefined} getAuditLog
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.getAuditLog = null;

        /**
         * Request getConsistencyProof.
         * @member {tdx_request.IGetConsistencyProof|null|undefined} getConsistencyProof
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.getConsistencyProof = null;

        /**
         * Request getInclusionProof.
         * @member {tdx_request.IGetInclusionProof|null|undefined} getInclusionProof
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.getInclusionProof = null;

        /**
         * Request startConversion.
         * @member {tdx_request.IStartConversion|null|undefined} startConversion
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.startConversion = null;

        /**
         * Request getChunkFromYSentinel.
         * @member {tdx_request.IGetChunkFromYSentinel|null|undefined} getChunkFromYSentinel
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.getChunkFromYSentinel = null;

        /**
         * Request topMovers.
         * @member {tdx_request.ITopMovers|null|undefined} topMovers
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.topMovers = null;

        /**
         * Request operationCountOverTime.
         * @member {tdx_request.IOperationCountOverTime|null|undefined} operationCountOverTime
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.operationCountOverTime = null;

        /**
         * Request storageDistribution.
         * @member {tdx_request.IStorageDistribution|null|undefined} storageDistribution
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.storageDistribution = null;

        /**
         * Request accessByLocation.
         * @member {tdx_request.IAccessByLocation|null|undefined} accessByLocation
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.accessByLocation = null;

        /**
         * Request externalShareTopUsers.
         * @member {tdx_request.IExternalShareTopUsers|null|undefined} externalShareTopUsers
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.externalShareTopUsers = null;

        /**
         * Request overviewOffHoursRatio.
         * @member {tdx_request.IOverview_OffHoursRatio|null|undefined} overviewOffHoursRatio
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.overviewOffHoursRatio = null;

        /**
         * Request getRemovedUsersFromLogs.
         * @member {tdx_request.IGetRemovedUsersFromLogs|null|undefined} getRemovedUsersFromLogs
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.getRemovedUsersFromLogs = null;

        /**
         * Request getRemovedTeamsFromLogs.
         * @member {tdx_request.IGetRemovedTeamsFromLogs|null|undefined} getRemovedTeamsFromLogs
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.getRemovedTeamsFromLogs = null;

        /**
         * Request user_ActivityTimeline.
         * @member {tdx_request.IUser_ActivityTimeline|null|undefined} user_ActivityTimeline
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_ActivityTimeline = null;

        /**
         * Request user_CountriesAccessedFrom.
         * @member {tdx_request.IUser_CountriesAccessedFrom|null|undefined} user_CountriesAccessedFrom
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_CountriesAccessedFrom = null;

        /**
         * Request user_OpCount.
         * @member {tdx_request.IUser_OpCount|null|undefined} user_OpCount
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_OpCount = null;

        /**
         * Request user_WriteActivity.
         * @member {tdx_request.IUser_WriteActivity|null|undefined} user_WriteActivity
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_WriteActivity = null;

        /**
         * Request user_StorageBreakdown.
         * @member {tdx_request.IUser_StorageBreakdown|null|undefined} user_StorageBreakdown
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_StorageBreakdown = null;

        /**
         * Request user_FilesTouched.
         * @member {tdx_request.IUser_FilesTouched|null|undefined} user_FilesTouched
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_FilesTouched = null;

        /**
         * Request user_SharingActions.
         * @member {tdx_request.IUser_SharingActions|null|undefined} user_SharingActions
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_SharingActions = null;

        /**
         * Request user_PermissionRecieved.
         * @member {tdx_request.IUser_PermissionRecieved|null|undefined} user_PermissionRecieved
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_PermissionRecieved = null;

        /**
         * Request user_DeniedAttempts.
         * @member {tdx_request.IUser_DeniedAttempts|null|undefined} user_DeniedAttempts
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_DeniedAttempts = null;

        /**
         * Request user_RiskScore.
         * @member {tdx_request.IUser_RiskScore|null|undefined} user_RiskScore
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_RiskScore = null;

        /**
         * Request user_TopContributingSignals.
         * @member {tdx_request.IUser_TopContributingSignals|null|undefined} user_TopContributingSignals
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_TopContributingSignals = null;

        /**
         * Request user_Anomalies.
         * @member {tdx_request.IUser_Anomalies|null|undefined} user_Anomalies
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_Anomalies = null;

        /**
         * Request user_Overview.
         * @member {tdx_request.IUser_Overview|null|undefined} user_Overview
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.user_Overview = null;

        /**
         * Request fileDetails.
         * @member {tdx_request.IFileDetails|null|undefined} fileDetails
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.fileDetails = null;

        /**
         * Request fileSummary.
         * @member {tdx_request.IFileSummary|null|undefined} fileSummary
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.fileSummary = null;

        /**
         * Request lifecycleEvents.
         * @member {tdx_request.ILifecycleEvents|null|undefined} lifecycleEvents
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.lifecycleEvents = null;

        /**
         * Request versionHistory.
         * @member {tdx_request.IVersionHistory|null|undefined} versionHistory
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.versionHistory = null;

        /**
         * Request shares.
         * @member {tdx_request.IShares|null|undefined} shares
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.shares = null;

        /**
         * Request pathHistory.
         * @member {tdx_request.IPathHistory|null|undefined} pathHistory
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.pathHistory = null;

        /**
         * Request actorStats.
         * @member {tdx_request.IActorStats|null|undefined} actorStats
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.actorStats = null;

        /**
         * Request countryStats.
         * @member {tdx_request.ICountryStats|null|undefined} countryStats
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.countryStats = null;

        /**
         * Request userTimeHeatmap.
         * @member {tdx_request.IUser_TimeHeatmap|null|undefined} userTimeHeatmap
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.userTimeHeatmap = null;

        /**
         * Request teamMembers.
         * @member {tdx_request.ITeam_Members|null|undefined} teamMembers
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.teamMembers = null;

        /**
         * Request teamActivityTimeline.
         * @member {tdx_request.ITeam_ActivityTimeline|null|undefined} teamActivityTimeline
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.teamActivityTimeline = null;

        /**
         * Request teamFilesTouched.
         * @member {tdx_request.ITeam_FilesTouched|null|undefined} teamFilesTouched
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.teamFilesTouched = null;

        /**
         * Request teamMembershipChanges.
         * @member {tdx_request.ITeam_MembershipChanges|null|undefined} teamMembershipChanges
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.teamMembershipChanges = null;

        /**
         * Request teamRoleIntersection.
         * @member {tdx_request.ITeam_RoleIntersection|null|undefined} teamRoleIntersection
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.teamRoleIntersection = null;

        /**
         * Request listFilesForDashboard.
         * @member {tdx_request.IListFilesForDashboard|null|undefined} listFilesForDashboard
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.listFilesForDashboard = null;

        /**
         * Request teamSharingActions.
         * @member {tdx_request.ITeam_SharingActions|null|undefined} teamSharingActions
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.teamSharingActions = null;

        /**
         * Request collaborationFlow.
         * @member {tdx_request.ICollaborationFlow|null|undefined} collaborationFlow
         * @memberof tdx_request.Request
         * @instance
         */
        Request.prototype.collaborationFlow = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * Request _id.
         * @member {"id"|undefined} _id
         * @memberof tdx_request.Request
         * @instance
         */
        Object.defineProperty(Request.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Request Operation.
         * @member {"listLogs"|"crateAlert"|"deleteAlert"|"listAlerts"|"updateAlert"|"getLedgerRange"|"getAuditLog"|"getConsistencyProof"|"getInclusionProof"|"startConversion"|"getChunkFromYSentinel"|"topMovers"|"operationCountOverTime"|"storageDistribution"|"accessByLocation"|"externalShareTopUsers"|"overviewOffHoursRatio"|"getRemovedUsersFromLogs"|"getRemovedTeamsFromLogs"|"user_ActivityTimeline"|"user_CountriesAccessedFrom"|"user_OpCount"|"user_WriteActivity"|"user_StorageBreakdown"|"user_FilesTouched"|"user_SharingActions"|"user_PermissionRecieved"|"user_DeniedAttempts"|"user_RiskScore"|"user_TopContributingSignals"|"user_Anomalies"|"user_Overview"|"fileDetails"|"fileSummary"|"lifecycleEvents"|"versionHistory"|"shares"|"pathHistory"|"actorStats"|"countryStats"|"userTimeHeatmap"|"teamMembers"|"teamActivityTimeline"|"teamFilesTouched"|"teamMembershipChanges"|"teamRoleIntersection"|"listFilesForDashboard"|"teamSharingActions"|"collaborationFlow"|undefined} Operation
         * @memberof tdx_request.Request
         * @instance
         */
        Object.defineProperty(Request.prototype, "Operation", {
            get: $util.oneOfGetter($oneOfFields = ["listLogs", "crateAlert", "deleteAlert", "listAlerts", "updateAlert", "getLedgerRange", "getAuditLog", "getConsistencyProof", "getInclusionProof", "startConversion", "getChunkFromYSentinel", "topMovers", "operationCountOverTime", "storageDistribution", "accessByLocation", "externalShareTopUsers", "overviewOffHoursRatio", "getRemovedUsersFromLogs", "getRemovedTeamsFromLogs", "user_ActivityTimeline", "user_CountriesAccessedFrom", "user_OpCount", "user_WriteActivity", "user_StorageBreakdown", "user_FilesTouched", "user_SharingActions", "user_PermissionRecieved", "user_DeniedAttempts", "user_RiskScore", "user_TopContributingSignals", "user_Anomalies", "user_Overview", "fileDetails", "fileSummary", "lifecycleEvents", "versionHistory", "shares", "pathHistory", "actorStats", "countryStats", "userTimeHeatmap", "teamMembers", "teamActivityTimeline", "teamFilesTouched", "teamMembershipChanges", "teamRoleIntersection", "listFilesForDashboard", "teamSharingActions", "collaborationFlow"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Request instance using the specified properties.
         * @function create
         * @memberof tdx_request.Request
         * @static
         * @param {tdx_request.IRequest=} [properties] Properties to set
         * @returns {tdx_request.Request} Request instance
         */
        Request.create = function create(properties) {
            return new Request(properties);
        };

        /**
         * Encodes the specified Request message. Does not implicitly {@link tdx_request.Request.verify|verify} messages.
         * @function encode
         * @memberof tdx_request.Request
         * @static
         * @param {tdx_request.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
            if (message.listLogs != null && Object.hasOwnProperty.call(message, "listLogs"))
                $root.tdx_request.ListLogsFromQuery.encode(message.listLogs, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.crateAlert != null && Object.hasOwnProperty.call(message, "crateAlert"))
                $root.tdx_request.CreateAlert.encode(message.crateAlert, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.deleteAlert != null && Object.hasOwnProperty.call(message, "deleteAlert"))
                $root.tdx_request.DeleteAlert.encode(message.deleteAlert, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.listAlerts != null && Object.hasOwnProperty.call(message, "listAlerts"))
                $root.tdx_request.ListAlerts.encode(message.listAlerts, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.updateAlert != null && Object.hasOwnProperty.call(message, "updateAlert"))
                $root.tdx_request.UpdateAlert.encode(message.updateAlert, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.getLedgerRange != null && Object.hasOwnProperty.call(message, "getLedgerRange"))
                $root.tdx_request.GetLedgerRange.encode(message.getLedgerRange, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.getAuditLog != null && Object.hasOwnProperty.call(message, "getAuditLog"))
                $root.tdx_request.GetAuditLog.encode(message.getAuditLog, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.getConsistencyProof != null && Object.hasOwnProperty.call(message, "getConsistencyProof"))
                $root.tdx_request.GetConsistencyProof.encode(message.getConsistencyProof, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.getInclusionProof != null && Object.hasOwnProperty.call(message, "getInclusionProof"))
                $root.tdx_request.GetInclusionProof.encode(message.getInclusionProof, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.startConversion != null && Object.hasOwnProperty.call(message, "startConversion"))
                $root.tdx_request.StartConversion.encode(message.startConversion, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.getChunkFromYSentinel != null && Object.hasOwnProperty.call(message, "getChunkFromYSentinel"))
                $root.tdx_request.GetChunkFromYSentinel.encode(message.getChunkFromYSentinel, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.storageDistribution != null && Object.hasOwnProperty.call(message, "storageDistribution"))
                $root.tdx_request.StorageDistribution.encode(message.storageDistribution, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.operationCountOverTime != null && Object.hasOwnProperty.call(message, "operationCountOverTime"))
                $root.tdx_request.OperationCountOverTime.encode(message.operationCountOverTime, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.accessByLocation != null && Object.hasOwnProperty.call(message, "accessByLocation"))
                $root.tdx_request.AccessByLocation.encode(message.accessByLocation, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.topMovers != null && Object.hasOwnProperty.call(message, "topMovers"))
                $root.tdx_request.TopMovers.encode(message.topMovers, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.externalShareTopUsers != null && Object.hasOwnProperty.call(message, "externalShareTopUsers"))
                $root.tdx_request.ExternalShareTopUsers.encode(message.externalShareTopUsers, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.getRemovedUsersFromLogs != null && Object.hasOwnProperty.call(message, "getRemovedUsersFromLogs"))
                $root.tdx_request.GetRemovedUsersFromLogs.encode(message.getRemovedUsersFromLogs, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
            if (message.getRemovedTeamsFromLogs != null && Object.hasOwnProperty.call(message, "getRemovedTeamsFromLogs"))
                $root.tdx_request.GetRemovedTeamsFromLogs.encode(message.getRemovedTeamsFromLogs, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            if (message.user_ActivityTimeline != null && Object.hasOwnProperty.call(message, "user_ActivityTimeline"))
                $root.tdx_request.User_ActivityTimeline.encode(message.user_ActivityTimeline, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
            if (message.user_CountriesAccessedFrom != null && Object.hasOwnProperty.call(message, "user_CountriesAccessedFrom"))
                $root.tdx_request.User_CountriesAccessedFrom.encode(message.user_CountriesAccessedFrom, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
            if (message.user_OpCount != null && Object.hasOwnProperty.call(message, "user_OpCount"))
                $root.tdx_request.User_OpCount.encode(message.user_OpCount, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
            if (message.user_WriteActivity != null && Object.hasOwnProperty.call(message, "user_WriteActivity"))
                $root.tdx_request.User_WriteActivity.encode(message.user_WriteActivity, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
            if (message.user_StorageBreakdown != null && Object.hasOwnProperty.call(message, "user_StorageBreakdown"))
                $root.tdx_request.User_StorageBreakdown.encode(message.user_StorageBreakdown, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
            if (message.user_FilesTouched != null && Object.hasOwnProperty.call(message, "user_FilesTouched"))
                $root.tdx_request.User_FilesTouched.encode(message.user_FilesTouched, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
            if (message.user_SharingActions != null && Object.hasOwnProperty.call(message, "user_SharingActions"))
                $root.tdx_request.User_SharingActions.encode(message.user_SharingActions, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
            if (message.user_PermissionRecieved != null && Object.hasOwnProperty.call(message, "user_PermissionRecieved"))
                $root.tdx_request.User_PermissionRecieved.encode(message.user_PermissionRecieved, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
            if (message.user_DeniedAttempts != null && Object.hasOwnProperty.call(message, "user_DeniedAttempts"))
                $root.tdx_request.User_DeniedAttempts.encode(message.user_DeniedAttempts, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
            if (message.user_RiskScore != null && Object.hasOwnProperty.call(message, "user_RiskScore"))
                $root.tdx_request.User_RiskScore.encode(message.user_RiskScore, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
            if (message.user_TopContributingSignals != null && Object.hasOwnProperty.call(message, "user_TopContributingSignals"))
                $root.tdx_request.User_TopContributingSignals.encode(message.user_TopContributingSignals, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
            if (message.user_Anomalies != null && Object.hasOwnProperty.call(message, "user_Anomalies"))
                $root.tdx_request.User_Anomalies.encode(message.user_Anomalies, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
            if (message.user_Overview != null && Object.hasOwnProperty.call(message, "user_Overview"))
                $root.tdx_request.User_Overview.encode(message.user_Overview, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
            if (message.fileDetails != null && Object.hasOwnProperty.call(message, "fileDetails"))
                $root.tdx_request.FileDetails.encode(message.fileDetails, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
            if (message.fileSummary != null && Object.hasOwnProperty.call(message, "fileSummary"))
                $root.tdx_request.FileSummary.encode(message.fileSummary, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
            if (message.lifecycleEvents != null && Object.hasOwnProperty.call(message, "lifecycleEvents"))
                $root.tdx_request.LifecycleEvents.encode(message.lifecycleEvents, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
            if (message.versionHistory != null && Object.hasOwnProperty.call(message, "versionHistory"))
                $root.tdx_request.VersionHistory.encode(message.versionHistory, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
            if (message.shares != null && Object.hasOwnProperty.call(message, "shares"))
                $root.tdx_request.Shares.encode(message.shares, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
            if (message.pathHistory != null && Object.hasOwnProperty.call(message, "pathHistory"))
                $root.tdx_request.PathHistory.encode(message.pathHistory, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
            if (message.actorStats != null && Object.hasOwnProperty.call(message, "actorStats"))
                $root.tdx_request.ActorStats.encode(message.actorStats, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
            if (message.countryStats != null && Object.hasOwnProperty.call(message, "countryStats"))
                $root.tdx_request.CountryStats.encode(message.countryStats, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
            if (message.userTimeHeatmap != null && Object.hasOwnProperty.call(message, "userTimeHeatmap"))
                $root.tdx_request.User_TimeHeatmap.encode(message.userTimeHeatmap, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
            if (message.teamMembers != null && Object.hasOwnProperty.call(message, "teamMembers"))
                $root.tdx_request.Team_Members.encode(message.teamMembers, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
            if (message.teamActivityTimeline != null && Object.hasOwnProperty.call(message, "teamActivityTimeline"))
                $root.tdx_request.Team_ActivityTimeline.encode(message.teamActivityTimeline, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
            if (message.teamFilesTouched != null && Object.hasOwnProperty.call(message, "teamFilesTouched"))
                $root.tdx_request.Team_FilesTouched.encode(message.teamFilesTouched, writer.uint32(/* id 44, wireType 2 =*/354).fork()).ldelim();
            if (message.teamMembershipChanges != null && Object.hasOwnProperty.call(message, "teamMembershipChanges"))
                $root.tdx_request.Team_MembershipChanges.encode(message.teamMembershipChanges, writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
            if (message.teamRoleIntersection != null && Object.hasOwnProperty.call(message, "teamRoleIntersection"))
                $root.tdx_request.Team_RoleIntersection.encode(message.teamRoleIntersection, writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
            if (message.listFilesForDashboard != null && Object.hasOwnProperty.call(message, "listFilesForDashboard"))
                $root.tdx_request.ListFilesForDashboard.encode(message.listFilesForDashboard, writer.uint32(/* id 47, wireType 2 =*/378).fork()).ldelim();
            if (message.teamSharingActions != null && Object.hasOwnProperty.call(message, "teamSharingActions"))
                $root.tdx_request.Team_SharingActions.encode(message.teamSharingActions, writer.uint32(/* id 48, wireType 2 =*/386).fork()).ldelim();
            if (message.overviewOffHoursRatio != null && Object.hasOwnProperty.call(message, "overviewOffHoursRatio"))
                $root.tdx_request.Overview_OffHoursRatio.encode(message.overviewOffHoursRatio, writer.uint32(/* id 49, wireType 2 =*/394).fork()).ldelim();
            if (message.collaborationFlow != null && Object.hasOwnProperty.call(message, "collaborationFlow"))
                $root.tdx_request.CollaborationFlow.encode(message.collaborationFlow, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Request message, length delimited. Does not implicitly {@link tdx_request.Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_request.Request
         * @static
         * @param {tdx_request.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Request message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_request.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_request.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_request.Request();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.uint64();
                        break;
                    }
                case 2: {
                        message.listLogs = $root.tdx_request.ListLogsFromQuery.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.crateAlert = $root.tdx_request.CreateAlert.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.deleteAlert = $root.tdx_request.DeleteAlert.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.listAlerts = $root.tdx_request.ListAlerts.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.updateAlert = $root.tdx_request.UpdateAlert.decode(reader, reader.uint32());
                        break;
                    }
                case 7: {
                        message.getLedgerRange = $root.tdx_request.GetLedgerRange.decode(reader, reader.uint32());
                        break;
                    }
                case 8: {
                        message.getAuditLog = $root.tdx_request.GetAuditLog.decode(reader, reader.uint32());
                        break;
                    }
                case 9: {
                        message.getConsistencyProof = $root.tdx_request.GetConsistencyProof.decode(reader, reader.uint32());
                        break;
                    }
                case 10: {
                        message.getInclusionProof = $root.tdx_request.GetInclusionProof.decode(reader, reader.uint32());
                        break;
                    }
                case 11: {
                        message.startConversion = $root.tdx_request.StartConversion.decode(reader, reader.uint32());
                        break;
                    }
                case 12: {
                        message.getChunkFromYSentinel = $root.tdx_request.GetChunkFromYSentinel.decode(reader, reader.uint32());
                        break;
                    }
                case 16: {
                        message.topMovers = $root.tdx_request.TopMovers.decode(reader, reader.uint32());
                        break;
                    }
                case 14: {
                        message.operationCountOverTime = $root.tdx_request.OperationCountOverTime.decode(reader, reader.uint32());
                        break;
                    }
                case 13: {
                        message.storageDistribution = $root.tdx_request.StorageDistribution.decode(reader, reader.uint32());
                        break;
                    }
                case 15: {
                        message.accessByLocation = $root.tdx_request.AccessByLocation.decode(reader, reader.uint32());
                        break;
                    }
                case 17: {
                        message.externalShareTopUsers = $root.tdx_request.ExternalShareTopUsers.decode(reader, reader.uint32());
                        break;
                    }
                case 49: {
                        message.overviewOffHoursRatio = $root.tdx_request.Overview_OffHoursRatio.decode(reader, reader.uint32());
                        break;
                    }
                case 18: {
                        message.getRemovedUsersFromLogs = $root.tdx_request.GetRemovedUsersFromLogs.decode(reader, reader.uint32());
                        break;
                    }
                case 19: {
                        message.getRemovedTeamsFromLogs = $root.tdx_request.GetRemovedTeamsFromLogs.decode(reader, reader.uint32());
                        break;
                    }
                case 20: {
                        message.user_ActivityTimeline = $root.tdx_request.User_ActivityTimeline.decode(reader, reader.uint32());
                        break;
                    }
                case 21: {
                        message.user_CountriesAccessedFrom = $root.tdx_request.User_CountriesAccessedFrom.decode(reader, reader.uint32());
                        break;
                    }
                case 22: {
                        message.user_OpCount = $root.tdx_request.User_OpCount.decode(reader, reader.uint32());
                        break;
                    }
                case 23: {
                        message.user_WriteActivity = $root.tdx_request.User_WriteActivity.decode(reader, reader.uint32());
                        break;
                    }
                case 24: {
                        message.user_StorageBreakdown = $root.tdx_request.User_StorageBreakdown.decode(reader, reader.uint32());
                        break;
                    }
                case 25: {
                        message.user_FilesTouched = $root.tdx_request.User_FilesTouched.decode(reader, reader.uint32());
                        break;
                    }
                case 26: {
                        message.user_SharingActions = $root.tdx_request.User_SharingActions.decode(reader, reader.uint32());
                        break;
                    }
                case 27: {
                        message.user_PermissionRecieved = $root.tdx_request.User_PermissionRecieved.decode(reader, reader.uint32());
                        break;
                    }
                case 28: {
                        message.user_DeniedAttempts = $root.tdx_request.User_DeniedAttempts.decode(reader, reader.uint32());
                        break;
                    }
                case 29: {
                        message.user_RiskScore = $root.tdx_request.User_RiskScore.decode(reader, reader.uint32());
                        break;
                    }
                case 30: {
                        message.user_TopContributingSignals = $root.tdx_request.User_TopContributingSignals.decode(reader, reader.uint32());
                        break;
                    }
                case 31: {
                        message.user_Anomalies = $root.tdx_request.User_Anomalies.decode(reader, reader.uint32());
                        break;
                    }
                case 32: {
                        message.user_Overview = $root.tdx_request.User_Overview.decode(reader, reader.uint32());
                        break;
                    }
                case 33: {
                        message.fileDetails = $root.tdx_request.FileDetails.decode(reader, reader.uint32());
                        break;
                    }
                case 34: {
                        message.fileSummary = $root.tdx_request.FileSummary.decode(reader, reader.uint32());
                        break;
                    }
                case 35: {
                        message.lifecycleEvents = $root.tdx_request.LifecycleEvents.decode(reader, reader.uint32());
                        break;
                    }
                case 36: {
                        message.versionHistory = $root.tdx_request.VersionHistory.decode(reader, reader.uint32());
                        break;
                    }
                case 37: {
                        message.shares = $root.tdx_request.Shares.decode(reader, reader.uint32());
                        break;
                    }
                case 38: {
                        message.pathHistory = $root.tdx_request.PathHistory.decode(reader, reader.uint32());
                        break;
                    }
                case 39: {
                        message.actorStats = $root.tdx_request.ActorStats.decode(reader, reader.uint32());
                        break;
                    }
                case 40: {
                        message.countryStats = $root.tdx_request.CountryStats.decode(reader, reader.uint32());
                        break;
                    }
                case 41: {
                        message.userTimeHeatmap = $root.tdx_request.User_TimeHeatmap.decode(reader, reader.uint32());
                        break;
                    }
                case 42: {
                        message.teamMembers = $root.tdx_request.Team_Members.decode(reader, reader.uint32());
                        break;
                    }
                case 43: {
                        message.teamActivityTimeline = $root.tdx_request.Team_ActivityTimeline.decode(reader, reader.uint32());
                        break;
                    }
                case 44: {
                        message.teamFilesTouched = $root.tdx_request.Team_FilesTouched.decode(reader, reader.uint32());
                        break;
                    }
                case 45: {
                        message.teamMembershipChanges = $root.tdx_request.Team_MembershipChanges.decode(reader, reader.uint32());
                        break;
                    }
                case 46: {
                        message.teamRoleIntersection = $root.tdx_request.Team_RoleIntersection.decode(reader, reader.uint32());
                        break;
                    }
                case 47: {
                        message.listFilesForDashboard = $root.tdx_request.ListFilesForDashboard.decode(reader, reader.uint32());
                        break;
                    }
                case 48: {
                        message.teamSharingActions = $root.tdx_request.Team_SharingActions.decode(reader, reader.uint32());
                        break;
                    }
                case 50: {
                        message.collaborationFlow = $root.tdx_request.CollaborationFlow.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_request.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_request.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Request message.
         * @function verify
         * @memberof tdx_request.Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Request.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.id != null && message.hasOwnProperty("id")) {
                properties._id = 1;
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            }
            if (message.listLogs != null && message.hasOwnProperty("listLogs")) {
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.ListLogsFromQuery.verify(message.listLogs);
                    if (error)
                        return "listLogs." + error;
                }
            }
            if (message.crateAlert != null && message.hasOwnProperty("crateAlert")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.CreateAlert.verify(message.crateAlert);
                    if (error)
                        return "crateAlert." + error;
                }
            }
            if (message.deleteAlert != null && message.hasOwnProperty("deleteAlert")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.DeleteAlert.verify(message.deleteAlert);
                    if (error)
                        return "deleteAlert." + error;
                }
            }
            if (message.listAlerts != null && message.hasOwnProperty("listAlerts")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.ListAlerts.verify(message.listAlerts);
                    if (error)
                        return "listAlerts." + error;
                }
            }
            if (message.updateAlert != null && message.hasOwnProperty("updateAlert")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.UpdateAlert.verify(message.updateAlert);
                    if (error)
                        return "updateAlert." + error;
                }
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.GetLedgerRange.verify(message.getLedgerRange);
                    if (error)
                        return "getLedgerRange." + error;
                }
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.GetAuditLog.verify(message.getAuditLog);
                    if (error)
                        return "getAuditLog." + error;
                }
            }
            if (message.getConsistencyProof != null && message.hasOwnProperty("getConsistencyProof")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.GetConsistencyProof.verify(message.getConsistencyProof);
                    if (error)
                        return "getConsistencyProof." + error;
                }
            }
            if (message.getInclusionProof != null && message.hasOwnProperty("getInclusionProof")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.GetInclusionProof.verify(message.getInclusionProof);
                    if (error)
                        return "getInclusionProof." + error;
                }
            }
            if (message.startConversion != null && message.hasOwnProperty("startConversion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.StartConversion.verify(message.startConversion);
                    if (error)
                        return "startConversion." + error;
                }
            }
            if (message.getChunkFromYSentinel != null && message.hasOwnProperty("getChunkFromYSentinel")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.GetChunkFromYSentinel.verify(message.getChunkFromYSentinel);
                    if (error)
                        return "getChunkFromYSentinel." + error;
                }
            }
            if (message.topMovers != null && message.hasOwnProperty("topMovers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.TopMovers.verify(message.topMovers);
                    if (error)
                        return "topMovers." + error;
                }
            }
            if (message.operationCountOverTime != null && message.hasOwnProperty("operationCountOverTime")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.OperationCountOverTime.verify(message.operationCountOverTime);
                    if (error)
                        return "operationCountOverTime." + error;
                }
            }
            if (message.storageDistribution != null && message.hasOwnProperty("storageDistribution")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.StorageDistribution.verify(message.storageDistribution);
                    if (error)
                        return "storageDistribution." + error;
                }
            }
            if (message.accessByLocation != null && message.hasOwnProperty("accessByLocation")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.AccessByLocation.verify(message.accessByLocation);
                    if (error)
                        return "accessByLocation." + error;
                }
            }
            if (message.externalShareTopUsers != null && message.hasOwnProperty("externalShareTopUsers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.ExternalShareTopUsers.verify(message.externalShareTopUsers);
                    if (error)
                        return "externalShareTopUsers." + error;
                }
            }
            if (message.overviewOffHoursRatio != null && message.hasOwnProperty("overviewOffHoursRatio")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Overview_OffHoursRatio.verify(message.overviewOffHoursRatio);
                    if (error)
                        return "overviewOffHoursRatio." + error;
                }
            }
            if (message.getRemovedUsersFromLogs != null && message.hasOwnProperty("getRemovedUsersFromLogs")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.GetRemovedUsersFromLogs.verify(message.getRemovedUsersFromLogs);
                    if (error)
                        return "getRemovedUsersFromLogs." + error;
                }
            }
            if (message.getRemovedTeamsFromLogs != null && message.hasOwnProperty("getRemovedTeamsFromLogs")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.GetRemovedTeamsFromLogs.verify(message.getRemovedTeamsFromLogs);
                    if (error)
                        return "getRemovedTeamsFromLogs." + error;
                }
            }
            if (message.user_ActivityTimeline != null && message.hasOwnProperty("user_ActivityTimeline")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_ActivityTimeline.verify(message.user_ActivityTimeline);
                    if (error)
                        return "user_ActivityTimeline." + error;
                }
            }
            if (message.user_CountriesAccessedFrom != null && message.hasOwnProperty("user_CountriesAccessedFrom")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_CountriesAccessedFrom.verify(message.user_CountriesAccessedFrom);
                    if (error)
                        return "user_CountriesAccessedFrom." + error;
                }
            }
            if (message.user_OpCount != null && message.hasOwnProperty("user_OpCount")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_OpCount.verify(message.user_OpCount);
                    if (error)
                        return "user_OpCount." + error;
                }
            }
            if (message.user_WriteActivity != null && message.hasOwnProperty("user_WriteActivity")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_WriteActivity.verify(message.user_WriteActivity);
                    if (error)
                        return "user_WriteActivity." + error;
                }
            }
            if (message.user_StorageBreakdown != null && message.hasOwnProperty("user_StorageBreakdown")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_StorageBreakdown.verify(message.user_StorageBreakdown);
                    if (error)
                        return "user_StorageBreakdown." + error;
                }
            }
            if (message.user_FilesTouched != null && message.hasOwnProperty("user_FilesTouched")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_FilesTouched.verify(message.user_FilesTouched);
                    if (error)
                        return "user_FilesTouched." + error;
                }
            }
            if (message.user_SharingActions != null && message.hasOwnProperty("user_SharingActions")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_SharingActions.verify(message.user_SharingActions);
                    if (error)
                        return "user_SharingActions." + error;
                }
            }
            if (message.user_PermissionRecieved != null && message.hasOwnProperty("user_PermissionRecieved")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_PermissionRecieved.verify(message.user_PermissionRecieved);
                    if (error)
                        return "user_PermissionRecieved." + error;
                }
            }
            if (message.user_DeniedAttempts != null && message.hasOwnProperty("user_DeniedAttempts")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_DeniedAttempts.verify(message.user_DeniedAttempts);
                    if (error)
                        return "user_DeniedAttempts." + error;
                }
            }
            if (message.user_RiskScore != null && message.hasOwnProperty("user_RiskScore")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_RiskScore.verify(message.user_RiskScore);
                    if (error)
                        return "user_RiskScore." + error;
                }
            }
            if (message.user_TopContributingSignals != null && message.hasOwnProperty("user_TopContributingSignals")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_TopContributingSignals.verify(message.user_TopContributingSignals);
                    if (error)
                        return "user_TopContributingSignals." + error;
                }
            }
            if (message.user_Anomalies != null && message.hasOwnProperty("user_Anomalies")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_Anomalies.verify(message.user_Anomalies);
                    if (error)
                        return "user_Anomalies." + error;
                }
            }
            if (message.user_Overview != null && message.hasOwnProperty("user_Overview")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_Overview.verify(message.user_Overview);
                    if (error)
                        return "user_Overview." + error;
                }
            }
            if (message.fileDetails != null && message.hasOwnProperty("fileDetails")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.FileDetails.verify(message.fileDetails);
                    if (error)
                        return "fileDetails." + error;
                }
            }
            if (message.fileSummary != null && message.hasOwnProperty("fileSummary")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.FileSummary.verify(message.fileSummary);
                    if (error)
                        return "fileSummary." + error;
                }
            }
            if (message.lifecycleEvents != null && message.hasOwnProperty("lifecycleEvents")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.LifecycleEvents.verify(message.lifecycleEvents);
                    if (error)
                        return "lifecycleEvents." + error;
                }
            }
            if (message.versionHistory != null && message.hasOwnProperty("versionHistory")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.VersionHistory.verify(message.versionHistory);
                    if (error)
                        return "versionHistory." + error;
                }
            }
            if (message.shares != null && message.hasOwnProperty("shares")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Shares.verify(message.shares);
                    if (error)
                        return "shares." + error;
                }
            }
            if (message.pathHistory != null && message.hasOwnProperty("pathHistory")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.PathHistory.verify(message.pathHistory);
                    if (error)
                        return "pathHistory." + error;
                }
            }
            if (message.actorStats != null && message.hasOwnProperty("actorStats")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.ActorStats.verify(message.actorStats);
                    if (error)
                        return "actorStats." + error;
                }
            }
            if (message.countryStats != null && message.hasOwnProperty("countryStats")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.CountryStats.verify(message.countryStats);
                    if (error)
                        return "countryStats." + error;
                }
            }
            if (message.userTimeHeatmap != null && message.hasOwnProperty("userTimeHeatmap")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.User_TimeHeatmap.verify(message.userTimeHeatmap);
                    if (error)
                        return "userTimeHeatmap." + error;
                }
            }
            if (message.teamMembers != null && message.hasOwnProperty("teamMembers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Team_Members.verify(message.teamMembers);
                    if (error)
                        return "teamMembers." + error;
                }
            }
            if (message.teamActivityTimeline != null && message.hasOwnProperty("teamActivityTimeline")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Team_ActivityTimeline.verify(message.teamActivityTimeline);
                    if (error)
                        return "teamActivityTimeline." + error;
                }
            }
            if (message.teamFilesTouched != null && message.hasOwnProperty("teamFilesTouched")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Team_FilesTouched.verify(message.teamFilesTouched);
                    if (error)
                        return "teamFilesTouched." + error;
                }
            }
            if (message.teamMembershipChanges != null && message.hasOwnProperty("teamMembershipChanges")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Team_MembershipChanges.verify(message.teamMembershipChanges);
                    if (error)
                        return "teamMembershipChanges." + error;
                }
            }
            if (message.teamRoleIntersection != null && message.hasOwnProperty("teamRoleIntersection")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Team_RoleIntersection.verify(message.teamRoleIntersection);
                    if (error)
                        return "teamRoleIntersection." + error;
                }
            }
            if (message.listFilesForDashboard != null && message.hasOwnProperty("listFilesForDashboard")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.ListFilesForDashboard.verify(message.listFilesForDashboard);
                    if (error)
                        return "listFilesForDashboard." + error;
                }
            }
            if (message.teamSharingActions != null && message.hasOwnProperty("teamSharingActions")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.Team_SharingActions.verify(message.teamSharingActions);
                    if (error)
                        return "teamSharingActions." + error;
                }
            }
            if (message.collaborationFlow != null && message.hasOwnProperty("collaborationFlow")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_request.CollaborationFlow.verify(message.collaborationFlow);
                    if (error)
                        return "collaborationFlow." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_request.Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_request.Request} Request
         */
        Request.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_request.Request)
                return object;
            let message = new $root.tdx_request.Request();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.listLogs != null) {
                if (typeof object.listLogs !== "object")
                    throw TypeError(".tdx_request.Request.listLogs: object expected");
                message.listLogs = $root.tdx_request.ListLogsFromQuery.fromObject(object.listLogs);
            }
            if (object.crateAlert != null) {
                if (typeof object.crateAlert !== "object")
                    throw TypeError(".tdx_request.Request.crateAlert: object expected");
                message.crateAlert = $root.tdx_request.CreateAlert.fromObject(object.crateAlert);
            }
            if (object.deleteAlert != null) {
                if (typeof object.deleteAlert !== "object")
                    throw TypeError(".tdx_request.Request.deleteAlert: object expected");
                message.deleteAlert = $root.tdx_request.DeleteAlert.fromObject(object.deleteAlert);
            }
            if (object.listAlerts != null) {
                if (typeof object.listAlerts !== "object")
                    throw TypeError(".tdx_request.Request.listAlerts: object expected");
                message.listAlerts = $root.tdx_request.ListAlerts.fromObject(object.listAlerts);
            }
            if (object.updateAlert != null) {
                if (typeof object.updateAlert !== "object")
                    throw TypeError(".tdx_request.Request.updateAlert: object expected");
                message.updateAlert = $root.tdx_request.UpdateAlert.fromObject(object.updateAlert);
            }
            if (object.getLedgerRange != null) {
                if (typeof object.getLedgerRange !== "object")
                    throw TypeError(".tdx_request.Request.getLedgerRange: object expected");
                message.getLedgerRange = $root.tdx_request.GetLedgerRange.fromObject(object.getLedgerRange);
            }
            if (object.getAuditLog != null) {
                if (typeof object.getAuditLog !== "object")
                    throw TypeError(".tdx_request.Request.getAuditLog: object expected");
                message.getAuditLog = $root.tdx_request.GetAuditLog.fromObject(object.getAuditLog);
            }
            if (object.getConsistencyProof != null) {
                if (typeof object.getConsistencyProof !== "object")
                    throw TypeError(".tdx_request.Request.getConsistencyProof: object expected");
                message.getConsistencyProof = $root.tdx_request.GetConsistencyProof.fromObject(object.getConsistencyProof);
            }
            if (object.getInclusionProof != null) {
                if (typeof object.getInclusionProof !== "object")
                    throw TypeError(".tdx_request.Request.getInclusionProof: object expected");
                message.getInclusionProof = $root.tdx_request.GetInclusionProof.fromObject(object.getInclusionProof);
            }
            if (object.startConversion != null) {
                if (typeof object.startConversion !== "object")
                    throw TypeError(".tdx_request.Request.startConversion: object expected");
                message.startConversion = $root.tdx_request.StartConversion.fromObject(object.startConversion);
            }
            if (object.getChunkFromYSentinel != null) {
                if (typeof object.getChunkFromYSentinel !== "object")
                    throw TypeError(".tdx_request.Request.getChunkFromYSentinel: object expected");
                message.getChunkFromYSentinel = $root.tdx_request.GetChunkFromYSentinel.fromObject(object.getChunkFromYSentinel);
            }
            if (object.topMovers != null) {
                if (typeof object.topMovers !== "object")
                    throw TypeError(".tdx_request.Request.topMovers: object expected");
                message.topMovers = $root.tdx_request.TopMovers.fromObject(object.topMovers);
            }
            if (object.operationCountOverTime != null) {
                if (typeof object.operationCountOverTime !== "object")
                    throw TypeError(".tdx_request.Request.operationCountOverTime: object expected");
                message.operationCountOverTime = $root.tdx_request.OperationCountOverTime.fromObject(object.operationCountOverTime);
            }
            if (object.storageDistribution != null) {
                if (typeof object.storageDistribution !== "object")
                    throw TypeError(".tdx_request.Request.storageDistribution: object expected");
                message.storageDistribution = $root.tdx_request.StorageDistribution.fromObject(object.storageDistribution);
            }
            if (object.accessByLocation != null) {
                if (typeof object.accessByLocation !== "object")
                    throw TypeError(".tdx_request.Request.accessByLocation: object expected");
                message.accessByLocation = $root.tdx_request.AccessByLocation.fromObject(object.accessByLocation);
            }
            if (object.externalShareTopUsers != null) {
                if (typeof object.externalShareTopUsers !== "object")
                    throw TypeError(".tdx_request.Request.externalShareTopUsers: object expected");
                message.externalShareTopUsers = $root.tdx_request.ExternalShareTopUsers.fromObject(object.externalShareTopUsers);
            }
            if (object.overviewOffHoursRatio != null) {
                if (typeof object.overviewOffHoursRatio !== "object")
                    throw TypeError(".tdx_request.Request.overviewOffHoursRatio: object expected");
                message.overviewOffHoursRatio = $root.tdx_request.Overview_OffHoursRatio.fromObject(object.overviewOffHoursRatio);
            }
            if (object.getRemovedUsersFromLogs != null) {
                if (typeof object.getRemovedUsersFromLogs !== "object")
                    throw TypeError(".tdx_request.Request.getRemovedUsersFromLogs: object expected");
                message.getRemovedUsersFromLogs = $root.tdx_request.GetRemovedUsersFromLogs.fromObject(object.getRemovedUsersFromLogs);
            }
            if (object.getRemovedTeamsFromLogs != null) {
                if (typeof object.getRemovedTeamsFromLogs !== "object")
                    throw TypeError(".tdx_request.Request.getRemovedTeamsFromLogs: object expected");
                message.getRemovedTeamsFromLogs = $root.tdx_request.GetRemovedTeamsFromLogs.fromObject(object.getRemovedTeamsFromLogs);
            }
            if (object.user_ActivityTimeline != null) {
                if (typeof object.user_ActivityTimeline !== "object")
                    throw TypeError(".tdx_request.Request.user_ActivityTimeline: object expected");
                message.user_ActivityTimeline = $root.tdx_request.User_ActivityTimeline.fromObject(object.user_ActivityTimeline);
            }
            if (object.user_CountriesAccessedFrom != null) {
                if (typeof object.user_CountriesAccessedFrom !== "object")
                    throw TypeError(".tdx_request.Request.user_CountriesAccessedFrom: object expected");
                message.user_CountriesAccessedFrom = $root.tdx_request.User_CountriesAccessedFrom.fromObject(object.user_CountriesAccessedFrom);
            }
            if (object.user_OpCount != null) {
                if (typeof object.user_OpCount !== "object")
                    throw TypeError(".tdx_request.Request.user_OpCount: object expected");
                message.user_OpCount = $root.tdx_request.User_OpCount.fromObject(object.user_OpCount);
            }
            if (object.user_WriteActivity != null) {
                if (typeof object.user_WriteActivity !== "object")
                    throw TypeError(".tdx_request.Request.user_WriteActivity: object expected");
                message.user_WriteActivity = $root.tdx_request.User_WriteActivity.fromObject(object.user_WriteActivity);
            }
            if (object.user_StorageBreakdown != null) {
                if (typeof object.user_StorageBreakdown !== "object")
                    throw TypeError(".tdx_request.Request.user_StorageBreakdown: object expected");
                message.user_StorageBreakdown = $root.tdx_request.User_StorageBreakdown.fromObject(object.user_StorageBreakdown);
            }
            if (object.user_FilesTouched != null) {
                if (typeof object.user_FilesTouched !== "object")
                    throw TypeError(".tdx_request.Request.user_FilesTouched: object expected");
                message.user_FilesTouched = $root.tdx_request.User_FilesTouched.fromObject(object.user_FilesTouched);
            }
            if (object.user_SharingActions != null) {
                if (typeof object.user_SharingActions !== "object")
                    throw TypeError(".tdx_request.Request.user_SharingActions: object expected");
                message.user_SharingActions = $root.tdx_request.User_SharingActions.fromObject(object.user_SharingActions);
            }
            if (object.user_PermissionRecieved != null) {
                if (typeof object.user_PermissionRecieved !== "object")
                    throw TypeError(".tdx_request.Request.user_PermissionRecieved: object expected");
                message.user_PermissionRecieved = $root.tdx_request.User_PermissionRecieved.fromObject(object.user_PermissionRecieved);
            }
            if (object.user_DeniedAttempts != null) {
                if (typeof object.user_DeniedAttempts !== "object")
                    throw TypeError(".tdx_request.Request.user_DeniedAttempts: object expected");
                message.user_DeniedAttempts = $root.tdx_request.User_DeniedAttempts.fromObject(object.user_DeniedAttempts);
            }
            if (object.user_RiskScore != null) {
                if (typeof object.user_RiskScore !== "object")
                    throw TypeError(".tdx_request.Request.user_RiskScore: object expected");
                message.user_RiskScore = $root.tdx_request.User_RiskScore.fromObject(object.user_RiskScore);
            }
            if (object.user_TopContributingSignals != null) {
                if (typeof object.user_TopContributingSignals !== "object")
                    throw TypeError(".tdx_request.Request.user_TopContributingSignals: object expected");
                message.user_TopContributingSignals = $root.tdx_request.User_TopContributingSignals.fromObject(object.user_TopContributingSignals);
            }
            if (object.user_Anomalies != null) {
                if (typeof object.user_Anomalies !== "object")
                    throw TypeError(".tdx_request.Request.user_Anomalies: object expected");
                message.user_Anomalies = $root.tdx_request.User_Anomalies.fromObject(object.user_Anomalies);
            }
            if (object.user_Overview != null) {
                if (typeof object.user_Overview !== "object")
                    throw TypeError(".tdx_request.Request.user_Overview: object expected");
                message.user_Overview = $root.tdx_request.User_Overview.fromObject(object.user_Overview);
            }
            if (object.fileDetails != null) {
                if (typeof object.fileDetails !== "object")
                    throw TypeError(".tdx_request.Request.fileDetails: object expected");
                message.fileDetails = $root.tdx_request.FileDetails.fromObject(object.fileDetails);
            }
            if (object.fileSummary != null) {
                if (typeof object.fileSummary !== "object")
                    throw TypeError(".tdx_request.Request.fileSummary: object expected");
                message.fileSummary = $root.tdx_request.FileSummary.fromObject(object.fileSummary);
            }
            if (object.lifecycleEvents != null) {
                if (typeof object.lifecycleEvents !== "object")
                    throw TypeError(".tdx_request.Request.lifecycleEvents: object expected");
                message.lifecycleEvents = $root.tdx_request.LifecycleEvents.fromObject(object.lifecycleEvents);
            }
            if (object.versionHistory != null) {
                if (typeof object.versionHistory !== "object")
                    throw TypeError(".tdx_request.Request.versionHistory: object expected");
                message.versionHistory = $root.tdx_request.VersionHistory.fromObject(object.versionHistory);
            }
            if (object.shares != null) {
                if (typeof object.shares !== "object")
                    throw TypeError(".tdx_request.Request.shares: object expected");
                message.shares = $root.tdx_request.Shares.fromObject(object.shares);
            }
            if (object.pathHistory != null) {
                if (typeof object.pathHistory !== "object")
                    throw TypeError(".tdx_request.Request.pathHistory: object expected");
                message.pathHistory = $root.tdx_request.PathHistory.fromObject(object.pathHistory);
            }
            if (object.actorStats != null) {
                if (typeof object.actorStats !== "object")
                    throw TypeError(".tdx_request.Request.actorStats: object expected");
                message.actorStats = $root.tdx_request.ActorStats.fromObject(object.actorStats);
            }
            if (object.countryStats != null) {
                if (typeof object.countryStats !== "object")
                    throw TypeError(".tdx_request.Request.countryStats: object expected");
                message.countryStats = $root.tdx_request.CountryStats.fromObject(object.countryStats);
            }
            if (object.userTimeHeatmap != null) {
                if (typeof object.userTimeHeatmap !== "object")
                    throw TypeError(".tdx_request.Request.userTimeHeatmap: object expected");
                message.userTimeHeatmap = $root.tdx_request.User_TimeHeatmap.fromObject(object.userTimeHeatmap);
            }
            if (object.teamMembers != null) {
                if (typeof object.teamMembers !== "object")
                    throw TypeError(".tdx_request.Request.teamMembers: object expected");
                message.teamMembers = $root.tdx_request.Team_Members.fromObject(object.teamMembers);
            }
            if (object.teamActivityTimeline != null) {
                if (typeof object.teamActivityTimeline !== "object")
                    throw TypeError(".tdx_request.Request.teamActivityTimeline: object expected");
                message.teamActivityTimeline = $root.tdx_request.Team_ActivityTimeline.fromObject(object.teamActivityTimeline);
            }
            if (object.teamFilesTouched != null) {
                if (typeof object.teamFilesTouched !== "object")
                    throw TypeError(".tdx_request.Request.teamFilesTouched: object expected");
                message.teamFilesTouched = $root.tdx_request.Team_FilesTouched.fromObject(object.teamFilesTouched);
            }
            if (object.teamMembershipChanges != null) {
                if (typeof object.teamMembershipChanges !== "object")
                    throw TypeError(".tdx_request.Request.teamMembershipChanges: object expected");
                message.teamMembershipChanges = $root.tdx_request.Team_MembershipChanges.fromObject(object.teamMembershipChanges);
            }
            if (object.teamRoleIntersection != null) {
                if (typeof object.teamRoleIntersection !== "object")
                    throw TypeError(".tdx_request.Request.teamRoleIntersection: object expected");
                message.teamRoleIntersection = $root.tdx_request.Team_RoleIntersection.fromObject(object.teamRoleIntersection);
            }
            if (object.listFilesForDashboard != null) {
                if (typeof object.listFilesForDashboard !== "object")
                    throw TypeError(".tdx_request.Request.listFilesForDashboard: object expected");
                message.listFilesForDashboard = $root.tdx_request.ListFilesForDashboard.fromObject(object.listFilesForDashboard);
            }
            if (object.teamSharingActions != null) {
                if (typeof object.teamSharingActions !== "object")
                    throw TypeError(".tdx_request.Request.teamSharingActions: object expected");
                message.teamSharingActions = $root.tdx_request.Team_SharingActions.fromObject(object.teamSharingActions);
            }
            if (object.collaborationFlow != null) {
                if (typeof object.collaborationFlow !== "object")
                    throw TypeError(".tdx_request.Request.collaborationFlow: object expected");
                message.collaborationFlow = $root.tdx_request.CollaborationFlow.fromObject(object.collaborationFlow);
            }
            return message;
        };

        /**
         * Creates a plain object from a Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_request.Request
         * @static
         * @param {tdx_request.Request} message Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.id != null && message.hasOwnProperty("id")) {
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (options.oneofs)
                    object._id = "id";
            }
            if (message.listLogs != null && message.hasOwnProperty("listLogs")) {
                object.listLogs = $root.tdx_request.ListLogsFromQuery.toObject(message.listLogs, options);
                if (options.oneofs)
                    object.Operation = "listLogs";
            }
            if (message.crateAlert != null && message.hasOwnProperty("crateAlert")) {
                object.crateAlert = $root.tdx_request.CreateAlert.toObject(message.crateAlert, options);
                if (options.oneofs)
                    object.Operation = "crateAlert";
            }
            if (message.deleteAlert != null && message.hasOwnProperty("deleteAlert")) {
                object.deleteAlert = $root.tdx_request.DeleteAlert.toObject(message.deleteAlert, options);
                if (options.oneofs)
                    object.Operation = "deleteAlert";
            }
            if (message.listAlerts != null && message.hasOwnProperty("listAlerts")) {
                object.listAlerts = $root.tdx_request.ListAlerts.toObject(message.listAlerts, options);
                if (options.oneofs)
                    object.Operation = "listAlerts";
            }
            if (message.updateAlert != null && message.hasOwnProperty("updateAlert")) {
                object.updateAlert = $root.tdx_request.UpdateAlert.toObject(message.updateAlert, options);
                if (options.oneofs)
                    object.Operation = "updateAlert";
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                object.getLedgerRange = $root.tdx_request.GetLedgerRange.toObject(message.getLedgerRange, options);
                if (options.oneofs)
                    object.Operation = "getLedgerRange";
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                object.getAuditLog = $root.tdx_request.GetAuditLog.toObject(message.getAuditLog, options);
                if (options.oneofs)
                    object.Operation = "getAuditLog";
            }
            if (message.getConsistencyProof != null && message.hasOwnProperty("getConsistencyProof")) {
                object.getConsistencyProof = $root.tdx_request.GetConsistencyProof.toObject(message.getConsistencyProof, options);
                if (options.oneofs)
                    object.Operation = "getConsistencyProof";
            }
            if (message.getInclusionProof != null && message.hasOwnProperty("getInclusionProof")) {
                object.getInclusionProof = $root.tdx_request.GetInclusionProof.toObject(message.getInclusionProof, options);
                if (options.oneofs)
                    object.Operation = "getInclusionProof";
            }
            if (message.startConversion != null && message.hasOwnProperty("startConversion")) {
                object.startConversion = $root.tdx_request.StartConversion.toObject(message.startConversion, options);
                if (options.oneofs)
                    object.Operation = "startConversion";
            }
            if (message.getChunkFromYSentinel != null && message.hasOwnProperty("getChunkFromYSentinel")) {
                object.getChunkFromYSentinel = $root.tdx_request.GetChunkFromYSentinel.toObject(message.getChunkFromYSentinel, options);
                if (options.oneofs)
                    object.Operation = "getChunkFromYSentinel";
            }
            if (message.storageDistribution != null && message.hasOwnProperty("storageDistribution")) {
                object.storageDistribution = $root.tdx_request.StorageDistribution.toObject(message.storageDistribution, options);
                if (options.oneofs)
                    object.Operation = "storageDistribution";
            }
            if (message.operationCountOverTime != null && message.hasOwnProperty("operationCountOverTime")) {
                object.operationCountOverTime = $root.tdx_request.OperationCountOverTime.toObject(message.operationCountOverTime, options);
                if (options.oneofs)
                    object.Operation = "operationCountOverTime";
            }
            if (message.accessByLocation != null && message.hasOwnProperty("accessByLocation")) {
                object.accessByLocation = $root.tdx_request.AccessByLocation.toObject(message.accessByLocation, options);
                if (options.oneofs)
                    object.Operation = "accessByLocation";
            }
            if (message.topMovers != null && message.hasOwnProperty("topMovers")) {
                object.topMovers = $root.tdx_request.TopMovers.toObject(message.topMovers, options);
                if (options.oneofs)
                    object.Operation = "topMovers";
            }
            if (message.externalShareTopUsers != null && message.hasOwnProperty("externalShareTopUsers")) {
                object.externalShareTopUsers = $root.tdx_request.ExternalShareTopUsers.toObject(message.externalShareTopUsers, options);
                if (options.oneofs)
                    object.Operation = "externalShareTopUsers";
            }
            if (message.getRemovedUsersFromLogs != null && message.hasOwnProperty("getRemovedUsersFromLogs")) {
                object.getRemovedUsersFromLogs = $root.tdx_request.GetRemovedUsersFromLogs.toObject(message.getRemovedUsersFromLogs, options);
                if (options.oneofs)
                    object.Operation = "getRemovedUsersFromLogs";
            }
            if (message.getRemovedTeamsFromLogs != null && message.hasOwnProperty("getRemovedTeamsFromLogs")) {
                object.getRemovedTeamsFromLogs = $root.tdx_request.GetRemovedTeamsFromLogs.toObject(message.getRemovedTeamsFromLogs, options);
                if (options.oneofs)
                    object.Operation = "getRemovedTeamsFromLogs";
            }
            if (message.user_ActivityTimeline != null && message.hasOwnProperty("user_ActivityTimeline")) {
                object.user_ActivityTimeline = $root.tdx_request.User_ActivityTimeline.toObject(message.user_ActivityTimeline, options);
                if (options.oneofs)
                    object.Operation = "user_ActivityTimeline";
            }
            if (message.user_CountriesAccessedFrom != null && message.hasOwnProperty("user_CountriesAccessedFrom")) {
                object.user_CountriesAccessedFrom = $root.tdx_request.User_CountriesAccessedFrom.toObject(message.user_CountriesAccessedFrom, options);
                if (options.oneofs)
                    object.Operation = "user_CountriesAccessedFrom";
            }
            if (message.user_OpCount != null && message.hasOwnProperty("user_OpCount")) {
                object.user_OpCount = $root.tdx_request.User_OpCount.toObject(message.user_OpCount, options);
                if (options.oneofs)
                    object.Operation = "user_OpCount";
            }
            if (message.user_WriteActivity != null && message.hasOwnProperty("user_WriteActivity")) {
                object.user_WriteActivity = $root.tdx_request.User_WriteActivity.toObject(message.user_WriteActivity, options);
                if (options.oneofs)
                    object.Operation = "user_WriteActivity";
            }
            if (message.user_StorageBreakdown != null && message.hasOwnProperty("user_StorageBreakdown")) {
                object.user_StorageBreakdown = $root.tdx_request.User_StorageBreakdown.toObject(message.user_StorageBreakdown, options);
                if (options.oneofs)
                    object.Operation = "user_StorageBreakdown";
            }
            if (message.user_FilesTouched != null && message.hasOwnProperty("user_FilesTouched")) {
                object.user_FilesTouched = $root.tdx_request.User_FilesTouched.toObject(message.user_FilesTouched, options);
                if (options.oneofs)
                    object.Operation = "user_FilesTouched";
            }
            if (message.user_SharingActions != null && message.hasOwnProperty("user_SharingActions")) {
                object.user_SharingActions = $root.tdx_request.User_SharingActions.toObject(message.user_SharingActions, options);
                if (options.oneofs)
                    object.Operation = "user_SharingActions";
            }
            if (message.user_PermissionRecieved != null && message.hasOwnProperty("user_PermissionRecieved")) {
                object.user_PermissionRecieved = $root.tdx_request.User_PermissionRecieved.toObject(message.user_PermissionRecieved, options);
                if (options.oneofs)
                    object.Operation = "user_PermissionRecieved";
            }
            if (message.user_DeniedAttempts != null && message.hasOwnProperty("user_DeniedAttempts")) {
                object.user_DeniedAttempts = $root.tdx_request.User_DeniedAttempts.toObject(message.user_DeniedAttempts, options);
                if (options.oneofs)
                    object.Operation = "user_DeniedAttempts";
            }
            if (message.user_RiskScore != null && message.hasOwnProperty("user_RiskScore")) {
                object.user_RiskScore = $root.tdx_request.User_RiskScore.toObject(message.user_RiskScore, options);
                if (options.oneofs)
                    object.Operation = "user_RiskScore";
            }
            if (message.user_TopContributingSignals != null && message.hasOwnProperty("user_TopContributingSignals")) {
                object.user_TopContributingSignals = $root.tdx_request.User_TopContributingSignals.toObject(message.user_TopContributingSignals, options);
                if (options.oneofs)
                    object.Operation = "user_TopContributingSignals";
            }
            if (message.user_Anomalies != null && message.hasOwnProperty("user_Anomalies")) {
                object.user_Anomalies = $root.tdx_request.User_Anomalies.toObject(message.user_Anomalies, options);
                if (options.oneofs)
                    object.Operation = "user_Anomalies";
            }
            if (message.user_Overview != null && message.hasOwnProperty("user_Overview")) {
                object.user_Overview = $root.tdx_request.User_Overview.toObject(message.user_Overview, options);
                if (options.oneofs)
                    object.Operation = "user_Overview";
            }
            if (message.fileDetails != null && message.hasOwnProperty("fileDetails")) {
                object.fileDetails = $root.tdx_request.FileDetails.toObject(message.fileDetails, options);
                if (options.oneofs)
                    object.Operation = "fileDetails";
            }
            if (message.fileSummary != null && message.hasOwnProperty("fileSummary")) {
                object.fileSummary = $root.tdx_request.FileSummary.toObject(message.fileSummary, options);
                if (options.oneofs)
                    object.Operation = "fileSummary";
            }
            if (message.lifecycleEvents != null && message.hasOwnProperty("lifecycleEvents")) {
                object.lifecycleEvents = $root.tdx_request.LifecycleEvents.toObject(message.lifecycleEvents, options);
                if (options.oneofs)
                    object.Operation = "lifecycleEvents";
            }
            if (message.versionHistory != null && message.hasOwnProperty("versionHistory")) {
                object.versionHistory = $root.tdx_request.VersionHistory.toObject(message.versionHistory, options);
                if (options.oneofs)
                    object.Operation = "versionHistory";
            }
            if (message.shares != null && message.hasOwnProperty("shares")) {
                object.shares = $root.tdx_request.Shares.toObject(message.shares, options);
                if (options.oneofs)
                    object.Operation = "shares";
            }
            if (message.pathHistory != null && message.hasOwnProperty("pathHistory")) {
                object.pathHistory = $root.tdx_request.PathHistory.toObject(message.pathHistory, options);
                if (options.oneofs)
                    object.Operation = "pathHistory";
            }
            if (message.actorStats != null && message.hasOwnProperty("actorStats")) {
                object.actorStats = $root.tdx_request.ActorStats.toObject(message.actorStats, options);
                if (options.oneofs)
                    object.Operation = "actorStats";
            }
            if (message.countryStats != null && message.hasOwnProperty("countryStats")) {
                object.countryStats = $root.tdx_request.CountryStats.toObject(message.countryStats, options);
                if (options.oneofs)
                    object.Operation = "countryStats";
            }
            if (message.userTimeHeatmap != null && message.hasOwnProperty("userTimeHeatmap")) {
                object.userTimeHeatmap = $root.tdx_request.User_TimeHeatmap.toObject(message.userTimeHeatmap, options);
                if (options.oneofs)
                    object.Operation = "userTimeHeatmap";
            }
            if (message.teamMembers != null && message.hasOwnProperty("teamMembers")) {
                object.teamMembers = $root.tdx_request.Team_Members.toObject(message.teamMembers, options);
                if (options.oneofs)
                    object.Operation = "teamMembers";
            }
            if (message.teamActivityTimeline != null && message.hasOwnProperty("teamActivityTimeline")) {
                object.teamActivityTimeline = $root.tdx_request.Team_ActivityTimeline.toObject(message.teamActivityTimeline, options);
                if (options.oneofs)
                    object.Operation = "teamActivityTimeline";
            }
            if (message.teamFilesTouched != null && message.hasOwnProperty("teamFilesTouched")) {
                object.teamFilesTouched = $root.tdx_request.Team_FilesTouched.toObject(message.teamFilesTouched, options);
                if (options.oneofs)
                    object.Operation = "teamFilesTouched";
            }
            if (message.teamMembershipChanges != null && message.hasOwnProperty("teamMembershipChanges")) {
                object.teamMembershipChanges = $root.tdx_request.Team_MembershipChanges.toObject(message.teamMembershipChanges, options);
                if (options.oneofs)
                    object.Operation = "teamMembershipChanges";
            }
            if (message.teamRoleIntersection != null && message.hasOwnProperty("teamRoleIntersection")) {
                object.teamRoleIntersection = $root.tdx_request.Team_RoleIntersection.toObject(message.teamRoleIntersection, options);
                if (options.oneofs)
                    object.Operation = "teamRoleIntersection";
            }
            if (message.listFilesForDashboard != null && message.hasOwnProperty("listFilesForDashboard")) {
                object.listFilesForDashboard = $root.tdx_request.ListFilesForDashboard.toObject(message.listFilesForDashboard, options);
                if (options.oneofs)
                    object.Operation = "listFilesForDashboard";
            }
            if (message.teamSharingActions != null && message.hasOwnProperty("teamSharingActions")) {
                object.teamSharingActions = $root.tdx_request.Team_SharingActions.toObject(message.teamSharingActions, options);
                if (options.oneofs)
                    object.Operation = "teamSharingActions";
            }
            if (message.overviewOffHoursRatio != null && message.hasOwnProperty("overviewOffHoursRatio")) {
                object.overviewOffHoursRatio = $root.tdx_request.Overview_OffHoursRatio.toObject(message.overviewOffHoursRatio, options);
                if (options.oneofs)
                    object.Operation = "overviewOffHoursRatio";
            }
            if (message.collaborationFlow != null && message.hasOwnProperty("collaborationFlow")) {
                object.collaborationFlow = $root.tdx_request.CollaborationFlow.toObject(message.collaborationFlow, options);
                if (options.oneofs)
                    object.Operation = "collaborationFlow";
            }
            return object;
        };

        /**
         * Converts this Request to JSON.
         * @function toJSON
         * @memberof tdx_request.Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Request
         * @function getTypeUrl
         * @memberof tdx_request.Request
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_request.Request";
        };

        return Request;
    })();

    return tdx_request;
})();

export const tdx_response = $root.tdx_response = (() => {

    /**
     * Namespace tdx_response.
     * @exports tdx_response
     * @namespace
     */
    const tdx_response = {};

    /**
     * Status enum.
     * @name tdx_response.Status
     * @enum {number}
     * @property {number} SUCCESS=0 SUCCESS value
     * @property {number} BACKEND_ERROR=1 BACKEND_ERROR value
     * @property {number} AUTHENTICATION_FAILURE=2 AUTHENTICATION_FAILURE value
     * @property {number} CRYPTO_FAILURE=3 CRYPTO_FAILURE value
     * @property {number} STORAGE_FAILURE=4 STORAGE_FAILURE value
     * @property {number} INVALID_REQUEST=5 INVALID_REQUEST value
     * @property {number} INVALID_RESPONSE=6 INVALID_RESPONSE value
     * @property {number} OBJECT_NOT_FOUND=7 OBJECT_NOT_FOUND value
     * @property {number} OBJECT_EXISTS=8 OBJECT_EXISTS value
     * @property {number} OBJECT_CORRUPTED=9 OBJECT_CORRUPTED value
     * @property {number} OBJECT_LOCKED=10 OBJECT_LOCKED value
     * @property {number} ACCESS_DENIED=11 ACCESS_DENIED value
     * @property {number} QUOTA_EXCEEDED=12 QUOTA_EXCEEDED value
     * @property {number} STORAGE_FULL=13 STORAGE_FULL value
     * @property {number} STORAGE_UNAVAILABLE=14 STORAGE_UNAVAILABLE value
     * @property {number} STORAGE_CORRUPTED=15 STORAGE_CORRUPTED value
     * @property {number} STORAGE_MISCONFIGURED=16 STORAGE_MISCONFIGURED value
     * @property {number} STORAGE_READ_ONLY=17 STORAGE_READ_ONLY value
     * @property {number} STORAGE_DISABLED=18 STORAGE_DISABLED value
     * @property {number} FAILURE=100 FAILURE value
     * @property {number} SQL_ERROR=19 SQL_ERROR value
     */
    tdx_response.Status = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SUCCESS"] = 0;
        values[valuesById[1] = "BACKEND_ERROR"] = 1;
        values[valuesById[2] = "AUTHENTICATION_FAILURE"] = 2;
        values[valuesById[3] = "CRYPTO_FAILURE"] = 3;
        values[valuesById[4] = "STORAGE_FAILURE"] = 4;
        values[valuesById[5] = "INVALID_REQUEST"] = 5;
        values[valuesById[6] = "INVALID_RESPONSE"] = 6;
        values[valuesById[7] = "OBJECT_NOT_FOUND"] = 7;
        values[valuesById[8] = "OBJECT_EXISTS"] = 8;
        values[valuesById[9] = "OBJECT_CORRUPTED"] = 9;
        values[valuesById[10] = "OBJECT_LOCKED"] = 10;
        values[valuesById[11] = "ACCESS_DENIED"] = 11;
        values[valuesById[12] = "QUOTA_EXCEEDED"] = 12;
        values[valuesById[13] = "STORAGE_FULL"] = 13;
        values[valuesById[14] = "STORAGE_UNAVAILABLE"] = 14;
        values[valuesById[15] = "STORAGE_CORRUPTED"] = 15;
        values[valuesById[16] = "STORAGE_MISCONFIGURED"] = 16;
        values[valuesById[17] = "STORAGE_READ_ONLY"] = 17;
        values[valuesById[18] = "STORAGE_DISABLED"] = 18;
        values[valuesById[100] = "FAILURE"] = 100;
        values[valuesById[19] = "SQL_ERROR"] = 19;
        return values;
    })();

    tdx_response.PageToken = (function() {

        /**
         * Properties of a PageToken.
         * @memberof tdx_response
         * @interface IPageToken
         * @property {number|null} [pageSize] PageToken pageSize
         * @property {number|Long|null} [creationTime] PageToken creationTime
         */

        /**
         * Constructs a new PageToken.
         * @memberof tdx_response
         * @classdesc Represents a PageToken.
         * @implements IPageToken
         * @constructor
         * @param {tdx_response.IPageToken=} [properties] Properties to set
         */
        function PageToken(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PageToken pageSize.
         * @member {number} pageSize
         * @memberof tdx_response.PageToken
         * @instance
         */
        PageToken.prototype.pageSize = 0;

        /**
         * PageToken creationTime.
         * @member {number|Long} creationTime
         * @memberof tdx_response.PageToken
         * @instance
         */
        PageToken.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new PageToken instance using the specified properties.
         * @function create
         * @memberof tdx_response.PageToken
         * @static
         * @param {tdx_response.IPageToken=} [properties] Properties to set
         * @returns {tdx_response.PageToken} PageToken instance
         */
        PageToken.create = function create(properties) {
            return new PageToken(properties);
        };

        /**
         * Encodes the specified PageToken message. Does not implicitly {@link tdx_response.PageToken.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.PageToken
         * @static
         * @param {tdx_response.IPageToken} message PageToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pageSize);
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.creationTime);
            return writer;
        };

        /**
         * Encodes the specified PageToken message, length delimited. Does not implicitly {@link tdx_response.PageToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.PageToken
         * @static
         * @param {tdx_response.IPageToken} message PageToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PageToken message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.PageToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.PageToken} PageToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageToken.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.PageToken();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pageSize = reader.uint32();
                        break;
                    }
                case 2: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PageToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.PageToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.PageToken} PageToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PageToken message.
         * @function verify
         * @memberof tdx_response.PageToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PageToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a PageToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.PageToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.PageToken} PageToken
         */
        PageToken.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.PageToken)
                return object;
            let message = new $root.tdx_response.PageToken();
            if (object.pageSize != null)
                message.pageSize = object.pageSize >>> 0;
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a PageToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.PageToken
         * @static
         * @param {tdx_response.PageToken} message PageToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PageToken.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pageSize = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                object.pageSize = message.pageSize;
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            return object;
        };

        /**
         * Converts this PageToken to JSON.
         * @function toJSON
         * @memberof tdx_response.PageToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PageToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PageToken
         * @function getTypeUrl
         * @memberof tdx_response.PageToken
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PageToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.PageToken";
        };

        return PageToken;
    })();

    tdx_response.LogStruct = (function() {

        /**
         * Properties of a LogStruct.
         * @memberof tdx_response
         * @interface ILogStruct
         * @property {string|null} [subject] LogStruct subject
         */

        /**
         * Constructs a new LogStruct.
         * @memberof tdx_response
         * @classdesc Represents a LogStruct.
         * @implements ILogStruct
         * @constructor
         * @param {tdx_response.ILogStruct=} [properties] Properties to set
         */
        function LogStruct(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LogStruct subject.
         * @member {string} subject
         * @memberof tdx_response.LogStruct
         * @instance
         */
        LogStruct.prototype.subject = "";

        /**
         * Creates a new LogStruct instance using the specified properties.
         * @function create
         * @memberof tdx_response.LogStruct
         * @static
         * @param {tdx_response.ILogStruct=} [properties] Properties to set
         * @returns {tdx_response.LogStruct} LogStruct instance
         */
        LogStruct.create = function create(properties) {
            return new LogStruct(properties);
        };

        /**
         * Encodes the specified LogStruct message. Does not implicitly {@link tdx_response.LogStruct.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.LogStruct
         * @static
         * @param {tdx_response.ILogStruct} message LogStruct message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LogStruct.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.subject != null && Object.hasOwnProperty.call(message, "subject"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.subject);
            return writer;
        };

        /**
         * Encodes the specified LogStruct message, length delimited. Does not implicitly {@link tdx_response.LogStruct.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.LogStruct
         * @static
         * @param {tdx_response.ILogStruct} message LogStruct message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LogStruct.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LogStruct message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.LogStruct
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.LogStruct} LogStruct
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LogStruct.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.LogStruct();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.subject = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LogStruct message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.LogStruct
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.LogStruct} LogStruct
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LogStruct.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LogStruct message.
         * @function verify
         * @memberof tdx_response.LogStruct
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LogStruct.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.subject != null && message.hasOwnProperty("subject"))
                if (!$util.isString(message.subject))
                    return "subject: string expected";
            return null;
        };

        /**
         * Creates a LogStruct message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.LogStruct
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.LogStruct} LogStruct
         */
        LogStruct.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.LogStruct)
                return object;
            let message = new $root.tdx_response.LogStruct();
            if (object.subject != null)
                message.subject = String(object.subject);
            return message;
        };

        /**
         * Creates a plain object from a LogStruct message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.LogStruct
         * @static
         * @param {tdx_response.LogStruct} message LogStruct
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LogStruct.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.subject = "";
            if (message.subject != null && message.hasOwnProperty("subject"))
                object.subject = message.subject;
            return object;
        };

        /**
         * Converts this LogStruct to JSON.
         * @function toJSON
         * @memberof tdx_response.LogStruct
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LogStruct.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LogStruct
         * @function getTypeUrl
         * @memberof tdx_response.LogStruct
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LogStruct.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.LogStruct";
        };

        return LogStruct;
    })();

    /**
     * cell_type enum.
     * @name tdx_response.cell_type
     * @enum {number}
     * @property {number} Str=0 Str value
     * @property {number} Int=1 Int value
     * @property {number} Float=2 Float value
     * @property {number} Bool=3 Bool value
     * @property {number} Timestamp=4 Timestamp value
     * @property {number} Date=5 Date value
     * @property {number} DollarQuoted=6 DollarQuoted value
     * @property {number} EscapedString=7 EscapedString value
     * @property {number} NationalString=8 NationalString value
     * @property {number} HexString=9 HexString value
     * @property {number} DoubleQuoted=10 DoubleQuoted value
     * @property {number} Null=11 Null value
     * @property {number} UnQuoted=12 UnQuoted value
     */
    tdx_response.cell_type = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Str"] = 0;
        values[valuesById[1] = "Int"] = 1;
        values[valuesById[2] = "Float"] = 2;
        values[valuesById[3] = "Bool"] = 3;
        values[valuesById[4] = "Timestamp"] = 4;
        values[valuesById[5] = "Date"] = 5;
        values[valuesById[6] = "DollarQuoted"] = 6;
        values[valuesById[7] = "EscapedString"] = 7;
        values[valuesById[8] = "NationalString"] = 8;
        values[valuesById[9] = "HexString"] = 9;
        values[valuesById[10] = "DoubleQuoted"] = 10;
        values[valuesById[11] = "Null"] = 11;
        values[valuesById[12] = "UnQuoted"] = 12;
        return values;
    })();

    tdx_response.Row = (function() {

        /**
         * Properties of a Row.
         * @memberof tdx_response
         * @interface IRow
         * @property {Array.<Uint8Array>|null} [cells] Row cells
         */

        /**
         * Constructs a new Row.
         * @memberof tdx_response
         * @classdesc Represents a Row.
         * @implements IRow
         * @constructor
         * @param {tdx_response.IRow=} [properties] Properties to set
         */
        function Row(properties) {
            this.cells = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Row cells.
         * @member {Array.<Uint8Array>} cells
         * @memberof tdx_response.Row
         * @instance
         */
        Row.prototype.cells = $util.emptyArray;

        /**
         * Creates a new Row instance using the specified properties.
         * @function create
         * @memberof tdx_response.Row
         * @static
         * @param {tdx_response.IRow=} [properties] Properties to set
         * @returns {tdx_response.Row} Row instance
         */
        Row.create = function create(properties) {
            return new Row(properties);
        };

        /**
         * Encodes the specified Row message. Does not implicitly {@link tdx_response.Row.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Row
         * @static
         * @param {tdx_response.IRow} message Row message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Row.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cells != null && message.cells.length)
                for (let i = 0; i < message.cells.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.cells[i]);
            return writer;
        };

        /**
         * Encodes the specified Row message, length delimited. Does not implicitly {@link tdx_response.Row.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Row
         * @static
         * @param {tdx_response.IRow} message Row message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Row.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Row message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Row
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Row} Row
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Row.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Row();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.cells && message.cells.length))
                            message.cells = [];
                        message.cells.push(reader.bytes());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Row message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Row
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Row} Row
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Row.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Row message.
         * @function verify
         * @memberof tdx_response.Row
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Row.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cells != null && message.hasOwnProperty("cells")) {
                if (!Array.isArray(message.cells))
                    return "cells: array expected";
                for (let i = 0; i < message.cells.length; ++i)
                    if (!(message.cells[i] && typeof message.cells[i].length === "number" || $util.isString(message.cells[i])))
                        return "cells: buffer[] expected";
            }
            return null;
        };

        /**
         * Creates a Row message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Row
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Row} Row
         */
        Row.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Row)
                return object;
            let message = new $root.tdx_response.Row();
            if (object.cells) {
                if (!Array.isArray(object.cells))
                    throw TypeError(".tdx_response.Row.cells: array expected");
                message.cells = [];
                for (let i = 0; i < object.cells.length; ++i)
                    if (typeof object.cells[i] === "string")
                        $util.base64.decode(object.cells[i], message.cells[i] = $util.newBuffer($util.base64.length(object.cells[i])), 0);
                    else if (object.cells[i].length >= 0)
                        message.cells[i] = object.cells[i];
            }
            return message;
        };

        /**
         * Creates a plain object from a Row message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Row
         * @static
         * @param {tdx_response.Row} message Row
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Row.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.cells = [];
            if (message.cells && message.cells.length) {
                object.cells = [];
                for (let j = 0; j < message.cells.length; ++j)
                    object.cells[j] = options.bytes === String ? $util.base64.encode(message.cells[j], 0, message.cells[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.cells[j]) : message.cells[j];
            }
            return object;
        };

        /**
         * Converts this Row to JSON.
         * @function toJSON
         * @memberof tdx_response.Row
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Row.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Row
         * @function getTypeUrl
         * @memberof tdx_response.Row
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Row.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Row";
        };

        return Row;
    })();

    tdx_response.ListLogsFromQuery = (function() {

        /**
         * Properties of a ListLogsFromQuery.
         * @memberof tdx_response
         * @interface IListLogsFromQuery
         * @property {tdx_response.Status|null} [status] ListLogsFromQuery status
         * @property {Array.<tdx_response.ILogStruct>|null} [logs] ListLogsFromQuery logs
         * @property {Uint8Array|null} [pageToken] ListLogsFromQuery pageToken
         * @property {Array.<Uint8Array>|null} [rows] ListLogsFromQuery rows
         * @property {Array.<string>|null} [graphGrammarJsons] ListLogsFromQuery graphGrammarJsons
         */

        /**
         * Constructs a new ListLogsFromQuery.
         * @memberof tdx_response
         * @classdesc Represents a ListLogsFromQuery.
         * @implements IListLogsFromQuery
         * @constructor
         * @param {tdx_response.IListLogsFromQuery=} [properties] Properties to set
         */
        function ListLogsFromQuery(properties) {
            this.logs = [];
            this.rows = [];
            this.graphGrammarJsons = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListLogsFromQuery status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.status = 0;

        /**
         * ListLogsFromQuery logs.
         * @member {Array.<tdx_response.ILogStruct>} logs
         * @memberof tdx_response.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.logs = $util.emptyArray;

        /**
         * ListLogsFromQuery pageToken.
         * @member {Uint8Array} pageToken
         * @memberof tdx_response.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.pageToken = $util.newBuffer([]);

        /**
         * ListLogsFromQuery rows.
         * @member {Array.<Uint8Array>} rows
         * @memberof tdx_response.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.rows = $util.emptyArray;

        /**
         * ListLogsFromQuery graphGrammarJsons.
         * @member {Array.<string>} graphGrammarJsons
         * @memberof tdx_response.ListLogsFromQuery
         * @instance
         */
        ListLogsFromQuery.prototype.graphGrammarJsons = $util.emptyArray;

        /**
         * Creates a new ListLogsFromQuery instance using the specified properties.
         * @function create
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {tdx_response.IListLogsFromQuery=} [properties] Properties to set
         * @returns {tdx_response.ListLogsFromQuery} ListLogsFromQuery instance
         */
        ListLogsFromQuery.create = function create(properties) {
            return new ListLogsFromQuery(properties);
        };

        /**
         * Encodes the specified ListLogsFromQuery message. Does not implicitly {@link tdx_response.ListLogsFromQuery.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {tdx_response.IListLogsFromQuery} message ListLogsFromQuery message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLogsFromQuery.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.logs != null && message.logs.length)
                for (let i = 0; i < message.logs.length; ++i)
                    $root.tdx_response.LogStruct.encode(message.logs[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.pageToken);
            if (message.rows != null && message.rows.length)
                for (let i = 0; i < message.rows.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.rows[i]);
            if (message.graphGrammarJsons != null && message.graphGrammarJsons.length)
                for (let i = 0; i < message.graphGrammarJsons.length; ++i)
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.graphGrammarJsons[i]);
            return writer;
        };

        /**
         * Encodes the specified ListLogsFromQuery message, length delimited. Does not implicitly {@link tdx_response.ListLogsFromQuery.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {tdx_response.IListLogsFromQuery} message ListLogsFromQuery message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLogsFromQuery.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListLogsFromQuery message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.ListLogsFromQuery} ListLogsFromQuery
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLogsFromQuery.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ListLogsFromQuery();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.logs && message.logs.length))
                            message.logs = [];
                        message.logs.push($root.tdx_response.LogStruct.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 6: {
                        if (!(message.rows && message.rows.length))
                            message.rows = [];
                        message.rows.push(reader.bytes());
                        break;
                    }
                case 7: {
                        if (!(message.graphGrammarJsons && message.graphGrammarJsons.length))
                            message.graphGrammarJsons = [];
                        message.graphGrammarJsons.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListLogsFromQuery message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.ListLogsFromQuery} ListLogsFromQuery
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLogsFromQuery.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListLogsFromQuery message.
         * @function verify
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListLogsFromQuery.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.logs != null && message.hasOwnProperty("logs")) {
                if (!Array.isArray(message.logs))
                    return "logs: array expected";
                for (let i = 0; i < message.logs.length; ++i) {
                    let error = $root.tdx_response.LogStruct.verify(message.logs[i]);
                    if (error)
                        return "logs." + error;
                }
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            if (message.rows != null && message.hasOwnProperty("rows")) {
                if (!Array.isArray(message.rows))
                    return "rows: array expected";
                for (let i = 0; i < message.rows.length; ++i)
                    if (!(message.rows[i] && typeof message.rows[i].length === "number" || $util.isString(message.rows[i])))
                        return "rows: buffer[] expected";
            }
            if (message.graphGrammarJsons != null && message.hasOwnProperty("graphGrammarJsons")) {
                if (!Array.isArray(message.graphGrammarJsons))
                    return "graphGrammarJsons: array expected";
                for (let i = 0; i < message.graphGrammarJsons.length; ++i)
                    if (!$util.isString(message.graphGrammarJsons[i]))
                        return "graphGrammarJsons: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ListLogsFromQuery message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.ListLogsFromQuery} ListLogsFromQuery
         */
        ListLogsFromQuery.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.ListLogsFromQuery)
                return object;
            let message = new $root.tdx_response.ListLogsFromQuery();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.logs) {
                if (!Array.isArray(object.logs))
                    throw TypeError(".tdx_response.ListLogsFromQuery.logs: array expected");
                message.logs = [];
                for (let i = 0; i < object.logs.length; ++i) {
                    if (typeof object.logs[i] !== "object")
                        throw TypeError(".tdx_response.ListLogsFromQuery.logs: object expected");
                    message.logs[i] = $root.tdx_response.LogStruct.fromObject(object.logs[i]);
                }
            }
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.rows) {
                if (!Array.isArray(object.rows))
                    throw TypeError(".tdx_response.ListLogsFromQuery.rows: array expected");
                message.rows = [];
                for (let i = 0; i < object.rows.length; ++i)
                    if (typeof object.rows[i] === "string")
                        $util.base64.decode(object.rows[i], message.rows[i] = $util.newBuffer($util.base64.length(object.rows[i])), 0);
                    else if (object.rows[i].length >= 0)
                        message.rows[i] = object.rows[i];
            }
            if (object.graphGrammarJsons) {
                if (!Array.isArray(object.graphGrammarJsons))
                    throw TypeError(".tdx_response.ListLogsFromQuery.graphGrammarJsons: array expected");
                message.graphGrammarJsons = [];
                for (let i = 0; i < object.graphGrammarJsons.length; ++i)
                    message.graphGrammarJsons[i] = String(object.graphGrammarJsons[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListLogsFromQuery message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {tdx_response.ListLogsFromQuery} message ListLogsFromQuery
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListLogsFromQuery.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.logs = [];
                object.rows = [];
                object.graphGrammarJsons = [];
            }
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.pageToken = "";
                else {
                    object.pageToken = [];
                    if (options.bytes !== Array)
                        object.pageToken = $util.newBuffer(object.pageToken);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.logs && message.logs.length) {
                object.logs = [];
                for (let j = 0; j < message.logs.length; ++j)
                    object.logs[j] = $root.tdx_response.LogStruct.toObject(message.logs[j], options);
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
            if (message.rows && message.rows.length) {
                object.rows = [];
                for (let j = 0; j < message.rows.length; ++j)
                    object.rows[j] = options.bytes === String ? $util.base64.encode(message.rows[j], 0, message.rows[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.rows[j]) : message.rows[j];
            }
            if (message.graphGrammarJsons && message.graphGrammarJsons.length) {
                object.graphGrammarJsons = [];
                for (let j = 0; j < message.graphGrammarJsons.length; ++j)
                    object.graphGrammarJsons[j] = message.graphGrammarJsons[j];
            }
            return object;
        };

        /**
         * Converts this ListLogsFromQuery to JSON.
         * @function toJSON
         * @memberof tdx_response.ListLogsFromQuery
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListLogsFromQuery.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListLogsFromQuery
         * @function getTypeUrl
         * @memberof tdx_response.ListLogsFromQuery
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListLogsFromQuery.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.ListLogsFromQuery";
        };

        return ListLogsFromQuery;
    })();

    tdx_response.Result = (function() {

        /**
         * Properties of a Result.
         * @memberof tdx_response
         * @interface IResult
         * @property {tdx_response.Status|null} [Status] Result Status
         * @property {string|null} [message] Result message
         */

        /**
         * Constructs a new Result.
         * @memberof tdx_response
         * @classdesc Represents a Result.
         * @implements IResult
         * @constructor
         * @param {tdx_response.IResult=} [properties] Properties to set
         */
        function Result(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Result Status.
         * @member {tdx_response.Status} Status
         * @memberof tdx_response.Result
         * @instance
         */
        Result.prototype.Status = 0;

        /**
         * Result message.
         * @member {string} message
         * @memberof tdx_response.Result
         * @instance
         */
        Result.prototype.message = "";

        /**
         * Creates a new Result instance using the specified properties.
         * @function create
         * @memberof tdx_response.Result
         * @static
         * @param {tdx_response.IResult=} [properties] Properties to set
         * @returns {tdx_response.Result} Result instance
         */
        Result.create = function create(properties) {
            return new Result(properties);
        };

        /**
         * Encodes the specified Result message. Does not implicitly {@link tdx_response.Result.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Result
         * @static
         * @param {tdx_response.IResult} message Result message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Result.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Status != null && Object.hasOwnProperty.call(message, "Status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified Result message, length delimited. Does not implicitly {@link tdx_response.Result.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Result
         * @static
         * @param {tdx_response.IResult} message Result message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Result.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Result message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Result
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Result} Result
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Result.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Result();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.Status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Result message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Result
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Result} Result
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Result.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Result message.
         * @function verify
         * @memberof tdx_response.Result
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Result.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Status != null && message.hasOwnProperty("Status"))
                switch (message.Status) {
                default:
                    return "Status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a Result message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Result
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Result} Result
         */
        Result.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Result)
                return object;
            let message = new $root.tdx_response.Result();
            switch (object.Status) {
            default:
                if (typeof object.Status === "number") {
                    message.Status = object.Status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.Status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.Status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.Status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.Status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.Status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.Status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.Status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.Status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.Status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.Status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.Status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.Status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.Status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.Status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.Status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.Status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.Status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.Status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.Status = 18;
                break;
            case "FAILURE":
            case 100:
                message.Status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.Status = 19;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a Result message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Result
         * @static
         * @param {tdx_response.Result} message Result
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Result.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.Status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.Status != null && message.hasOwnProperty("Status"))
                object.Status = options.enums === String ? $root.tdx_response.Status[message.Status] === undefined ? message.Status : $root.tdx_response.Status[message.Status] : message.Status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this Result to JSON.
         * @function toJSON
         * @memberof tdx_response.Result
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Result.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Result
         * @function getTypeUrl
         * @memberof tdx_response.Result
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Result.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Result";
        };

        return Result;
    })();

    tdx_response.CreateAlert = (function() {

        /**
         * Properties of a CreateAlert.
         * @memberof tdx_response
         * @interface ICreateAlert
         * @property {tdx_response.IResult|null} [result] CreateAlert result
         * @property {string|null} [summary] CreateAlert summary
         */

        /**
         * Constructs a new CreateAlert.
         * @memberof tdx_response
         * @classdesc Represents a CreateAlert.
         * @implements ICreateAlert
         * @constructor
         * @param {tdx_response.ICreateAlert=} [properties] Properties to set
         */
        function CreateAlert(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateAlert result.
         * @member {tdx_response.IResult|null|undefined} result
         * @memberof tdx_response.CreateAlert
         * @instance
         */
        CreateAlert.prototype.result = null;

        /**
         * CreateAlert summary.
         * @member {string|null|undefined} summary
         * @memberof tdx_response.CreateAlert
         * @instance
         */
        CreateAlert.prototype.summary = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * CreateAlert _summary.
         * @member {"summary"|undefined} _summary
         * @memberof tdx_response.CreateAlert
         * @instance
         */
        Object.defineProperty(CreateAlert.prototype, "_summary", {
            get: $util.oneOfGetter($oneOfFields = ["summary"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CreateAlert instance using the specified properties.
         * @function create
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {tdx_response.ICreateAlert=} [properties] Properties to set
         * @returns {tdx_response.CreateAlert} CreateAlert instance
         */
        CreateAlert.create = function create(properties) {
            return new CreateAlert(properties);
        };

        /**
         * Encodes the specified CreateAlert message. Does not implicitly {@link tdx_response.CreateAlert.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {tdx_response.ICreateAlert} message CreateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAlert.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                $root.tdx_response.Result.encode(message.result, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.summary);
            return writer;
        };

        /**
         * Encodes the specified CreateAlert message, length delimited. Does not implicitly {@link tdx_response.CreateAlert.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {tdx_response.ICreateAlert} message CreateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAlert.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateAlert message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.CreateAlert} CreateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAlert.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.CreateAlert();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.result = $root.tdx_response.Result.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.summary = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateAlert message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.CreateAlert} CreateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAlert.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateAlert message.
         * @function verify
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateAlert.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.result != null && message.hasOwnProperty("result")) {
                let error = $root.tdx_response.Result.verify(message.result);
                if (error)
                    return "result." + error;
            }
            if (message.summary != null && message.hasOwnProperty("summary")) {
                properties._summary = 1;
                if (!$util.isString(message.summary))
                    return "summary: string expected";
            }
            return null;
        };

        /**
         * Creates a CreateAlert message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.CreateAlert} CreateAlert
         */
        CreateAlert.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.CreateAlert)
                return object;
            let message = new $root.tdx_response.CreateAlert();
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".tdx_response.CreateAlert.result: object expected");
                message.result = $root.tdx_response.Result.fromObject(object.result);
            }
            if (object.summary != null)
                message.summary = String(object.summary);
            return message;
        };

        /**
         * Creates a plain object from a CreateAlert message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {tdx_response.CreateAlert} message CreateAlert
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateAlert.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.result = null;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.tdx_response.Result.toObject(message.result, options);
            if (message.summary != null && message.hasOwnProperty("summary")) {
                object.summary = message.summary;
                if (options.oneofs)
                    object._summary = "summary";
            }
            return object;
        };

        /**
         * Converts this CreateAlert to JSON.
         * @function toJSON
         * @memberof tdx_response.CreateAlert
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateAlert.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateAlert
         * @function getTypeUrl
         * @memberof tdx_response.CreateAlert
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateAlert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.CreateAlert";
        };

        return CreateAlert;
    })();

    tdx_response.DeleteAlert = (function() {

        /**
         * Properties of a DeleteAlert.
         * @memberof tdx_response
         * @interface IDeleteAlert
         * @property {tdx_response.IResult|null} [result] DeleteAlert result
         */

        /**
         * Constructs a new DeleteAlert.
         * @memberof tdx_response
         * @classdesc Represents a DeleteAlert.
         * @implements IDeleteAlert
         * @constructor
         * @param {tdx_response.IDeleteAlert=} [properties] Properties to set
         */
        function DeleteAlert(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteAlert result.
         * @member {tdx_response.IResult|null|undefined} result
         * @memberof tdx_response.DeleteAlert
         * @instance
         */
        DeleteAlert.prototype.result = null;

        /**
         * Creates a new DeleteAlert instance using the specified properties.
         * @function create
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {tdx_response.IDeleteAlert=} [properties] Properties to set
         * @returns {tdx_response.DeleteAlert} DeleteAlert instance
         */
        DeleteAlert.create = function create(properties) {
            return new DeleteAlert(properties);
        };

        /**
         * Encodes the specified DeleteAlert message. Does not implicitly {@link tdx_response.DeleteAlert.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {tdx_response.IDeleteAlert} message DeleteAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAlert.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                $root.tdx_response.Result.encode(message.result, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified DeleteAlert message, length delimited. Does not implicitly {@link tdx_response.DeleteAlert.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {tdx_response.IDeleteAlert} message DeleteAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAlert.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteAlert message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.DeleteAlert} DeleteAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAlert.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.DeleteAlert();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.result = $root.tdx_response.Result.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteAlert message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.DeleteAlert} DeleteAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAlert.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteAlert message.
         * @function verify
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteAlert.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result")) {
                let error = $root.tdx_response.Result.verify(message.result);
                if (error)
                    return "result." + error;
            }
            return null;
        };

        /**
         * Creates a DeleteAlert message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.DeleteAlert} DeleteAlert
         */
        DeleteAlert.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.DeleteAlert)
                return object;
            let message = new $root.tdx_response.DeleteAlert();
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".tdx_response.DeleteAlert.result: object expected");
                message.result = $root.tdx_response.Result.fromObject(object.result);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeleteAlert message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {tdx_response.DeleteAlert} message DeleteAlert
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteAlert.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.result = null;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.tdx_response.Result.toObject(message.result, options);
            return object;
        };

        /**
         * Converts this DeleteAlert to JSON.
         * @function toJSON
         * @memberof tdx_response.DeleteAlert
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteAlert.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteAlert
         * @function getTypeUrl
         * @memberof tdx_response.DeleteAlert
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteAlert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.DeleteAlert";
        };

        return DeleteAlert;
    })();

    tdx_response.ListAlerts = (function() {

        /**
         * Properties of a ListAlerts.
         * @memberof tdx_response
         * @interface IListAlerts
         * @property {tdx_response.IResult|null} [result] ListAlerts result
         * @property {Array.<string>|null} [alerts] ListAlerts alerts
         * @property {Array.<boolean>|null} [enabled] ListAlerts enabled
         * @property {Array.<boolean>|null} [isDeleteable] ListAlerts isDeleteable
         * @property {Array.<string>|null} [summary] ListAlerts summary
         */

        /**
         * Constructs a new ListAlerts.
         * @memberof tdx_response
         * @classdesc Represents a ListAlerts.
         * @implements IListAlerts
         * @constructor
         * @param {tdx_response.IListAlerts=} [properties] Properties to set
         */
        function ListAlerts(properties) {
            this.alerts = [];
            this.enabled = [];
            this.isDeleteable = [];
            this.summary = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListAlerts result.
         * @member {tdx_response.IResult|null|undefined} result
         * @memberof tdx_response.ListAlerts
         * @instance
         */
        ListAlerts.prototype.result = null;

        /**
         * ListAlerts alerts.
         * @member {Array.<string>} alerts
         * @memberof tdx_response.ListAlerts
         * @instance
         */
        ListAlerts.prototype.alerts = $util.emptyArray;

        /**
         * ListAlerts enabled.
         * @member {Array.<boolean>} enabled
         * @memberof tdx_response.ListAlerts
         * @instance
         */
        ListAlerts.prototype.enabled = $util.emptyArray;

        /**
         * ListAlerts isDeleteable.
         * @member {Array.<boolean>} isDeleteable
         * @memberof tdx_response.ListAlerts
         * @instance
         */
        ListAlerts.prototype.isDeleteable = $util.emptyArray;

        /**
         * ListAlerts summary.
         * @member {Array.<string>} summary
         * @memberof tdx_response.ListAlerts
         * @instance
         */
        ListAlerts.prototype.summary = $util.emptyArray;

        /**
         * Creates a new ListAlerts instance using the specified properties.
         * @function create
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {tdx_response.IListAlerts=} [properties] Properties to set
         * @returns {tdx_response.ListAlerts} ListAlerts instance
         */
        ListAlerts.create = function create(properties) {
            return new ListAlerts(properties);
        };

        /**
         * Encodes the specified ListAlerts message. Does not implicitly {@link tdx_response.ListAlerts.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {tdx_response.IListAlerts} message ListAlerts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListAlerts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                $root.tdx_response.Result.encode(message.result, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.alerts != null && message.alerts.length)
                for (let i = 0; i < message.alerts.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.alerts[i]);
            if (message.enabled != null && message.enabled.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.enabled.length; ++i)
                    writer.bool(message.enabled[i]);
                writer.ldelim();
            }
            if (message.isDeleteable != null && message.isDeleteable.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.isDeleteable.length; ++i)
                    writer.bool(message.isDeleteable[i]);
                writer.ldelim();
            }
            if (message.summary != null && message.summary.length)
                for (let i = 0; i < message.summary.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.summary[i]);
            return writer;
        };

        /**
         * Encodes the specified ListAlerts message, length delimited. Does not implicitly {@link tdx_response.ListAlerts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {tdx_response.IListAlerts} message ListAlerts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListAlerts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListAlerts message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.ListAlerts} ListAlerts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListAlerts.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ListAlerts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.result = $root.tdx_response.Result.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (!(message.alerts && message.alerts.length))
                            message.alerts = [];
                        message.alerts.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.enabled && message.enabled.length))
                            message.enabled = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.enabled.push(reader.bool());
                        } else
                            message.enabled.push(reader.bool());
                        break;
                    }
                case 4: {
                        if (!(message.isDeleteable && message.isDeleteable.length))
                            message.isDeleteable = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.isDeleteable.push(reader.bool());
                        } else
                            message.isDeleteable.push(reader.bool());
                        break;
                    }
                case 5: {
                        if (!(message.summary && message.summary.length))
                            message.summary = [];
                        message.summary.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListAlerts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.ListAlerts} ListAlerts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListAlerts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListAlerts message.
         * @function verify
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListAlerts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result")) {
                let error = $root.tdx_response.Result.verify(message.result);
                if (error)
                    return "result." + error;
            }
            if (message.alerts != null && message.hasOwnProperty("alerts")) {
                if (!Array.isArray(message.alerts))
                    return "alerts: array expected";
                for (let i = 0; i < message.alerts.length; ++i)
                    if (!$util.isString(message.alerts[i]))
                        return "alerts: string[] expected";
            }
            if (message.enabled != null && message.hasOwnProperty("enabled")) {
                if (!Array.isArray(message.enabled))
                    return "enabled: array expected";
                for (let i = 0; i < message.enabled.length; ++i)
                    if (typeof message.enabled[i] !== "boolean")
                        return "enabled: boolean[] expected";
            }
            if (message.isDeleteable != null && message.hasOwnProperty("isDeleteable")) {
                if (!Array.isArray(message.isDeleteable))
                    return "isDeleteable: array expected";
                for (let i = 0; i < message.isDeleteable.length; ++i)
                    if (typeof message.isDeleteable[i] !== "boolean")
                        return "isDeleteable: boolean[] expected";
            }
            if (message.summary != null && message.hasOwnProperty("summary")) {
                if (!Array.isArray(message.summary))
                    return "summary: array expected";
                for (let i = 0; i < message.summary.length; ++i)
                    if (!$util.isString(message.summary[i]))
                        return "summary: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ListAlerts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.ListAlerts} ListAlerts
         */
        ListAlerts.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.ListAlerts)
                return object;
            let message = new $root.tdx_response.ListAlerts();
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".tdx_response.ListAlerts.result: object expected");
                message.result = $root.tdx_response.Result.fromObject(object.result);
            }
            if (object.alerts) {
                if (!Array.isArray(object.alerts))
                    throw TypeError(".tdx_response.ListAlerts.alerts: array expected");
                message.alerts = [];
                for (let i = 0; i < object.alerts.length; ++i)
                    message.alerts[i] = String(object.alerts[i]);
            }
            if (object.enabled) {
                if (!Array.isArray(object.enabled))
                    throw TypeError(".tdx_response.ListAlerts.enabled: array expected");
                message.enabled = [];
                for (let i = 0; i < object.enabled.length; ++i)
                    message.enabled[i] = Boolean(object.enabled[i]);
            }
            if (object.isDeleteable) {
                if (!Array.isArray(object.isDeleteable))
                    throw TypeError(".tdx_response.ListAlerts.isDeleteable: array expected");
                message.isDeleteable = [];
                for (let i = 0; i < object.isDeleteable.length; ++i)
                    message.isDeleteable[i] = Boolean(object.isDeleteable[i]);
            }
            if (object.summary) {
                if (!Array.isArray(object.summary))
                    throw TypeError(".tdx_response.ListAlerts.summary: array expected");
                message.summary = [];
                for (let i = 0; i < object.summary.length; ++i)
                    message.summary[i] = String(object.summary[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListAlerts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {tdx_response.ListAlerts} message ListAlerts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListAlerts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.alerts = [];
                object.enabled = [];
                object.isDeleteable = [];
                object.summary = [];
            }
            if (options.defaults)
                object.result = null;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.tdx_response.Result.toObject(message.result, options);
            if (message.alerts && message.alerts.length) {
                object.alerts = [];
                for (let j = 0; j < message.alerts.length; ++j)
                    object.alerts[j] = message.alerts[j];
            }
            if (message.enabled && message.enabled.length) {
                object.enabled = [];
                for (let j = 0; j < message.enabled.length; ++j)
                    object.enabled[j] = message.enabled[j];
            }
            if (message.isDeleteable && message.isDeleteable.length) {
                object.isDeleteable = [];
                for (let j = 0; j < message.isDeleteable.length; ++j)
                    object.isDeleteable[j] = message.isDeleteable[j];
            }
            if (message.summary && message.summary.length) {
                object.summary = [];
                for (let j = 0; j < message.summary.length; ++j)
                    object.summary[j] = message.summary[j];
            }
            return object;
        };

        /**
         * Converts this ListAlerts to JSON.
         * @function toJSON
         * @memberof tdx_response.ListAlerts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListAlerts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListAlerts
         * @function getTypeUrl
         * @memberof tdx_response.ListAlerts
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListAlerts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.ListAlerts";
        };

        return ListAlerts;
    })();

    tdx_response.UpdateAlert = (function() {

        /**
         * Properties of an UpdateAlert.
         * @memberof tdx_response
         * @interface IUpdateAlert
         * @property {tdx_response.IResult|null} [result] UpdateAlert result
         */

        /**
         * Constructs a new UpdateAlert.
         * @memberof tdx_response
         * @classdesc Represents an UpdateAlert.
         * @implements IUpdateAlert
         * @constructor
         * @param {tdx_response.IUpdateAlert=} [properties] Properties to set
         */
        function UpdateAlert(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateAlert result.
         * @member {tdx_response.IResult|null|undefined} result
         * @memberof tdx_response.UpdateAlert
         * @instance
         */
        UpdateAlert.prototype.result = null;

        /**
         * Creates a new UpdateAlert instance using the specified properties.
         * @function create
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {tdx_response.IUpdateAlert=} [properties] Properties to set
         * @returns {tdx_response.UpdateAlert} UpdateAlert instance
         */
        UpdateAlert.create = function create(properties) {
            return new UpdateAlert(properties);
        };

        /**
         * Encodes the specified UpdateAlert message. Does not implicitly {@link tdx_response.UpdateAlert.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {tdx_response.IUpdateAlert} message UpdateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAlert.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                $root.tdx_response.Result.encode(message.result, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UpdateAlert message, length delimited. Does not implicitly {@link tdx_response.UpdateAlert.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {tdx_response.IUpdateAlert} message UpdateAlert message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAlert.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateAlert message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.UpdateAlert} UpdateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAlert.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.UpdateAlert();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.result = $root.tdx_response.Result.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateAlert message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.UpdateAlert} UpdateAlert
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAlert.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateAlert message.
         * @function verify
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateAlert.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result")) {
                let error = $root.tdx_response.Result.verify(message.result);
                if (error)
                    return "result." + error;
            }
            return null;
        };

        /**
         * Creates an UpdateAlert message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.UpdateAlert} UpdateAlert
         */
        UpdateAlert.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.UpdateAlert)
                return object;
            let message = new $root.tdx_response.UpdateAlert();
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".tdx_response.UpdateAlert.result: object expected");
                message.result = $root.tdx_response.Result.fromObject(object.result);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateAlert message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {tdx_response.UpdateAlert} message UpdateAlert
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateAlert.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.result = null;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.tdx_response.Result.toObject(message.result, options);
            return object;
        };

        /**
         * Converts this UpdateAlert to JSON.
         * @function toJSON
         * @memberof tdx_response.UpdateAlert
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateAlert.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateAlert
         * @function getTypeUrl
         * @memberof tdx_response.UpdateAlert
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateAlert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.UpdateAlert";
        };

        return UpdateAlert;
    })();

    tdx_response.GetAuditLog = (function() {

        /**
         * Properties of a GetAuditLog.
         * @memberof tdx_response
         * @interface IGetAuditLog
         * @property {tdx_response.Status|null} [status] GetAuditLog status
         * @property {Uint8Array|null} [data] GetAuditLog data
         * @property {Uint8Array|null} [signedHash] GetAuditLog signedHash
         * @property {Uint8Array|null} [certificate] GetAuditLog certificate
         */

        /**
         * Constructs a new GetAuditLog.
         * @memberof tdx_response
         * @classdesc Represents a GetAuditLog.
         * @implements IGetAuditLog
         * @constructor
         * @param {tdx_response.IGetAuditLog=} [properties] Properties to set
         */
        function GetAuditLog(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetAuditLog status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.status = 0;

        /**
         * GetAuditLog data.
         * @member {Uint8Array} data
         * @memberof tdx_response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.data = $util.newBuffer([]);

        /**
         * GetAuditLog signedHash.
         * @member {Uint8Array} signedHash
         * @memberof tdx_response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.signedHash = $util.newBuffer([]);

        /**
         * GetAuditLog certificate.
         * @member {Uint8Array} certificate
         * @memberof tdx_response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.certificate = $util.newBuffer([]);

        /**
         * Creates a new GetAuditLog instance using the specified properties.
         * @function create
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {tdx_response.IGetAuditLog=} [properties] Properties to set
         * @returns {tdx_response.GetAuditLog} GetAuditLog instance
         */
        GetAuditLog.create = function create(properties) {
            return new GetAuditLog(properties);
        };

        /**
         * Encodes the specified GetAuditLog message. Does not implicitly {@link tdx_response.GetAuditLog.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {tdx_response.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.signedHash != null && Object.hasOwnProperty.call(message, "signedHash"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.signedHash);
            if (message.certificate != null && Object.hasOwnProperty.call(message, "certificate"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.certificate);
            return writer;
        };

        /**
         * Encodes the specified GetAuditLog message, length delimited. Does not implicitly {@link tdx_response.GetAuditLog.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {tdx_response.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.GetAuditLog();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.signedHash = reader.bytes();
                        break;
                    }
                case 4: {
                        message.certificate = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAuditLog message.
         * @function verify
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAuditLog.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.signedHash != null && message.hasOwnProperty("signedHash"))
                if (!(message.signedHash && typeof message.signedHash.length === "number" || $util.isString(message.signedHash)))
                    return "signedHash: buffer expected";
            if (message.certificate != null && message.hasOwnProperty("certificate"))
                if (!(message.certificate && typeof message.certificate.length === "number" || $util.isString(message.certificate)))
                    return "certificate: buffer expected";
            return null;
        };

        /**
         * Creates a GetAuditLog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.GetAuditLog} GetAuditLog
         */
        GetAuditLog.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.GetAuditLog)
                return object;
            let message = new $root.tdx_response.GetAuditLog();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.signedHash != null)
                if (typeof object.signedHash === "string")
                    $util.base64.decode(object.signedHash, message.signedHash = $util.newBuffer($util.base64.length(object.signedHash)), 0);
                else if (object.signedHash.length >= 0)
                    message.signedHash = object.signedHash;
            if (object.certificate != null)
                if (typeof object.certificate === "string")
                    $util.base64.decode(object.certificate, message.certificate = $util.newBuffer($util.base64.length(object.certificate)), 0);
                else if (object.certificate.length >= 0)
                    message.certificate = object.certificate;
            return message;
        };

        /**
         * Creates a plain object from a GetAuditLog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {tdx_response.GetAuditLog} message GetAuditLog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAuditLog.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if (options.bytes === String)
                    object.signedHash = "";
                else {
                    object.signedHash = [];
                    if (options.bytes !== Array)
                        object.signedHash = $util.newBuffer(object.signedHash);
                }
                if (options.bytes === String)
                    object.certificate = "";
                else {
                    object.certificate = [];
                    if (options.bytes !== Array)
                        object.certificate = $util.newBuffer(object.certificate);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.signedHash != null && message.hasOwnProperty("signedHash"))
                object.signedHash = options.bytes === String ? $util.base64.encode(message.signedHash, 0, message.signedHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.signedHash) : message.signedHash;
            if (message.certificate != null && message.hasOwnProperty("certificate"))
                object.certificate = options.bytes === String ? $util.base64.encode(message.certificate, 0, message.certificate.length) : options.bytes === Array ? Array.prototype.slice.call(message.certificate) : message.certificate;
            return object;
        };

        /**
         * Converts this GetAuditLog to JSON.
         * @function toJSON
         * @memberof tdx_response.GetAuditLog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAuditLog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetAuditLog
         * @function getTypeUrl
         * @memberof tdx_response.GetAuditLog
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetAuditLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.GetAuditLog";
        };

        return GetAuditLog;
    })();

    tdx_response.LogFileMeta = (function() {

        /**
         * Properties of a LogFileMeta.
         * @memberof tdx_response
         * @interface ILogFileMeta
         * @property {string|null} [name] LogFileMeta name
         * @property {number|Long|null} [startTime] LogFileMeta startTime
         * @property {number|Long|null} [endTime] LogFileMeta endTime
         * @property {number|Long|null} [size] LogFileMeta size
         * @property {string|null} [logHash] LogFileMeta logHash
         * @property {string|null} [signedHash] LogFileMeta signedHash
         * @property {string|null} [transactionId] LogFileMeta transactionId
         */

        /**
         * Constructs a new LogFileMeta.
         * @memberof tdx_response
         * @classdesc Represents a LogFileMeta.
         * @implements ILogFileMeta
         * @constructor
         * @param {tdx_response.ILogFileMeta=} [properties] Properties to set
         */
        function LogFileMeta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LogFileMeta name.
         * @member {string} name
         * @memberof tdx_response.LogFileMeta
         * @instance
         */
        LogFileMeta.prototype.name = "";

        /**
         * LogFileMeta startTime.
         * @member {number|Long} startTime
         * @memberof tdx_response.LogFileMeta
         * @instance
         */
        LogFileMeta.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * LogFileMeta endTime.
         * @member {number|Long} endTime
         * @memberof tdx_response.LogFileMeta
         * @instance
         */
        LogFileMeta.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * LogFileMeta size.
         * @member {number|Long} size
         * @memberof tdx_response.LogFileMeta
         * @instance
         */
        LogFileMeta.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * LogFileMeta logHash.
         * @member {string} logHash
         * @memberof tdx_response.LogFileMeta
         * @instance
         */
        LogFileMeta.prototype.logHash = "";

        /**
         * LogFileMeta signedHash.
         * @member {string} signedHash
         * @memberof tdx_response.LogFileMeta
         * @instance
         */
        LogFileMeta.prototype.signedHash = "";

        /**
         * LogFileMeta transactionId.
         * @member {string} transactionId
         * @memberof tdx_response.LogFileMeta
         * @instance
         */
        LogFileMeta.prototype.transactionId = "";

        /**
         * Creates a new LogFileMeta instance using the specified properties.
         * @function create
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {tdx_response.ILogFileMeta=} [properties] Properties to set
         * @returns {tdx_response.LogFileMeta} LogFileMeta instance
         */
        LogFileMeta.create = function create(properties) {
            return new LogFileMeta(properties);
        };

        /**
         * Encodes the specified LogFileMeta message. Does not implicitly {@link tdx_response.LogFileMeta.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {tdx_response.ILogFileMeta} message LogFileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LogFileMeta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.endTime);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.size);
            if (message.logHash != null && Object.hasOwnProperty.call(message, "logHash"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.logHash);
            if (message.signedHash != null && Object.hasOwnProperty.call(message, "signedHash"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.signedHash);
            if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.transactionId);
            return writer;
        };

        /**
         * Encodes the specified LogFileMeta message, length delimited. Does not implicitly {@link tdx_response.LogFileMeta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {tdx_response.ILogFileMeta} message LogFileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LogFileMeta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LogFileMeta message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.LogFileMeta} LogFileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LogFileMeta.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.LogFileMeta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 3: {
                        message.endTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.size = reader.int64();
                        break;
                    }
                case 5: {
                        message.logHash = reader.string();
                        break;
                    }
                case 6: {
                        message.signedHash = reader.string();
                        break;
                    }
                case 7: {
                        message.transactionId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LogFileMeta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.LogFileMeta} LogFileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LogFileMeta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LogFileMeta message.
         * @function verify
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LogFileMeta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            if (message.logHash != null && message.hasOwnProperty("logHash"))
                if (!$util.isString(message.logHash))
                    return "logHash: string expected";
            if (message.signedHash != null && message.hasOwnProperty("signedHash"))
                if (!$util.isString(message.signedHash))
                    return "signedHash: string expected";
            if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                if (!$util.isString(message.transactionId))
                    return "transactionId: string expected";
            return null;
        };

        /**
         * Creates a LogFileMeta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.LogFileMeta} LogFileMeta
         */
        LogFileMeta.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.LogFileMeta)
                return object;
            let message = new $root.tdx_response.LogFileMeta();
            if (object.name != null)
                message.name = String(object.name);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
            if (object.logHash != null)
                message.logHash = String(object.logHash);
            if (object.signedHash != null)
                message.signedHash = String(object.signedHash);
            if (object.transactionId != null)
                message.transactionId = String(object.transactionId);
            return message;
        };

        /**
         * Creates a plain object from a LogFileMeta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {tdx_response.LogFileMeta} message LogFileMeta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LogFileMeta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                object.logHash = "";
                object.signedHash = "";
                object.transactionId = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
            if (message.logHash != null && message.hasOwnProperty("logHash"))
                object.logHash = message.logHash;
            if (message.signedHash != null && message.hasOwnProperty("signedHash"))
                object.signedHash = message.signedHash;
            if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                object.transactionId = message.transactionId;
            return object;
        };

        /**
         * Converts this LogFileMeta to JSON.
         * @function toJSON
         * @memberof tdx_response.LogFileMeta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LogFileMeta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LogFileMeta
         * @function getTypeUrl
         * @memberof tdx_response.LogFileMeta
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LogFileMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.LogFileMeta";
        };

        return LogFileMeta;
    })();

    tdx_response.GetLedgerRange = (function() {

        /**
         * Properties of a GetLedgerRange.
         * @memberof tdx_response
         * @interface IGetLedgerRange
         * @property {tdx_response.Status|null} [status] GetLedgerRange status
         * @property {Uint8Array|null} [pageTokenLogs] GetLedgerRange pageTokenLogs
         * @property {Array.<tdx_response.ILogFileMeta>|null} [logFileMetas] GetLedgerRange logFileMetas
         */

        /**
         * Constructs a new GetLedgerRange.
         * @memberof tdx_response
         * @classdesc Represents a GetLedgerRange.
         * @implements IGetLedgerRange
         * @constructor
         * @param {tdx_response.IGetLedgerRange=} [properties] Properties to set
         */
        function GetLedgerRange(properties) {
            this.logFileMetas = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLedgerRange status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.status = 0;

        /**
         * GetLedgerRange pageTokenLogs.
         * @member {Uint8Array|null|undefined} pageTokenLogs
         * @memberof tdx_response.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.pageTokenLogs = null;

        /**
         * GetLedgerRange logFileMetas.
         * @member {Array.<tdx_response.ILogFileMeta>} logFileMetas
         * @memberof tdx_response.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.logFileMetas = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * GetLedgerRange _pageTokenLogs.
         * @member {"pageTokenLogs"|undefined} _pageTokenLogs
         * @memberof tdx_response.GetLedgerRange
         * @instance
         */
        Object.defineProperty(GetLedgerRange.prototype, "_pageTokenLogs", {
            get: $util.oneOfGetter($oneOfFields = ["pageTokenLogs"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetLedgerRange instance using the specified properties.
         * @function create
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {tdx_response.IGetLedgerRange=} [properties] Properties to set
         * @returns {tdx_response.GetLedgerRange} GetLedgerRange instance
         */
        GetLedgerRange.create = function create(properties) {
            return new GetLedgerRange(properties);
        };

        /**
         * Encodes the specified GetLedgerRange message. Does not implicitly {@link tdx_response.GetLedgerRange.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {tdx_response.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.pageTokenLogs != null && Object.hasOwnProperty.call(message, "pageTokenLogs"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.pageTokenLogs);
            if (message.logFileMetas != null && message.logFileMetas.length)
                for (let i = 0; i < message.logFileMetas.length; ++i)
                    $root.tdx_response.LogFileMeta.encode(message.logFileMetas[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetLedgerRange message, length delimited. Does not implicitly {@link tdx_response.GetLedgerRange.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {tdx_response.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.GetLedgerRange();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.pageTokenLogs = reader.bytes();
                        break;
                    }
                case 3: {
                        if (!(message.logFileMetas && message.logFileMetas.length))
                            message.logFileMetas = [];
                        message.logFileMetas.push($root.tdx_response.LogFileMeta.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLedgerRange message.
         * @function verify
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLedgerRange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.pageTokenLogs != null && message.hasOwnProperty("pageTokenLogs")) {
                properties._pageTokenLogs = 1;
                if (!(message.pageTokenLogs && typeof message.pageTokenLogs.length === "number" || $util.isString(message.pageTokenLogs)))
                    return "pageTokenLogs: buffer expected";
            }
            if (message.logFileMetas != null && message.hasOwnProperty("logFileMetas")) {
                if (!Array.isArray(message.logFileMetas))
                    return "logFileMetas: array expected";
                for (let i = 0; i < message.logFileMetas.length; ++i) {
                    let error = $root.tdx_response.LogFileMeta.verify(message.logFileMetas[i]);
                    if (error)
                        return "logFileMetas." + error;
                }
            }
            return null;
        };

        /**
         * Creates a GetLedgerRange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.GetLedgerRange} GetLedgerRange
         */
        GetLedgerRange.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.GetLedgerRange)
                return object;
            let message = new $root.tdx_response.GetLedgerRange();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.pageTokenLogs != null)
                if (typeof object.pageTokenLogs === "string")
                    $util.base64.decode(object.pageTokenLogs, message.pageTokenLogs = $util.newBuffer($util.base64.length(object.pageTokenLogs)), 0);
                else if (object.pageTokenLogs.length >= 0)
                    message.pageTokenLogs = object.pageTokenLogs;
            if (object.logFileMetas) {
                if (!Array.isArray(object.logFileMetas))
                    throw TypeError(".tdx_response.GetLedgerRange.logFileMetas: array expected");
                message.logFileMetas = [];
                for (let i = 0; i < object.logFileMetas.length; ++i) {
                    if (typeof object.logFileMetas[i] !== "object")
                        throw TypeError(".tdx_response.GetLedgerRange.logFileMetas: object expected");
                    message.logFileMetas[i] = $root.tdx_response.LogFileMeta.fromObject(object.logFileMetas[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetLedgerRange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {tdx_response.GetLedgerRange} message GetLedgerRange
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLedgerRange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.logFileMetas = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.pageTokenLogs != null && message.hasOwnProperty("pageTokenLogs")) {
                object.pageTokenLogs = options.bytes === String ? $util.base64.encode(message.pageTokenLogs, 0, message.pageTokenLogs.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageTokenLogs) : message.pageTokenLogs;
                if (options.oneofs)
                    object._pageTokenLogs = "pageTokenLogs";
            }
            if (message.logFileMetas && message.logFileMetas.length) {
                object.logFileMetas = [];
                for (let j = 0; j < message.logFileMetas.length; ++j)
                    object.logFileMetas[j] = $root.tdx_response.LogFileMeta.toObject(message.logFileMetas[j], options);
            }
            return object;
        };

        /**
         * Converts this GetLedgerRange to JSON.
         * @function toJSON
         * @memberof tdx_response.GetLedgerRange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLedgerRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLedgerRange
         * @function getTypeUrl
         * @memberof tdx_response.GetLedgerRange
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLedgerRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.GetLedgerRange";
        };

        return GetLedgerRange;
    })();

    tdx_response.GetInclusionProof = (function() {

        /**
         * Properties of a GetInclusionProof.
         * @memberof tdx_response
         * @interface IGetInclusionProof
         * @property {tdx_response.Status|null} [status] GetInclusionProof status
         * @property {string|null} [transactionId] GetInclusionProof transactionId
         * @property {Array.<Uint8Array>|null} [proof] GetInclusionProof proof
         * @property {Uint8Array|null} [rootHash] GetInclusionProof rootHash
         * @property {Uint8Array|null} [signedRootHash] GetInclusionProof signedRootHash
         * @property {Uint8Array|null} [leafHash] GetInclusionProof leafHash
         * @property {number|Long|null} [leafIndex] GetInclusionProof leafIndex
         * @property {number|Long|null} [leafCount] GetInclusionProof leafCount
         */

        /**
         * Constructs a new GetInclusionProof.
         * @memberof tdx_response
         * @classdesc Represents a GetInclusionProof.
         * @implements IGetInclusionProof
         * @constructor
         * @param {tdx_response.IGetInclusionProof=} [properties] Properties to set
         */
        function GetInclusionProof(properties) {
            this.proof = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetInclusionProof status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.status = 0;

        /**
         * GetInclusionProof transactionId.
         * @member {string} transactionId
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.transactionId = "";

        /**
         * GetInclusionProof proof.
         * @member {Array.<Uint8Array>} proof
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.proof = $util.emptyArray;

        /**
         * GetInclusionProof rootHash.
         * @member {Uint8Array} rootHash
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.rootHash = $util.newBuffer([]);

        /**
         * GetInclusionProof signedRootHash.
         * @member {Uint8Array} signedRootHash
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.signedRootHash = $util.newBuffer([]);

        /**
         * GetInclusionProof leafHash.
         * @member {Uint8Array} leafHash
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.leafHash = $util.newBuffer([]);

        /**
         * GetInclusionProof leafIndex.
         * @member {number|Long} leafIndex
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.leafIndex = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetInclusionProof leafCount.
         * @member {number|Long} leafCount
         * @memberof tdx_response.GetInclusionProof
         * @instance
         */
        GetInclusionProof.prototype.leafCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetInclusionProof instance using the specified properties.
         * @function create
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {tdx_response.IGetInclusionProof=} [properties] Properties to set
         * @returns {tdx_response.GetInclusionProof} GetInclusionProof instance
         */
        GetInclusionProof.create = function create(properties) {
            return new GetInclusionProof(properties);
        };

        /**
         * Encodes the specified GetInclusionProof message. Does not implicitly {@link tdx_response.GetInclusionProof.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {tdx_response.IGetInclusionProof} message GetInclusionProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetInclusionProof.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.transactionId);
            if (message.proof != null && message.proof.length)
                for (let i = 0; i < message.proof.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.proof[i]);
            if (message.rootHash != null && Object.hasOwnProperty.call(message, "rootHash"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.rootHash);
            if (message.signedRootHash != null && Object.hasOwnProperty.call(message, "signedRootHash"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.signedRootHash);
            if (message.leafHash != null && Object.hasOwnProperty.call(message, "leafHash"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.leafHash);
            if (message.leafIndex != null && Object.hasOwnProperty.call(message, "leafIndex"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.leafIndex);
            if (message.leafCount != null && Object.hasOwnProperty.call(message, "leafCount"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.leafCount);
            return writer;
        };

        /**
         * Encodes the specified GetInclusionProof message, length delimited. Does not implicitly {@link tdx_response.GetInclusionProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {tdx_response.IGetInclusionProof} message GetInclusionProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetInclusionProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetInclusionProof message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.GetInclusionProof} GetInclusionProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetInclusionProof.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.GetInclusionProof();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.transactionId = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.proof && message.proof.length))
                            message.proof = [];
                        message.proof.push(reader.bytes());
                        break;
                    }
                case 4: {
                        message.rootHash = reader.bytes();
                        break;
                    }
                case 5: {
                        message.signedRootHash = reader.bytes();
                        break;
                    }
                case 6: {
                        message.leafHash = reader.bytes();
                        break;
                    }
                case 7: {
                        message.leafIndex = reader.uint64();
                        break;
                    }
                case 8: {
                        message.leafCount = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetInclusionProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.GetInclusionProof} GetInclusionProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetInclusionProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetInclusionProof message.
         * @function verify
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetInclusionProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                if (!$util.isString(message.transactionId))
                    return "transactionId: string expected";
            if (message.proof != null && message.hasOwnProperty("proof")) {
                if (!Array.isArray(message.proof))
                    return "proof: array expected";
                for (let i = 0; i < message.proof.length; ++i)
                    if (!(message.proof[i] && typeof message.proof[i].length === "number" || $util.isString(message.proof[i])))
                        return "proof: buffer[] expected";
            }
            if (message.rootHash != null && message.hasOwnProperty("rootHash"))
                if (!(message.rootHash && typeof message.rootHash.length === "number" || $util.isString(message.rootHash)))
                    return "rootHash: buffer expected";
            if (message.signedRootHash != null && message.hasOwnProperty("signedRootHash"))
                if (!(message.signedRootHash && typeof message.signedRootHash.length === "number" || $util.isString(message.signedRootHash)))
                    return "signedRootHash: buffer expected";
            if (message.leafHash != null && message.hasOwnProperty("leafHash"))
                if (!(message.leafHash && typeof message.leafHash.length === "number" || $util.isString(message.leafHash)))
                    return "leafHash: buffer expected";
            if (message.leafIndex != null && message.hasOwnProperty("leafIndex"))
                if (!$util.isInteger(message.leafIndex) && !(message.leafIndex && $util.isInteger(message.leafIndex.low) && $util.isInteger(message.leafIndex.high)))
                    return "leafIndex: integer|Long expected";
            if (message.leafCount != null && message.hasOwnProperty("leafCount"))
                if (!$util.isInteger(message.leafCount) && !(message.leafCount && $util.isInteger(message.leafCount.low) && $util.isInteger(message.leafCount.high)))
                    return "leafCount: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetInclusionProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.GetInclusionProof} GetInclusionProof
         */
        GetInclusionProof.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.GetInclusionProof)
                return object;
            let message = new $root.tdx_response.GetInclusionProof();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.transactionId != null)
                message.transactionId = String(object.transactionId);
            if (object.proof) {
                if (!Array.isArray(object.proof))
                    throw TypeError(".tdx_response.GetInclusionProof.proof: array expected");
                message.proof = [];
                for (let i = 0; i < object.proof.length; ++i)
                    if (typeof object.proof[i] === "string")
                        $util.base64.decode(object.proof[i], message.proof[i] = $util.newBuffer($util.base64.length(object.proof[i])), 0);
                    else if (object.proof[i].length >= 0)
                        message.proof[i] = object.proof[i];
            }
            if (object.rootHash != null)
                if (typeof object.rootHash === "string")
                    $util.base64.decode(object.rootHash, message.rootHash = $util.newBuffer($util.base64.length(object.rootHash)), 0);
                else if (object.rootHash.length >= 0)
                    message.rootHash = object.rootHash;
            if (object.signedRootHash != null)
                if (typeof object.signedRootHash === "string")
                    $util.base64.decode(object.signedRootHash, message.signedRootHash = $util.newBuffer($util.base64.length(object.signedRootHash)), 0);
                else if (object.signedRootHash.length >= 0)
                    message.signedRootHash = object.signedRootHash;
            if (object.leafHash != null)
                if (typeof object.leafHash === "string")
                    $util.base64.decode(object.leafHash, message.leafHash = $util.newBuffer($util.base64.length(object.leafHash)), 0);
                else if (object.leafHash.length >= 0)
                    message.leafHash = object.leafHash;
            if (object.leafIndex != null)
                if ($util.Long)
                    (message.leafIndex = $util.Long.fromValue(object.leafIndex)).unsigned = true;
                else if (typeof object.leafIndex === "string")
                    message.leafIndex = parseInt(object.leafIndex, 10);
                else if (typeof object.leafIndex === "number")
                    message.leafIndex = object.leafIndex;
                else if (typeof object.leafIndex === "object")
                    message.leafIndex = new $util.LongBits(object.leafIndex.low >>> 0, object.leafIndex.high >>> 0).toNumber(true);
            if (object.leafCount != null)
                if ($util.Long)
                    (message.leafCount = $util.Long.fromValue(object.leafCount)).unsigned = true;
                else if (typeof object.leafCount === "string")
                    message.leafCount = parseInt(object.leafCount, 10);
                else if (typeof object.leafCount === "number")
                    message.leafCount = object.leafCount;
                else if (typeof object.leafCount === "object")
                    message.leafCount = new $util.LongBits(object.leafCount.low >>> 0, object.leafCount.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetInclusionProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {tdx_response.GetInclusionProof} message GetInclusionProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetInclusionProof.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.proof = [];
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.transactionId = "";
                if (options.bytes === String)
                    object.rootHash = "";
                else {
                    object.rootHash = [];
                    if (options.bytes !== Array)
                        object.rootHash = $util.newBuffer(object.rootHash);
                }
                if (options.bytes === String)
                    object.signedRootHash = "";
                else {
                    object.signedRootHash = [];
                    if (options.bytes !== Array)
                        object.signedRootHash = $util.newBuffer(object.signedRootHash);
                }
                if (options.bytes === String)
                    object.leafHash = "";
                else {
                    object.leafHash = [];
                    if (options.bytes !== Array)
                        object.leafHash = $util.newBuffer(object.leafHash);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.leafIndex = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.leafIndex = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.leafCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.leafCount = options.longs === String ? "0" : 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                object.transactionId = message.transactionId;
            if (message.proof && message.proof.length) {
                object.proof = [];
                for (let j = 0; j < message.proof.length; ++j)
                    object.proof[j] = options.bytes === String ? $util.base64.encode(message.proof[j], 0, message.proof[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.proof[j]) : message.proof[j];
            }
            if (message.rootHash != null && message.hasOwnProperty("rootHash"))
                object.rootHash = options.bytes === String ? $util.base64.encode(message.rootHash, 0, message.rootHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.rootHash) : message.rootHash;
            if (message.signedRootHash != null && message.hasOwnProperty("signedRootHash"))
                object.signedRootHash = options.bytes === String ? $util.base64.encode(message.signedRootHash, 0, message.signedRootHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.signedRootHash) : message.signedRootHash;
            if (message.leafHash != null && message.hasOwnProperty("leafHash"))
                object.leafHash = options.bytes === String ? $util.base64.encode(message.leafHash, 0, message.leafHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.leafHash) : message.leafHash;
            if (message.leafIndex != null && message.hasOwnProperty("leafIndex"))
                if (typeof message.leafIndex === "number")
                    object.leafIndex = options.longs === String ? String(message.leafIndex) : message.leafIndex;
                else
                    object.leafIndex = options.longs === String ? $util.Long.prototype.toString.call(message.leafIndex) : options.longs === Number ? new $util.LongBits(message.leafIndex.low >>> 0, message.leafIndex.high >>> 0).toNumber(true) : message.leafIndex;
            if (message.leafCount != null && message.hasOwnProperty("leafCount"))
                if (typeof message.leafCount === "number")
                    object.leafCount = options.longs === String ? String(message.leafCount) : message.leafCount;
                else
                    object.leafCount = options.longs === String ? $util.Long.prototype.toString.call(message.leafCount) : options.longs === Number ? new $util.LongBits(message.leafCount.low >>> 0, message.leafCount.high >>> 0).toNumber(true) : message.leafCount;
            return object;
        };

        /**
         * Converts this GetInclusionProof to JSON.
         * @function toJSON
         * @memberof tdx_response.GetInclusionProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetInclusionProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetInclusionProof
         * @function getTypeUrl
         * @memberof tdx_response.GetInclusionProof
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetInclusionProof.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.GetInclusionProof";
        };

        return GetInclusionProof;
    })();

    tdx_response.GetConsistencyProof = (function() {

        /**
         * Properties of a GetConsistencyProof.
         * @memberof tdx_response
         * @interface IGetConsistencyProof
         * @property {tdx_response.Status|null} [status] GetConsistencyProof status
         * @property {string|null} [transactionId] GetConsistencyProof transactionId
         * @property {Array.<Uint8Array>|null} [proof] GetConsistencyProof proof
         * @property {Uint8Array|null} [rootHash] GetConsistencyProof rootHash
         * @property {Uint8Array|null} [signedRootHash] GetConsistencyProof signedRootHash
         * @property {Uint8Array|null} [oldRootHash] GetConsistencyProof oldRootHash
         * @property {number|Long|null} [pastLeafCount] GetConsistencyProof pastLeafCount
         * @property {number|Long|null} [currentLeafCount] GetConsistencyProof currentLeafCount
         */

        /**
         * Constructs a new GetConsistencyProof.
         * @memberof tdx_response
         * @classdesc Represents a GetConsistencyProof.
         * @implements IGetConsistencyProof
         * @constructor
         * @param {tdx_response.IGetConsistencyProof=} [properties] Properties to set
         */
        function GetConsistencyProof(properties) {
            this.proof = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetConsistencyProof status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.status = 0;

        /**
         * GetConsistencyProof transactionId.
         * @member {string} transactionId
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.transactionId = "";

        /**
         * GetConsistencyProof proof.
         * @member {Array.<Uint8Array>} proof
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.proof = $util.emptyArray;

        /**
         * GetConsistencyProof rootHash.
         * @member {Uint8Array} rootHash
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.rootHash = $util.newBuffer([]);

        /**
         * GetConsistencyProof signedRootHash.
         * @member {Uint8Array} signedRootHash
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.signedRootHash = $util.newBuffer([]);

        /**
         * GetConsistencyProof oldRootHash.
         * @member {Uint8Array} oldRootHash
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.oldRootHash = $util.newBuffer([]);

        /**
         * GetConsistencyProof pastLeafCount.
         * @member {number|Long} pastLeafCount
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.pastLeafCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetConsistencyProof currentLeafCount.
         * @member {number|Long} currentLeafCount
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         */
        GetConsistencyProof.prototype.currentLeafCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetConsistencyProof instance using the specified properties.
         * @function create
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {tdx_response.IGetConsistencyProof=} [properties] Properties to set
         * @returns {tdx_response.GetConsistencyProof} GetConsistencyProof instance
         */
        GetConsistencyProof.create = function create(properties) {
            return new GetConsistencyProof(properties);
        };

        /**
         * Encodes the specified GetConsistencyProof message. Does not implicitly {@link tdx_response.GetConsistencyProof.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {tdx_response.IGetConsistencyProof} message GetConsistencyProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetConsistencyProof.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.transactionId);
            if (message.proof != null && message.proof.length)
                for (let i = 0; i < message.proof.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.proof[i]);
            if (message.rootHash != null && Object.hasOwnProperty.call(message, "rootHash"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.rootHash);
            if (message.signedRootHash != null && Object.hasOwnProperty.call(message, "signedRootHash"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.signedRootHash);
            if (message.oldRootHash != null && Object.hasOwnProperty.call(message, "oldRootHash"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.oldRootHash);
            if (message.pastLeafCount != null && Object.hasOwnProperty.call(message, "pastLeafCount"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.pastLeafCount);
            if (message.currentLeafCount != null && Object.hasOwnProperty.call(message, "currentLeafCount"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.currentLeafCount);
            return writer;
        };

        /**
         * Encodes the specified GetConsistencyProof message, length delimited. Does not implicitly {@link tdx_response.GetConsistencyProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {tdx_response.IGetConsistencyProof} message GetConsistencyProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetConsistencyProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetConsistencyProof message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.GetConsistencyProof} GetConsistencyProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetConsistencyProof.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.GetConsistencyProof();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.transactionId = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.proof && message.proof.length))
                            message.proof = [];
                        message.proof.push(reader.bytes());
                        break;
                    }
                case 4: {
                        message.rootHash = reader.bytes();
                        break;
                    }
                case 5: {
                        message.signedRootHash = reader.bytes();
                        break;
                    }
                case 6: {
                        message.oldRootHash = reader.bytes();
                        break;
                    }
                case 7: {
                        message.pastLeafCount = reader.uint64();
                        break;
                    }
                case 8: {
                        message.currentLeafCount = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetConsistencyProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.GetConsistencyProof} GetConsistencyProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetConsistencyProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetConsistencyProof message.
         * @function verify
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetConsistencyProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                if (!$util.isString(message.transactionId))
                    return "transactionId: string expected";
            if (message.proof != null && message.hasOwnProperty("proof")) {
                if (!Array.isArray(message.proof))
                    return "proof: array expected";
                for (let i = 0; i < message.proof.length; ++i)
                    if (!(message.proof[i] && typeof message.proof[i].length === "number" || $util.isString(message.proof[i])))
                        return "proof: buffer[] expected";
            }
            if (message.rootHash != null && message.hasOwnProperty("rootHash"))
                if (!(message.rootHash && typeof message.rootHash.length === "number" || $util.isString(message.rootHash)))
                    return "rootHash: buffer expected";
            if (message.signedRootHash != null && message.hasOwnProperty("signedRootHash"))
                if (!(message.signedRootHash && typeof message.signedRootHash.length === "number" || $util.isString(message.signedRootHash)))
                    return "signedRootHash: buffer expected";
            if (message.oldRootHash != null && message.hasOwnProperty("oldRootHash"))
                if (!(message.oldRootHash && typeof message.oldRootHash.length === "number" || $util.isString(message.oldRootHash)))
                    return "oldRootHash: buffer expected";
            if (message.pastLeafCount != null && message.hasOwnProperty("pastLeafCount"))
                if (!$util.isInteger(message.pastLeafCount) && !(message.pastLeafCount && $util.isInteger(message.pastLeafCount.low) && $util.isInteger(message.pastLeafCount.high)))
                    return "pastLeafCount: integer|Long expected";
            if (message.currentLeafCount != null && message.hasOwnProperty("currentLeafCount"))
                if (!$util.isInteger(message.currentLeafCount) && !(message.currentLeafCount && $util.isInteger(message.currentLeafCount.low) && $util.isInteger(message.currentLeafCount.high)))
                    return "currentLeafCount: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetConsistencyProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.GetConsistencyProof} GetConsistencyProof
         */
        GetConsistencyProof.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.GetConsistencyProof)
                return object;
            let message = new $root.tdx_response.GetConsistencyProof();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.transactionId != null)
                message.transactionId = String(object.transactionId);
            if (object.proof) {
                if (!Array.isArray(object.proof))
                    throw TypeError(".tdx_response.GetConsistencyProof.proof: array expected");
                message.proof = [];
                for (let i = 0; i < object.proof.length; ++i)
                    if (typeof object.proof[i] === "string")
                        $util.base64.decode(object.proof[i], message.proof[i] = $util.newBuffer($util.base64.length(object.proof[i])), 0);
                    else if (object.proof[i].length >= 0)
                        message.proof[i] = object.proof[i];
            }
            if (object.rootHash != null)
                if (typeof object.rootHash === "string")
                    $util.base64.decode(object.rootHash, message.rootHash = $util.newBuffer($util.base64.length(object.rootHash)), 0);
                else if (object.rootHash.length >= 0)
                    message.rootHash = object.rootHash;
            if (object.signedRootHash != null)
                if (typeof object.signedRootHash === "string")
                    $util.base64.decode(object.signedRootHash, message.signedRootHash = $util.newBuffer($util.base64.length(object.signedRootHash)), 0);
                else if (object.signedRootHash.length >= 0)
                    message.signedRootHash = object.signedRootHash;
            if (object.oldRootHash != null)
                if (typeof object.oldRootHash === "string")
                    $util.base64.decode(object.oldRootHash, message.oldRootHash = $util.newBuffer($util.base64.length(object.oldRootHash)), 0);
                else if (object.oldRootHash.length >= 0)
                    message.oldRootHash = object.oldRootHash;
            if (object.pastLeafCount != null)
                if ($util.Long)
                    (message.pastLeafCount = $util.Long.fromValue(object.pastLeafCount)).unsigned = true;
                else if (typeof object.pastLeafCount === "string")
                    message.pastLeafCount = parseInt(object.pastLeafCount, 10);
                else if (typeof object.pastLeafCount === "number")
                    message.pastLeafCount = object.pastLeafCount;
                else if (typeof object.pastLeafCount === "object")
                    message.pastLeafCount = new $util.LongBits(object.pastLeafCount.low >>> 0, object.pastLeafCount.high >>> 0).toNumber(true);
            if (object.currentLeafCount != null)
                if ($util.Long)
                    (message.currentLeafCount = $util.Long.fromValue(object.currentLeafCount)).unsigned = true;
                else if (typeof object.currentLeafCount === "string")
                    message.currentLeafCount = parseInt(object.currentLeafCount, 10);
                else if (typeof object.currentLeafCount === "number")
                    message.currentLeafCount = object.currentLeafCount;
                else if (typeof object.currentLeafCount === "object")
                    message.currentLeafCount = new $util.LongBits(object.currentLeafCount.low >>> 0, object.currentLeafCount.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetConsistencyProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {tdx_response.GetConsistencyProof} message GetConsistencyProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetConsistencyProof.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.proof = [];
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.transactionId = "";
                if (options.bytes === String)
                    object.rootHash = "";
                else {
                    object.rootHash = [];
                    if (options.bytes !== Array)
                        object.rootHash = $util.newBuffer(object.rootHash);
                }
                if (options.bytes === String)
                    object.signedRootHash = "";
                else {
                    object.signedRootHash = [];
                    if (options.bytes !== Array)
                        object.signedRootHash = $util.newBuffer(object.signedRootHash);
                }
                if (options.bytes === String)
                    object.oldRootHash = "";
                else {
                    object.oldRootHash = [];
                    if (options.bytes !== Array)
                        object.oldRootHash = $util.newBuffer(object.oldRootHash);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.pastLeafCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.pastLeafCount = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.currentLeafCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.currentLeafCount = options.longs === String ? "0" : 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                object.transactionId = message.transactionId;
            if (message.proof && message.proof.length) {
                object.proof = [];
                for (let j = 0; j < message.proof.length; ++j)
                    object.proof[j] = options.bytes === String ? $util.base64.encode(message.proof[j], 0, message.proof[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.proof[j]) : message.proof[j];
            }
            if (message.rootHash != null && message.hasOwnProperty("rootHash"))
                object.rootHash = options.bytes === String ? $util.base64.encode(message.rootHash, 0, message.rootHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.rootHash) : message.rootHash;
            if (message.signedRootHash != null && message.hasOwnProperty("signedRootHash"))
                object.signedRootHash = options.bytes === String ? $util.base64.encode(message.signedRootHash, 0, message.signedRootHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.signedRootHash) : message.signedRootHash;
            if (message.oldRootHash != null && message.hasOwnProperty("oldRootHash"))
                object.oldRootHash = options.bytes === String ? $util.base64.encode(message.oldRootHash, 0, message.oldRootHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.oldRootHash) : message.oldRootHash;
            if (message.pastLeafCount != null && message.hasOwnProperty("pastLeafCount"))
                if (typeof message.pastLeafCount === "number")
                    object.pastLeafCount = options.longs === String ? String(message.pastLeafCount) : message.pastLeafCount;
                else
                    object.pastLeafCount = options.longs === String ? $util.Long.prototype.toString.call(message.pastLeafCount) : options.longs === Number ? new $util.LongBits(message.pastLeafCount.low >>> 0, message.pastLeafCount.high >>> 0).toNumber(true) : message.pastLeafCount;
            if (message.currentLeafCount != null && message.hasOwnProperty("currentLeafCount"))
                if (typeof message.currentLeafCount === "number")
                    object.currentLeafCount = options.longs === String ? String(message.currentLeafCount) : message.currentLeafCount;
                else
                    object.currentLeafCount = options.longs === String ? $util.Long.prototype.toString.call(message.currentLeafCount) : options.longs === Number ? new $util.LongBits(message.currentLeafCount.low >>> 0, message.currentLeafCount.high >>> 0).toNumber(true) : message.currentLeafCount;
            return object;
        };

        /**
         * Converts this GetConsistencyProof to JSON.
         * @function toJSON
         * @memberof tdx_response.GetConsistencyProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetConsistencyProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetConsistencyProof
         * @function getTypeUrl
         * @memberof tdx_response.GetConsistencyProof
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetConsistencyProof.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.GetConsistencyProof";
        };

        return GetConsistencyProof;
    })();

    tdx_response.GetChunkFromYSentinel = (function() {

        /**
         * Properties of a GetChunkFromYSentinel.
         * @memberof tdx_response
         * @interface IGetChunkFromYSentinel
         * @property {tdx_response.Status|null} [status] GetChunkFromYSentinel status
         * @property {Uint8Array|null} [data] GetChunkFromYSentinel data
         */

        /**
         * Constructs a new GetChunkFromYSentinel.
         * @memberof tdx_response
         * @classdesc Represents a GetChunkFromYSentinel.
         * @implements IGetChunkFromYSentinel
         * @constructor
         * @param {tdx_response.IGetChunkFromYSentinel=} [properties] Properties to set
         */
        function GetChunkFromYSentinel(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetChunkFromYSentinel status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.GetChunkFromYSentinel
         * @instance
         */
        GetChunkFromYSentinel.prototype.status = 0;

        /**
         * GetChunkFromYSentinel data.
         * @member {Uint8Array} data
         * @memberof tdx_response.GetChunkFromYSentinel
         * @instance
         */
        GetChunkFromYSentinel.prototype.data = $util.newBuffer([]);

        /**
         * Creates a new GetChunkFromYSentinel instance using the specified properties.
         * @function create
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {tdx_response.IGetChunkFromYSentinel=} [properties] Properties to set
         * @returns {tdx_response.GetChunkFromYSentinel} GetChunkFromYSentinel instance
         */
        GetChunkFromYSentinel.create = function create(properties) {
            return new GetChunkFromYSentinel(properties);
        };

        /**
         * Encodes the specified GetChunkFromYSentinel message. Does not implicitly {@link tdx_response.GetChunkFromYSentinel.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {tdx_response.IGetChunkFromYSentinel} message GetChunkFromYSentinel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunkFromYSentinel.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified GetChunkFromYSentinel message, length delimited. Does not implicitly {@link tdx_response.GetChunkFromYSentinel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {tdx_response.IGetChunkFromYSentinel} message GetChunkFromYSentinel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunkFromYSentinel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetChunkFromYSentinel message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.GetChunkFromYSentinel} GetChunkFromYSentinel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunkFromYSentinel.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.GetChunkFromYSentinel();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetChunkFromYSentinel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.GetChunkFromYSentinel} GetChunkFromYSentinel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunkFromYSentinel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetChunkFromYSentinel message.
         * @function verify
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetChunkFromYSentinel.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            return null;
        };

        /**
         * Creates a GetChunkFromYSentinel message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.GetChunkFromYSentinel} GetChunkFromYSentinel
         */
        GetChunkFromYSentinel.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.GetChunkFromYSentinel)
                return object;
            let message = new $root.tdx_response.GetChunkFromYSentinel();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a GetChunkFromYSentinel message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {tdx_response.GetChunkFromYSentinel} message GetChunkFromYSentinel
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetChunkFromYSentinel.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this GetChunkFromYSentinel to JSON.
         * @function toJSON
         * @memberof tdx_response.GetChunkFromYSentinel
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetChunkFromYSentinel.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetChunkFromYSentinel
         * @function getTypeUrl
         * @memberof tdx_response.GetChunkFromYSentinel
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetChunkFromYSentinel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.GetChunkFromYSentinel";
        };

        return GetChunkFromYSentinel;
    })();

    tdx_response.StartConversion = (function() {

        /**
         * Properties of a StartConversion.
         * @memberof tdx_response
         * @interface IStartConversion
         * @property {tdx_response.Status|null} [status] StartConversion status
         * @property {number|Long|null} [size] StartConversion size
         * @property {string|null} [fileName] StartConversion fileName
         */

        /**
         * Constructs a new StartConversion.
         * @memberof tdx_response
         * @classdesc Represents a StartConversion.
         * @implements IStartConversion
         * @constructor
         * @param {tdx_response.IStartConversion=} [properties] Properties to set
         */
        function StartConversion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StartConversion status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.StartConversion
         * @instance
         */
        StartConversion.prototype.status = 0;

        /**
         * StartConversion size.
         * @member {number|Long} size
         * @memberof tdx_response.StartConversion
         * @instance
         */
        StartConversion.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StartConversion fileName.
         * @member {string} fileName
         * @memberof tdx_response.StartConversion
         * @instance
         */
        StartConversion.prototype.fileName = "";

        /**
         * Creates a new StartConversion instance using the specified properties.
         * @function create
         * @memberof tdx_response.StartConversion
         * @static
         * @param {tdx_response.IStartConversion=} [properties] Properties to set
         * @returns {tdx_response.StartConversion} StartConversion instance
         */
        StartConversion.create = function create(properties) {
            return new StartConversion(properties);
        };

        /**
         * Encodes the specified StartConversion message. Does not implicitly {@link tdx_response.StartConversion.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.StartConversion
         * @static
         * @param {tdx_response.IStartConversion} message StartConversion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartConversion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.size);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileName);
            return writer;
        };

        /**
         * Encodes the specified StartConversion message, length delimited. Does not implicitly {@link tdx_response.StartConversion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.StartConversion
         * @static
         * @param {tdx_response.IStartConversion} message StartConversion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartConversion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartConversion message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.StartConversion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.StartConversion} StartConversion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartConversion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.StartConversion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.size = reader.uint64();
                        break;
                    }
                case 3: {
                        message.fileName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartConversion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.StartConversion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.StartConversion} StartConversion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartConversion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartConversion message.
         * @function verify
         * @memberof tdx_response.StartConversion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartConversion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            return null;
        };

        /**
         * Creates a StartConversion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.StartConversion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.StartConversion} StartConversion
         */
        StartConversion.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.StartConversion)
                return object;
            let message = new $root.tdx_response.StartConversion();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            return message;
        };

        /**
         * Creates a plain object from a StartConversion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.StartConversion
         * @static
         * @param {tdx_response.StartConversion} message StartConversion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartConversion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                object.fileName = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            return object;
        };

        /**
         * Converts this StartConversion to JSON.
         * @function toJSON
         * @memberof tdx_response.StartConversion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartConversion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StartConversion
         * @function getTypeUrl
         * @memberof tdx_response.StartConversion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StartConversion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.StartConversion";
        };

        return StartConversion;
    })();

    tdx_response.TopMovers = (function() {

        /**
         * Properties of a TopMovers.
         * @memberof tdx_response
         * @interface ITopMovers
         * @property {tdx_response.Status|null} [status] TopMovers status
         * @property {Array.<tdx_response.TopMovers.IMoverItem>|null} [moverItems] TopMovers moverItems
         */

        /**
         * Constructs a new TopMovers.
         * @memberof tdx_response
         * @classdesc Represents a TopMovers.
         * @implements ITopMovers
         * @constructor
         * @param {tdx_response.ITopMovers=} [properties] Properties to set
         */
        function TopMovers(properties) {
            this.moverItems = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TopMovers status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.TopMovers
         * @instance
         */
        TopMovers.prototype.status = 0;

        /**
         * TopMovers moverItems.
         * @member {Array.<tdx_response.TopMovers.IMoverItem>} moverItems
         * @memberof tdx_response.TopMovers
         * @instance
         */
        TopMovers.prototype.moverItems = $util.emptyArray;

        /**
         * Creates a new TopMovers instance using the specified properties.
         * @function create
         * @memberof tdx_response.TopMovers
         * @static
         * @param {tdx_response.ITopMovers=} [properties] Properties to set
         * @returns {tdx_response.TopMovers} TopMovers instance
         */
        TopMovers.create = function create(properties) {
            return new TopMovers(properties);
        };

        /**
         * Encodes the specified TopMovers message. Does not implicitly {@link tdx_response.TopMovers.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.TopMovers
         * @static
         * @param {tdx_response.ITopMovers} message TopMovers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopMovers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.moverItems != null && message.moverItems.length)
                for (let i = 0; i < message.moverItems.length; ++i)
                    $root.tdx_response.TopMovers.MoverItem.encode(message.moverItems[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TopMovers message, length delimited. Does not implicitly {@link tdx_response.TopMovers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.TopMovers
         * @static
         * @param {tdx_response.ITopMovers} message TopMovers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TopMovers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TopMovers message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.TopMovers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.TopMovers} TopMovers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopMovers.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.TopMovers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.moverItems && message.moverItems.length))
                            message.moverItems = [];
                        message.moverItems.push($root.tdx_response.TopMovers.MoverItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TopMovers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.TopMovers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.TopMovers} TopMovers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TopMovers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TopMovers message.
         * @function verify
         * @memberof tdx_response.TopMovers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TopMovers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.moverItems != null && message.hasOwnProperty("moverItems")) {
                if (!Array.isArray(message.moverItems))
                    return "moverItems: array expected";
                for (let i = 0; i < message.moverItems.length; ++i) {
                    let error = $root.tdx_response.TopMovers.MoverItem.verify(message.moverItems[i]);
                    if (error)
                        return "moverItems." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TopMovers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.TopMovers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.TopMovers} TopMovers
         */
        TopMovers.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.TopMovers)
                return object;
            let message = new $root.tdx_response.TopMovers();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.moverItems) {
                if (!Array.isArray(object.moverItems))
                    throw TypeError(".tdx_response.TopMovers.moverItems: array expected");
                message.moverItems = [];
                for (let i = 0; i < object.moverItems.length; ++i) {
                    if (typeof object.moverItems[i] !== "object")
                        throw TypeError(".tdx_response.TopMovers.moverItems: object expected");
                    message.moverItems[i] = $root.tdx_response.TopMovers.MoverItem.fromObject(object.moverItems[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TopMovers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.TopMovers
         * @static
         * @param {tdx_response.TopMovers} message TopMovers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TopMovers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.moverItems = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.moverItems && message.moverItems.length) {
                object.moverItems = [];
                for (let j = 0; j < message.moverItems.length; ++j)
                    object.moverItems[j] = $root.tdx_response.TopMovers.MoverItem.toObject(message.moverItems[j], options);
            }
            return object;
        };

        /**
         * Converts this TopMovers to JSON.
         * @function toJSON
         * @memberof tdx_response.TopMovers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TopMovers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TopMovers
         * @function getTypeUrl
         * @memberof tdx_response.TopMovers
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TopMovers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.TopMovers";
        };

        TopMovers.MoverItem = (function() {

            /**
             * Properties of a MoverItem.
             * @memberof tdx_response.TopMovers
             * @interface IMoverItem
             * @property {string|null} [operation] MoverItem operation
             * @property {Array.<string>|null} [user] MoverItem user
             * @property {Array.<number|Long>|null} [count] MoverItem count
             */

            /**
             * Constructs a new MoverItem.
             * @memberof tdx_response.TopMovers
             * @classdesc Represents a MoverItem.
             * @implements IMoverItem
             * @constructor
             * @param {tdx_response.TopMovers.IMoverItem=} [properties] Properties to set
             */
            function MoverItem(properties) {
                this.user = [];
                this.count = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MoverItem operation.
             * @member {string} operation
             * @memberof tdx_response.TopMovers.MoverItem
             * @instance
             */
            MoverItem.prototype.operation = "";

            /**
             * MoverItem user.
             * @member {Array.<string>} user
             * @memberof tdx_response.TopMovers.MoverItem
             * @instance
             */
            MoverItem.prototype.user = $util.emptyArray;

            /**
             * MoverItem count.
             * @member {Array.<number|Long>} count
             * @memberof tdx_response.TopMovers.MoverItem
             * @instance
             */
            MoverItem.prototype.count = $util.emptyArray;

            /**
             * Creates a new MoverItem instance using the specified properties.
             * @function create
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {tdx_response.TopMovers.IMoverItem=} [properties] Properties to set
             * @returns {tdx_response.TopMovers.MoverItem} MoverItem instance
             */
            MoverItem.create = function create(properties) {
                return new MoverItem(properties);
            };

            /**
             * Encodes the specified MoverItem message. Does not implicitly {@link tdx_response.TopMovers.MoverItem.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {tdx_response.TopMovers.IMoverItem} message MoverItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MoverItem.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.operation);
                if (message.user != null && message.user.length)
                    for (let i = 0; i < message.user.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.user[i]);
                if (message.count != null && message.count.length) {
                    writer.uint32(/* id 3, wireType 2 =*/26).fork();
                    for (let i = 0; i < message.count.length; ++i)
                        writer.int64(message.count[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified MoverItem message, length delimited. Does not implicitly {@link tdx_response.TopMovers.MoverItem.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {tdx_response.TopMovers.IMoverItem} message MoverItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MoverItem.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MoverItem message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.TopMovers.MoverItem} MoverItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MoverItem.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.TopMovers.MoverItem();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.operation = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.user && message.user.length))
                                message.user = [];
                            message.user.push(reader.string());
                            break;
                        }
                    case 3: {
                            if (!(message.count && message.count.length))
                                message.count = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.count.push(reader.int64());
                            } else
                                message.count.push(reader.int64());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MoverItem message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.TopMovers.MoverItem} MoverItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MoverItem.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MoverItem message.
             * @function verify
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MoverItem.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.user != null && message.hasOwnProperty("user")) {
                    if (!Array.isArray(message.user))
                        return "user: array expected";
                    for (let i = 0; i < message.user.length; ++i)
                        if (!$util.isString(message.user[i]))
                            return "user: string[] expected";
                }
                if (message.count != null && message.hasOwnProperty("count")) {
                    if (!Array.isArray(message.count))
                        return "count: array expected";
                    for (let i = 0; i < message.count.length; ++i)
                        if (!$util.isInteger(message.count[i]) && !(message.count[i] && $util.isInteger(message.count[i].low) && $util.isInteger(message.count[i].high)))
                            return "count: integer|Long[] expected";
                }
                return null;
            };

            /**
             * Creates a MoverItem message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.TopMovers.MoverItem} MoverItem
             */
            MoverItem.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.TopMovers.MoverItem)
                    return object;
                let message = new $root.tdx_response.TopMovers.MoverItem();
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.user) {
                    if (!Array.isArray(object.user))
                        throw TypeError(".tdx_response.TopMovers.MoverItem.user: array expected");
                    message.user = [];
                    for (let i = 0; i < object.user.length; ++i)
                        message.user[i] = String(object.user[i]);
                }
                if (object.count) {
                    if (!Array.isArray(object.count))
                        throw TypeError(".tdx_response.TopMovers.MoverItem.count: array expected");
                    message.count = [];
                    for (let i = 0; i < object.count.length; ++i)
                        if ($util.Long)
                            (message.count[i] = $util.Long.fromValue(object.count[i])).unsigned = false;
                        else if (typeof object.count[i] === "string")
                            message.count[i] = parseInt(object.count[i], 10);
                        else if (typeof object.count[i] === "number")
                            message.count[i] = object.count[i];
                        else if (typeof object.count[i] === "object")
                            message.count[i] = new $util.LongBits(object.count[i].low >>> 0, object.count[i].high >>> 0).toNumber();
                }
                return message;
            };

            /**
             * Creates a plain object from a MoverItem message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {tdx_response.TopMovers.MoverItem} message MoverItem
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MoverItem.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.user = [];
                    object.count = [];
                }
                if (options.defaults)
                    object.operation = "";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.user && message.user.length) {
                    object.user = [];
                    for (let j = 0; j < message.user.length; ++j)
                        object.user[j] = message.user[j];
                }
                if (message.count && message.count.length) {
                    object.count = [];
                    for (let j = 0; j < message.count.length; ++j)
                        if (typeof message.count[j] === "number")
                            object.count[j] = options.longs === String ? String(message.count[j]) : message.count[j];
                        else
                            object.count[j] = options.longs === String ? $util.Long.prototype.toString.call(message.count[j]) : options.longs === Number ? new $util.LongBits(message.count[j].low >>> 0, message.count[j].high >>> 0).toNumber() : message.count[j];
                }
                return object;
            };

            /**
             * Converts this MoverItem to JSON.
             * @function toJSON
             * @memberof tdx_response.TopMovers.MoverItem
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MoverItem.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for MoverItem
             * @function getTypeUrl
             * @memberof tdx_response.TopMovers.MoverItem
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            MoverItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.TopMovers.MoverItem";
            };

            return MoverItem;
        })();

        return TopMovers;
    })();

    /**
     * FileStatus enum.
     * @name tdx_response.FileStatus
     * @enum {number}
     * @property {number} FILE_STATUS_UNKNOWN=0 FILE_STATUS_UNKNOWN value
     * @property {number} FILE_STATUS_ALIVE=1 FILE_STATUS_ALIVE value
     * @property {number} FILE_STATUS_DELETED=2 FILE_STATUS_DELETED value
     * @property {number} FILE_STATUS_ARCHIVED=3 FILE_STATUS_ARCHIVED value
     * @property {number} FILE_STATUS_QUARANTINED=4 FILE_STATUS_QUARANTINED value
     */
    tdx_response.FileStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FILE_STATUS_UNKNOWN"] = 0;
        values[valuesById[1] = "FILE_STATUS_ALIVE"] = 1;
        values[valuesById[2] = "FILE_STATUS_DELETED"] = 2;
        values[valuesById[3] = "FILE_STATUS_ARCHIVED"] = 3;
        values[valuesById[4] = "FILE_STATUS_QUARANTINED"] = 4;
        return values;
    })();

    /**
     * OperationResult enum.
     * @name tdx_response.OperationResult
     * @enum {number}
     * @property {number} OPERATION_RESULT_UNKNOWN=0 OPERATION_RESULT_UNKNOWN value
     * @property {number} OPERATION_ALLOWED=1 OPERATION_ALLOWED value
     * @property {number} OPERATION_DENIED=2 OPERATION_DENIED value
     */
    tdx_response.OperationResult = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OPERATION_RESULT_UNKNOWN"] = 0;
        values[valuesById[1] = "OPERATION_ALLOWED"] = 1;
        values[valuesById[2] = "OPERATION_DENIED"] = 2;
        return values;
    })();

    /**
     * VersionKind enum.
     * @name tdx_response.VersionKind
     * @enum {number}
     * @property {number} VERSION_KIND_UNKNOWN=0 VERSION_KIND_UNKNOWN value
     * @property {number} VERSION_CREATED=1 VERSION_CREATED value
     * @property {number} VERSION_UPDATED=2 VERSION_UPDATED value
     * @property {number} VERSION_RESTORED=3 VERSION_RESTORED value
     * @property {number} VERSION_REMOVED=4 VERSION_REMOVED value
     */
    tdx_response.VersionKind = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "VERSION_KIND_UNKNOWN"] = 0;
        values[valuesById[1] = "VERSION_CREATED"] = 1;
        values[valuesById[2] = "VERSION_UPDATED"] = 2;
        values[valuesById[3] = "VERSION_RESTORED"] = 3;
        values[valuesById[4] = "VERSION_REMOVED"] = 4;
        return values;
    })();

    /**
     * Permission enum.
     * @name tdx_response.Permission
     * @enum {number}
     * @property {number} PERMISSION_UNKNOWN=0 PERMISSION_UNKNOWN value
     * @property {number} PERMISSION_READ=1 PERMISSION_READ value
     * @property {number} PERMISSION_WRITE=2 PERMISSION_WRITE value
     * @property {number} PERMISSION_EDIT=3 PERMISSION_EDIT value
     */
    tdx_response.Permission = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PERMISSION_UNKNOWN"] = 0;
        values[valuesById[1] = "PERMISSION_READ"] = 1;
        values[valuesById[2] = "PERMISSION_WRITE"] = 2;
        values[valuesById[3] = "PERMISSION_EDIT"] = 3;
        return values;
    })();

    /**
     * ShareType enum.
     * @name tdx_response.ShareType
     * @enum {number}
     * @property {number} SHARE_TYPE_UNKNOWN=0 SHARE_TYPE_UNKNOWN value
     * @property {number} SHARE_TYPE_USER=1 SHARE_TYPE_USER value
     * @property {number} SHARE_TYPE_TEAM=2 SHARE_TYPE_TEAM value
     * @property {number} SHARE_TYPE_EXTERNAL=3 SHARE_TYPE_EXTERNAL value
     */
    tdx_response.ShareType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SHARE_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "SHARE_TYPE_USER"] = 1;
        values[valuesById[2] = "SHARE_TYPE_TEAM"] = 2;
        values[valuesById[3] = "SHARE_TYPE_EXTERNAL"] = 3;
        return values;
    })();

    /**
     * TrustTier enum.
     * @name tdx_response.TrustTier
     * @enum {number}
     * @property {number} TRUST_TIER_UNKNOWN=0 TRUST_TIER_UNKNOWN value
     * @property {number} TRUST_TIER_TRUSTED=1 TRUST_TIER_TRUSTED value
     * @property {number} TRUST_TIER_FOREIGN=2 TRUST_TIER_FOREIGN value
     * @property {number} TRUST_TIER_BLOCKED=3 TRUST_TIER_BLOCKED value
     */
    tdx_response.TrustTier = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TRUST_TIER_UNKNOWN"] = 0;
        values[valuesById[1] = "TRUST_TIER_TRUSTED"] = 1;
        values[valuesById[2] = "TRUST_TIER_FOREIGN"] = 2;
        values[valuesById[3] = "TRUST_TIER_BLOCKED"] = 3;
        return values;
    })();

    tdx_response.FileDetails = (function() {

        /**
         * Properties of a FileDetails.
         * @memberof tdx_response
         * @interface IFileDetails
         * @property {tdx_response.Status|null} [status] FileDetails status
         * @property {tdx_response.FileDetails.IFileDetail|null} [details] FileDetails details
         */

        /**
         * Constructs a new FileDetails.
         * @memberof tdx_response
         * @classdesc Represents a FileDetails.
         * @implements IFileDetails
         * @constructor
         * @param {tdx_response.IFileDetails=} [properties] Properties to set
         */
        function FileDetails(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileDetails status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.FileDetails
         * @instance
         */
        FileDetails.prototype.status = 0;

        /**
         * FileDetails details.
         * @member {tdx_response.FileDetails.IFileDetail|null|undefined} details
         * @memberof tdx_response.FileDetails
         * @instance
         */
        FileDetails.prototype.details = null;

        /**
         * Creates a new FileDetails instance using the specified properties.
         * @function create
         * @memberof tdx_response.FileDetails
         * @static
         * @param {tdx_response.IFileDetails=} [properties] Properties to set
         * @returns {tdx_response.FileDetails} FileDetails instance
         */
        FileDetails.create = function create(properties) {
            return new FileDetails(properties);
        };

        /**
         * Encodes the specified FileDetails message. Does not implicitly {@link tdx_response.FileDetails.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.FileDetails
         * @static
         * @param {tdx_response.IFileDetails} message FileDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                $root.tdx_response.FileDetails.FileDetail.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified FileDetails message, length delimited. Does not implicitly {@link tdx_response.FileDetails.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.FileDetails
         * @static
         * @param {tdx_response.IFileDetails} message FileDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileDetails message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.FileDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.FileDetails} FileDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDetails.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.FileDetails();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.details = $root.tdx_response.FileDetails.FileDetail.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileDetails message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.FileDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.FileDetails} FileDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileDetails message.
         * @function verify
         * @memberof tdx_response.FileDetails
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.details != null && message.hasOwnProperty("details")) {
                let error = $root.tdx_response.FileDetails.FileDetail.verify(message.details);
                if (error)
                    return "details." + error;
            }
            return null;
        };

        /**
         * Creates a FileDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.FileDetails
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.FileDetails} FileDetails
         */
        FileDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.FileDetails)
                return object;
            let message = new $root.tdx_response.FileDetails();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.details != null) {
                if (typeof object.details !== "object")
                    throw TypeError(".tdx_response.FileDetails.details: object expected");
                message.details = $root.tdx_response.FileDetails.FileDetail.fromObject(object.details);
            }
            return message;
        };

        /**
         * Creates a plain object from a FileDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.FileDetails
         * @static
         * @param {tdx_response.FileDetails} message FileDetails
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.details = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.details != null && message.hasOwnProperty("details"))
                object.details = $root.tdx_response.FileDetails.FileDetail.toObject(message.details, options);
            return object;
        };

        /**
         * Converts this FileDetails to JSON.
         * @function toJSON
         * @memberof tdx_response.FileDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileDetails
         * @function getTypeUrl
         * @memberof tdx_response.FileDetails
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.FileDetails";
        };

        FileDetails.FileDetail = (function() {

            /**
             * Properties of a FileDetail.
             * @memberof tdx_response.FileDetails
             * @interface IFileDetail
             * @property {string|null} [name] FileDetail name
             * @property {string|null} [path] FileDetail path
             * @property {string|null} [type] FileDetail type
             * @property {number|Long|null} [size] FileDetail size
             * @property {number|null} [versionCount] FileDetail versionCount
             * @property {number|Long|null} [updatedAt] FileDetail updatedAt
             * @property {Array.<string>|null} [tags] FileDetail tags
             * @property {tdx_response.FileStatus|null} [status] FileDetail status
             */

            /**
             * Constructs a new FileDetail.
             * @memberof tdx_response.FileDetails
             * @classdesc Represents a FileDetail.
             * @implements IFileDetail
             * @constructor
             * @param {tdx_response.FileDetails.IFileDetail=} [properties] Properties to set
             */
            function FileDetail(properties) {
                this.tags = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileDetail name.
             * @member {string} name
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.name = "";

            /**
             * FileDetail path.
             * @member {string} path
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.path = "";

            /**
             * FileDetail type.
             * @member {string} type
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.type = "";

            /**
             * FileDetail size.
             * @member {number|Long} size
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * FileDetail versionCount.
             * @member {number} versionCount
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.versionCount = 0;

            /**
             * FileDetail updatedAt.
             * @member {number|Long} updatedAt
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * FileDetail tags.
             * @member {Array.<string>} tags
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.tags = $util.emptyArray;

            /**
             * FileDetail status.
             * @member {tdx_response.FileStatus} status
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             */
            FileDetail.prototype.status = 0;

            /**
             * Creates a new FileDetail instance using the specified properties.
             * @function create
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {tdx_response.FileDetails.IFileDetail=} [properties] Properties to set
             * @returns {tdx_response.FileDetails.FileDetail} FileDetail instance
             */
            FileDetail.create = function create(properties) {
                return new FileDetail(properties);
            };

            /**
             * Encodes the specified FileDetail message. Does not implicitly {@link tdx_response.FileDetails.FileDetail.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {tdx_response.FileDetails.IFileDetail} message FileDetail message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDetail.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.size);
                if (message.versionCount != null && Object.hasOwnProperty.call(message, "versionCount"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.versionCount);
                if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.updatedAt);
                if (message.tags != null && message.tags.length)
                    for (let i = 0; i < message.tags.length; ++i)
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.tags[i]);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
                return writer;
            };

            /**
             * Encodes the specified FileDetail message, length delimited. Does not implicitly {@link tdx_response.FileDetails.FileDetail.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {tdx_response.FileDetails.IFileDetail} message FileDetail message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDetail.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileDetail message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.FileDetails.FileDetail} FileDetail
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDetail.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.FileDetails.FileDetail();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.name = reader.string();
                            break;
                        }
                    case 2: {
                            message.path = reader.string();
                            break;
                        }
                    case 3: {
                            message.type = reader.string();
                            break;
                        }
                    case 4: {
                            message.size = reader.uint64();
                            break;
                        }
                    case 5: {
                            message.versionCount = reader.uint32();
                            break;
                        }
                    case 6: {
                            message.updatedAt = reader.uint64();
                            break;
                        }
                    case 7: {
                            if (!(message.tags && message.tags.length))
                                message.tags = [];
                            message.tags.push(reader.string());
                            break;
                        }
                    case 8: {
                            message.status = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileDetail message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.FileDetails.FileDetail} FileDetail
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDetail.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileDetail message.
             * @function verify
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileDetail.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.path != null && message.hasOwnProperty("path"))
                    if (!$util.isString(message.path))
                        return "path: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                if (message.versionCount != null && message.hasOwnProperty("versionCount"))
                    if (!$util.isInteger(message.versionCount))
                        return "versionCount: integer expected";
                if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                    if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                        return "updatedAt: integer|Long expected";
                if (message.tags != null && message.hasOwnProperty("tags")) {
                    if (!Array.isArray(message.tags))
                        return "tags: array expected";
                    for (let i = 0; i < message.tags.length; ++i)
                        if (!$util.isString(message.tags[i]))
                            return "tags: string[] expected";
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    switch (message.status) {
                    default:
                        return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                return null;
            };

            /**
             * Creates a FileDetail message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.FileDetails.FileDetail} FileDetail
             */
            FileDetail.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.FileDetails.FileDetail)
                    return object;
                let message = new $root.tdx_response.FileDetails.FileDetail();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.path != null)
                    message.path = String(object.path);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
                if (object.versionCount != null)
                    message.versionCount = object.versionCount >>> 0;
                if (object.updatedAt != null)
                    if ($util.Long)
                        (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = true;
                    else if (typeof object.updatedAt === "string")
                        message.updatedAt = parseInt(object.updatedAt, 10);
                    else if (typeof object.updatedAt === "number")
                        message.updatedAt = object.updatedAt;
                    else if (typeof object.updatedAt === "object")
                        message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber(true);
                if (object.tags) {
                    if (!Array.isArray(object.tags))
                        throw TypeError(".tdx_response.FileDetails.FileDetail.tags: array expected");
                    message.tags = [];
                    for (let i = 0; i < object.tags.length; ++i)
                        message.tags[i] = String(object.tags[i]);
                }
                switch (object.status) {
                default:
                    if (typeof object.status === "number") {
                        message.status = object.status;
                        break;
                    }
                    break;
                case "FILE_STATUS_UNKNOWN":
                case 0:
                    message.status = 0;
                    break;
                case "FILE_STATUS_ALIVE":
                case 1:
                    message.status = 1;
                    break;
                case "FILE_STATUS_DELETED":
                case 2:
                    message.status = 2;
                    break;
                case "FILE_STATUS_ARCHIVED":
                case 3:
                    message.status = 3;
                    break;
                case "FILE_STATUS_QUARANTINED":
                case 4:
                    message.status = 4;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a FileDetail message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {tdx_response.FileDetails.FileDetail} message FileDetail
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileDetail.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.tags = [];
                if (options.defaults) {
                    object.name = "";
                    object.path = "";
                    object.type = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                    object.versionCount = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.updatedAt = options.longs === String ? "0" : 0;
                    object.status = options.enums === String ? "FILE_STATUS_UNKNOWN" : 0;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.path != null && message.hasOwnProperty("path"))
                    object.path = message.path;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
                if (message.versionCount != null && message.hasOwnProperty("versionCount"))
                    object.versionCount = message.versionCount;
                if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                    if (typeof message.updatedAt === "number")
                        object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                    else
                        object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber(true) : message.updatedAt;
                if (message.tags && message.tags.length) {
                    object.tags = [];
                    for (let j = 0; j < message.tags.length; ++j)
                        object.tags[j] = message.tags[j];
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = options.enums === String ? $root.tdx_response.FileStatus[message.status] === undefined ? message.status : $root.tdx_response.FileStatus[message.status] : message.status;
                return object;
            };

            /**
             * Converts this FileDetail to JSON.
             * @function toJSON
             * @memberof tdx_response.FileDetails.FileDetail
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileDetail.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileDetail
             * @function getTypeUrl
             * @memberof tdx_response.FileDetails.FileDetail
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.FileDetails.FileDetail";
            };

            return FileDetail;
        })();

        return FileDetails;
    })();

    tdx_response.FileSummary = (function() {

        /**
         * Properties of a FileSummary.
         * @memberof tdx_response
         * @interface IFileSummary
         * @property {tdx_response.Status|null} [status] FileSummary status
         * @property {tdx_response.FileSummary.ISummary|null} [summary] FileSummary summary
         */

        /**
         * Constructs a new FileSummary.
         * @memberof tdx_response
         * @classdesc Represents a FileSummary.
         * @implements IFileSummary
         * @constructor
         * @param {tdx_response.IFileSummary=} [properties] Properties to set
         */
        function FileSummary(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileSummary status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.FileSummary
         * @instance
         */
        FileSummary.prototype.status = 0;

        /**
         * FileSummary summary.
         * @member {tdx_response.FileSummary.ISummary|null|undefined} summary
         * @memberof tdx_response.FileSummary
         * @instance
         */
        FileSummary.prototype.summary = null;

        /**
         * Creates a new FileSummary instance using the specified properties.
         * @function create
         * @memberof tdx_response.FileSummary
         * @static
         * @param {tdx_response.IFileSummary=} [properties] Properties to set
         * @returns {tdx_response.FileSummary} FileSummary instance
         */
        FileSummary.create = function create(properties) {
            return new FileSummary(properties);
        };

        /**
         * Encodes the specified FileSummary message. Does not implicitly {@link tdx_response.FileSummary.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.FileSummary
         * @static
         * @param {tdx_response.IFileSummary} message FileSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileSummary.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                $root.tdx_response.FileSummary.Summary.encode(message.summary, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified FileSummary message, length delimited. Does not implicitly {@link tdx_response.FileSummary.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.FileSummary
         * @static
         * @param {tdx_response.IFileSummary} message FileSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileSummary.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileSummary message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.FileSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.FileSummary} FileSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileSummary.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.FileSummary();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.summary = $root.tdx_response.FileSummary.Summary.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileSummary message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.FileSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.FileSummary} FileSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileSummary.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileSummary message.
         * @function verify
         * @memberof tdx_response.FileSummary
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileSummary.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.summary != null && message.hasOwnProperty("summary")) {
                let error = $root.tdx_response.FileSummary.Summary.verify(message.summary);
                if (error)
                    return "summary." + error;
            }
            return null;
        };

        /**
         * Creates a FileSummary message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.FileSummary
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.FileSummary} FileSummary
         */
        FileSummary.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.FileSummary)
                return object;
            let message = new $root.tdx_response.FileSummary();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.summary != null) {
                if (typeof object.summary !== "object")
                    throw TypeError(".tdx_response.FileSummary.summary: object expected");
                message.summary = $root.tdx_response.FileSummary.Summary.fromObject(object.summary);
            }
            return message;
        };

        /**
         * Creates a plain object from a FileSummary message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.FileSummary
         * @static
         * @param {tdx_response.FileSummary} message FileSummary
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileSummary.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.summary = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.summary != null && message.hasOwnProperty("summary"))
                object.summary = $root.tdx_response.FileSummary.Summary.toObject(message.summary, options);
            return object;
        };

        /**
         * Converts this FileSummary to JSON.
         * @function toJSON
         * @memberof tdx_response.FileSummary
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileSummary.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileSummary
         * @function getTypeUrl
         * @memberof tdx_response.FileSummary
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileSummary.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.FileSummary";
        };

        FileSummary.Summary = (function() {

            /**
             * Properties of a Summary.
             * @memberof tdx_response.FileSummary
             * @interface ISummary
             * @property {number|Long|null} [totalEvents] Summary totalEvents
             * @property {number|null} [distinctActors] Summary distinctActors
             * @property {number|null} [distinctCountries] Summary distinctCountries
             * @property {number|null} [activeShares] Summary activeShares
             * @property {number|null} [externalRecipients] Summary externalRecipients
             * @property {number|null} [forks] Summary forks
             * @property {number|null} [deniedAttempts] Summary deniedAttempts
             * @property {number|null} [pathChanges] Summary pathChanges
             */

            /**
             * Constructs a new Summary.
             * @memberof tdx_response.FileSummary
             * @classdesc Represents a Summary.
             * @implements ISummary
             * @constructor
             * @param {tdx_response.FileSummary.ISummary=} [properties] Properties to set
             */
            function Summary(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Summary totalEvents.
             * @member {number|Long} totalEvents
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.totalEvents = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Summary distinctActors.
             * @member {number} distinctActors
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.distinctActors = 0;

            /**
             * Summary distinctCountries.
             * @member {number} distinctCountries
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.distinctCountries = 0;

            /**
             * Summary activeShares.
             * @member {number} activeShares
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.activeShares = 0;

            /**
             * Summary externalRecipients.
             * @member {number} externalRecipients
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.externalRecipients = 0;

            /**
             * Summary forks.
             * @member {number} forks
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.forks = 0;

            /**
             * Summary deniedAttempts.
             * @member {number} deniedAttempts
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.deniedAttempts = 0;

            /**
             * Summary pathChanges.
             * @member {number} pathChanges
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             */
            Summary.prototype.pathChanges = 0;

            /**
             * Creates a new Summary instance using the specified properties.
             * @function create
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {tdx_response.FileSummary.ISummary=} [properties] Properties to set
             * @returns {tdx_response.FileSummary.Summary} Summary instance
             */
            Summary.create = function create(properties) {
                return new Summary(properties);
            };

            /**
             * Encodes the specified Summary message. Does not implicitly {@link tdx_response.FileSummary.Summary.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {tdx_response.FileSummary.ISummary} message Summary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Summary.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.totalEvents != null && Object.hasOwnProperty.call(message, "totalEvents"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.totalEvents);
                if (message.distinctActors != null && Object.hasOwnProperty.call(message, "distinctActors"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.distinctActors);
                if (message.distinctCountries != null && Object.hasOwnProperty.call(message, "distinctCountries"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.distinctCountries);
                if (message.activeShares != null && Object.hasOwnProperty.call(message, "activeShares"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.activeShares);
                if (message.externalRecipients != null && Object.hasOwnProperty.call(message, "externalRecipients"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.externalRecipients);
                if (message.forks != null && Object.hasOwnProperty.call(message, "forks"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.forks);
                if (message.deniedAttempts != null && Object.hasOwnProperty.call(message, "deniedAttempts"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.deniedAttempts);
                if (message.pathChanges != null && Object.hasOwnProperty.call(message, "pathChanges"))
                    writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.pathChanges);
                return writer;
            };

            /**
             * Encodes the specified Summary message, length delimited. Does not implicitly {@link tdx_response.FileSummary.Summary.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {tdx_response.FileSummary.ISummary} message Summary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Summary.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Summary message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.FileSummary.Summary} Summary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Summary.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.FileSummary.Summary();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.totalEvents = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.distinctActors = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.distinctCountries = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.activeShares = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.externalRecipients = reader.uint32();
                            break;
                        }
                    case 6: {
                            message.forks = reader.uint32();
                            break;
                        }
                    case 7: {
                            message.deniedAttempts = reader.uint32();
                            break;
                        }
                    case 8: {
                            message.pathChanges = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Summary message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.FileSummary.Summary} Summary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Summary.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Summary message.
             * @function verify
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Summary.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.totalEvents != null && message.hasOwnProperty("totalEvents"))
                    if (!$util.isInteger(message.totalEvents) && !(message.totalEvents && $util.isInteger(message.totalEvents.low) && $util.isInteger(message.totalEvents.high)))
                        return "totalEvents: integer|Long expected";
                if (message.distinctActors != null && message.hasOwnProperty("distinctActors"))
                    if (!$util.isInteger(message.distinctActors))
                        return "distinctActors: integer expected";
                if (message.distinctCountries != null && message.hasOwnProperty("distinctCountries"))
                    if (!$util.isInteger(message.distinctCountries))
                        return "distinctCountries: integer expected";
                if (message.activeShares != null && message.hasOwnProperty("activeShares"))
                    if (!$util.isInteger(message.activeShares))
                        return "activeShares: integer expected";
                if (message.externalRecipients != null && message.hasOwnProperty("externalRecipients"))
                    if (!$util.isInteger(message.externalRecipients))
                        return "externalRecipients: integer expected";
                if (message.forks != null && message.hasOwnProperty("forks"))
                    if (!$util.isInteger(message.forks))
                        return "forks: integer expected";
                if (message.deniedAttempts != null && message.hasOwnProperty("deniedAttempts"))
                    if (!$util.isInteger(message.deniedAttempts))
                        return "deniedAttempts: integer expected";
                if (message.pathChanges != null && message.hasOwnProperty("pathChanges"))
                    if (!$util.isInteger(message.pathChanges))
                        return "pathChanges: integer expected";
                return null;
            };

            /**
             * Creates a Summary message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.FileSummary.Summary} Summary
             */
            Summary.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.FileSummary.Summary)
                    return object;
                let message = new $root.tdx_response.FileSummary.Summary();
                if (object.totalEvents != null)
                    if ($util.Long)
                        (message.totalEvents = $util.Long.fromValue(object.totalEvents)).unsigned = true;
                    else if (typeof object.totalEvents === "string")
                        message.totalEvents = parseInt(object.totalEvents, 10);
                    else if (typeof object.totalEvents === "number")
                        message.totalEvents = object.totalEvents;
                    else if (typeof object.totalEvents === "object")
                        message.totalEvents = new $util.LongBits(object.totalEvents.low >>> 0, object.totalEvents.high >>> 0).toNumber(true);
                if (object.distinctActors != null)
                    message.distinctActors = object.distinctActors >>> 0;
                if (object.distinctCountries != null)
                    message.distinctCountries = object.distinctCountries >>> 0;
                if (object.activeShares != null)
                    message.activeShares = object.activeShares >>> 0;
                if (object.externalRecipients != null)
                    message.externalRecipients = object.externalRecipients >>> 0;
                if (object.forks != null)
                    message.forks = object.forks >>> 0;
                if (object.deniedAttempts != null)
                    message.deniedAttempts = object.deniedAttempts >>> 0;
                if (object.pathChanges != null)
                    message.pathChanges = object.pathChanges >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a Summary message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {tdx_response.FileSummary.Summary} message Summary
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Summary.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.totalEvents = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.totalEvents = options.longs === String ? "0" : 0;
                    object.distinctActors = 0;
                    object.distinctCountries = 0;
                    object.activeShares = 0;
                    object.externalRecipients = 0;
                    object.forks = 0;
                    object.deniedAttempts = 0;
                    object.pathChanges = 0;
                }
                if (message.totalEvents != null && message.hasOwnProperty("totalEvents"))
                    if (typeof message.totalEvents === "number")
                        object.totalEvents = options.longs === String ? String(message.totalEvents) : message.totalEvents;
                    else
                        object.totalEvents = options.longs === String ? $util.Long.prototype.toString.call(message.totalEvents) : options.longs === Number ? new $util.LongBits(message.totalEvents.low >>> 0, message.totalEvents.high >>> 0).toNumber(true) : message.totalEvents;
                if (message.distinctActors != null && message.hasOwnProperty("distinctActors"))
                    object.distinctActors = message.distinctActors;
                if (message.distinctCountries != null && message.hasOwnProperty("distinctCountries"))
                    object.distinctCountries = message.distinctCountries;
                if (message.activeShares != null && message.hasOwnProperty("activeShares"))
                    object.activeShares = message.activeShares;
                if (message.externalRecipients != null && message.hasOwnProperty("externalRecipients"))
                    object.externalRecipients = message.externalRecipients;
                if (message.forks != null && message.hasOwnProperty("forks"))
                    object.forks = message.forks;
                if (message.deniedAttempts != null && message.hasOwnProperty("deniedAttempts"))
                    object.deniedAttempts = message.deniedAttempts;
                if (message.pathChanges != null && message.hasOwnProperty("pathChanges"))
                    object.pathChanges = message.pathChanges;
                return object;
            };

            /**
             * Converts this Summary to JSON.
             * @function toJSON
             * @memberof tdx_response.FileSummary.Summary
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Summary.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Summary
             * @function getTypeUrl
             * @memberof tdx_response.FileSummary.Summary
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Summary.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.FileSummary.Summary";
            };

            return Summary;
        })();

        return FileSummary;
    })();

    tdx_response.LifecycleEvents = (function() {

        /**
         * Properties of a LifecycleEvents.
         * @memberof tdx_response
         * @interface ILifecycleEvents
         * @property {tdx_response.Status|null} [status] LifecycleEvents status
         * @property {Array.<tdx_response.LifecycleEvents.IEvent>|null} [events] LifecycleEvents events
         */

        /**
         * Constructs a new LifecycleEvents.
         * @memberof tdx_response
         * @classdesc Represents a LifecycleEvents.
         * @implements ILifecycleEvents
         * @constructor
         * @param {tdx_response.ILifecycleEvents=} [properties] Properties to set
         */
        function LifecycleEvents(properties) {
            this.events = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LifecycleEvents status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.status = 0;

        /**
         * LifecycleEvents events.
         * @member {Array.<tdx_response.LifecycleEvents.IEvent>} events
         * @memberof tdx_response.LifecycleEvents
         * @instance
         */
        LifecycleEvents.prototype.events = $util.emptyArray;

        /**
         * Creates a new LifecycleEvents instance using the specified properties.
         * @function create
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {tdx_response.ILifecycleEvents=} [properties] Properties to set
         * @returns {tdx_response.LifecycleEvents} LifecycleEvents instance
         */
        LifecycleEvents.create = function create(properties) {
            return new LifecycleEvents(properties);
        };

        /**
         * Encodes the specified LifecycleEvents message. Does not implicitly {@link tdx_response.LifecycleEvents.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {tdx_response.ILifecycleEvents} message LifecycleEvents message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LifecycleEvents.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.events != null && message.events.length)
                for (let i = 0; i < message.events.length; ++i)
                    $root.tdx_response.LifecycleEvents.Event.encode(message.events[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified LifecycleEvents message, length delimited. Does not implicitly {@link tdx_response.LifecycleEvents.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {tdx_response.ILifecycleEvents} message LifecycleEvents message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LifecycleEvents.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LifecycleEvents message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.LifecycleEvents} LifecycleEvents
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LifecycleEvents.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.LifecycleEvents();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.events && message.events.length))
                            message.events = [];
                        message.events.push($root.tdx_response.LifecycleEvents.Event.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LifecycleEvents message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.LifecycleEvents} LifecycleEvents
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LifecycleEvents.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LifecycleEvents message.
         * @function verify
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LifecycleEvents.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.events != null && message.hasOwnProperty("events")) {
                if (!Array.isArray(message.events))
                    return "events: array expected";
                for (let i = 0; i < message.events.length; ++i) {
                    let error = $root.tdx_response.LifecycleEvents.Event.verify(message.events[i]);
                    if (error)
                        return "events." + error;
                }
            }
            return null;
        };

        /**
         * Creates a LifecycleEvents message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.LifecycleEvents} LifecycleEvents
         */
        LifecycleEvents.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.LifecycleEvents)
                return object;
            let message = new $root.tdx_response.LifecycleEvents();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.events) {
                if (!Array.isArray(object.events))
                    throw TypeError(".tdx_response.LifecycleEvents.events: array expected");
                message.events = [];
                for (let i = 0; i < object.events.length; ++i) {
                    if (typeof object.events[i] !== "object")
                        throw TypeError(".tdx_response.LifecycleEvents.events: object expected");
                    message.events[i] = $root.tdx_response.LifecycleEvents.Event.fromObject(object.events[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a LifecycleEvents message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {tdx_response.LifecycleEvents} message LifecycleEvents
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LifecycleEvents.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.events = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.events && message.events.length) {
                object.events = [];
                for (let j = 0; j < message.events.length; ++j)
                    object.events[j] = $root.tdx_response.LifecycleEvents.Event.toObject(message.events[j], options);
            }
            return object;
        };

        /**
         * Converts this LifecycleEvents to JSON.
         * @function toJSON
         * @memberof tdx_response.LifecycleEvents
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LifecycleEvents.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LifecycleEvents
         * @function getTypeUrl
         * @memberof tdx_response.LifecycleEvents
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LifecycleEvents.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.LifecycleEvents";
        };

        LifecycleEvents.Event = (function() {

            /**
             * Properties of an Event.
             * @memberof tdx_response.LifecycleEvents
             * @interface IEvent
             * @property {number|Long|null} [timestamp] Event timestamp
             * @property {string|null} [operation] Event operation
             * @property {string|null} [actor] Event actor
             * @property {string|null} [country] Event country
             * @property {string|null} [detail] Event detail
             * @property {string|null} [grantedBy] Event grantedBy
             * @property {tdx_response.OperationResult|null} [result] Event result
             * @property {string|null} [destinationFileId] Event destinationFileId
             */

            /**
             * Constructs a new Event.
             * @memberof tdx_response.LifecycleEvents
             * @classdesc Represents an Event.
             * @implements IEvent
             * @constructor
             * @param {tdx_response.LifecycleEvents.IEvent=} [properties] Properties to set
             */
            function Event(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Event timestamp.
             * @member {number|Long} timestamp
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Event operation.
             * @member {string} operation
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.operation = "";

            /**
             * Event actor.
             * @member {string} actor
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.actor = "";

            /**
             * Event country.
             * @member {string} country
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.country = "";

            /**
             * Event detail.
             * @member {string} detail
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.detail = "";

            /**
             * Event grantedBy.
             * @member {string} grantedBy
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.grantedBy = "";

            /**
             * Event result.
             * @member {tdx_response.OperationResult} result
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.result = 0;

            /**
             * Event destinationFileId.
             * @member {string} destinationFileId
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             */
            Event.prototype.destinationFileId = "";

            /**
             * Creates a new Event instance using the specified properties.
             * @function create
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {tdx_response.LifecycleEvents.IEvent=} [properties] Properties to set
             * @returns {tdx_response.LifecycleEvents.Event} Event instance
             */
            Event.create = function create(properties) {
                return new Event(properties);
            };

            /**
             * Encodes the specified Event message. Does not implicitly {@link tdx_response.LifecycleEvents.Event.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {tdx_response.LifecycleEvents.IEvent} message Event message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Event.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.operation);
                if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.actor);
                if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.country);
                if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.detail);
                if (message.grantedBy != null && Object.hasOwnProperty.call(message, "grantedBy"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.grantedBy);
                if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.result);
                if (message.destinationFileId != null && Object.hasOwnProperty.call(message, "destinationFileId"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.destinationFileId);
                return writer;
            };

            /**
             * Encodes the specified Event message, length delimited. Does not implicitly {@link tdx_response.LifecycleEvents.Event.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {tdx_response.LifecycleEvents.IEvent} message Event message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Event.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Event message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.LifecycleEvents.Event} Event
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Event.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.LifecycleEvents.Event();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.timestamp = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.operation = reader.string();
                            break;
                        }
                    case 3: {
                            message.actor = reader.string();
                            break;
                        }
                    case 4: {
                            message.country = reader.string();
                            break;
                        }
                    case 5: {
                            message.detail = reader.string();
                            break;
                        }
                    case 6: {
                            message.grantedBy = reader.string();
                            break;
                        }
                    case 7: {
                            message.result = reader.int32();
                            break;
                        }
                    case 8: {
                            message.destinationFileId = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Event message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.LifecycleEvents.Event} Event
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Event.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Event message.
             * @function verify
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Event.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.actor != null && message.hasOwnProperty("actor"))
                    if (!$util.isString(message.actor))
                        return "actor: string expected";
                if (message.country != null && message.hasOwnProperty("country"))
                    if (!$util.isString(message.country))
                        return "country: string expected";
                if (message.detail != null && message.hasOwnProperty("detail"))
                    if (!$util.isString(message.detail))
                        return "detail: string expected";
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    if (!$util.isString(message.grantedBy))
                        return "grantedBy: string expected";
                if (message.result != null && message.hasOwnProperty("result"))
                    switch (message.result) {
                    default:
                        return "result: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.destinationFileId != null && message.hasOwnProperty("destinationFileId"))
                    if (!$util.isString(message.destinationFileId))
                        return "destinationFileId: string expected";
                return null;
            };

            /**
             * Creates an Event message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.LifecycleEvents.Event} Event
             */
            Event.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.LifecycleEvents.Event)
                    return object;
                let message = new $root.tdx_response.LifecycleEvents.Event();
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.actor != null)
                    message.actor = String(object.actor);
                if (object.country != null)
                    message.country = String(object.country);
                if (object.detail != null)
                    message.detail = String(object.detail);
                if (object.grantedBy != null)
                    message.grantedBy = String(object.grantedBy);
                switch (object.result) {
                default:
                    if (typeof object.result === "number") {
                        message.result = object.result;
                        break;
                    }
                    break;
                case "OPERATION_RESULT_UNKNOWN":
                case 0:
                    message.result = 0;
                    break;
                case "OPERATION_ALLOWED":
                case 1:
                    message.result = 1;
                    break;
                case "OPERATION_DENIED":
                case 2:
                    message.result = 2;
                    break;
                }
                if (object.destinationFileId != null)
                    message.destinationFileId = String(object.destinationFileId);
                return message;
            };

            /**
             * Creates a plain object from an Event message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {tdx_response.LifecycleEvents.Event} message Event
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Event.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    object.operation = "";
                    object.actor = "";
                    object.country = "";
                    object.detail = "";
                    object.grantedBy = "";
                    object.result = options.enums === String ? "OPERATION_RESULT_UNKNOWN" : 0;
                    object.destinationFileId = "";
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.actor != null && message.hasOwnProperty("actor"))
                    object.actor = message.actor;
                if (message.country != null && message.hasOwnProperty("country"))
                    object.country = message.country;
                if (message.detail != null && message.hasOwnProperty("detail"))
                    object.detail = message.detail;
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    object.grantedBy = message.grantedBy;
                if (message.result != null && message.hasOwnProperty("result"))
                    object.result = options.enums === String ? $root.tdx_response.OperationResult[message.result] === undefined ? message.result : $root.tdx_response.OperationResult[message.result] : message.result;
                if (message.destinationFileId != null && message.hasOwnProperty("destinationFileId"))
                    object.destinationFileId = message.destinationFileId;
                return object;
            };

            /**
             * Converts this Event to JSON.
             * @function toJSON
             * @memberof tdx_response.LifecycleEvents.Event
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Event.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Event
             * @function getTypeUrl
             * @memberof tdx_response.LifecycleEvents.Event
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Event.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.LifecycleEvents.Event";
            };

            return Event;
        })();

        return LifecycleEvents;
    })();

    tdx_response.VersionHistory = (function() {

        /**
         * Properties of a VersionHistory.
         * @memberof tdx_response
         * @interface IVersionHistory
         * @property {tdx_response.Status|null} [status] VersionHistory status
         * @property {Array.<tdx_response.VersionHistory.IVersion>|null} [versions] VersionHistory versions
         */

        /**
         * Constructs a new VersionHistory.
         * @memberof tdx_response
         * @classdesc Represents a VersionHistory.
         * @implements IVersionHistory
         * @constructor
         * @param {tdx_response.IVersionHistory=} [properties] Properties to set
         */
        function VersionHistory(properties) {
            this.versions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VersionHistory status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.VersionHistory
         * @instance
         */
        VersionHistory.prototype.status = 0;

        /**
         * VersionHistory versions.
         * @member {Array.<tdx_response.VersionHistory.IVersion>} versions
         * @memberof tdx_response.VersionHistory
         * @instance
         */
        VersionHistory.prototype.versions = $util.emptyArray;

        /**
         * Creates a new VersionHistory instance using the specified properties.
         * @function create
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {tdx_response.IVersionHistory=} [properties] Properties to set
         * @returns {tdx_response.VersionHistory} VersionHistory instance
         */
        VersionHistory.create = function create(properties) {
            return new VersionHistory(properties);
        };

        /**
         * Encodes the specified VersionHistory message. Does not implicitly {@link tdx_response.VersionHistory.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {tdx_response.IVersionHistory} message VersionHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VersionHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.versions != null && message.versions.length)
                for (let i = 0; i < message.versions.length; ++i)
                    $root.tdx_response.VersionHistory.Version.encode(message.versions[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified VersionHistory message, length delimited. Does not implicitly {@link tdx_response.VersionHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {tdx_response.IVersionHistory} message VersionHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VersionHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VersionHistory message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.VersionHistory} VersionHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VersionHistory.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.VersionHistory();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.versions && message.versions.length))
                            message.versions = [];
                        message.versions.push($root.tdx_response.VersionHistory.Version.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VersionHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.VersionHistory} VersionHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VersionHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VersionHistory message.
         * @function verify
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VersionHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.versions != null && message.hasOwnProperty("versions")) {
                if (!Array.isArray(message.versions))
                    return "versions: array expected";
                for (let i = 0; i < message.versions.length; ++i) {
                    let error = $root.tdx_response.VersionHistory.Version.verify(message.versions[i]);
                    if (error)
                        return "versions." + error;
                }
            }
            return null;
        };

        /**
         * Creates a VersionHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.VersionHistory} VersionHistory
         */
        VersionHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.VersionHistory)
                return object;
            let message = new $root.tdx_response.VersionHistory();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.versions) {
                if (!Array.isArray(object.versions))
                    throw TypeError(".tdx_response.VersionHistory.versions: array expected");
                message.versions = [];
                for (let i = 0; i < object.versions.length; ++i) {
                    if (typeof object.versions[i] !== "object")
                        throw TypeError(".tdx_response.VersionHistory.versions: object expected");
                    message.versions[i] = $root.tdx_response.VersionHistory.Version.fromObject(object.versions[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a VersionHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {tdx_response.VersionHistory} message VersionHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VersionHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.versions = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.versions && message.versions.length) {
                object.versions = [];
                for (let j = 0; j < message.versions.length; ++j)
                    object.versions[j] = $root.tdx_response.VersionHistory.Version.toObject(message.versions[j], options);
            }
            return object;
        };

        /**
         * Converts this VersionHistory to JSON.
         * @function toJSON
         * @memberof tdx_response.VersionHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VersionHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VersionHistory
         * @function getTypeUrl
         * @memberof tdx_response.VersionHistory
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VersionHistory.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.VersionHistory";
        };

        VersionHistory.Version = (function() {

            /**
             * Properties of a Version.
             * @memberof tdx_response.VersionHistory
             * @interface IVersion
             * @property {tdx_response.VersionKind|null} [kind] Version kind
             * @property {string|null} [version] Version version
             * @property {number|Long|null} [timestamp] Version timestamp
             * @property {string|null} [actor] Version actor
             * @property {number|Long|null} [size] Version size
             * @property {string|null} [note] Version note
             */

            /**
             * Constructs a new Version.
             * @memberof tdx_response.VersionHistory
             * @classdesc Represents a Version.
             * @implements IVersion
             * @constructor
             * @param {tdx_response.VersionHistory.IVersion=} [properties] Properties to set
             */
            function Version(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Version kind.
             * @member {tdx_response.VersionKind} kind
             * @memberof tdx_response.VersionHistory.Version
             * @instance
             */
            Version.prototype.kind = 0;

            /**
             * Version version.
             * @member {string} version
             * @memberof tdx_response.VersionHistory.Version
             * @instance
             */
            Version.prototype.version = "";

            /**
             * Version timestamp.
             * @member {number|Long} timestamp
             * @memberof tdx_response.VersionHistory.Version
             * @instance
             */
            Version.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Version actor.
             * @member {string} actor
             * @memberof tdx_response.VersionHistory.Version
             * @instance
             */
            Version.prototype.actor = "";

            /**
             * Version size.
             * @member {number|Long} size
             * @memberof tdx_response.VersionHistory.Version
             * @instance
             */
            Version.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Version note.
             * @member {string} note
             * @memberof tdx_response.VersionHistory.Version
             * @instance
             */
            Version.prototype.note = "";

            /**
             * Creates a new Version instance using the specified properties.
             * @function create
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {tdx_response.VersionHistory.IVersion=} [properties] Properties to set
             * @returns {tdx_response.VersionHistory.Version} Version instance
             */
            Version.create = function create(properties) {
                return new Version(properties);
            };

            /**
             * Encodes the specified Version message. Does not implicitly {@link tdx_response.VersionHistory.Version.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {tdx_response.VersionHistory.IVersion} message Version message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Version.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.kind);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.timestamp);
                if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.actor);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.size);
                if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.note);
                return writer;
            };

            /**
             * Encodes the specified Version message, length delimited. Does not implicitly {@link tdx_response.VersionHistory.Version.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {tdx_response.VersionHistory.IVersion} message Version message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Version.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Version message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.VersionHistory.Version} Version
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Version.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.VersionHistory.Version();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.kind = reader.int32();
                            break;
                        }
                    case 2: {
                            message.version = reader.string();
                            break;
                        }
                    case 3: {
                            message.timestamp = reader.uint64();
                            break;
                        }
                    case 4: {
                            message.actor = reader.string();
                            break;
                        }
                    case 5: {
                            message.size = reader.uint64();
                            break;
                        }
                    case 6: {
                            message.note = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Version message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.VersionHistory.Version} Version
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Version.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Version message.
             * @function verify
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Version.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.kind != null && message.hasOwnProperty("kind"))
                    switch (message.kind) {
                    default:
                        return "kind: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.actor != null && message.hasOwnProperty("actor"))
                    if (!$util.isString(message.actor))
                        return "actor: string expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                if (message.note != null && message.hasOwnProperty("note"))
                    if (!$util.isString(message.note))
                        return "note: string expected";
                return null;
            };

            /**
             * Creates a Version message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.VersionHistory.Version} Version
             */
            Version.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.VersionHistory.Version)
                    return object;
                let message = new $root.tdx_response.VersionHistory.Version();
                switch (object.kind) {
                default:
                    if (typeof object.kind === "number") {
                        message.kind = object.kind;
                        break;
                    }
                    break;
                case "VERSION_KIND_UNKNOWN":
                case 0:
                    message.kind = 0;
                    break;
                case "VERSION_CREATED":
                case 1:
                    message.kind = 1;
                    break;
                case "VERSION_UPDATED":
                case 2:
                    message.kind = 2;
                    break;
                case "VERSION_RESTORED":
                case 3:
                    message.kind = 3;
                    break;
                case "VERSION_REMOVED":
                case 4:
                    message.kind = 4;
                    break;
                }
                if (object.version != null)
                    message.version = String(object.version);
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                if (object.actor != null)
                    message.actor = String(object.actor);
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
                if (object.note != null)
                    message.note = String(object.note);
                return message;
            };

            /**
             * Creates a plain object from a Version message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {tdx_response.VersionHistory.Version} message Version
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Version.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.kind = options.enums === String ? "VERSION_KIND_UNKNOWN" : 0;
                    object.version = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    object.actor = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                    object.note = "";
                }
                if (message.kind != null && message.hasOwnProperty("kind"))
                    object.kind = options.enums === String ? $root.tdx_response.VersionKind[message.kind] === undefined ? message.kind : $root.tdx_response.VersionKind[message.kind] : message.kind;
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                if (message.actor != null && message.hasOwnProperty("actor"))
                    object.actor = message.actor;
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
                if (message.note != null && message.hasOwnProperty("note"))
                    object.note = message.note;
                return object;
            };

            /**
             * Converts this Version to JSON.
             * @function toJSON
             * @memberof tdx_response.VersionHistory.Version
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Version.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Version
             * @function getTypeUrl
             * @memberof tdx_response.VersionHistory.Version
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Version.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.VersionHistory.Version";
            };

            return Version;
        })();

        return VersionHistory;
    })();

    tdx_response.Shares = (function() {

        /**
         * Properties of a Shares.
         * @memberof tdx_response
         * @interface IShares
         * @property {tdx_response.Status|null} [status] Shares status
         * @property {Array.<tdx_response.Shares.IShare>|null} [shares] Shares shares
         */

        /**
         * Constructs a new Shares.
         * @memberof tdx_response
         * @classdesc Represents a Shares.
         * @implements IShares
         * @constructor
         * @param {tdx_response.IShares=} [properties] Properties to set
         */
        function Shares(properties) {
            this.shares = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Shares status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Shares
         * @instance
         */
        Shares.prototype.status = 0;

        /**
         * Shares shares.
         * @member {Array.<tdx_response.Shares.IShare>} shares
         * @memberof tdx_response.Shares
         * @instance
         */
        Shares.prototype.shares = $util.emptyArray;

        /**
         * Creates a new Shares instance using the specified properties.
         * @function create
         * @memberof tdx_response.Shares
         * @static
         * @param {tdx_response.IShares=} [properties] Properties to set
         * @returns {tdx_response.Shares} Shares instance
         */
        Shares.create = function create(properties) {
            return new Shares(properties);
        };

        /**
         * Encodes the specified Shares message. Does not implicitly {@link tdx_response.Shares.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Shares
         * @static
         * @param {tdx_response.IShares} message Shares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Shares.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.shares != null && message.shares.length)
                for (let i = 0; i < message.shares.length; ++i)
                    $root.tdx_response.Shares.Share.encode(message.shares[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Shares message, length delimited. Does not implicitly {@link tdx_response.Shares.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Shares
         * @static
         * @param {tdx_response.IShares} message Shares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Shares.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Shares message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Shares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Shares} Shares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Shares.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Shares();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.shares && message.shares.length))
                            message.shares = [];
                        message.shares.push($root.tdx_response.Shares.Share.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Shares message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Shares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Shares} Shares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Shares.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Shares message.
         * @function verify
         * @memberof tdx_response.Shares
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Shares.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.shares != null && message.hasOwnProperty("shares")) {
                if (!Array.isArray(message.shares))
                    return "shares: array expected";
                for (let i = 0; i < message.shares.length; ++i) {
                    let error = $root.tdx_response.Shares.Share.verify(message.shares[i]);
                    if (error)
                        return "shares." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Shares message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Shares
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Shares} Shares
         */
        Shares.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Shares)
                return object;
            let message = new $root.tdx_response.Shares();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.shares) {
                if (!Array.isArray(object.shares))
                    throw TypeError(".tdx_response.Shares.shares: array expected");
                message.shares = [];
                for (let i = 0; i < object.shares.length; ++i) {
                    if (typeof object.shares[i] !== "object")
                        throw TypeError(".tdx_response.Shares.shares: object expected");
                    message.shares[i] = $root.tdx_response.Shares.Share.fromObject(object.shares[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Shares message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Shares
         * @static
         * @param {tdx_response.Shares} message Shares
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Shares.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.shares = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.shares && message.shares.length) {
                object.shares = [];
                for (let j = 0; j < message.shares.length; ++j)
                    object.shares[j] = $root.tdx_response.Shares.Share.toObject(message.shares[j], options);
            }
            return object;
        };

        /**
         * Converts this Shares to JSON.
         * @function toJSON
         * @memberof tdx_response.Shares
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Shares.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Shares
         * @function getTypeUrl
         * @memberof tdx_response.Shares
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Shares.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Shares";
        };

        Shares.Share = (function() {

            /**
             * Properties of a Share.
             * @memberof tdx_response.Shares
             * @interface IShare
             * @property {string|null} [recipient] Share recipient
             * @property {tdx_response.ShareType|null} [type] Share type
             * @property {tdx_response.Permission|null} [permission] Share permission
             * @property {string|null} [grantedBy] Share grantedBy
             */

            /**
             * Constructs a new Share.
             * @memberof tdx_response.Shares
             * @classdesc Represents a Share.
             * @implements IShare
             * @constructor
             * @param {tdx_response.Shares.IShare=} [properties] Properties to set
             */
            function Share(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Share recipient.
             * @member {string} recipient
             * @memberof tdx_response.Shares.Share
             * @instance
             */
            Share.prototype.recipient = "";

            /**
             * Share type.
             * @member {tdx_response.ShareType} type
             * @memberof tdx_response.Shares.Share
             * @instance
             */
            Share.prototype.type = 0;

            /**
             * Share permission.
             * @member {tdx_response.Permission} permission
             * @memberof tdx_response.Shares.Share
             * @instance
             */
            Share.prototype.permission = 0;

            /**
             * Share grantedBy.
             * @member {string} grantedBy
             * @memberof tdx_response.Shares.Share
             * @instance
             */
            Share.prototype.grantedBy = "";

            /**
             * Creates a new Share instance using the specified properties.
             * @function create
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {tdx_response.Shares.IShare=} [properties] Properties to set
             * @returns {tdx_response.Shares.Share} Share instance
             */
            Share.create = function create(properties) {
                return new Share(properties);
            };

            /**
             * Encodes the specified Share message. Does not implicitly {@link tdx_response.Shares.Share.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {tdx_response.Shares.IShare} message Share message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Share.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.recipient != null && Object.hasOwnProperty.call(message, "recipient"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.recipient);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.permission);
                if (message.grantedBy != null && Object.hasOwnProperty.call(message, "grantedBy"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.grantedBy);
                return writer;
            };

            /**
             * Encodes the specified Share message, length delimited. Does not implicitly {@link tdx_response.Shares.Share.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {tdx_response.Shares.IShare} message Share message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Share.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Share message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.Shares.Share} Share
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Share.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Shares.Share();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.recipient = reader.string();
                            break;
                        }
                    case 2: {
                            message.type = reader.int32();
                            break;
                        }
                    case 3: {
                            message.permission = reader.int32();
                            break;
                        }
                    case 4: {
                            message.grantedBy = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Share message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.Shares.Share} Share
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Share.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Share message.
             * @function verify
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Share.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.recipient != null && message.hasOwnProperty("recipient"))
                    if (!$util.isString(message.recipient))
                        return "recipient: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.permission != null && message.hasOwnProperty("permission"))
                    switch (message.permission) {
                    default:
                        return "permission: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    if (!$util.isString(message.grantedBy))
                        return "grantedBy: string expected";
                return null;
            };

            /**
             * Creates a Share message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.Shares.Share} Share
             */
            Share.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.Shares.Share)
                    return object;
                let message = new $root.tdx_response.Shares.Share();
                if (object.recipient != null)
                    message.recipient = String(object.recipient);
                switch (object.type) {
                default:
                    if (typeof object.type === "number") {
                        message.type = object.type;
                        break;
                    }
                    break;
                case "SHARE_TYPE_UNKNOWN":
                case 0:
                    message.type = 0;
                    break;
                case "SHARE_TYPE_USER":
                case 1:
                    message.type = 1;
                    break;
                case "SHARE_TYPE_TEAM":
                case 2:
                    message.type = 2;
                    break;
                case "SHARE_TYPE_EXTERNAL":
                case 3:
                    message.type = 3;
                    break;
                }
                switch (object.permission) {
                default:
                    if (typeof object.permission === "number") {
                        message.permission = object.permission;
                        break;
                    }
                    break;
                case "PERMISSION_UNKNOWN":
                case 0:
                    message.permission = 0;
                    break;
                case "PERMISSION_READ":
                case 1:
                    message.permission = 1;
                    break;
                case "PERMISSION_WRITE":
                case 2:
                    message.permission = 2;
                    break;
                case "PERMISSION_EDIT":
                case 3:
                    message.permission = 3;
                    break;
                }
                if (object.grantedBy != null)
                    message.grantedBy = String(object.grantedBy);
                return message;
            };

            /**
             * Creates a plain object from a Share message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {tdx_response.Shares.Share} message Share
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Share.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.recipient = "";
                    object.type = options.enums === String ? "SHARE_TYPE_UNKNOWN" : 0;
                    object.permission = options.enums === String ? "PERMISSION_UNKNOWN" : 0;
                    object.grantedBy = "";
                }
                if (message.recipient != null && message.hasOwnProperty("recipient"))
                    object.recipient = message.recipient;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.tdx_response.ShareType[message.type] === undefined ? message.type : $root.tdx_response.ShareType[message.type] : message.type;
                if (message.permission != null && message.hasOwnProperty("permission"))
                    object.permission = options.enums === String ? $root.tdx_response.Permission[message.permission] === undefined ? message.permission : $root.tdx_response.Permission[message.permission] : message.permission;
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    object.grantedBy = message.grantedBy;
                return object;
            };

            /**
             * Converts this Share to JSON.
             * @function toJSON
             * @memberof tdx_response.Shares.Share
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Share.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Share
             * @function getTypeUrl
             * @memberof tdx_response.Shares.Share
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Share.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.Shares.Share";
            };

            return Share;
        })();

        return Shares;
    })();

    tdx_response.PathHistory = (function() {

        /**
         * Properties of a PathHistory.
         * @memberof tdx_response
         * @interface IPathHistory
         * @property {tdx_response.Status|null} [status] PathHistory status
         * @property {Array.<tdx_response.PathHistory.IPathChange>|null} [changes] PathHistory changes
         */

        /**
         * Constructs a new PathHistory.
         * @memberof tdx_response
         * @classdesc Represents a PathHistory.
         * @implements IPathHistory
         * @constructor
         * @param {tdx_response.IPathHistory=} [properties] Properties to set
         */
        function PathHistory(properties) {
            this.changes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PathHistory status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.PathHistory
         * @instance
         */
        PathHistory.prototype.status = 0;

        /**
         * PathHistory changes.
         * @member {Array.<tdx_response.PathHistory.IPathChange>} changes
         * @memberof tdx_response.PathHistory
         * @instance
         */
        PathHistory.prototype.changes = $util.emptyArray;

        /**
         * Creates a new PathHistory instance using the specified properties.
         * @function create
         * @memberof tdx_response.PathHistory
         * @static
         * @param {tdx_response.IPathHistory=} [properties] Properties to set
         * @returns {tdx_response.PathHistory} PathHistory instance
         */
        PathHistory.create = function create(properties) {
            return new PathHistory(properties);
        };

        /**
         * Encodes the specified PathHistory message. Does not implicitly {@link tdx_response.PathHistory.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.PathHistory
         * @static
         * @param {tdx_response.IPathHistory} message PathHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PathHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.changes != null && message.changes.length)
                for (let i = 0; i < message.changes.length; ++i)
                    $root.tdx_response.PathHistory.PathChange.encode(message.changes[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PathHistory message, length delimited. Does not implicitly {@link tdx_response.PathHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.PathHistory
         * @static
         * @param {tdx_response.IPathHistory} message PathHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PathHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PathHistory message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.PathHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.PathHistory} PathHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PathHistory.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.PathHistory();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.changes && message.changes.length))
                            message.changes = [];
                        message.changes.push($root.tdx_response.PathHistory.PathChange.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PathHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.PathHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.PathHistory} PathHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PathHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PathHistory message.
         * @function verify
         * @memberof tdx_response.PathHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PathHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.changes != null && message.hasOwnProperty("changes")) {
                if (!Array.isArray(message.changes))
                    return "changes: array expected";
                for (let i = 0; i < message.changes.length; ++i) {
                    let error = $root.tdx_response.PathHistory.PathChange.verify(message.changes[i]);
                    if (error)
                        return "changes." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PathHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.PathHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.PathHistory} PathHistory
         */
        PathHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.PathHistory)
                return object;
            let message = new $root.tdx_response.PathHistory();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.changes) {
                if (!Array.isArray(object.changes))
                    throw TypeError(".tdx_response.PathHistory.changes: array expected");
                message.changes = [];
                for (let i = 0; i < object.changes.length; ++i) {
                    if (typeof object.changes[i] !== "object")
                        throw TypeError(".tdx_response.PathHistory.changes: object expected");
                    message.changes[i] = $root.tdx_response.PathHistory.PathChange.fromObject(object.changes[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PathHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.PathHistory
         * @static
         * @param {tdx_response.PathHistory} message PathHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PathHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.changes = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.changes && message.changes.length) {
                object.changes = [];
                for (let j = 0; j < message.changes.length; ++j)
                    object.changes[j] = $root.tdx_response.PathHistory.PathChange.toObject(message.changes[j], options);
            }
            return object;
        };

        /**
         * Converts this PathHistory to JSON.
         * @function toJSON
         * @memberof tdx_response.PathHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PathHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PathHistory
         * @function getTypeUrl
         * @memberof tdx_response.PathHistory
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PathHistory.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.PathHistory";
        };

        PathHistory.PathChange = (function() {

            /**
             * Properties of a PathChange.
             * @memberof tdx_response.PathHistory
             * @interface IPathChange
             * @property {number|Long|null} [timestamp] PathChange timestamp
             * @property {string|null} [operation] PathChange operation
             * @property {string|null} [fromPath] PathChange fromPath
             * @property {string|null} [toPath] PathChange toPath
             * @property {string|null} [actor] PathChange actor
             */

            /**
             * Constructs a new PathChange.
             * @memberof tdx_response.PathHistory
             * @classdesc Represents a PathChange.
             * @implements IPathChange
             * @constructor
             * @param {tdx_response.PathHistory.IPathChange=} [properties] Properties to set
             */
            function PathChange(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PathChange timestamp.
             * @member {number|Long} timestamp
             * @memberof tdx_response.PathHistory.PathChange
             * @instance
             */
            PathChange.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * PathChange operation.
             * @member {string} operation
             * @memberof tdx_response.PathHistory.PathChange
             * @instance
             */
            PathChange.prototype.operation = "";

            /**
             * PathChange fromPath.
             * @member {string} fromPath
             * @memberof tdx_response.PathHistory.PathChange
             * @instance
             */
            PathChange.prototype.fromPath = "";

            /**
             * PathChange toPath.
             * @member {string} toPath
             * @memberof tdx_response.PathHistory.PathChange
             * @instance
             */
            PathChange.prototype.toPath = "";

            /**
             * PathChange actor.
             * @member {string} actor
             * @memberof tdx_response.PathHistory.PathChange
             * @instance
             */
            PathChange.prototype.actor = "";

            /**
             * Creates a new PathChange instance using the specified properties.
             * @function create
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {tdx_response.PathHistory.IPathChange=} [properties] Properties to set
             * @returns {tdx_response.PathHistory.PathChange} PathChange instance
             */
            PathChange.create = function create(properties) {
                return new PathChange(properties);
            };

            /**
             * Encodes the specified PathChange message. Does not implicitly {@link tdx_response.PathHistory.PathChange.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {tdx_response.PathHistory.IPathChange} message PathChange message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PathChange.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.operation);
                if (message.fromPath != null && Object.hasOwnProperty.call(message, "fromPath"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromPath);
                if (message.toPath != null && Object.hasOwnProperty.call(message, "toPath"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.toPath);
                if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.actor);
                return writer;
            };

            /**
             * Encodes the specified PathChange message, length delimited. Does not implicitly {@link tdx_response.PathHistory.PathChange.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {tdx_response.PathHistory.IPathChange} message PathChange message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PathChange.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PathChange message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.PathHistory.PathChange} PathChange
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PathChange.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.PathHistory.PathChange();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.timestamp = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.operation = reader.string();
                            break;
                        }
                    case 3: {
                            message.fromPath = reader.string();
                            break;
                        }
                    case 4: {
                            message.toPath = reader.string();
                            break;
                        }
                    case 5: {
                            message.actor = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PathChange message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.PathHistory.PathChange} PathChange
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PathChange.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PathChange message.
             * @function verify
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PathChange.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.fromPath != null && message.hasOwnProperty("fromPath"))
                    if (!$util.isString(message.fromPath))
                        return "fromPath: string expected";
                if (message.toPath != null && message.hasOwnProperty("toPath"))
                    if (!$util.isString(message.toPath))
                        return "toPath: string expected";
                if (message.actor != null && message.hasOwnProperty("actor"))
                    if (!$util.isString(message.actor))
                        return "actor: string expected";
                return null;
            };

            /**
             * Creates a PathChange message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.PathHistory.PathChange} PathChange
             */
            PathChange.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.PathHistory.PathChange)
                    return object;
                let message = new $root.tdx_response.PathHistory.PathChange();
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.fromPath != null)
                    message.fromPath = String(object.fromPath);
                if (object.toPath != null)
                    message.toPath = String(object.toPath);
                if (object.actor != null)
                    message.actor = String(object.actor);
                return message;
            };

            /**
             * Creates a plain object from a PathChange message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {tdx_response.PathHistory.PathChange} message PathChange
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PathChange.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    object.operation = "";
                    object.fromPath = "";
                    object.toPath = "";
                    object.actor = "";
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.fromPath != null && message.hasOwnProperty("fromPath"))
                    object.fromPath = message.fromPath;
                if (message.toPath != null && message.hasOwnProperty("toPath"))
                    object.toPath = message.toPath;
                if (message.actor != null && message.hasOwnProperty("actor"))
                    object.actor = message.actor;
                return object;
            };

            /**
             * Converts this PathChange to JSON.
             * @function toJSON
             * @memberof tdx_response.PathHistory.PathChange
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PathChange.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PathChange
             * @function getTypeUrl
             * @memberof tdx_response.PathHistory.PathChange
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PathChange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.PathHistory.PathChange";
            };

            return PathChange;
        })();

        return PathHistory;
    })();

    tdx_response.ActorStats = (function() {

        /**
         * Properties of an ActorStats.
         * @memberof tdx_response
         * @interface IActorStats
         * @property {tdx_response.Status|null} [status] ActorStats status
         * @property {Array.<tdx_response.ActorStats.IActorStat>|null} [actors] ActorStats actors
         */

        /**
         * Constructs a new ActorStats.
         * @memberof tdx_response
         * @classdesc Represents an ActorStats.
         * @implements IActorStats
         * @constructor
         * @param {tdx_response.IActorStats=} [properties] Properties to set
         */
        function ActorStats(properties) {
            this.actors = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ActorStats status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.ActorStats
         * @instance
         */
        ActorStats.prototype.status = 0;

        /**
         * ActorStats actors.
         * @member {Array.<tdx_response.ActorStats.IActorStat>} actors
         * @memberof tdx_response.ActorStats
         * @instance
         */
        ActorStats.prototype.actors = $util.emptyArray;

        /**
         * Creates a new ActorStats instance using the specified properties.
         * @function create
         * @memberof tdx_response.ActorStats
         * @static
         * @param {tdx_response.IActorStats=} [properties] Properties to set
         * @returns {tdx_response.ActorStats} ActorStats instance
         */
        ActorStats.create = function create(properties) {
            return new ActorStats(properties);
        };

        /**
         * Encodes the specified ActorStats message. Does not implicitly {@link tdx_response.ActorStats.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.ActorStats
         * @static
         * @param {tdx_response.IActorStats} message ActorStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActorStats.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.actors != null && message.actors.length)
                for (let i = 0; i < message.actors.length; ++i)
                    $root.tdx_response.ActorStats.ActorStat.encode(message.actors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ActorStats message, length delimited. Does not implicitly {@link tdx_response.ActorStats.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.ActorStats
         * @static
         * @param {tdx_response.IActorStats} message ActorStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActorStats.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ActorStats message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.ActorStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.ActorStats} ActorStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActorStats.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ActorStats();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.actors && message.actors.length))
                            message.actors = [];
                        message.actors.push($root.tdx_response.ActorStats.ActorStat.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ActorStats message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.ActorStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.ActorStats} ActorStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActorStats.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ActorStats message.
         * @function verify
         * @memberof tdx_response.ActorStats
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ActorStats.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.actors != null && message.hasOwnProperty("actors")) {
                if (!Array.isArray(message.actors))
                    return "actors: array expected";
                for (let i = 0; i < message.actors.length; ++i) {
                    let error = $root.tdx_response.ActorStats.ActorStat.verify(message.actors[i]);
                    if (error)
                        return "actors." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ActorStats message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.ActorStats
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.ActorStats} ActorStats
         */
        ActorStats.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.ActorStats)
                return object;
            let message = new $root.tdx_response.ActorStats();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.actors) {
                if (!Array.isArray(object.actors))
                    throw TypeError(".tdx_response.ActorStats.actors: array expected");
                message.actors = [];
                for (let i = 0; i < object.actors.length; ++i) {
                    if (typeof object.actors[i] !== "object")
                        throw TypeError(".tdx_response.ActorStats.actors: object expected");
                    message.actors[i] = $root.tdx_response.ActorStats.ActorStat.fromObject(object.actors[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ActorStats message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.ActorStats
         * @static
         * @param {tdx_response.ActorStats} message ActorStats
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ActorStats.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.actors = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.actors && message.actors.length) {
                object.actors = [];
                for (let j = 0; j < message.actors.length; ++j)
                    object.actors[j] = $root.tdx_response.ActorStats.ActorStat.toObject(message.actors[j], options);
            }
            return object;
        };

        /**
         * Converts this ActorStats to JSON.
         * @function toJSON
         * @memberof tdx_response.ActorStats
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ActorStats.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ActorStats
         * @function getTypeUrl
         * @memberof tdx_response.ActorStats
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ActorStats.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.ActorStats";
        };

        ActorStats.ActorStat = (function() {

            /**
             * Properties of an ActorStat.
             * @memberof tdx_response.ActorStats
             * @interface IActorStat
             * @property {string|null} [actor] ActorStat actor
             * @property {number|Long|null} [eventCount] ActorStat eventCount
             * @property {number|null} [percentage] ActorStat percentage
             */

            /**
             * Constructs a new ActorStat.
             * @memberof tdx_response.ActorStats
             * @classdesc Represents an ActorStat.
             * @implements IActorStat
             * @constructor
             * @param {tdx_response.ActorStats.IActorStat=} [properties] Properties to set
             */
            function ActorStat(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ActorStat actor.
             * @member {string} actor
             * @memberof tdx_response.ActorStats.ActorStat
             * @instance
             */
            ActorStat.prototype.actor = "";

            /**
             * ActorStat eventCount.
             * @member {number|Long} eventCount
             * @memberof tdx_response.ActorStats.ActorStat
             * @instance
             */
            ActorStat.prototype.eventCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * ActorStat percentage.
             * @member {number} percentage
             * @memberof tdx_response.ActorStats.ActorStat
             * @instance
             */
            ActorStat.prototype.percentage = 0;

            /**
             * Creates a new ActorStat instance using the specified properties.
             * @function create
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {tdx_response.ActorStats.IActorStat=} [properties] Properties to set
             * @returns {tdx_response.ActorStats.ActorStat} ActorStat instance
             */
            ActorStat.create = function create(properties) {
                return new ActorStat(properties);
            };

            /**
             * Encodes the specified ActorStat message. Does not implicitly {@link tdx_response.ActorStats.ActorStat.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {tdx_response.ActorStats.IActorStat} message ActorStat message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ActorStat.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.actor);
                if (message.eventCount != null && Object.hasOwnProperty.call(message, "eventCount"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.eventCount);
                if (message.percentage != null && Object.hasOwnProperty.call(message, "percentage"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.percentage);
                return writer;
            };

            /**
             * Encodes the specified ActorStat message, length delimited. Does not implicitly {@link tdx_response.ActorStats.ActorStat.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {tdx_response.ActorStats.IActorStat} message ActorStat message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ActorStat.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ActorStat message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.ActorStats.ActorStat} ActorStat
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ActorStat.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ActorStats.ActorStat();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.actor = reader.string();
                            break;
                        }
                    case 2: {
                            message.eventCount = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.percentage = reader.double();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ActorStat message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.ActorStats.ActorStat} ActorStat
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ActorStat.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ActorStat message.
             * @function verify
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ActorStat.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.actor != null && message.hasOwnProperty("actor"))
                    if (!$util.isString(message.actor))
                        return "actor: string expected";
                if (message.eventCount != null && message.hasOwnProperty("eventCount"))
                    if (!$util.isInteger(message.eventCount) && !(message.eventCount && $util.isInteger(message.eventCount.low) && $util.isInteger(message.eventCount.high)))
                        return "eventCount: integer|Long expected";
                if (message.percentage != null && message.hasOwnProperty("percentage"))
                    if (typeof message.percentage !== "number")
                        return "percentage: number expected";
                return null;
            };

            /**
             * Creates an ActorStat message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.ActorStats.ActorStat} ActorStat
             */
            ActorStat.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.ActorStats.ActorStat)
                    return object;
                let message = new $root.tdx_response.ActorStats.ActorStat();
                if (object.actor != null)
                    message.actor = String(object.actor);
                if (object.eventCount != null)
                    if ($util.Long)
                        (message.eventCount = $util.Long.fromValue(object.eventCount)).unsigned = true;
                    else if (typeof object.eventCount === "string")
                        message.eventCount = parseInt(object.eventCount, 10);
                    else if (typeof object.eventCount === "number")
                        message.eventCount = object.eventCount;
                    else if (typeof object.eventCount === "object")
                        message.eventCount = new $util.LongBits(object.eventCount.low >>> 0, object.eventCount.high >>> 0).toNumber(true);
                if (object.percentage != null)
                    message.percentage = Number(object.percentage);
                return message;
            };

            /**
             * Creates a plain object from an ActorStat message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {tdx_response.ActorStats.ActorStat} message ActorStat
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ActorStat.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.actor = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.eventCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.eventCount = options.longs === String ? "0" : 0;
                    object.percentage = 0;
                }
                if (message.actor != null && message.hasOwnProperty("actor"))
                    object.actor = message.actor;
                if (message.eventCount != null && message.hasOwnProperty("eventCount"))
                    if (typeof message.eventCount === "number")
                        object.eventCount = options.longs === String ? String(message.eventCount) : message.eventCount;
                    else
                        object.eventCount = options.longs === String ? $util.Long.prototype.toString.call(message.eventCount) : options.longs === Number ? new $util.LongBits(message.eventCount.low >>> 0, message.eventCount.high >>> 0).toNumber(true) : message.eventCount;
                if (message.percentage != null && message.hasOwnProperty("percentage"))
                    object.percentage = options.json && !isFinite(message.percentage) ? String(message.percentage) : message.percentage;
                return object;
            };

            /**
             * Converts this ActorStat to JSON.
             * @function toJSON
             * @memberof tdx_response.ActorStats.ActorStat
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ActorStat.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ActorStat
             * @function getTypeUrl
             * @memberof tdx_response.ActorStats.ActorStat
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ActorStat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.ActorStats.ActorStat";
            };

            return ActorStat;
        })();

        return ActorStats;
    })();

    tdx_response.CountryStats = (function() {

        /**
         * Properties of a CountryStats.
         * @memberof tdx_response
         * @interface ICountryStats
         * @property {tdx_response.Status|null} [status] CountryStats status
         * @property {Array.<tdx_response.CountryStats.ICountryStat>|null} [countries] CountryStats countries
         */

        /**
         * Constructs a new CountryStats.
         * @memberof tdx_response
         * @classdesc Represents a CountryStats.
         * @implements ICountryStats
         * @constructor
         * @param {tdx_response.ICountryStats=} [properties] Properties to set
         */
        function CountryStats(properties) {
            this.countries = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CountryStats status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.CountryStats
         * @instance
         */
        CountryStats.prototype.status = 0;

        /**
         * CountryStats countries.
         * @member {Array.<tdx_response.CountryStats.ICountryStat>} countries
         * @memberof tdx_response.CountryStats
         * @instance
         */
        CountryStats.prototype.countries = $util.emptyArray;

        /**
         * Creates a new CountryStats instance using the specified properties.
         * @function create
         * @memberof tdx_response.CountryStats
         * @static
         * @param {tdx_response.ICountryStats=} [properties] Properties to set
         * @returns {tdx_response.CountryStats} CountryStats instance
         */
        CountryStats.create = function create(properties) {
            return new CountryStats(properties);
        };

        /**
         * Encodes the specified CountryStats message. Does not implicitly {@link tdx_response.CountryStats.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.CountryStats
         * @static
         * @param {tdx_response.ICountryStats} message CountryStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CountryStats.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.countries != null && message.countries.length)
                for (let i = 0; i < message.countries.length; ++i)
                    $root.tdx_response.CountryStats.CountryStat.encode(message.countries[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CountryStats message, length delimited. Does not implicitly {@link tdx_response.CountryStats.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.CountryStats
         * @static
         * @param {tdx_response.ICountryStats} message CountryStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CountryStats.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CountryStats message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.CountryStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.CountryStats} CountryStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CountryStats.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.CountryStats();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.countries && message.countries.length))
                            message.countries = [];
                        message.countries.push($root.tdx_response.CountryStats.CountryStat.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CountryStats message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.CountryStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.CountryStats} CountryStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CountryStats.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CountryStats message.
         * @function verify
         * @memberof tdx_response.CountryStats
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CountryStats.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.countries != null && message.hasOwnProperty("countries")) {
                if (!Array.isArray(message.countries))
                    return "countries: array expected";
                for (let i = 0; i < message.countries.length; ++i) {
                    let error = $root.tdx_response.CountryStats.CountryStat.verify(message.countries[i]);
                    if (error)
                        return "countries." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CountryStats message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.CountryStats
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.CountryStats} CountryStats
         */
        CountryStats.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.CountryStats)
                return object;
            let message = new $root.tdx_response.CountryStats();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.countries) {
                if (!Array.isArray(object.countries))
                    throw TypeError(".tdx_response.CountryStats.countries: array expected");
                message.countries = [];
                for (let i = 0; i < object.countries.length; ++i) {
                    if (typeof object.countries[i] !== "object")
                        throw TypeError(".tdx_response.CountryStats.countries: object expected");
                    message.countries[i] = $root.tdx_response.CountryStats.CountryStat.fromObject(object.countries[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CountryStats message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.CountryStats
         * @static
         * @param {tdx_response.CountryStats} message CountryStats
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CountryStats.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.countries = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.countries && message.countries.length) {
                object.countries = [];
                for (let j = 0; j < message.countries.length; ++j)
                    object.countries[j] = $root.tdx_response.CountryStats.CountryStat.toObject(message.countries[j], options);
            }
            return object;
        };

        /**
         * Converts this CountryStats to JSON.
         * @function toJSON
         * @memberof tdx_response.CountryStats
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CountryStats.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CountryStats
         * @function getTypeUrl
         * @memberof tdx_response.CountryStats
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CountryStats.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.CountryStats";
        };

        CountryStats.CountryStat = (function() {

            /**
             * Properties of a CountryStat.
             * @memberof tdx_response.CountryStats
             * @interface ICountryStat
             * @property {string|null} [country] CountryStat country
             * @property {number|Long|null} [eventCount] CountryStat eventCount
             * @property {tdx_response.TrustTier|null} [trustTier] CountryStat trustTier
             */

            /**
             * Constructs a new CountryStat.
             * @memberof tdx_response.CountryStats
             * @classdesc Represents a CountryStat.
             * @implements ICountryStat
             * @constructor
             * @param {tdx_response.CountryStats.ICountryStat=} [properties] Properties to set
             */
            function CountryStat(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CountryStat country.
             * @member {string} country
             * @memberof tdx_response.CountryStats.CountryStat
             * @instance
             */
            CountryStat.prototype.country = "";

            /**
             * CountryStat eventCount.
             * @member {number|Long} eventCount
             * @memberof tdx_response.CountryStats.CountryStat
             * @instance
             */
            CountryStat.prototype.eventCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * CountryStat trustTier.
             * @member {tdx_response.TrustTier} trustTier
             * @memberof tdx_response.CountryStats.CountryStat
             * @instance
             */
            CountryStat.prototype.trustTier = 0;

            /**
             * Creates a new CountryStat instance using the specified properties.
             * @function create
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {tdx_response.CountryStats.ICountryStat=} [properties] Properties to set
             * @returns {tdx_response.CountryStats.CountryStat} CountryStat instance
             */
            CountryStat.create = function create(properties) {
                return new CountryStat(properties);
            };

            /**
             * Encodes the specified CountryStat message. Does not implicitly {@link tdx_response.CountryStats.CountryStat.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {tdx_response.CountryStats.ICountryStat} message CountryStat message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CountryStat.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.country);
                if (message.eventCount != null && Object.hasOwnProperty.call(message, "eventCount"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.eventCount);
                if (message.trustTier != null && Object.hasOwnProperty.call(message, "trustTier"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.trustTier);
                return writer;
            };

            /**
             * Encodes the specified CountryStat message, length delimited. Does not implicitly {@link tdx_response.CountryStats.CountryStat.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {tdx_response.CountryStats.ICountryStat} message CountryStat message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CountryStat.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CountryStat message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.CountryStats.CountryStat} CountryStat
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CountryStat.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.CountryStats.CountryStat();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.country = reader.string();
                            break;
                        }
                    case 2: {
                            message.eventCount = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.trustTier = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CountryStat message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.CountryStats.CountryStat} CountryStat
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CountryStat.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CountryStat message.
             * @function verify
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CountryStat.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.country != null && message.hasOwnProperty("country"))
                    if (!$util.isString(message.country))
                        return "country: string expected";
                if (message.eventCount != null && message.hasOwnProperty("eventCount"))
                    if (!$util.isInteger(message.eventCount) && !(message.eventCount && $util.isInteger(message.eventCount.low) && $util.isInteger(message.eventCount.high)))
                        return "eventCount: integer|Long expected";
                if (message.trustTier != null && message.hasOwnProperty("trustTier"))
                    switch (message.trustTier) {
                    default:
                        return "trustTier: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                return null;
            };

            /**
             * Creates a CountryStat message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.CountryStats.CountryStat} CountryStat
             */
            CountryStat.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.CountryStats.CountryStat)
                    return object;
                let message = new $root.tdx_response.CountryStats.CountryStat();
                if (object.country != null)
                    message.country = String(object.country);
                if (object.eventCount != null)
                    if ($util.Long)
                        (message.eventCount = $util.Long.fromValue(object.eventCount)).unsigned = true;
                    else if (typeof object.eventCount === "string")
                        message.eventCount = parseInt(object.eventCount, 10);
                    else if (typeof object.eventCount === "number")
                        message.eventCount = object.eventCount;
                    else if (typeof object.eventCount === "object")
                        message.eventCount = new $util.LongBits(object.eventCount.low >>> 0, object.eventCount.high >>> 0).toNumber(true);
                switch (object.trustTier) {
                default:
                    if (typeof object.trustTier === "number") {
                        message.trustTier = object.trustTier;
                        break;
                    }
                    break;
                case "TRUST_TIER_UNKNOWN":
                case 0:
                    message.trustTier = 0;
                    break;
                case "TRUST_TIER_TRUSTED":
                case 1:
                    message.trustTier = 1;
                    break;
                case "TRUST_TIER_FOREIGN":
                case 2:
                    message.trustTier = 2;
                    break;
                case "TRUST_TIER_BLOCKED":
                case 3:
                    message.trustTier = 3;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from a CountryStat message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {tdx_response.CountryStats.CountryStat} message CountryStat
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CountryStat.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.country = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.eventCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.eventCount = options.longs === String ? "0" : 0;
                    object.trustTier = options.enums === String ? "TRUST_TIER_UNKNOWN" : 0;
                }
                if (message.country != null && message.hasOwnProperty("country"))
                    object.country = message.country;
                if (message.eventCount != null && message.hasOwnProperty("eventCount"))
                    if (typeof message.eventCount === "number")
                        object.eventCount = options.longs === String ? String(message.eventCount) : message.eventCount;
                    else
                        object.eventCount = options.longs === String ? $util.Long.prototype.toString.call(message.eventCount) : options.longs === Number ? new $util.LongBits(message.eventCount.low >>> 0, message.eventCount.high >>> 0).toNumber(true) : message.eventCount;
                if (message.trustTier != null && message.hasOwnProperty("trustTier"))
                    object.trustTier = options.enums === String ? $root.tdx_response.TrustTier[message.trustTier] === undefined ? message.trustTier : $root.tdx_response.TrustTier[message.trustTier] : message.trustTier;
                return object;
            };

            /**
             * Converts this CountryStat to JSON.
             * @function toJSON
             * @memberof tdx_response.CountryStats.CountryStat
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CountryStat.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CountryStat
             * @function getTypeUrl
             * @memberof tdx_response.CountryStats.CountryStat
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CountryStat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.CountryStats.CountryStat";
            };

            return CountryStat;
        })();

        return CountryStats;
    })();

    tdx_response.ListFilesForDashboard = (function() {

        /**
         * Properties of a ListFilesForDashboard.
         * @memberof tdx_response
         * @interface IListFilesForDashboard
         * @property {tdx_response.Status|null} [status] ListFilesForDashboard status
         * @property {Array.<tdx_response.ListFilesForDashboard.IFileItem>|null} [files] ListFilesForDashboard files
         */

        /**
         * Constructs a new ListFilesForDashboard.
         * @memberof tdx_response
         * @classdesc Represents a ListFilesForDashboard.
         * @implements IListFilesForDashboard
         * @constructor
         * @param {tdx_response.IListFilesForDashboard=} [properties] Properties to set
         */
        function ListFilesForDashboard(properties) {
            this.files = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFilesForDashboard status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.status = 0;

        /**
         * ListFilesForDashboard files.
         * @member {Array.<tdx_response.ListFilesForDashboard.IFileItem>} files
         * @memberof tdx_response.ListFilesForDashboard
         * @instance
         */
        ListFilesForDashboard.prototype.files = $util.emptyArray;

        /**
         * Creates a new ListFilesForDashboard instance using the specified properties.
         * @function create
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {tdx_response.IListFilesForDashboard=} [properties] Properties to set
         * @returns {tdx_response.ListFilesForDashboard} ListFilesForDashboard instance
         */
        ListFilesForDashboard.create = function create(properties) {
            return new ListFilesForDashboard(properties);
        };

        /**
         * Encodes the specified ListFilesForDashboard message. Does not implicitly {@link tdx_response.ListFilesForDashboard.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {tdx_response.IListFilesForDashboard} message ListFilesForDashboard message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFilesForDashboard.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.files != null && message.files.length)
                for (let i = 0; i < message.files.length; ++i)
                    $root.tdx_response.ListFilesForDashboard.FileItem.encode(message.files[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ListFilesForDashboard message, length delimited. Does not implicitly {@link tdx_response.ListFilesForDashboard.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {tdx_response.IListFilesForDashboard} message ListFilesForDashboard message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFilesForDashboard.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListFilesForDashboard message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.ListFilesForDashboard} ListFilesForDashboard
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFilesForDashboard.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ListFilesForDashboard();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.files && message.files.length))
                            message.files = [];
                        message.files.push($root.tdx_response.ListFilesForDashboard.FileItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListFilesForDashboard message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.ListFilesForDashboard} ListFilesForDashboard
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFilesForDashboard.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListFilesForDashboard message.
         * @function verify
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListFilesForDashboard.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.files != null && message.hasOwnProperty("files")) {
                if (!Array.isArray(message.files))
                    return "files: array expected";
                for (let i = 0; i < message.files.length; ++i) {
                    let error = $root.tdx_response.ListFilesForDashboard.FileItem.verify(message.files[i]);
                    if (error)
                        return "files." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ListFilesForDashboard message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.ListFilesForDashboard} ListFilesForDashboard
         */
        ListFilesForDashboard.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.ListFilesForDashboard)
                return object;
            let message = new $root.tdx_response.ListFilesForDashboard();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.files) {
                if (!Array.isArray(object.files))
                    throw TypeError(".tdx_response.ListFilesForDashboard.files: array expected");
                message.files = [];
                for (let i = 0; i < object.files.length; ++i) {
                    if (typeof object.files[i] !== "object")
                        throw TypeError(".tdx_response.ListFilesForDashboard.files: object expected");
                    message.files[i] = $root.tdx_response.ListFilesForDashboard.FileItem.fromObject(object.files[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListFilesForDashboard message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {tdx_response.ListFilesForDashboard} message ListFilesForDashboard
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFilesForDashboard.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.files = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.files && message.files.length) {
                object.files = [];
                for (let j = 0; j < message.files.length; ++j)
                    object.files[j] = $root.tdx_response.ListFilesForDashboard.FileItem.toObject(message.files[j], options);
            }
            return object;
        };

        /**
         * Converts this ListFilesForDashboard to JSON.
         * @function toJSON
         * @memberof tdx_response.ListFilesForDashboard
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFilesForDashboard.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListFilesForDashboard
         * @function getTypeUrl
         * @memberof tdx_response.ListFilesForDashboard
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListFilesForDashboard.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.ListFilesForDashboard";
        };

        ListFilesForDashboard.FileItem = (function() {

            /**
             * Properties of a FileItem.
             * @memberof tdx_response.ListFilesForDashboard
             * @interface IFileItem
             * @property {string|null} [name] FileItem name
             * @property {string|null} [path] FileItem path
             * @property {number|null} [sizeMb] FileItem sizeMb
             * @property {string|null} [fileType] FileItem fileType
             * @property {string|null} [ownerEmail] FileItem ownerEmail
             * @property {number|Long|null} [updatedAt] FileItem updatedAt
             * @property {boolean|null} [isFolder] FileItem isFolder
             * @property {string|null} [uuid] FileItem uuid
             */

            /**
             * Constructs a new FileItem.
             * @memberof tdx_response.ListFilesForDashboard
             * @classdesc Represents a FileItem.
             * @implements IFileItem
             * @constructor
             * @param {tdx_response.ListFilesForDashboard.IFileItem=} [properties] Properties to set
             */
            function FileItem(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileItem name.
             * @member {string} name
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.name = "";

            /**
             * FileItem path.
             * @member {string} path
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.path = "";

            /**
             * FileItem sizeMb.
             * @member {number} sizeMb
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.sizeMb = 0;

            /**
             * FileItem fileType.
             * @member {string} fileType
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.fileType = "";

            /**
             * FileItem ownerEmail.
             * @member {string} ownerEmail
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.ownerEmail = "";

            /**
             * FileItem updatedAt.
             * @member {number|Long} updatedAt
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * FileItem isFolder.
             * @member {boolean} isFolder
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.isFolder = false;

            /**
             * FileItem uuid.
             * @member {string} uuid
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             */
            FileItem.prototype.uuid = "";

            /**
             * Creates a new FileItem instance using the specified properties.
             * @function create
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {tdx_response.ListFilesForDashboard.IFileItem=} [properties] Properties to set
             * @returns {tdx_response.ListFilesForDashboard.FileItem} FileItem instance
             */
            FileItem.create = function create(properties) {
                return new FileItem(properties);
            };

            /**
             * Encodes the specified FileItem message. Does not implicitly {@link tdx_response.ListFilesForDashboard.FileItem.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {tdx_response.ListFilesForDashboard.IFileItem} message FileItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileItem.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                if (message.sizeMb != null && Object.hasOwnProperty.call(message, "sizeMb"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.sizeMb);
                if (message.fileType != null && Object.hasOwnProperty.call(message, "fileType"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.fileType);
                if (message.ownerEmail != null && Object.hasOwnProperty.call(message, "ownerEmail"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.ownerEmail);
                if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.updatedAt);
                if (message.isFolder != null && Object.hasOwnProperty.call(message, "isFolder"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isFolder);
                if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.uuid);
                return writer;
            };

            /**
             * Encodes the specified FileItem message, length delimited. Does not implicitly {@link tdx_response.ListFilesForDashboard.FileItem.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {tdx_response.ListFilesForDashboard.IFileItem} message FileItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileItem.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileItem message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.ListFilesForDashboard.FileItem} FileItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileItem.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ListFilesForDashboard.FileItem();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.name = reader.string();
                            break;
                        }
                    case 2: {
                            message.path = reader.string();
                            break;
                        }
                    case 3: {
                            message.sizeMb = reader.double();
                            break;
                        }
                    case 4: {
                            message.fileType = reader.string();
                            break;
                        }
                    case 5: {
                            message.ownerEmail = reader.string();
                            break;
                        }
                    case 6: {
                            message.updatedAt = reader.int64();
                            break;
                        }
                    case 7: {
                            message.isFolder = reader.bool();
                            break;
                        }
                    case 8: {
                            message.uuid = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileItem message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.ListFilesForDashboard.FileItem} FileItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileItem.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileItem message.
             * @function verify
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileItem.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.path != null && message.hasOwnProperty("path"))
                    if (!$util.isString(message.path))
                        return "path: string expected";
                if (message.sizeMb != null && message.hasOwnProperty("sizeMb"))
                    if (typeof message.sizeMb !== "number")
                        return "sizeMb: number expected";
                if (message.fileType != null && message.hasOwnProperty("fileType"))
                    if (!$util.isString(message.fileType))
                        return "fileType: string expected";
                if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                    if (!$util.isString(message.ownerEmail))
                        return "ownerEmail: string expected";
                if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                    if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                        return "updatedAt: integer|Long expected";
                if (message.isFolder != null && message.hasOwnProperty("isFolder"))
                    if (typeof message.isFolder !== "boolean")
                        return "isFolder: boolean expected";
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    if (!$util.isString(message.uuid))
                        return "uuid: string expected";
                return null;
            };

            /**
             * Creates a FileItem message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.ListFilesForDashboard.FileItem} FileItem
             */
            FileItem.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.ListFilesForDashboard.FileItem)
                    return object;
                let message = new $root.tdx_response.ListFilesForDashboard.FileItem();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.path != null)
                    message.path = String(object.path);
                if (object.sizeMb != null)
                    message.sizeMb = Number(object.sizeMb);
                if (object.fileType != null)
                    message.fileType = String(object.fileType);
                if (object.ownerEmail != null)
                    message.ownerEmail = String(object.ownerEmail);
                if (object.updatedAt != null)
                    if ($util.Long)
                        (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                    else if (typeof object.updatedAt === "string")
                        message.updatedAt = parseInt(object.updatedAt, 10);
                    else if (typeof object.updatedAt === "number")
                        message.updatedAt = object.updatedAt;
                    else if (typeof object.updatedAt === "object")
                        message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
                if (object.isFolder != null)
                    message.isFolder = Boolean(object.isFolder);
                if (object.uuid != null)
                    message.uuid = String(object.uuid);
                return message;
            };

            /**
             * Creates a plain object from a FileItem message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {tdx_response.ListFilesForDashboard.FileItem} message FileItem
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileItem.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.name = "";
                    object.path = "";
                    object.sizeMb = 0;
                    object.fileType = "";
                    object.ownerEmail = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.updatedAt = options.longs === String ? "0" : 0;
                    object.isFolder = false;
                    object.uuid = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.path != null && message.hasOwnProperty("path"))
                    object.path = message.path;
                if (message.sizeMb != null && message.hasOwnProperty("sizeMb"))
                    object.sizeMb = options.json && !isFinite(message.sizeMb) ? String(message.sizeMb) : message.sizeMb;
                if (message.fileType != null && message.hasOwnProperty("fileType"))
                    object.fileType = message.fileType;
                if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                    object.ownerEmail = message.ownerEmail;
                if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                    if (typeof message.updatedAt === "number")
                        object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                    else
                        object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
                if (message.isFolder != null && message.hasOwnProperty("isFolder"))
                    object.isFolder = message.isFolder;
                if (message.uuid != null && message.hasOwnProperty("uuid"))
                    object.uuid = message.uuid;
                return object;
            };

            /**
             * Converts this FileItem to JSON.
             * @function toJSON
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileItem.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for FileItem
             * @function getTypeUrl
             * @memberof tdx_response.ListFilesForDashboard.FileItem
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            FileItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.ListFilesForDashboard.FileItem";
            };

            return FileItem;
        })();

        return ListFilesForDashboard;
    })();

    tdx_response.OperationCountOverTime = (function() {

        /**
         * Properties of an OperationCountOverTime.
         * @memberof tdx_response
         * @interface IOperationCountOverTime
         * @property {tdx_response.Status|null} [status] OperationCountOverTime status
         * @property {Array.<tdx_response.OperationCountOverTime.IOperationCount>|null} [operationCount] OperationCountOverTime operationCount
         */

        /**
         * Constructs a new OperationCountOverTime.
         * @memberof tdx_response
         * @classdesc Represents an OperationCountOverTime.
         * @implements IOperationCountOverTime
         * @constructor
         * @param {tdx_response.IOperationCountOverTime=} [properties] Properties to set
         */
        function OperationCountOverTime(properties) {
            this.operationCount = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OperationCountOverTime status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.OperationCountOverTime
         * @instance
         */
        OperationCountOverTime.prototype.status = 0;

        /**
         * OperationCountOverTime operationCount.
         * @member {Array.<tdx_response.OperationCountOverTime.IOperationCount>} operationCount
         * @memberof tdx_response.OperationCountOverTime
         * @instance
         */
        OperationCountOverTime.prototype.operationCount = $util.emptyArray;

        /**
         * Creates a new OperationCountOverTime instance using the specified properties.
         * @function create
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {tdx_response.IOperationCountOverTime=} [properties] Properties to set
         * @returns {tdx_response.OperationCountOverTime} OperationCountOverTime instance
         */
        OperationCountOverTime.create = function create(properties) {
            return new OperationCountOverTime(properties);
        };

        /**
         * Encodes the specified OperationCountOverTime message. Does not implicitly {@link tdx_response.OperationCountOverTime.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {tdx_response.IOperationCountOverTime} message OperationCountOverTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperationCountOverTime.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.operationCount != null && message.operationCount.length)
                for (let i = 0; i < message.operationCount.length; ++i)
                    $root.tdx_response.OperationCountOverTime.OperationCount.encode(message.operationCount[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OperationCountOverTime message, length delimited. Does not implicitly {@link tdx_response.OperationCountOverTime.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {tdx_response.IOperationCountOverTime} message OperationCountOverTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperationCountOverTime.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OperationCountOverTime message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.OperationCountOverTime} OperationCountOverTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperationCountOverTime.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.OperationCountOverTime();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.operationCount && message.operationCount.length))
                            message.operationCount = [];
                        message.operationCount.push($root.tdx_response.OperationCountOverTime.OperationCount.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OperationCountOverTime message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.OperationCountOverTime} OperationCountOverTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperationCountOverTime.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OperationCountOverTime message.
         * @function verify
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OperationCountOverTime.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.operationCount != null && message.hasOwnProperty("operationCount")) {
                if (!Array.isArray(message.operationCount))
                    return "operationCount: array expected";
                for (let i = 0; i < message.operationCount.length; ++i) {
                    let error = $root.tdx_response.OperationCountOverTime.OperationCount.verify(message.operationCount[i]);
                    if (error)
                        return "operationCount." + error;
                }
            }
            return null;
        };

        /**
         * Creates an OperationCountOverTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.OperationCountOverTime} OperationCountOverTime
         */
        OperationCountOverTime.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.OperationCountOverTime)
                return object;
            let message = new $root.tdx_response.OperationCountOverTime();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.operationCount) {
                if (!Array.isArray(object.operationCount))
                    throw TypeError(".tdx_response.OperationCountOverTime.operationCount: array expected");
                message.operationCount = [];
                for (let i = 0; i < object.operationCount.length; ++i) {
                    if (typeof object.operationCount[i] !== "object")
                        throw TypeError(".tdx_response.OperationCountOverTime.operationCount: object expected");
                    message.operationCount[i] = $root.tdx_response.OperationCountOverTime.OperationCount.fromObject(object.operationCount[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an OperationCountOverTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {tdx_response.OperationCountOverTime} message OperationCountOverTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OperationCountOverTime.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.operationCount = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.operationCount && message.operationCount.length) {
                object.operationCount = [];
                for (let j = 0; j < message.operationCount.length; ++j)
                    object.operationCount[j] = $root.tdx_response.OperationCountOverTime.OperationCount.toObject(message.operationCount[j], options);
            }
            return object;
        };

        /**
         * Converts this OperationCountOverTime to JSON.
         * @function toJSON
         * @memberof tdx_response.OperationCountOverTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OperationCountOverTime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OperationCountOverTime
         * @function getTypeUrl
         * @memberof tdx_response.OperationCountOverTime
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OperationCountOverTime.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.OperationCountOverTime";
        };

        OperationCountOverTime.OperationCount = (function() {

            /**
             * Properties of an OperationCount.
             * @memberof tdx_response.OperationCountOverTime
             * @interface IOperationCount
             * @property {string|null} [operation] OperationCount operation
             * @property {Array.<number|Long>|null} [date] OperationCount date
             * @property {Array.<number|Long>|null} [count] OperationCount count
             * @property {Array.<number|Long>|null} [deniedCount] OperationCount deniedCount
             */

            /**
             * Constructs a new OperationCount.
             * @memberof tdx_response.OperationCountOverTime
             * @classdesc Represents an OperationCount.
             * @implements IOperationCount
             * @constructor
             * @param {tdx_response.OperationCountOverTime.IOperationCount=} [properties] Properties to set
             */
            function OperationCount(properties) {
                this.date = [];
                this.count = [];
                this.deniedCount = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OperationCount operation.
             * @member {string} operation
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @instance
             */
            OperationCount.prototype.operation = "";

            /**
             * OperationCount date.
             * @member {Array.<number|Long>} date
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @instance
             */
            OperationCount.prototype.date = $util.emptyArray;

            /**
             * OperationCount count.
             * @member {Array.<number|Long>} count
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @instance
             */
            OperationCount.prototype.count = $util.emptyArray;

            /**
             * OperationCount deniedCount.
             * @member {Array.<number|Long>} deniedCount
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @instance
             */
            OperationCount.prototype.deniedCount = $util.emptyArray;

            /**
             * Creates a new OperationCount instance using the specified properties.
             * @function create
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {tdx_response.OperationCountOverTime.IOperationCount=} [properties] Properties to set
             * @returns {tdx_response.OperationCountOverTime.OperationCount} OperationCount instance
             */
            OperationCount.create = function create(properties) {
                return new OperationCount(properties);
            };

            /**
             * Encodes the specified OperationCount message. Does not implicitly {@link tdx_response.OperationCountOverTime.OperationCount.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {tdx_response.OperationCountOverTime.IOperationCount} message OperationCount message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperationCount.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.operation);
                if (message.date != null && message.date.length) {
                    writer.uint32(/* id 2, wireType 2 =*/18).fork();
                    for (let i = 0; i < message.date.length; ++i)
                        writer.int64(message.date[i]);
                    writer.ldelim();
                }
                if (message.count != null && message.count.length) {
                    writer.uint32(/* id 3, wireType 2 =*/26).fork();
                    for (let i = 0; i < message.count.length; ++i)
                        writer.int64(message.count[i]);
                    writer.ldelim();
                }
                if (message.deniedCount != null && message.deniedCount.length) {
                    writer.uint32(/* id 4, wireType 2 =*/34).fork();
                    for (let i = 0; i < message.deniedCount.length; ++i)
                        writer.int64(message.deniedCount[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified OperationCount message, length delimited. Does not implicitly {@link tdx_response.OperationCountOverTime.OperationCount.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {tdx_response.OperationCountOverTime.IOperationCount} message OperationCount message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OperationCount.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OperationCount message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.OperationCountOverTime.OperationCount} OperationCount
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperationCount.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.OperationCountOverTime.OperationCount();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.operation = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.date && message.date.length))
                                message.date = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.date.push(reader.int64());
                            } else
                                message.date.push(reader.int64());
                            break;
                        }
                    case 3: {
                            if (!(message.count && message.count.length))
                                message.count = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.count.push(reader.int64());
                            } else
                                message.count.push(reader.int64());
                            break;
                        }
                    case 4: {
                            if (!(message.deniedCount && message.deniedCount.length))
                                message.deniedCount = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.deniedCount.push(reader.int64());
                            } else
                                message.deniedCount.push(reader.int64());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OperationCount message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.OperationCountOverTime.OperationCount} OperationCount
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OperationCount.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OperationCount message.
             * @function verify
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OperationCount.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.date != null && message.hasOwnProperty("date")) {
                    if (!Array.isArray(message.date))
                        return "date: array expected";
                    for (let i = 0; i < message.date.length; ++i)
                        if (!$util.isInteger(message.date[i]) && !(message.date[i] && $util.isInteger(message.date[i].low) && $util.isInteger(message.date[i].high)))
                            return "date: integer|Long[] expected";
                }
                if (message.count != null && message.hasOwnProperty("count")) {
                    if (!Array.isArray(message.count))
                        return "count: array expected";
                    for (let i = 0; i < message.count.length; ++i)
                        if (!$util.isInteger(message.count[i]) && !(message.count[i] && $util.isInteger(message.count[i].low) && $util.isInteger(message.count[i].high)))
                            return "count: integer|Long[] expected";
                }
                if (message.deniedCount != null && message.hasOwnProperty("deniedCount")) {
                    if (!Array.isArray(message.deniedCount))
                        return "deniedCount: array expected";
                    for (let i = 0; i < message.deniedCount.length; ++i)
                        if (!$util.isInteger(message.deniedCount[i]) && !(message.deniedCount[i] && $util.isInteger(message.deniedCount[i].low) && $util.isInteger(message.deniedCount[i].high)))
                            return "deniedCount: integer|Long[] expected";
                }
                return null;
            };

            /**
             * Creates an OperationCount message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.OperationCountOverTime.OperationCount} OperationCount
             */
            OperationCount.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.OperationCountOverTime.OperationCount)
                    return object;
                let message = new $root.tdx_response.OperationCountOverTime.OperationCount();
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.date) {
                    if (!Array.isArray(object.date))
                        throw TypeError(".tdx_response.OperationCountOverTime.OperationCount.date: array expected");
                    message.date = [];
                    for (let i = 0; i < object.date.length; ++i)
                        if ($util.Long)
                            (message.date[i] = $util.Long.fromValue(object.date[i])).unsigned = false;
                        else if (typeof object.date[i] === "string")
                            message.date[i] = parseInt(object.date[i], 10);
                        else if (typeof object.date[i] === "number")
                            message.date[i] = object.date[i];
                        else if (typeof object.date[i] === "object")
                            message.date[i] = new $util.LongBits(object.date[i].low >>> 0, object.date[i].high >>> 0).toNumber();
                }
                if (object.count) {
                    if (!Array.isArray(object.count))
                        throw TypeError(".tdx_response.OperationCountOverTime.OperationCount.count: array expected");
                    message.count = [];
                    for (let i = 0; i < object.count.length; ++i)
                        if ($util.Long)
                            (message.count[i] = $util.Long.fromValue(object.count[i])).unsigned = false;
                        else if (typeof object.count[i] === "string")
                            message.count[i] = parseInt(object.count[i], 10);
                        else if (typeof object.count[i] === "number")
                            message.count[i] = object.count[i];
                        else if (typeof object.count[i] === "object")
                            message.count[i] = new $util.LongBits(object.count[i].low >>> 0, object.count[i].high >>> 0).toNumber();
                }
                if (object.deniedCount) {
                    if (!Array.isArray(object.deniedCount))
                        throw TypeError(".tdx_response.OperationCountOverTime.OperationCount.deniedCount: array expected");
                    message.deniedCount = [];
                    for (let i = 0; i < object.deniedCount.length; ++i)
                        if ($util.Long)
                            (message.deniedCount[i] = $util.Long.fromValue(object.deniedCount[i])).unsigned = false;
                        else if (typeof object.deniedCount[i] === "string")
                            message.deniedCount[i] = parseInt(object.deniedCount[i], 10);
                        else if (typeof object.deniedCount[i] === "number")
                            message.deniedCount[i] = object.deniedCount[i];
                        else if (typeof object.deniedCount[i] === "object")
                            message.deniedCount[i] = new $util.LongBits(object.deniedCount[i].low >>> 0, object.deniedCount[i].high >>> 0).toNumber();
                }
                return message;
            };

            /**
             * Creates a plain object from an OperationCount message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {tdx_response.OperationCountOverTime.OperationCount} message OperationCount
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OperationCount.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.date = [];
                    object.count = [];
                    object.deniedCount = [];
                }
                if (options.defaults)
                    object.operation = "";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.date && message.date.length) {
                    object.date = [];
                    for (let j = 0; j < message.date.length; ++j)
                        if (typeof message.date[j] === "number")
                            object.date[j] = options.longs === String ? String(message.date[j]) : message.date[j];
                        else
                            object.date[j] = options.longs === String ? $util.Long.prototype.toString.call(message.date[j]) : options.longs === Number ? new $util.LongBits(message.date[j].low >>> 0, message.date[j].high >>> 0).toNumber() : message.date[j];
                }
                if (message.count && message.count.length) {
                    object.count = [];
                    for (let j = 0; j < message.count.length; ++j)
                        if (typeof message.count[j] === "number")
                            object.count[j] = options.longs === String ? String(message.count[j]) : message.count[j];
                        else
                            object.count[j] = options.longs === String ? $util.Long.prototype.toString.call(message.count[j]) : options.longs === Number ? new $util.LongBits(message.count[j].low >>> 0, message.count[j].high >>> 0).toNumber() : message.count[j];
                }
                if (message.deniedCount && message.deniedCount.length) {
                    object.deniedCount = [];
                    for (let j = 0; j < message.deniedCount.length; ++j)
                        if (typeof message.deniedCount[j] === "number")
                            object.deniedCount[j] = options.longs === String ? String(message.deniedCount[j]) : message.deniedCount[j];
                        else
                            object.deniedCount[j] = options.longs === String ? $util.Long.prototype.toString.call(message.deniedCount[j]) : options.longs === Number ? new $util.LongBits(message.deniedCount[j].low >>> 0, message.deniedCount[j].high >>> 0).toNumber() : message.deniedCount[j];
                }
                return object;
            };

            /**
             * Converts this OperationCount to JSON.
             * @function toJSON
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OperationCount.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OperationCount
             * @function getTypeUrl
             * @memberof tdx_response.OperationCountOverTime.OperationCount
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OperationCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.OperationCountOverTime.OperationCount";
            };

            return OperationCount;
        })();

        return OperationCountOverTime;
    })();

    tdx_response.StorageDistribution = (function() {

        /**
         * Properties of a StorageDistribution.
         * @memberof tdx_response
         * @interface IStorageDistribution
         * @property {tdx_response.Status|null} [status] StorageDistribution status
         * @property {Array.<tdx_response.StorageDistribution.IStorageItem>|null} [storageItem] StorageDistribution storageItem
         */

        /**
         * Constructs a new StorageDistribution.
         * @memberof tdx_response
         * @classdesc Represents a StorageDistribution.
         * @implements IStorageDistribution
         * @constructor
         * @param {tdx_response.IStorageDistribution=} [properties] Properties to set
         */
        function StorageDistribution(properties) {
            this.storageItem = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StorageDistribution status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.StorageDistribution
         * @instance
         */
        StorageDistribution.prototype.status = 0;

        /**
         * StorageDistribution storageItem.
         * @member {Array.<tdx_response.StorageDistribution.IStorageItem>} storageItem
         * @memberof tdx_response.StorageDistribution
         * @instance
         */
        StorageDistribution.prototype.storageItem = $util.emptyArray;

        /**
         * Creates a new StorageDistribution instance using the specified properties.
         * @function create
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {tdx_response.IStorageDistribution=} [properties] Properties to set
         * @returns {tdx_response.StorageDistribution} StorageDistribution instance
         */
        StorageDistribution.create = function create(properties) {
            return new StorageDistribution(properties);
        };

        /**
         * Encodes the specified StorageDistribution message. Does not implicitly {@link tdx_response.StorageDistribution.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {tdx_response.IStorageDistribution} message StorageDistribution message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageDistribution.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.storageItem != null && message.storageItem.length)
                for (let i = 0; i < message.storageItem.length; ++i)
                    $root.tdx_response.StorageDistribution.StorageItem.encode(message.storageItem[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified StorageDistribution message, length delimited. Does not implicitly {@link tdx_response.StorageDistribution.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {tdx_response.IStorageDistribution} message StorageDistribution message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageDistribution.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StorageDistribution message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.StorageDistribution} StorageDistribution
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageDistribution.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.StorageDistribution();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.storageItem && message.storageItem.length))
                            message.storageItem = [];
                        message.storageItem.push($root.tdx_response.StorageDistribution.StorageItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StorageDistribution message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.StorageDistribution} StorageDistribution
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageDistribution.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StorageDistribution message.
         * @function verify
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StorageDistribution.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.storageItem != null && message.hasOwnProperty("storageItem")) {
                if (!Array.isArray(message.storageItem))
                    return "storageItem: array expected";
                for (let i = 0; i < message.storageItem.length; ++i) {
                    let error = $root.tdx_response.StorageDistribution.StorageItem.verify(message.storageItem[i]);
                    if (error)
                        return "storageItem." + error;
                }
            }
            return null;
        };

        /**
         * Creates a StorageDistribution message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.StorageDistribution} StorageDistribution
         */
        StorageDistribution.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.StorageDistribution)
                return object;
            let message = new $root.tdx_response.StorageDistribution();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.storageItem) {
                if (!Array.isArray(object.storageItem))
                    throw TypeError(".tdx_response.StorageDistribution.storageItem: array expected");
                message.storageItem = [];
                for (let i = 0; i < object.storageItem.length; ++i) {
                    if (typeof object.storageItem[i] !== "object")
                        throw TypeError(".tdx_response.StorageDistribution.storageItem: object expected");
                    message.storageItem[i] = $root.tdx_response.StorageDistribution.StorageItem.fromObject(object.storageItem[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a StorageDistribution message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {tdx_response.StorageDistribution} message StorageDistribution
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StorageDistribution.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.storageItem = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.storageItem && message.storageItem.length) {
                object.storageItem = [];
                for (let j = 0; j < message.storageItem.length; ++j)
                    object.storageItem[j] = $root.tdx_response.StorageDistribution.StorageItem.toObject(message.storageItem[j], options);
            }
            return object;
        };

        /**
         * Converts this StorageDistribution to JSON.
         * @function toJSON
         * @memberof tdx_response.StorageDistribution
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StorageDistribution.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StorageDistribution
         * @function getTypeUrl
         * @memberof tdx_response.StorageDistribution
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StorageDistribution.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.StorageDistribution";
        };

        StorageDistribution.StorageItem = (function() {

            /**
             * Properties of a StorageItem.
             * @memberof tdx_response.StorageDistribution
             * @interface IStorageItem
             * @property {string|null} [type] StorageItem type
             * @property {number|Long|null} [size] StorageItem size
             * @property {number|Long|null} [count] StorageItem count
             */

            /**
             * Constructs a new StorageItem.
             * @memberof tdx_response.StorageDistribution
             * @classdesc Represents a StorageItem.
             * @implements IStorageItem
             * @constructor
             * @param {tdx_response.StorageDistribution.IStorageItem=} [properties] Properties to set
             */
            function StorageItem(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StorageItem type.
             * @member {string} type
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @instance
             */
            StorageItem.prototype.type = "";

            /**
             * StorageItem size.
             * @member {number|Long} size
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @instance
             */
            StorageItem.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * StorageItem count.
             * @member {number|Long} count
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @instance
             */
            StorageItem.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new StorageItem instance using the specified properties.
             * @function create
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {tdx_response.StorageDistribution.IStorageItem=} [properties] Properties to set
             * @returns {tdx_response.StorageDistribution.StorageItem} StorageItem instance
             */
            StorageItem.create = function create(properties) {
                return new StorageItem(properties);
            };

            /**
             * Encodes the specified StorageItem message. Does not implicitly {@link tdx_response.StorageDistribution.StorageItem.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {tdx_response.StorageDistribution.IStorageItem} message StorageItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StorageItem.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.size);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.count);
                return writer;
            };

            /**
             * Encodes the specified StorageItem message, length delimited. Does not implicitly {@link tdx_response.StorageDistribution.StorageItem.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {tdx_response.StorageDistribution.IStorageItem} message StorageItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StorageItem.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StorageItem message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.StorageDistribution.StorageItem} StorageItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StorageItem.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.StorageDistribution.StorageItem();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.type = reader.string();
                            break;
                        }
                    case 2: {
                            message.size = reader.int64();
                            break;
                        }
                    case 3: {
                            message.count = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StorageItem message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.StorageDistribution.StorageItem} StorageItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StorageItem.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StorageItem message.
             * @function verify
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StorageItem.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                        return "count: integer|Long expected";
                return null;
            };

            /**
             * Creates a StorageItem message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.StorageDistribution.StorageItem} StorageItem
             */
            StorageItem.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.StorageDistribution.StorageItem)
                    return object;
                let message = new $root.tdx_response.StorageDistribution.StorageItem();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
                if (object.count != null)
                    if ($util.Long)
                        (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                    else if (typeof object.count === "string")
                        message.count = parseInt(object.count, 10);
                    else if (typeof object.count === "number")
                        message.count = object.count;
                    else if (typeof object.count === "object")
                        message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a StorageItem message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {tdx_response.StorageDistribution.StorageItem} message StorageItem
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StorageItem.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.type = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.count = options.longs === String ? "0" : 0;
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
                if (message.count != null && message.hasOwnProperty("count"))
                    if (typeof message.count === "number")
                        object.count = options.longs === String ? String(message.count) : message.count;
                    else
                        object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
                return object;
            };

            /**
             * Converts this StorageItem to JSON.
             * @function toJSON
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StorageItem.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StorageItem
             * @function getTypeUrl
             * @memberof tdx_response.StorageDistribution.StorageItem
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StorageItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.StorageDistribution.StorageItem";
            };

            return StorageItem;
        })();

        return StorageDistribution;
    })();

    tdx_response.AccessByLocation = (function() {

        /**
         * Properties of an AccessByLocation.
         * @memberof tdx_response
         * @interface IAccessByLocation
         * @property {tdx_response.Status|null} [status] AccessByLocation status
         * @property {Array.<tdx_response.AccessByLocation.IItem>|null} [items] AccessByLocation items
         */

        /**
         * Constructs a new AccessByLocation.
         * @memberof tdx_response
         * @classdesc Represents an AccessByLocation.
         * @implements IAccessByLocation
         * @constructor
         * @param {tdx_response.IAccessByLocation=} [properties] Properties to set
         */
        function AccessByLocation(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AccessByLocation status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.AccessByLocation
         * @instance
         */
        AccessByLocation.prototype.status = 0;

        /**
         * AccessByLocation items.
         * @member {Array.<tdx_response.AccessByLocation.IItem>} items
         * @memberof tdx_response.AccessByLocation
         * @instance
         */
        AccessByLocation.prototype.items = $util.emptyArray;

        /**
         * Creates a new AccessByLocation instance using the specified properties.
         * @function create
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {tdx_response.IAccessByLocation=} [properties] Properties to set
         * @returns {tdx_response.AccessByLocation} AccessByLocation instance
         */
        AccessByLocation.create = function create(properties) {
            return new AccessByLocation(properties);
        };

        /**
         * Encodes the specified AccessByLocation message. Does not implicitly {@link tdx_response.AccessByLocation.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {tdx_response.IAccessByLocation} message AccessByLocation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AccessByLocation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.AccessByLocation.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AccessByLocation message, length delimited. Does not implicitly {@link tdx_response.AccessByLocation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {tdx_response.IAccessByLocation} message AccessByLocation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AccessByLocation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AccessByLocation message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.AccessByLocation} AccessByLocation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AccessByLocation.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.AccessByLocation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.AccessByLocation.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AccessByLocation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.AccessByLocation} AccessByLocation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AccessByLocation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AccessByLocation message.
         * @function verify
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AccessByLocation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.AccessByLocation.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an AccessByLocation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.AccessByLocation} AccessByLocation
         */
        AccessByLocation.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.AccessByLocation)
                return object;
            let message = new $root.tdx_response.AccessByLocation();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.AccessByLocation.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.AccessByLocation.items: object expected");
                    message.items[i] = $root.tdx_response.AccessByLocation.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AccessByLocation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {tdx_response.AccessByLocation} message AccessByLocation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AccessByLocation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.AccessByLocation.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this AccessByLocation to JSON.
         * @function toJSON
         * @memberof tdx_response.AccessByLocation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AccessByLocation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AccessByLocation
         * @function getTypeUrl
         * @memberof tdx_response.AccessByLocation
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AccessByLocation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.AccessByLocation";
        };

        AccessByLocation.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.AccessByLocation
             * @interface IItem
             * @property {string|null} [location] Item location
             * @property {string|null} [country] Item country
             * @property {number|Long|null} [eventsCount] Item eventsCount
             * @property {number|null} [usersCount] Item usersCount
             * @property {tdx_response.AccessByLocation.Item.LocationStatus|null} [locationStatus] Item locationStatus
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.AccessByLocation
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.AccessByLocation.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item location.
             * @member {string} location
             * @memberof tdx_response.AccessByLocation.Item
             * @instance
             */
            Item.prototype.location = "";

            /**
             * Item country.
             * @member {string} country
             * @memberof tdx_response.AccessByLocation.Item
             * @instance
             */
            Item.prototype.country = "";

            /**
             * Item eventsCount.
             * @member {number|Long} eventsCount
             * @memberof tdx_response.AccessByLocation.Item
             * @instance
             */
            Item.prototype.eventsCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Item usersCount.
             * @member {number} usersCount
             * @memberof tdx_response.AccessByLocation.Item
             * @instance
             */
            Item.prototype.usersCount = 0;

            /**
             * Item locationStatus.
             * @member {tdx_response.AccessByLocation.Item.LocationStatus} locationStatus
             * @memberof tdx_response.AccessByLocation.Item
             * @instance
             */
            Item.prototype.locationStatus = 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {tdx_response.AccessByLocation.IItem=} [properties] Properties to set
             * @returns {tdx_response.AccessByLocation.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.AccessByLocation.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {tdx_response.AccessByLocation.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.location);
                if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.country);
                if (message.eventsCount != null && Object.hasOwnProperty.call(message, "eventsCount"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.eventsCount);
                if (message.usersCount != null && Object.hasOwnProperty.call(message, "usersCount"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.usersCount);
                if (message.locationStatus != null && Object.hasOwnProperty.call(message, "locationStatus"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.locationStatus);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.AccessByLocation.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {tdx_response.AccessByLocation.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.AccessByLocation.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.AccessByLocation.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 2: {
                            message.location = reader.string();
                            break;
                        }
                    case 3: {
                            message.country = reader.string();
                            break;
                        }
                    case 4: {
                            message.eventsCount = reader.int64();
                            break;
                        }
                    case 5: {
                            message.usersCount = reader.int32();
                            break;
                        }
                    case 6: {
                            message.locationStatus = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.AccessByLocation.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.location != null && message.hasOwnProperty("location"))
                    if (!$util.isString(message.location))
                        return "location: string expected";
                if (message.country != null && message.hasOwnProperty("country"))
                    if (!$util.isString(message.country))
                        return "country: string expected";
                if (message.eventsCount != null && message.hasOwnProperty("eventsCount"))
                    if (!$util.isInteger(message.eventsCount) && !(message.eventsCount && $util.isInteger(message.eventsCount.low) && $util.isInteger(message.eventsCount.high)))
                        return "eventsCount: integer|Long expected";
                if (message.usersCount != null && message.hasOwnProperty("usersCount"))
                    if (!$util.isInteger(message.usersCount))
                        return "usersCount: integer expected";
                if (message.locationStatus != null && message.hasOwnProperty("locationStatus"))
                    switch (message.locationStatus) {
                    default:
                        return "locationStatus: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.AccessByLocation.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.AccessByLocation.Item)
                    return object;
                let message = new $root.tdx_response.AccessByLocation.Item();
                if (object.location != null)
                    message.location = String(object.location);
                if (object.country != null)
                    message.country = String(object.country);
                if (object.eventsCount != null)
                    if ($util.Long)
                        (message.eventsCount = $util.Long.fromValue(object.eventsCount)).unsigned = false;
                    else if (typeof object.eventsCount === "string")
                        message.eventsCount = parseInt(object.eventsCount, 10);
                    else if (typeof object.eventsCount === "number")
                        message.eventsCount = object.eventsCount;
                    else if (typeof object.eventsCount === "object")
                        message.eventsCount = new $util.LongBits(object.eventsCount.low >>> 0, object.eventsCount.high >>> 0).toNumber();
                if (object.usersCount != null)
                    message.usersCount = object.usersCount | 0;
                switch (object.locationStatus) {
                default:
                    if (typeof object.locationStatus === "number") {
                        message.locationStatus = object.locationStatus;
                        break;
                    }
                    break;
                case "TRUSTED":
                case 0:
                    message.locationStatus = 0;
                    break;
                case "ALLOWED":
                case 1:
                    message.locationStatus = 1;
                    break;
                case "UNTRUSTED":
                case 2:
                    message.locationStatus = 2;
                    break;
                }
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {tdx_response.AccessByLocation.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.location = "";
                    object.country = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.eventsCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.eventsCount = options.longs === String ? "0" : 0;
                    object.usersCount = 0;
                    object.locationStatus = options.enums === String ? "TRUSTED" : 0;
                }
                if (message.location != null && message.hasOwnProperty("location"))
                    object.location = message.location;
                if (message.country != null && message.hasOwnProperty("country"))
                    object.country = message.country;
                if (message.eventsCount != null && message.hasOwnProperty("eventsCount"))
                    if (typeof message.eventsCount === "number")
                        object.eventsCount = options.longs === String ? String(message.eventsCount) : message.eventsCount;
                    else
                        object.eventsCount = options.longs === String ? $util.Long.prototype.toString.call(message.eventsCount) : options.longs === Number ? new $util.LongBits(message.eventsCount.low >>> 0, message.eventsCount.high >>> 0).toNumber() : message.eventsCount;
                if (message.usersCount != null && message.hasOwnProperty("usersCount"))
                    object.usersCount = message.usersCount;
                if (message.locationStatus != null && message.hasOwnProperty("locationStatus"))
                    object.locationStatus = options.enums === String ? $root.tdx_response.AccessByLocation.Item.LocationStatus[message.locationStatus] === undefined ? message.locationStatus : $root.tdx_response.AccessByLocation.Item.LocationStatus[message.locationStatus] : message.locationStatus;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.AccessByLocation.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.AccessByLocation.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.AccessByLocation.Item";
            };

            /**
             * LocationStatus enum.
             * @name tdx_response.AccessByLocation.Item.LocationStatus
             * @enum {number}
             * @property {number} TRUSTED=0 TRUSTED value
             * @property {number} ALLOWED=1 ALLOWED value
             * @property {number} UNTRUSTED=2 UNTRUSTED value
             */
            Item.LocationStatus = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TRUSTED"] = 0;
                values[valuesById[1] = "ALLOWED"] = 1;
                values[valuesById[2] = "UNTRUSTED"] = 2;
                return values;
            })();

            return Item;
        })();

        return AccessByLocation;
    })();

    tdx_response.ExternalShareTopUsers = (function() {

        /**
         * Properties of an ExternalShareTopUsers.
         * @memberof tdx_response
         * @interface IExternalShareTopUsers
         * @property {tdx_response.Status|null} [status] ExternalShareTopUsers status
         * @property {Array.<tdx_response.ExternalShareTopUsers.IItem>|null} [items] ExternalShareTopUsers items
         */

        /**
         * Constructs a new ExternalShareTopUsers.
         * @memberof tdx_response
         * @classdesc Represents an ExternalShareTopUsers.
         * @implements IExternalShareTopUsers
         * @constructor
         * @param {tdx_response.IExternalShareTopUsers=} [properties] Properties to set
         */
        function ExternalShareTopUsers(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExternalShareTopUsers status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.ExternalShareTopUsers
         * @instance
         */
        ExternalShareTopUsers.prototype.status = 0;

        /**
         * ExternalShareTopUsers items.
         * @member {Array.<tdx_response.ExternalShareTopUsers.IItem>} items
         * @memberof tdx_response.ExternalShareTopUsers
         * @instance
         */
        ExternalShareTopUsers.prototype.items = $util.emptyArray;

        /**
         * Creates a new ExternalShareTopUsers instance using the specified properties.
         * @function create
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {tdx_response.IExternalShareTopUsers=} [properties] Properties to set
         * @returns {tdx_response.ExternalShareTopUsers} ExternalShareTopUsers instance
         */
        ExternalShareTopUsers.create = function create(properties) {
            return new ExternalShareTopUsers(properties);
        };

        /**
         * Encodes the specified ExternalShareTopUsers message. Does not implicitly {@link tdx_response.ExternalShareTopUsers.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {tdx_response.IExternalShareTopUsers} message ExternalShareTopUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalShareTopUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.ExternalShareTopUsers.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ExternalShareTopUsers message, length delimited. Does not implicitly {@link tdx_response.ExternalShareTopUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {tdx_response.IExternalShareTopUsers} message ExternalShareTopUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalShareTopUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExternalShareTopUsers message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.ExternalShareTopUsers} ExternalShareTopUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalShareTopUsers.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ExternalShareTopUsers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.ExternalShareTopUsers.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExternalShareTopUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.ExternalShareTopUsers} ExternalShareTopUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalShareTopUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExternalShareTopUsers message.
         * @function verify
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExternalShareTopUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.ExternalShareTopUsers.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ExternalShareTopUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.ExternalShareTopUsers} ExternalShareTopUsers
         */
        ExternalShareTopUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.ExternalShareTopUsers)
                return object;
            let message = new $root.tdx_response.ExternalShareTopUsers();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.ExternalShareTopUsers.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.ExternalShareTopUsers.items: object expected");
                    message.items[i] = $root.tdx_response.ExternalShareTopUsers.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ExternalShareTopUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {tdx_response.ExternalShareTopUsers} message ExternalShareTopUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExternalShareTopUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.ExternalShareTopUsers.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ExternalShareTopUsers to JSON.
         * @function toJSON
         * @memberof tdx_response.ExternalShareTopUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExternalShareTopUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ExternalShareTopUsers
         * @function getTypeUrl
         * @memberof tdx_response.ExternalShareTopUsers
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ExternalShareTopUsers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.ExternalShareTopUsers";
        };

        ExternalShareTopUsers.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.ExternalShareTopUsers
             * @interface IItem
             * @property {string|null} [email] Item email
             * @property {number|null} [addObject] Item addObject
             * @property {number|null} [addSpace] Item addSpace
             * @property {number|null} [addUser] Item addUser
             * @property {number|null} [updatePermissions] Item updatePermissions
             * @property {number|null} [removeObject] Item removeObject
             * @property {number|null} [removeSpace] Item removeSpace
             * @property {number|null} [removeUser] Item removeUser
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.ExternalShareTopUsers
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.ExternalShareTopUsers.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item email.
             * @member {string} email
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.email = "";

            /**
             * Item addObject.
             * @member {number} addObject
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.addObject = 0;

            /**
             * Item addSpace.
             * @member {number} addSpace
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.addSpace = 0;

            /**
             * Item addUser.
             * @member {number} addUser
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.addUser = 0;

            /**
             * Item updatePermissions.
             * @member {number} updatePermissions
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.updatePermissions = 0;

            /**
             * Item removeObject.
             * @member {number} removeObject
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.removeObject = 0;

            /**
             * Item removeSpace.
             * @member {number} removeSpace
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.removeSpace = 0;

            /**
             * Item removeUser.
             * @member {number} removeUser
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             */
            Item.prototype.removeUser = 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {tdx_response.ExternalShareTopUsers.IItem=} [properties] Properties to set
             * @returns {tdx_response.ExternalShareTopUsers.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.ExternalShareTopUsers.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {tdx_response.ExternalShareTopUsers.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                if (message.addObject != null && Object.hasOwnProperty.call(message, "addObject"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.addObject);
                if (message.addSpace != null && Object.hasOwnProperty.call(message, "addSpace"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.addSpace);
                if (message.addUser != null && Object.hasOwnProperty.call(message, "addUser"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.addUser);
                if (message.updatePermissions != null && Object.hasOwnProperty.call(message, "updatePermissions"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.updatePermissions);
                if (message.removeObject != null && Object.hasOwnProperty.call(message, "removeObject"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.removeObject);
                if (message.removeSpace != null && Object.hasOwnProperty.call(message, "removeSpace"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.removeSpace);
                if (message.removeUser != null && Object.hasOwnProperty.call(message, "removeUser"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.removeUser);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.ExternalShareTopUsers.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {tdx_response.ExternalShareTopUsers.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.ExternalShareTopUsers.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.ExternalShareTopUsers.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.email = reader.string();
                            break;
                        }
                    case 2: {
                            message.addObject = reader.int32();
                            break;
                        }
                    case 3: {
                            message.addSpace = reader.int32();
                            break;
                        }
                    case 4: {
                            message.addUser = reader.int32();
                            break;
                        }
                    case 5: {
                            message.updatePermissions = reader.int32();
                            break;
                        }
                    case 6: {
                            message.removeObject = reader.int32();
                            break;
                        }
                    case 7: {
                            message.removeSpace = reader.int32();
                            break;
                        }
                    case 8: {
                            message.removeUser = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.ExternalShareTopUsers.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.addObject != null && message.hasOwnProperty("addObject"))
                    if (!$util.isInteger(message.addObject))
                        return "addObject: integer expected";
                if (message.addSpace != null && message.hasOwnProperty("addSpace"))
                    if (!$util.isInteger(message.addSpace))
                        return "addSpace: integer expected";
                if (message.addUser != null && message.hasOwnProperty("addUser"))
                    if (!$util.isInteger(message.addUser))
                        return "addUser: integer expected";
                if (message.updatePermissions != null && message.hasOwnProperty("updatePermissions"))
                    if (!$util.isInteger(message.updatePermissions))
                        return "updatePermissions: integer expected";
                if (message.removeObject != null && message.hasOwnProperty("removeObject"))
                    if (!$util.isInteger(message.removeObject))
                        return "removeObject: integer expected";
                if (message.removeSpace != null && message.hasOwnProperty("removeSpace"))
                    if (!$util.isInteger(message.removeSpace))
                        return "removeSpace: integer expected";
                if (message.removeUser != null && message.hasOwnProperty("removeUser"))
                    if (!$util.isInteger(message.removeUser))
                        return "removeUser: integer expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.ExternalShareTopUsers.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.ExternalShareTopUsers.Item)
                    return object;
                let message = new $root.tdx_response.ExternalShareTopUsers.Item();
                if (object.email != null)
                    message.email = String(object.email);
                if (object.addObject != null)
                    message.addObject = object.addObject | 0;
                if (object.addSpace != null)
                    message.addSpace = object.addSpace | 0;
                if (object.addUser != null)
                    message.addUser = object.addUser | 0;
                if (object.updatePermissions != null)
                    message.updatePermissions = object.updatePermissions | 0;
                if (object.removeObject != null)
                    message.removeObject = object.removeObject | 0;
                if (object.removeSpace != null)
                    message.removeSpace = object.removeSpace | 0;
                if (object.removeUser != null)
                    message.removeUser = object.removeUser | 0;
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {tdx_response.ExternalShareTopUsers.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.email = "";
                    object.addObject = 0;
                    object.addSpace = 0;
                    object.addUser = 0;
                    object.updatePermissions = 0;
                    object.removeObject = 0;
                    object.removeSpace = 0;
                    object.removeUser = 0;
                }
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                if (message.addObject != null && message.hasOwnProperty("addObject"))
                    object.addObject = message.addObject;
                if (message.addSpace != null && message.hasOwnProperty("addSpace"))
                    object.addSpace = message.addSpace;
                if (message.addUser != null && message.hasOwnProperty("addUser"))
                    object.addUser = message.addUser;
                if (message.updatePermissions != null && message.hasOwnProperty("updatePermissions"))
                    object.updatePermissions = message.updatePermissions;
                if (message.removeObject != null && message.hasOwnProperty("removeObject"))
                    object.removeObject = message.removeObject;
                if (message.removeSpace != null && message.hasOwnProperty("removeSpace"))
                    object.removeSpace = message.removeSpace;
                if (message.removeUser != null && message.hasOwnProperty("removeUser"))
                    object.removeUser = message.removeUser;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.ExternalShareTopUsers.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.ExternalShareTopUsers.Item";
            };

            return Item;
        })();

        return ExternalShareTopUsers;
    })();

    tdx_response.CollaborationFlow = (function() {

        /**
         * Properties of a CollaborationFlow.
         * @memberof tdx_response
         * @interface ICollaborationFlow
         * @property {tdx_response.Status|null} [status] CollaborationFlow status
         * @property {Array.<tdx_response.CollaborationFlow.IItem>|null} [items] CollaborationFlow items
         */

        /**
         * Constructs a new CollaborationFlow.
         * @memberof tdx_response
         * @classdesc Represents a CollaborationFlow.
         * @implements ICollaborationFlow
         * @constructor
         * @param {tdx_response.ICollaborationFlow=} [properties] Properties to set
         */
        function CollaborationFlow(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CollaborationFlow status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.CollaborationFlow
         * @instance
         */
        CollaborationFlow.prototype.status = 0;

        /**
         * CollaborationFlow items.
         * @member {Array.<tdx_response.CollaborationFlow.IItem>} items
         * @memberof tdx_response.CollaborationFlow
         * @instance
         */
        CollaborationFlow.prototype.items = $util.emptyArray;

        /**
         * Creates a new CollaborationFlow instance using the specified properties.
         * @function create
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {tdx_response.ICollaborationFlow=} [properties] Properties to set
         * @returns {tdx_response.CollaborationFlow} CollaborationFlow instance
         */
        CollaborationFlow.create = function create(properties) {
            return new CollaborationFlow(properties);
        };

        /**
         * Encodes the specified CollaborationFlow message. Does not implicitly {@link tdx_response.CollaborationFlow.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {tdx_response.ICollaborationFlow} message CollaborationFlow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CollaborationFlow.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.CollaborationFlow.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CollaborationFlow message, length delimited. Does not implicitly {@link tdx_response.CollaborationFlow.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {tdx_response.ICollaborationFlow} message CollaborationFlow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CollaborationFlow.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CollaborationFlow message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.CollaborationFlow} CollaborationFlow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CollaborationFlow.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.CollaborationFlow();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.CollaborationFlow.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CollaborationFlow message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.CollaborationFlow} CollaborationFlow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CollaborationFlow.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CollaborationFlow message.
         * @function verify
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CollaborationFlow.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.CollaborationFlow.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CollaborationFlow message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.CollaborationFlow} CollaborationFlow
         */
        CollaborationFlow.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.CollaborationFlow)
                return object;
            let message = new $root.tdx_response.CollaborationFlow();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.CollaborationFlow.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.CollaborationFlow.items: object expected");
                    message.items[i] = $root.tdx_response.CollaborationFlow.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CollaborationFlow message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {tdx_response.CollaborationFlow} message CollaborationFlow
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CollaborationFlow.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.CollaborationFlow.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this CollaborationFlow to JSON.
         * @function toJSON
         * @memberof tdx_response.CollaborationFlow
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CollaborationFlow.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CollaborationFlow
         * @function getTypeUrl
         * @memberof tdx_response.CollaborationFlow
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CollaborationFlow.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.CollaborationFlow";
        };

        CollaborationFlow.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.CollaborationFlow
             * @interface IItem
             * @property {string|null} [actor] Item actor
             * @property {string|null} [space] Item space
             * @property {string|null} [outcome] Item outcome
             * @property {number|Long|null} [count] Item count
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.CollaborationFlow
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.CollaborationFlow.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item actor.
             * @member {string} actor
             * @memberof tdx_response.CollaborationFlow.Item
             * @instance
             */
            Item.prototype.actor = "";

            /**
             * Item space.
             * @member {string} space
             * @memberof tdx_response.CollaborationFlow.Item
             * @instance
             */
            Item.prototype.space = "";

            /**
             * Item outcome.
             * @member {string} outcome
             * @memberof tdx_response.CollaborationFlow.Item
             * @instance
             */
            Item.prototype.outcome = "";

            /**
             * Item count.
             * @member {number|Long} count
             * @memberof tdx_response.CollaborationFlow.Item
             * @instance
             */
            Item.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {tdx_response.CollaborationFlow.IItem=} [properties] Properties to set
             * @returns {tdx_response.CollaborationFlow.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.CollaborationFlow.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {tdx_response.CollaborationFlow.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.actor != null && Object.hasOwnProperty.call(message, "actor"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.actor);
                if (message.space != null && Object.hasOwnProperty.call(message, "space"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.space);
                if (message.outcome != null && Object.hasOwnProperty.call(message, "outcome"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.outcome);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.count);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.CollaborationFlow.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {tdx_response.CollaborationFlow.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.CollaborationFlow.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.CollaborationFlow.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.actor = reader.string();
                            break;
                        }
                    case 2: {
                            message.space = reader.string();
                            break;
                        }
                    case 3: {
                            message.outcome = reader.string();
                            break;
                        }
                    case 4: {
                            message.count = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.CollaborationFlow.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.actor != null && message.hasOwnProperty("actor"))
                    if (!$util.isString(message.actor))
                        return "actor: string expected";
                if (message.space != null && message.hasOwnProperty("space"))
                    if (!$util.isString(message.space))
                        return "space: string expected";
                if (message.outcome != null && message.hasOwnProperty("outcome"))
                    if (!$util.isString(message.outcome))
                        return "outcome: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                        return "count: integer|Long expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.CollaborationFlow.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.CollaborationFlow.Item)
                    return object;
                let message = new $root.tdx_response.CollaborationFlow.Item();
                if (object.actor != null)
                    message.actor = String(object.actor);
                if (object.space != null)
                    message.space = String(object.space);
                if (object.outcome != null)
                    message.outcome = String(object.outcome);
                if (object.count != null)
                    if ($util.Long)
                        (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                    else if (typeof object.count === "string")
                        message.count = parseInt(object.count, 10);
                    else if (typeof object.count === "number")
                        message.count = object.count;
                    else if (typeof object.count === "object")
                        message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {tdx_response.CollaborationFlow.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.actor = "";
                    object.space = "";
                    object.outcome = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.count = options.longs === String ? "0" : 0;
                }
                if (message.actor != null && message.hasOwnProperty("actor"))
                    object.actor = message.actor;
                if (message.space != null && message.hasOwnProperty("space"))
                    object.space = message.space;
                if (message.outcome != null && message.hasOwnProperty("outcome"))
                    object.outcome = message.outcome;
                if (message.count != null && message.hasOwnProperty("count"))
                    if (typeof message.count === "number")
                        object.count = options.longs === String ? String(message.count) : message.count;
                    else
                        object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.CollaborationFlow.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.CollaborationFlow.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.CollaborationFlow.Item";
            };

            return Item;
        })();

        return CollaborationFlow;
    })();

    tdx_response.Overview_OffHoursRatio = (function() {

        /**
         * Properties of an Overview_OffHoursRatio.
         * @memberof tdx_response
         * @interface IOverview_OffHoursRatio
         * @property {tdx_response.Status|null} [status] Overview_OffHoursRatio status
         * @property {number|null} [offHours] Overview_OffHoursRatio offHours
         */

        /**
         * Constructs a new Overview_OffHoursRatio.
         * @memberof tdx_response
         * @classdesc Represents an Overview_OffHoursRatio.
         * @implements IOverview_OffHoursRatio
         * @constructor
         * @param {tdx_response.IOverview_OffHoursRatio=} [properties] Properties to set
         */
        function Overview_OffHoursRatio(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Overview_OffHoursRatio status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Overview_OffHoursRatio
         * @instance
         */
        Overview_OffHoursRatio.prototype.status = 0;

        /**
         * Overview_OffHoursRatio offHours.
         * @member {number} offHours
         * @memberof tdx_response.Overview_OffHoursRatio
         * @instance
         */
        Overview_OffHoursRatio.prototype.offHours = 0;

        /**
         * Creates a new Overview_OffHoursRatio instance using the specified properties.
         * @function create
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {tdx_response.IOverview_OffHoursRatio=} [properties] Properties to set
         * @returns {tdx_response.Overview_OffHoursRatio} Overview_OffHoursRatio instance
         */
        Overview_OffHoursRatio.create = function create(properties) {
            return new Overview_OffHoursRatio(properties);
        };

        /**
         * Encodes the specified Overview_OffHoursRatio message. Does not implicitly {@link tdx_response.Overview_OffHoursRatio.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {tdx_response.IOverview_OffHoursRatio} message Overview_OffHoursRatio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Overview_OffHoursRatio.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.offHours != null && Object.hasOwnProperty.call(message, "offHours"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.offHours);
            return writer;
        };

        /**
         * Encodes the specified Overview_OffHoursRatio message, length delimited. Does not implicitly {@link tdx_response.Overview_OffHoursRatio.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {tdx_response.IOverview_OffHoursRatio} message Overview_OffHoursRatio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Overview_OffHoursRatio.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Overview_OffHoursRatio message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Overview_OffHoursRatio} Overview_OffHoursRatio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Overview_OffHoursRatio.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Overview_OffHoursRatio();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.offHours = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Overview_OffHoursRatio message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Overview_OffHoursRatio} Overview_OffHoursRatio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Overview_OffHoursRatio.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Overview_OffHoursRatio message.
         * @function verify
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Overview_OffHoursRatio.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.offHours != null && message.hasOwnProperty("offHours"))
                if (!$util.isInteger(message.offHours))
                    return "offHours: integer expected";
            return null;
        };

        /**
         * Creates an Overview_OffHoursRatio message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Overview_OffHoursRatio} Overview_OffHoursRatio
         */
        Overview_OffHoursRatio.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Overview_OffHoursRatio)
                return object;
            let message = new $root.tdx_response.Overview_OffHoursRatio();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.offHours != null)
                message.offHours = object.offHours >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an Overview_OffHoursRatio message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {tdx_response.Overview_OffHoursRatio} message Overview_OffHoursRatio
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Overview_OffHoursRatio.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.offHours = 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.offHours != null && message.hasOwnProperty("offHours"))
                object.offHours = message.offHours;
            return object;
        };

        /**
         * Converts this Overview_OffHoursRatio to JSON.
         * @function toJSON
         * @memberof tdx_response.Overview_OffHoursRatio
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Overview_OffHoursRatio.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Overview_OffHoursRatio
         * @function getTypeUrl
         * @memberof tdx_response.Overview_OffHoursRatio
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Overview_OffHoursRatio.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Overview_OffHoursRatio";
        };

        return Overview_OffHoursRatio;
    })();

    tdx_response.GetRemovedUsersFromLogs = (function() {

        /**
         * Properties of a GetRemovedUsersFromLogs.
         * @memberof tdx_response
         * @interface IGetRemovedUsersFromLogs
         * @property {tdx_response.Status|null} [status] GetRemovedUsersFromLogs status
         * @property {Array.<string>|null} [email] GetRemovedUsersFromLogs email
         */

        /**
         * Constructs a new GetRemovedUsersFromLogs.
         * @memberof tdx_response
         * @classdesc Represents a GetRemovedUsersFromLogs.
         * @implements IGetRemovedUsersFromLogs
         * @constructor
         * @param {tdx_response.IGetRemovedUsersFromLogs=} [properties] Properties to set
         */
        function GetRemovedUsersFromLogs(properties) {
            this.email = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRemovedUsersFromLogs status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @instance
         */
        GetRemovedUsersFromLogs.prototype.status = 0;

        /**
         * GetRemovedUsersFromLogs email.
         * @member {Array.<string>} email
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @instance
         */
        GetRemovedUsersFromLogs.prototype.email = $util.emptyArray;

        /**
         * Creates a new GetRemovedUsersFromLogs instance using the specified properties.
         * @function create
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_response.IGetRemovedUsersFromLogs=} [properties] Properties to set
         * @returns {tdx_response.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs instance
         */
        GetRemovedUsersFromLogs.create = function create(properties) {
            return new GetRemovedUsersFromLogs(properties);
        };

        /**
         * Encodes the specified GetRemovedUsersFromLogs message. Does not implicitly {@link tdx_response.GetRemovedUsersFromLogs.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_response.IGetRemovedUsersFromLogs} message GetRemovedUsersFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedUsersFromLogs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.email != null && message.email.length)
                for (let i = 0; i < message.email.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.email[i]);
            return writer;
        };

        /**
         * Encodes the specified GetRemovedUsersFromLogs message, length delimited. Does not implicitly {@link tdx_response.GetRemovedUsersFromLogs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_response.IGetRemovedUsersFromLogs} message GetRemovedUsersFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedUsersFromLogs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRemovedUsersFromLogs message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedUsersFromLogs.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.GetRemovedUsersFromLogs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.email && message.email.length))
                            message.email = [];
                        message.email.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRemovedUsersFromLogs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedUsersFromLogs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRemovedUsersFromLogs message.
         * @function verify
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRemovedUsersFromLogs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.email != null && message.hasOwnProperty("email")) {
                if (!Array.isArray(message.email))
                    return "email: array expected";
                for (let i = 0; i < message.email.length; ++i)
                    if (!$util.isString(message.email[i]))
                        return "email: string[] expected";
            }
            return null;
        };

        /**
         * Creates a GetRemovedUsersFromLogs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.GetRemovedUsersFromLogs} GetRemovedUsersFromLogs
         */
        GetRemovedUsersFromLogs.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.GetRemovedUsersFromLogs)
                return object;
            let message = new $root.tdx_response.GetRemovedUsersFromLogs();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.email) {
                if (!Array.isArray(object.email))
                    throw TypeError(".tdx_response.GetRemovedUsersFromLogs.email: array expected");
                message.email = [];
                for (let i = 0; i < object.email.length; ++i)
                    message.email[i] = String(object.email[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetRemovedUsersFromLogs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {tdx_response.GetRemovedUsersFromLogs} message GetRemovedUsersFromLogs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRemovedUsersFromLogs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.email = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.email && message.email.length) {
                object.email = [];
                for (let j = 0; j < message.email.length; ++j)
                    object.email[j] = message.email[j];
            }
            return object;
        };

        /**
         * Converts this GetRemovedUsersFromLogs to JSON.
         * @function toJSON
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRemovedUsersFromLogs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRemovedUsersFromLogs
         * @function getTypeUrl
         * @memberof tdx_response.GetRemovedUsersFromLogs
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRemovedUsersFromLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.GetRemovedUsersFromLogs";
        };

        return GetRemovedUsersFromLogs;
    })();

    tdx_response.GetRemovedTeamsFromLogs = (function() {

        /**
         * Properties of a GetRemovedTeamsFromLogs.
         * @memberof tdx_response
         * @interface IGetRemovedTeamsFromLogs
         * @property {tdx_response.Status|null} [status] GetRemovedTeamsFromLogs status
         * @property {Array.<string>|null} [teamNames] GetRemovedTeamsFromLogs teamNames
         */

        /**
         * Constructs a new GetRemovedTeamsFromLogs.
         * @memberof tdx_response
         * @classdesc Represents a GetRemovedTeamsFromLogs.
         * @implements IGetRemovedTeamsFromLogs
         * @constructor
         * @param {tdx_response.IGetRemovedTeamsFromLogs=} [properties] Properties to set
         */
        function GetRemovedTeamsFromLogs(properties) {
            this.teamNames = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRemovedTeamsFromLogs status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @instance
         */
        GetRemovedTeamsFromLogs.prototype.status = 0;

        /**
         * GetRemovedTeamsFromLogs teamNames.
         * @member {Array.<string>} teamNames
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @instance
         */
        GetRemovedTeamsFromLogs.prototype.teamNames = $util.emptyArray;

        /**
         * Creates a new GetRemovedTeamsFromLogs instance using the specified properties.
         * @function create
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_response.IGetRemovedTeamsFromLogs=} [properties] Properties to set
         * @returns {tdx_response.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs instance
         */
        GetRemovedTeamsFromLogs.create = function create(properties) {
            return new GetRemovedTeamsFromLogs(properties);
        };

        /**
         * Encodes the specified GetRemovedTeamsFromLogs message. Does not implicitly {@link tdx_response.GetRemovedTeamsFromLogs.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_response.IGetRemovedTeamsFromLogs} message GetRemovedTeamsFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedTeamsFromLogs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.teamNames != null && message.teamNames.length)
                for (let i = 0; i < message.teamNames.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.teamNames[i]);
            return writer;
        };

        /**
         * Encodes the specified GetRemovedTeamsFromLogs message, length delimited. Does not implicitly {@link tdx_response.GetRemovedTeamsFromLogs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_response.IGetRemovedTeamsFromLogs} message GetRemovedTeamsFromLogs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRemovedTeamsFromLogs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRemovedTeamsFromLogs message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedTeamsFromLogs.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.GetRemovedTeamsFromLogs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.teamNames && message.teamNames.length))
                            message.teamNames = [];
                        message.teamNames.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRemovedTeamsFromLogs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRemovedTeamsFromLogs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRemovedTeamsFromLogs message.
         * @function verify
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRemovedTeamsFromLogs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.teamNames != null && message.hasOwnProperty("teamNames")) {
                if (!Array.isArray(message.teamNames))
                    return "teamNames: array expected";
                for (let i = 0; i < message.teamNames.length; ++i)
                    if (!$util.isString(message.teamNames[i]))
                        return "teamNames: string[] expected";
            }
            return null;
        };

        /**
         * Creates a GetRemovedTeamsFromLogs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.GetRemovedTeamsFromLogs} GetRemovedTeamsFromLogs
         */
        GetRemovedTeamsFromLogs.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.GetRemovedTeamsFromLogs)
                return object;
            let message = new $root.tdx_response.GetRemovedTeamsFromLogs();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.teamNames) {
                if (!Array.isArray(object.teamNames))
                    throw TypeError(".tdx_response.GetRemovedTeamsFromLogs.teamNames: array expected");
                message.teamNames = [];
                for (let i = 0; i < object.teamNames.length; ++i)
                    message.teamNames[i] = String(object.teamNames[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetRemovedTeamsFromLogs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {tdx_response.GetRemovedTeamsFromLogs} message GetRemovedTeamsFromLogs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRemovedTeamsFromLogs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.teamNames = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.teamNames && message.teamNames.length) {
                object.teamNames = [];
                for (let j = 0; j < message.teamNames.length; ++j)
                    object.teamNames[j] = message.teamNames[j];
            }
            return object;
        };

        /**
         * Converts this GetRemovedTeamsFromLogs to JSON.
         * @function toJSON
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRemovedTeamsFromLogs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRemovedTeamsFromLogs
         * @function getTypeUrl
         * @memberof tdx_response.GetRemovedTeamsFromLogs
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRemovedTeamsFromLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.GetRemovedTeamsFromLogs";
        };

        return GetRemovedTeamsFromLogs;
    })();

    tdx_response.User_ActivityTimeline = (function() {

        /**
         * Properties of a User_ActivityTimeline.
         * @memberof tdx_response
         * @interface IUser_ActivityTimeline
         * @property {tdx_response.Status|null} [status] User_ActivityTimeline status
         * @property {Array.<tdx_response.User_ActivityTimeline.IItem>|null} [items] User_ActivityTimeline items
         */

        /**
         * Constructs a new User_ActivityTimeline.
         * @memberof tdx_response
         * @classdesc Represents a User_ActivityTimeline.
         * @implements IUser_ActivityTimeline
         * @constructor
         * @param {tdx_response.IUser_ActivityTimeline=} [properties] Properties to set
         */
        function User_ActivityTimeline(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_ActivityTimeline status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_ActivityTimeline
         * @instance
         */
        User_ActivityTimeline.prototype.status = 0;

        /**
         * User_ActivityTimeline items.
         * @member {Array.<tdx_response.User_ActivityTimeline.IItem>} items
         * @memberof tdx_response.User_ActivityTimeline
         * @instance
         */
        User_ActivityTimeline.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_ActivityTimeline instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {tdx_response.IUser_ActivityTimeline=} [properties] Properties to set
         * @returns {tdx_response.User_ActivityTimeline} User_ActivityTimeline instance
         */
        User_ActivityTimeline.create = function create(properties) {
            return new User_ActivityTimeline(properties);
        };

        /**
         * Encodes the specified User_ActivityTimeline message. Does not implicitly {@link tdx_response.User_ActivityTimeline.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {tdx_response.IUser_ActivityTimeline} message User_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_ActivityTimeline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_ActivityTimeline.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_ActivityTimeline message, length delimited. Does not implicitly {@link tdx_response.User_ActivityTimeline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {tdx_response.IUser_ActivityTimeline} message User_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_ActivityTimeline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_ActivityTimeline message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_ActivityTimeline} User_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_ActivityTimeline.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_ActivityTimeline();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_ActivityTimeline.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_ActivityTimeline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_ActivityTimeline} User_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_ActivityTimeline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_ActivityTimeline message.
         * @function verify
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_ActivityTimeline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_ActivityTimeline.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_ActivityTimeline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_ActivityTimeline} User_ActivityTimeline
         */
        User_ActivityTimeline.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_ActivityTimeline)
                return object;
            let message = new $root.tdx_response.User_ActivityTimeline();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_ActivityTimeline.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_ActivityTimeline.items: object expected");
                    message.items[i] = $root.tdx_response.User_ActivityTimeline.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_ActivityTimeline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {tdx_response.User_ActivityTimeline} message User_ActivityTimeline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_ActivityTimeline.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_ActivityTimeline.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_ActivityTimeline to JSON.
         * @function toJSON
         * @memberof tdx_response.User_ActivityTimeline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_ActivityTimeline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_ActivityTimeline
         * @function getTypeUrl
         * @memberof tdx_response.User_ActivityTimeline
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_ActivityTimeline.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_ActivityTimeline";
        };

        User_ActivityTimeline.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_ActivityTimeline
             * @interface IItem
             * @property {number|Long|null} [timestamp] Item timestamp
             * @property {string|null} [operation] Item operation
             * @property {string|null} [operationDoneBy] Item operationDoneBy
             * @property {string|null} [impactedUser] Item impactedUser
             * @property {string|null} [location] Item location
             * @property {boolean|null} [success] Item success
             * @property {string|null} [grantedBy] Item grantedBy
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_ActivityTimeline
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_ActivityTimeline.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item timestamp.
             * @member {number|Long} timestamp
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             */
            Item.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item operation.
             * @member {string} operation
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             */
            Item.prototype.operation = "";

            /**
             * Item operationDoneBy.
             * @member {string} operationDoneBy
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             */
            Item.prototype.operationDoneBy = "";

            /**
             * Item impactedUser.
             * @member {string} impactedUser
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             */
            Item.prototype.impactedUser = "";

            /**
             * Item location.
             * @member {string} location
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             */
            Item.prototype.location = "";

            /**
             * Item success.
             * @member {boolean} success
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             */
            Item.prototype.success = false;

            /**
             * Item grantedBy.
             * @member {string} grantedBy
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             */
            Item.prototype.grantedBy = "";

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {tdx_response.User_ActivityTimeline.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_ActivityTimeline.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_ActivityTimeline.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {tdx_response.User_ActivityTimeline.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.operation);
                if (message.operationDoneBy != null && Object.hasOwnProperty.call(message, "operationDoneBy"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.operationDoneBy);
                if (message.impactedUser != null && Object.hasOwnProperty.call(message, "impactedUser"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.impactedUser);
                if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.location);
                if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                    writer.uint32(/* id 6, wireType 0 =*/48).bool(message.success);
                if (message.grantedBy != null && Object.hasOwnProperty.call(message, "grantedBy"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.grantedBy);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_ActivityTimeline.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {tdx_response.User_ActivityTimeline.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_ActivityTimeline.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_ActivityTimeline.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.timestamp = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.operation = reader.string();
                            break;
                        }
                    case 3: {
                            message.operationDoneBy = reader.string();
                            break;
                        }
                    case 4: {
                            message.impactedUser = reader.string();
                            break;
                        }
                    case 5: {
                            message.location = reader.string();
                            break;
                        }
                    case 6: {
                            message.success = reader.bool();
                            break;
                        }
                    case 7: {
                            message.grantedBy = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_ActivityTimeline.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.operationDoneBy != null && message.hasOwnProperty("operationDoneBy"))
                    if (!$util.isString(message.operationDoneBy))
                        return "operationDoneBy: string expected";
                if (message.impactedUser != null && message.hasOwnProperty("impactedUser"))
                    if (!$util.isString(message.impactedUser))
                        return "impactedUser: string expected";
                if (message.location != null && message.hasOwnProperty("location"))
                    if (!$util.isString(message.location))
                        return "location: string expected";
                if (message.success != null && message.hasOwnProperty("success"))
                    if (typeof message.success !== "boolean")
                        return "success: boolean expected";
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    if (!$util.isString(message.grantedBy))
                        return "grantedBy: string expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_ActivityTimeline.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_ActivityTimeline.Item)
                    return object;
                let message = new $root.tdx_response.User_ActivityTimeline.Item();
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.operationDoneBy != null)
                    message.operationDoneBy = String(object.operationDoneBy);
                if (object.impactedUser != null)
                    message.impactedUser = String(object.impactedUser);
                if (object.location != null)
                    message.location = String(object.location);
                if (object.success != null)
                    message.success = Boolean(object.success);
                if (object.grantedBy != null)
                    message.grantedBy = String(object.grantedBy);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {tdx_response.User_ActivityTimeline.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    object.operation = "";
                    object.operationDoneBy = "";
                    object.impactedUser = "";
                    object.location = "";
                    object.success = false;
                    object.grantedBy = "";
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.operationDoneBy != null && message.hasOwnProperty("operationDoneBy"))
                    object.operationDoneBy = message.operationDoneBy;
                if (message.impactedUser != null && message.hasOwnProperty("impactedUser"))
                    object.impactedUser = message.impactedUser;
                if (message.location != null && message.hasOwnProperty("location"))
                    object.location = message.location;
                if (message.success != null && message.hasOwnProperty("success"))
                    object.success = message.success;
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    object.grantedBy = message.grantedBy;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_ActivityTimeline.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_ActivityTimeline.Item";
            };

            return Item;
        })();

        return User_ActivityTimeline;
    })();

    tdx_response.User_CountriesAccessedFrom = (function() {

        /**
         * Properties of a User_CountriesAccessedFrom.
         * @memberof tdx_response
         * @interface IUser_CountriesAccessedFrom
         * @property {tdx_response.Status|null} [status] User_CountriesAccessedFrom status
         * @property {Array.<tdx_response.User_CountriesAccessedFrom.IItem>|null} [items] User_CountriesAccessedFrom items
         */

        /**
         * Constructs a new User_CountriesAccessedFrom.
         * @memberof tdx_response
         * @classdesc Represents a User_CountriesAccessedFrom.
         * @implements IUser_CountriesAccessedFrom
         * @constructor
         * @param {tdx_response.IUser_CountriesAccessedFrom=} [properties] Properties to set
         */
        function User_CountriesAccessedFrom(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_CountriesAccessedFrom status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @instance
         */
        User_CountriesAccessedFrom.prototype.status = 0;

        /**
         * User_CountriesAccessedFrom items.
         * @member {Array.<tdx_response.User_CountriesAccessedFrom.IItem>} items
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @instance
         */
        User_CountriesAccessedFrom.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_CountriesAccessedFrom instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {tdx_response.IUser_CountriesAccessedFrom=} [properties] Properties to set
         * @returns {tdx_response.User_CountriesAccessedFrom} User_CountriesAccessedFrom instance
         */
        User_CountriesAccessedFrom.create = function create(properties) {
            return new User_CountriesAccessedFrom(properties);
        };

        /**
         * Encodes the specified User_CountriesAccessedFrom message. Does not implicitly {@link tdx_response.User_CountriesAccessedFrom.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {tdx_response.IUser_CountriesAccessedFrom} message User_CountriesAccessedFrom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_CountriesAccessedFrom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_CountriesAccessedFrom.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_CountriesAccessedFrom message, length delimited. Does not implicitly {@link tdx_response.User_CountriesAccessedFrom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {tdx_response.IUser_CountriesAccessedFrom} message User_CountriesAccessedFrom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_CountriesAccessedFrom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_CountriesAccessedFrom message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_CountriesAccessedFrom} User_CountriesAccessedFrom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_CountriesAccessedFrom.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_CountriesAccessedFrom();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_CountriesAccessedFrom.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_CountriesAccessedFrom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_CountriesAccessedFrom} User_CountriesAccessedFrom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_CountriesAccessedFrom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_CountriesAccessedFrom message.
         * @function verify
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_CountriesAccessedFrom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_CountriesAccessedFrom.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_CountriesAccessedFrom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_CountriesAccessedFrom} User_CountriesAccessedFrom
         */
        User_CountriesAccessedFrom.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_CountriesAccessedFrom)
                return object;
            let message = new $root.tdx_response.User_CountriesAccessedFrom();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_CountriesAccessedFrom.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_CountriesAccessedFrom.items: object expected");
                    message.items[i] = $root.tdx_response.User_CountriesAccessedFrom.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_CountriesAccessedFrom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {tdx_response.User_CountriesAccessedFrom} message User_CountriesAccessedFrom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_CountriesAccessedFrom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_CountriesAccessedFrom.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_CountriesAccessedFrom to JSON.
         * @function toJSON
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_CountriesAccessedFrom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_CountriesAccessedFrom
         * @function getTypeUrl
         * @memberof tdx_response.User_CountriesAccessedFrom
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_CountriesAccessedFrom.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_CountriesAccessedFrom";
        };

        User_CountriesAccessedFrom.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_CountriesAccessedFrom
             * @interface IItem
             * @property {string|null} [location] Item location
             * @property {number|null} [count] Item count
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_CountriesAccessedFrom
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_CountriesAccessedFrom.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item location.
             * @member {string} location
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @instance
             */
            Item.prototype.location = "";

            /**
             * Item count.
             * @member {number} count
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @instance
             */
            Item.prototype.count = 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {tdx_response.User_CountriesAccessedFrom.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_CountriesAccessedFrom.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_CountriesAccessedFrom.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {tdx_response.User_CountriesAccessedFrom.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.location);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.count);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_CountriesAccessedFrom.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {tdx_response.User_CountriesAccessedFrom.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_CountriesAccessedFrom.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_CountriesAccessedFrom.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.location = reader.string();
                            break;
                        }
                    case 2: {
                            message.count = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_CountriesAccessedFrom.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.location != null && message.hasOwnProperty("location"))
                    if (!$util.isString(message.location))
                        return "location: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_CountriesAccessedFrom.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_CountriesAccessedFrom.Item)
                    return object;
                let message = new $root.tdx_response.User_CountriesAccessedFrom.Item();
                if (object.location != null)
                    message.location = String(object.location);
                if (object.count != null)
                    message.count = object.count | 0;
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {tdx_response.User_CountriesAccessedFrom.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.location = "";
                    object.count = 0;
                }
                if (message.location != null && message.hasOwnProperty("location"))
                    object.location = message.location;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_CountriesAccessedFrom.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_CountriesAccessedFrom.Item";
            };

            return Item;
        })();

        return User_CountriesAccessedFrom;
    })();

    tdx_response.User_OpCount = (function() {

        /**
         * Properties of a User_OpCount.
         * @memberof tdx_response
         * @interface IUser_OpCount
         * @property {tdx_response.Status|null} [status] User_OpCount status
         * @property {Array.<tdx_response.User_OpCount.IItem>|null} [items] User_OpCount items
         */

        /**
         * Constructs a new User_OpCount.
         * @memberof tdx_response
         * @classdesc Represents a User_OpCount.
         * @implements IUser_OpCount
         * @constructor
         * @param {tdx_response.IUser_OpCount=} [properties] Properties to set
         */
        function User_OpCount(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_OpCount status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_OpCount
         * @instance
         */
        User_OpCount.prototype.status = 0;

        /**
         * User_OpCount items.
         * @member {Array.<tdx_response.User_OpCount.IItem>} items
         * @memberof tdx_response.User_OpCount
         * @instance
         */
        User_OpCount.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_OpCount instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {tdx_response.IUser_OpCount=} [properties] Properties to set
         * @returns {tdx_response.User_OpCount} User_OpCount instance
         */
        User_OpCount.create = function create(properties) {
            return new User_OpCount(properties);
        };

        /**
         * Encodes the specified User_OpCount message. Does not implicitly {@link tdx_response.User_OpCount.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {tdx_response.IUser_OpCount} message User_OpCount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_OpCount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_OpCount.Item.encode(message.items[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_OpCount message, length delimited. Does not implicitly {@link tdx_response.User_OpCount.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {tdx_response.IUser_OpCount} message User_OpCount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_OpCount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_OpCount message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_OpCount} User_OpCount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_OpCount.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_OpCount();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_OpCount.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_OpCount message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_OpCount} User_OpCount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_OpCount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_OpCount message.
         * @function verify
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_OpCount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_OpCount.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_OpCount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_OpCount} User_OpCount
         */
        User_OpCount.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_OpCount)
                return object;
            let message = new $root.tdx_response.User_OpCount();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_OpCount.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_OpCount.items: object expected");
                    message.items[i] = $root.tdx_response.User_OpCount.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_OpCount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {tdx_response.User_OpCount} message User_OpCount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_OpCount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_OpCount.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_OpCount to JSON.
         * @function toJSON
         * @memberof tdx_response.User_OpCount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_OpCount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_OpCount
         * @function getTypeUrl
         * @memberof tdx_response.User_OpCount
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_OpCount.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_OpCount";
        };

        User_OpCount.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_OpCount
             * @interface IItem
             * @property {string|null} [operation] Item operation
             * @property {number|null} [count] Item count
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_OpCount
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_OpCount.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item operation.
             * @member {string} operation
             * @memberof tdx_response.User_OpCount.Item
             * @instance
             */
            Item.prototype.operation = "";

            /**
             * Item count.
             * @member {number} count
             * @memberof tdx_response.User_OpCount.Item
             * @instance
             */
            Item.prototype.count = 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {tdx_response.User_OpCount.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_OpCount.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_OpCount.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {tdx_response.User_OpCount.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.operation);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.count);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_OpCount.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {tdx_response.User_OpCount.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_OpCount.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_OpCount.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.operation = reader.string();
                            break;
                        }
                    case 2: {
                            message.count = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_OpCount.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_OpCount.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_OpCount.Item)
                    return object;
                let message = new $root.tdx_response.User_OpCount.Item();
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.count != null)
                    message.count = object.count | 0;
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {tdx_response.User_OpCount.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.operation = "";
                    object.count = 0;
                }
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_OpCount.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_OpCount.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_OpCount.Item";
            };

            return Item;
        })();

        return User_OpCount;
    })();

    tdx_response.User_WriteActivity = (function() {

        /**
         * Properties of a User_WriteActivity.
         * @memberof tdx_response
         * @interface IUser_WriteActivity
         * @property {tdx_response.Status|null} [status] User_WriteActivity status
         * @property {Array.<tdx_response.User_WriteActivity.IItem>|null} [items] User_WriteActivity items
         */

        /**
         * Constructs a new User_WriteActivity.
         * @memberof tdx_response
         * @classdesc Represents a User_WriteActivity.
         * @implements IUser_WriteActivity
         * @constructor
         * @param {tdx_response.IUser_WriteActivity=} [properties] Properties to set
         */
        function User_WriteActivity(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_WriteActivity status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_WriteActivity
         * @instance
         */
        User_WriteActivity.prototype.status = 0;

        /**
         * User_WriteActivity items.
         * @member {Array.<tdx_response.User_WriteActivity.IItem>} items
         * @memberof tdx_response.User_WriteActivity
         * @instance
         */
        User_WriteActivity.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_WriteActivity instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {tdx_response.IUser_WriteActivity=} [properties] Properties to set
         * @returns {tdx_response.User_WriteActivity} User_WriteActivity instance
         */
        User_WriteActivity.create = function create(properties) {
            return new User_WriteActivity(properties);
        };

        /**
         * Encodes the specified User_WriteActivity message. Does not implicitly {@link tdx_response.User_WriteActivity.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {tdx_response.IUser_WriteActivity} message User_WriteActivity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_WriteActivity.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_WriteActivity.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_WriteActivity message, length delimited. Does not implicitly {@link tdx_response.User_WriteActivity.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {tdx_response.IUser_WriteActivity} message User_WriteActivity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_WriteActivity.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_WriteActivity message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_WriteActivity} User_WriteActivity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_WriteActivity.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_WriteActivity();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_WriteActivity.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_WriteActivity message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_WriteActivity} User_WriteActivity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_WriteActivity.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_WriteActivity message.
         * @function verify
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_WriteActivity.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_WriteActivity.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_WriteActivity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_WriteActivity} User_WriteActivity
         */
        User_WriteActivity.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_WriteActivity)
                return object;
            let message = new $root.tdx_response.User_WriteActivity();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_WriteActivity.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_WriteActivity.items: object expected");
                    message.items[i] = $root.tdx_response.User_WriteActivity.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_WriteActivity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {tdx_response.User_WriteActivity} message User_WriteActivity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_WriteActivity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_WriteActivity.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_WriteActivity to JSON.
         * @function toJSON
         * @memberof tdx_response.User_WriteActivity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_WriteActivity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_WriteActivity
         * @function getTypeUrl
         * @memberof tdx_response.User_WriteActivity
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_WriteActivity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_WriteActivity";
        };

        User_WriteActivity.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_WriteActivity
             * @interface IItem
             * @property {string|null} [date] Item date
             * @property {number|Long|null} [totBytes] Item totBytes
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_WriteActivity
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_WriteActivity.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item date.
             * @member {string} date
             * @memberof tdx_response.User_WriteActivity.Item
             * @instance
             */
            Item.prototype.date = "";

            /**
             * Item totBytes.
             * @member {number|Long} totBytes
             * @memberof tdx_response.User_WriteActivity.Item
             * @instance
             */
            Item.prototype.totBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {tdx_response.User_WriteActivity.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_WriteActivity.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_WriteActivity.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {tdx_response.User_WriteActivity.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.date);
                if (message.totBytes != null && Object.hasOwnProperty.call(message, "totBytes"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totBytes);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_WriteActivity.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {tdx_response.User_WriteActivity.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_WriteActivity.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_WriteActivity.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.date = reader.string();
                            break;
                        }
                    case 2: {
                            message.totBytes = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_WriteActivity.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.totBytes != null && message.hasOwnProperty("totBytes"))
                    if (!$util.isInteger(message.totBytes) && !(message.totBytes && $util.isInteger(message.totBytes.low) && $util.isInteger(message.totBytes.high)))
                        return "totBytes: integer|Long expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_WriteActivity.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_WriteActivity.Item)
                    return object;
                let message = new $root.tdx_response.User_WriteActivity.Item();
                if (object.date != null)
                    message.date = String(object.date);
                if (object.totBytes != null)
                    if ($util.Long)
                        (message.totBytes = $util.Long.fromValue(object.totBytes)).unsigned = false;
                    else if (typeof object.totBytes === "string")
                        message.totBytes = parseInt(object.totBytes, 10);
                    else if (typeof object.totBytes === "number")
                        message.totBytes = object.totBytes;
                    else if (typeof object.totBytes === "object")
                        message.totBytes = new $util.LongBits(object.totBytes.low >>> 0, object.totBytes.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {tdx_response.User_WriteActivity.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.date = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.totBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.totBytes = options.longs === String ? "0" : 0;
                }
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.totBytes != null && message.hasOwnProperty("totBytes"))
                    if (typeof message.totBytes === "number")
                        object.totBytes = options.longs === String ? String(message.totBytes) : message.totBytes;
                    else
                        object.totBytes = options.longs === String ? $util.Long.prototype.toString.call(message.totBytes) : options.longs === Number ? new $util.LongBits(message.totBytes.low >>> 0, message.totBytes.high >>> 0).toNumber() : message.totBytes;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_WriteActivity.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_WriteActivity.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_WriteActivity.Item";
            };

            return Item;
        })();

        return User_WriteActivity;
    })();

    tdx_response.User_StorageBreakdown = (function() {

        /**
         * Properties of a User_StorageBreakdown.
         * @memberof tdx_response
         * @interface IUser_StorageBreakdown
         * @property {tdx_response.Status|null} [status] User_StorageBreakdown status
         * @property {Array.<tdx_response.User_StorageBreakdown.IItem>|null} [items] User_StorageBreakdown items
         */

        /**
         * Constructs a new User_StorageBreakdown.
         * @memberof tdx_response
         * @classdesc Represents a User_StorageBreakdown.
         * @implements IUser_StorageBreakdown
         * @constructor
         * @param {tdx_response.IUser_StorageBreakdown=} [properties] Properties to set
         */
        function User_StorageBreakdown(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_StorageBreakdown status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_StorageBreakdown
         * @instance
         */
        User_StorageBreakdown.prototype.status = 0;

        /**
         * User_StorageBreakdown items.
         * @member {Array.<tdx_response.User_StorageBreakdown.IItem>} items
         * @memberof tdx_response.User_StorageBreakdown
         * @instance
         */
        User_StorageBreakdown.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_StorageBreakdown instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {tdx_response.IUser_StorageBreakdown=} [properties] Properties to set
         * @returns {tdx_response.User_StorageBreakdown} User_StorageBreakdown instance
         */
        User_StorageBreakdown.create = function create(properties) {
            return new User_StorageBreakdown(properties);
        };

        /**
         * Encodes the specified User_StorageBreakdown message. Does not implicitly {@link tdx_response.User_StorageBreakdown.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {tdx_response.IUser_StorageBreakdown} message User_StorageBreakdown message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_StorageBreakdown.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_StorageBreakdown.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_StorageBreakdown message, length delimited. Does not implicitly {@link tdx_response.User_StorageBreakdown.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {tdx_response.IUser_StorageBreakdown} message User_StorageBreakdown message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_StorageBreakdown.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_StorageBreakdown message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_StorageBreakdown} User_StorageBreakdown
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_StorageBreakdown.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_StorageBreakdown();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_StorageBreakdown.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_StorageBreakdown message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_StorageBreakdown} User_StorageBreakdown
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_StorageBreakdown.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_StorageBreakdown message.
         * @function verify
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_StorageBreakdown.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_StorageBreakdown.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_StorageBreakdown message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_StorageBreakdown} User_StorageBreakdown
         */
        User_StorageBreakdown.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_StorageBreakdown)
                return object;
            let message = new $root.tdx_response.User_StorageBreakdown();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_StorageBreakdown.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_StorageBreakdown.items: object expected");
                    message.items[i] = $root.tdx_response.User_StorageBreakdown.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_StorageBreakdown message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {tdx_response.User_StorageBreakdown} message User_StorageBreakdown
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_StorageBreakdown.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_StorageBreakdown.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_StorageBreakdown to JSON.
         * @function toJSON
         * @memberof tdx_response.User_StorageBreakdown
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_StorageBreakdown.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_StorageBreakdown
         * @function getTypeUrl
         * @memberof tdx_response.User_StorageBreakdown
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_StorageBreakdown.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_StorageBreakdown";
        };

        User_StorageBreakdown.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_StorageBreakdown
             * @interface IItem
             * @property {string|null} [type] Item type
             * @property {number|Long|null} [totBytes] Item totBytes
             * @property {number|Long|null} [count] Item count
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_StorageBreakdown
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_StorageBreakdown.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item type.
             * @member {string} type
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @instance
             */
            Item.prototype.type = "";

            /**
             * Item totBytes.
             * @member {number|Long} totBytes
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @instance
             */
            Item.prototype.totBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Item count.
             * @member {number|Long} count
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @instance
             */
            Item.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {tdx_response.User_StorageBreakdown.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_StorageBreakdown.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_StorageBreakdown.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {tdx_response.User_StorageBreakdown.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.totBytes != null && Object.hasOwnProperty.call(message, "totBytes"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totBytes);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.count);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_StorageBreakdown.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {tdx_response.User_StorageBreakdown.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_StorageBreakdown.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_StorageBreakdown.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.type = reader.string();
                            break;
                        }
                    case 2: {
                            message.totBytes = reader.int64();
                            break;
                        }
                    case 3: {
                            message.count = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_StorageBreakdown.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.totBytes != null && message.hasOwnProperty("totBytes"))
                    if (!$util.isInteger(message.totBytes) && !(message.totBytes && $util.isInteger(message.totBytes.low) && $util.isInteger(message.totBytes.high)))
                        return "totBytes: integer|Long expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                        return "count: integer|Long expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_StorageBreakdown.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_StorageBreakdown.Item)
                    return object;
                let message = new $root.tdx_response.User_StorageBreakdown.Item();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.totBytes != null)
                    if ($util.Long)
                        (message.totBytes = $util.Long.fromValue(object.totBytes)).unsigned = false;
                    else if (typeof object.totBytes === "string")
                        message.totBytes = parseInt(object.totBytes, 10);
                    else if (typeof object.totBytes === "number")
                        message.totBytes = object.totBytes;
                    else if (typeof object.totBytes === "object")
                        message.totBytes = new $util.LongBits(object.totBytes.low >>> 0, object.totBytes.high >>> 0).toNumber();
                if (object.count != null)
                    if ($util.Long)
                        (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                    else if (typeof object.count === "string")
                        message.count = parseInt(object.count, 10);
                    else if (typeof object.count === "number")
                        message.count = object.count;
                    else if (typeof object.count === "object")
                        message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {tdx_response.User_StorageBreakdown.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.type = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.totBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.totBytes = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.count = options.longs === String ? "0" : 0;
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.totBytes != null && message.hasOwnProperty("totBytes"))
                    if (typeof message.totBytes === "number")
                        object.totBytes = options.longs === String ? String(message.totBytes) : message.totBytes;
                    else
                        object.totBytes = options.longs === String ? $util.Long.prototype.toString.call(message.totBytes) : options.longs === Number ? new $util.LongBits(message.totBytes.low >>> 0, message.totBytes.high >>> 0).toNumber() : message.totBytes;
                if (message.count != null && message.hasOwnProperty("count"))
                    if (typeof message.count === "number")
                        object.count = options.longs === String ? String(message.count) : message.count;
                    else
                        object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_StorageBreakdown.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_StorageBreakdown.Item";
            };

            return Item;
        })();

        return User_StorageBreakdown;
    })();

    tdx_response.User_FilesTouched = (function() {

        /**
         * Properties of a User_FilesTouched.
         * @memberof tdx_response
         * @interface IUser_FilesTouched
         * @property {tdx_response.Status|null} [status] User_FilesTouched status
         * @property {Array.<tdx_response.User_FilesTouched.IItem>|null} [items] User_FilesTouched items
         */

        /**
         * Constructs a new User_FilesTouched.
         * @memberof tdx_response
         * @classdesc Represents a User_FilesTouched.
         * @implements IUser_FilesTouched
         * @constructor
         * @param {tdx_response.IUser_FilesTouched=} [properties] Properties to set
         */
        function User_FilesTouched(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_FilesTouched status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_FilesTouched
         * @instance
         */
        User_FilesTouched.prototype.status = 0;

        /**
         * User_FilesTouched items.
         * @member {Array.<tdx_response.User_FilesTouched.IItem>} items
         * @memberof tdx_response.User_FilesTouched
         * @instance
         */
        User_FilesTouched.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_FilesTouched instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {tdx_response.IUser_FilesTouched=} [properties] Properties to set
         * @returns {tdx_response.User_FilesTouched} User_FilesTouched instance
         */
        User_FilesTouched.create = function create(properties) {
            return new User_FilesTouched(properties);
        };

        /**
         * Encodes the specified User_FilesTouched message. Does not implicitly {@link tdx_response.User_FilesTouched.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {tdx_response.IUser_FilesTouched} message User_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_FilesTouched.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_FilesTouched.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_FilesTouched message, length delimited. Does not implicitly {@link tdx_response.User_FilesTouched.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {tdx_response.IUser_FilesTouched} message User_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_FilesTouched.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_FilesTouched message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_FilesTouched} User_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_FilesTouched.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_FilesTouched();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_FilesTouched.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_FilesTouched message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_FilesTouched} User_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_FilesTouched.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_FilesTouched message.
         * @function verify
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_FilesTouched.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_FilesTouched.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_FilesTouched message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_FilesTouched} User_FilesTouched
         */
        User_FilesTouched.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_FilesTouched)
                return object;
            let message = new $root.tdx_response.User_FilesTouched();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_FilesTouched.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_FilesTouched.items: object expected");
                    message.items[i] = $root.tdx_response.User_FilesTouched.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_FilesTouched message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {tdx_response.User_FilesTouched} message User_FilesTouched
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_FilesTouched.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_FilesTouched.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_FilesTouched to JSON.
         * @function toJSON
         * @memberof tdx_response.User_FilesTouched
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_FilesTouched.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_FilesTouched
         * @function getTypeUrl
         * @memberof tdx_response.User_FilesTouched
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_FilesTouched.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_FilesTouched";
        };

        User_FilesTouched.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_FilesTouched
             * @interface IItem
             * @property {string|null} [objectPath] Item objectPath
             * @property {number|null} [reads] Item reads
             * @property {number|null} [writes] Item writes
             * @property {number|null} [shares] Item shares
             * @property {number|null} [deletes] Item deletes
             * @property {number|Long|null} [bytesOut] Item bytesOut
             * @property {number|Long|null} [lastTouched] Item lastTouched
             * @property {number|Long|null} [bytesIn] Item bytesIn
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_FilesTouched
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_FilesTouched.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item objectPath.
             * @member {string} objectPath
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.objectPath = "";

            /**
             * Item reads.
             * @member {number} reads
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.reads = 0;

            /**
             * Item writes.
             * @member {number} writes
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.writes = 0;

            /**
             * Item shares.
             * @member {number} shares
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.shares = 0;

            /**
             * Item deletes.
             * @member {number} deletes
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.deletes = 0;

            /**
             * Item bytesOut.
             * @member {number|Long} bytesOut
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.bytesOut = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Item lastTouched.
             * @member {number|Long} lastTouched
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.lastTouched = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Item bytesIn.
             * @member {number|Long} bytesIn
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             */
            Item.prototype.bytesIn = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {tdx_response.User_FilesTouched.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_FilesTouched.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_FilesTouched.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {tdx_response.User_FilesTouched.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.objectPath != null && Object.hasOwnProperty.call(message, "objectPath"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.objectPath);
                if (message.reads != null && Object.hasOwnProperty.call(message, "reads"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.reads);
                if (message.writes != null && Object.hasOwnProperty.call(message, "writes"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.writes);
                if (message.shares != null && Object.hasOwnProperty.call(message, "shares"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.shares);
                if (message.deletes != null && Object.hasOwnProperty.call(message, "deletes"))
                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.deletes);
                if (message.bytesOut != null && Object.hasOwnProperty.call(message, "bytesOut"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.bytesOut);
                if (message.lastTouched != null && Object.hasOwnProperty.call(message, "lastTouched"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastTouched);
                if (message.bytesIn != null && Object.hasOwnProperty.call(message, "bytesIn"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.bytesIn);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_FilesTouched.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {tdx_response.User_FilesTouched.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_FilesTouched.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_FilesTouched.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.objectPath = reader.string();
                            break;
                        }
                    case 2: {
                            message.reads = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.writes = reader.uint32();
                            break;
                        }
                    case 4: {
                            message.shares = reader.uint32();
                            break;
                        }
                    case 5: {
                            message.deletes = reader.uint32();
                            break;
                        }
                    case 6: {
                            message.bytesOut = reader.int64();
                            break;
                        }
                    case 7: {
                            message.lastTouched = reader.int64();
                            break;
                        }
                    case 8: {
                            message.bytesIn = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_FilesTouched.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                    if (!$util.isString(message.objectPath))
                        return "objectPath: string expected";
                if (message.reads != null && message.hasOwnProperty("reads"))
                    if (!$util.isInteger(message.reads))
                        return "reads: integer expected";
                if (message.writes != null && message.hasOwnProperty("writes"))
                    if (!$util.isInteger(message.writes))
                        return "writes: integer expected";
                if (message.shares != null && message.hasOwnProperty("shares"))
                    if (!$util.isInteger(message.shares))
                        return "shares: integer expected";
                if (message.deletes != null && message.hasOwnProperty("deletes"))
                    if (!$util.isInteger(message.deletes))
                        return "deletes: integer expected";
                if (message.bytesOut != null && message.hasOwnProperty("bytesOut"))
                    if (!$util.isInteger(message.bytesOut) && !(message.bytesOut && $util.isInteger(message.bytesOut.low) && $util.isInteger(message.bytesOut.high)))
                        return "bytesOut: integer|Long expected";
                if (message.lastTouched != null && message.hasOwnProperty("lastTouched"))
                    if (!$util.isInteger(message.lastTouched) && !(message.lastTouched && $util.isInteger(message.lastTouched.low) && $util.isInteger(message.lastTouched.high)))
                        return "lastTouched: integer|Long expected";
                if (message.bytesIn != null && message.hasOwnProperty("bytesIn"))
                    if (!$util.isInteger(message.bytesIn) && !(message.bytesIn && $util.isInteger(message.bytesIn.low) && $util.isInteger(message.bytesIn.high)))
                        return "bytesIn: integer|Long expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_FilesTouched.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_FilesTouched.Item)
                    return object;
                let message = new $root.tdx_response.User_FilesTouched.Item();
                if (object.objectPath != null)
                    message.objectPath = String(object.objectPath);
                if (object.reads != null)
                    message.reads = object.reads >>> 0;
                if (object.writes != null)
                    message.writes = object.writes >>> 0;
                if (object.shares != null)
                    message.shares = object.shares >>> 0;
                if (object.deletes != null)
                    message.deletes = object.deletes >>> 0;
                if (object.bytesOut != null)
                    if ($util.Long)
                        (message.bytesOut = $util.Long.fromValue(object.bytesOut)).unsigned = false;
                    else if (typeof object.bytesOut === "string")
                        message.bytesOut = parseInt(object.bytesOut, 10);
                    else if (typeof object.bytesOut === "number")
                        message.bytesOut = object.bytesOut;
                    else if (typeof object.bytesOut === "object")
                        message.bytesOut = new $util.LongBits(object.bytesOut.low >>> 0, object.bytesOut.high >>> 0).toNumber();
                if (object.lastTouched != null)
                    if ($util.Long)
                        (message.lastTouched = $util.Long.fromValue(object.lastTouched)).unsigned = false;
                    else if (typeof object.lastTouched === "string")
                        message.lastTouched = parseInt(object.lastTouched, 10);
                    else if (typeof object.lastTouched === "number")
                        message.lastTouched = object.lastTouched;
                    else if (typeof object.lastTouched === "object")
                        message.lastTouched = new $util.LongBits(object.lastTouched.low >>> 0, object.lastTouched.high >>> 0).toNumber();
                if (object.bytesIn != null)
                    if ($util.Long)
                        (message.bytesIn = $util.Long.fromValue(object.bytesIn)).unsigned = false;
                    else if (typeof object.bytesIn === "string")
                        message.bytesIn = parseInt(object.bytesIn, 10);
                    else if (typeof object.bytesIn === "number")
                        message.bytesIn = object.bytesIn;
                    else if (typeof object.bytesIn === "object")
                        message.bytesIn = new $util.LongBits(object.bytesIn.low >>> 0, object.bytesIn.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {tdx_response.User_FilesTouched.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.objectPath = "";
                    object.reads = 0;
                    object.writes = 0;
                    object.shares = 0;
                    object.deletes = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.bytesOut = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.bytesOut = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.lastTouched = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lastTouched = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.bytesIn = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.bytesIn = options.longs === String ? "0" : 0;
                }
                if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                    object.objectPath = message.objectPath;
                if (message.reads != null && message.hasOwnProperty("reads"))
                    object.reads = message.reads;
                if (message.writes != null && message.hasOwnProperty("writes"))
                    object.writes = message.writes;
                if (message.shares != null && message.hasOwnProperty("shares"))
                    object.shares = message.shares;
                if (message.deletes != null && message.hasOwnProperty("deletes"))
                    object.deletes = message.deletes;
                if (message.bytesOut != null && message.hasOwnProperty("bytesOut"))
                    if (typeof message.bytesOut === "number")
                        object.bytesOut = options.longs === String ? String(message.bytesOut) : message.bytesOut;
                    else
                        object.bytesOut = options.longs === String ? $util.Long.prototype.toString.call(message.bytesOut) : options.longs === Number ? new $util.LongBits(message.bytesOut.low >>> 0, message.bytesOut.high >>> 0).toNumber() : message.bytesOut;
                if (message.lastTouched != null && message.hasOwnProperty("lastTouched"))
                    if (typeof message.lastTouched === "number")
                        object.lastTouched = options.longs === String ? String(message.lastTouched) : message.lastTouched;
                    else
                        object.lastTouched = options.longs === String ? $util.Long.prototype.toString.call(message.lastTouched) : options.longs === Number ? new $util.LongBits(message.lastTouched.low >>> 0, message.lastTouched.high >>> 0).toNumber() : message.lastTouched;
                if (message.bytesIn != null && message.hasOwnProperty("bytesIn"))
                    if (typeof message.bytesIn === "number")
                        object.bytesIn = options.longs === String ? String(message.bytesIn) : message.bytesIn;
                    else
                        object.bytesIn = options.longs === String ? $util.Long.prototype.toString.call(message.bytesIn) : options.longs === Number ? new $util.LongBits(message.bytesIn.low >>> 0, message.bytesIn.high >>> 0).toNumber() : message.bytesIn;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_FilesTouched.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_FilesTouched.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_FilesTouched.Item";
            };

            return Item;
        })();

        return User_FilesTouched;
    })();

    tdx_response.User_SharingActions = (function() {

        /**
         * Properties of a User_SharingActions.
         * @memberof tdx_response
         * @interface IUser_SharingActions
         * @property {tdx_response.Status|null} [status] User_SharingActions status
         * @property {Array.<tdx_response.User_SharingActions.IItem>|null} [items] User_SharingActions items
         */

        /**
         * Constructs a new User_SharingActions.
         * @memberof tdx_response
         * @classdesc Represents a User_SharingActions.
         * @implements IUser_SharingActions
         * @constructor
         * @param {tdx_response.IUser_SharingActions=} [properties] Properties to set
         */
        function User_SharingActions(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_SharingActions status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_SharingActions
         * @instance
         */
        User_SharingActions.prototype.status = 0;

        /**
         * User_SharingActions items.
         * @member {Array.<tdx_response.User_SharingActions.IItem>} items
         * @memberof tdx_response.User_SharingActions
         * @instance
         */
        User_SharingActions.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_SharingActions instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {tdx_response.IUser_SharingActions=} [properties] Properties to set
         * @returns {tdx_response.User_SharingActions} User_SharingActions instance
         */
        User_SharingActions.create = function create(properties) {
            return new User_SharingActions(properties);
        };

        /**
         * Encodes the specified User_SharingActions message. Does not implicitly {@link tdx_response.User_SharingActions.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {tdx_response.IUser_SharingActions} message User_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_SharingActions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_SharingActions.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_SharingActions message, length delimited. Does not implicitly {@link tdx_response.User_SharingActions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {tdx_response.IUser_SharingActions} message User_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_SharingActions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_SharingActions message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_SharingActions} User_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_SharingActions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_SharingActions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_SharingActions.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_SharingActions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_SharingActions} User_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_SharingActions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_SharingActions message.
         * @function verify
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_SharingActions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_SharingActions.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_SharingActions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_SharingActions} User_SharingActions
         */
        User_SharingActions.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_SharingActions)
                return object;
            let message = new $root.tdx_response.User_SharingActions();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_SharingActions.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_SharingActions.items: object expected");
                    message.items[i] = $root.tdx_response.User_SharingActions.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_SharingActions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {tdx_response.User_SharingActions} message User_SharingActions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_SharingActions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_SharingActions.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_SharingActions to JSON.
         * @function toJSON
         * @memberof tdx_response.User_SharingActions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_SharingActions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_SharingActions
         * @function getTypeUrl
         * @memberof tdx_response.User_SharingActions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_SharingActions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_SharingActions";
        };

        User_SharingActions.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_SharingActions
             * @interface IItem
             * @property {number|Long|null} [timestamp] Item timestamp
             * @property {string|null} [objectPath] Item objectPath
             * @property {string|null} [recipient] Item recipient
             * @property {string|null} [recipientType] Item recipientType
             * @property {boolean|null} [success] Item success
             * @property {string|null} [grantedBy] Item grantedBy
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_SharingActions
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_SharingActions.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item timestamp.
             * @member {number|Long} timestamp
             * @memberof tdx_response.User_SharingActions.Item
             * @instance
             */
            Item.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item objectPath.
             * @member {string} objectPath
             * @memberof tdx_response.User_SharingActions.Item
             * @instance
             */
            Item.prototype.objectPath = "";

            /**
             * Item recipient.
             * @member {string} recipient
             * @memberof tdx_response.User_SharingActions.Item
             * @instance
             */
            Item.prototype.recipient = "";

            /**
             * Item recipientType.
             * @member {string} recipientType
             * @memberof tdx_response.User_SharingActions.Item
             * @instance
             */
            Item.prototype.recipientType = "";

            /**
             * Item success.
             * @member {boolean} success
             * @memberof tdx_response.User_SharingActions.Item
             * @instance
             */
            Item.prototype.success = false;

            /**
             * Item grantedBy.
             * @member {string} grantedBy
             * @memberof tdx_response.User_SharingActions.Item
             * @instance
             */
            Item.prototype.grantedBy = "";

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {tdx_response.User_SharingActions.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_SharingActions.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_SharingActions.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {tdx_response.User_SharingActions.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
                if (message.objectPath != null && Object.hasOwnProperty.call(message, "objectPath"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.objectPath);
                if (message.recipient != null && Object.hasOwnProperty.call(message, "recipient"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.recipient);
                if (message.recipientType != null && Object.hasOwnProperty.call(message, "recipientType"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.recipientType);
                if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.success);
                if (message.grantedBy != null && Object.hasOwnProperty.call(message, "grantedBy"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.grantedBy);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_SharingActions.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {tdx_response.User_SharingActions.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_SharingActions.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_SharingActions.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.timestamp = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.objectPath = reader.string();
                            break;
                        }
                    case 3: {
                            message.recipient = reader.string();
                            break;
                        }
                    case 4: {
                            message.recipientType = reader.string();
                            break;
                        }
                    case 5: {
                            message.success = reader.bool();
                            break;
                        }
                    case 6: {
                            message.grantedBy = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_SharingActions.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                    if (!$util.isString(message.objectPath))
                        return "objectPath: string expected";
                if (message.recipient != null && message.hasOwnProperty("recipient"))
                    if (!$util.isString(message.recipient))
                        return "recipient: string expected";
                if (message.recipientType != null && message.hasOwnProperty("recipientType"))
                    if (!$util.isString(message.recipientType))
                        return "recipientType: string expected";
                if (message.success != null && message.hasOwnProperty("success"))
                    if (typeof message.success !== "boolean")
                        return "success: boolean expected";
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    if (!$util.isString(message.grantedBy))
                        return "grantedBy: string expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_SharingActions.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_SharingActions.Item)
                    return object;
                let message = new $root.tdx_response.User_SharingActions.Item();
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                if (object.objectPath != null)
                    message.objectPath = String(object.objectPath);
                if (object.recipient != null)
                    message.recipient = String(object.recipient);
                if (object.recipientType != null)
                    message.recipientType = String(object.recipientType);
                if (object.success != null)
                    message.success = Boolean(object.success);
                if (object.grantedBy != null)
                    message.grantedBy = String(object.grantedBy);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {tdx_response.User_SharingActions.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    object.objectPath = "";
                    object.recipient = "";
                    object.recipientType = "";
                    object.success = false;
                    object.grantedBy = "";
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                    object.objectPath = message.objectPath;
                if (message.recipient != null && message.hasOwnProperty("recipient"))
                    object.recipient = message.recipient;
                if (message.recipientType != null && message.hasOwnProperty("recipientType"))
                    object.recipientType = message.recipientType;
                if (message.success != null && message.hasOwnProperty("success"))
                    object.success = message.success;
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    object.grantedBy = message.grantedBy;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_SharingActions.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_SharingActions.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_SharingActions.Item";
            };

            return Item;
        })();

        return User_SharingActions;
    })();

    tdx_response.User_PermissionRecieved = (function() {

        /**
         * Properties of a User_PermissionRecieved.
         * @memberof tdx_response
         * @interface IUser_PermissionRecieved
         * @property {tdx_response.Status|null} [status] User_PermissionRecieved status
         * @property {Array.<string>|null} [roles] User_PermissionRecieved roles
         * @property {Array.<string>|null} [teams] User_PermissionRecieved teams
         */

        /**
         * Constructs a new User_PermissionRecieved.
         * @memberof tdx_response
         * @classdesc Represents a User_PermissionRecieved.
         * @implements IUser_PermissionRecieved
         * @constructor
         * @param {tdx_response.IUser_PermissionRecieved=} [properties] Properties to set
         */
        function User_PermissionRecieved(properties) {
            this.roles = [];
            this.teams = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_PermissionRecieved status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.status = 0;

        /**
         * User_PermissionRecieved roles.
         * @member {Array.<string>} roles
         * @memberof tdx_response.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.roles = $util.emptyArray;

        /**
         * User_PermissionRecieved teams.
         * @member {Array.<string>} teams
         * @memberof tdx_response.User_PermissionRecieved
         * @instance
         */
        User_PermissionRecieved.prototype.teams = $util.emptyArray;

        /**
         * Creates a new User_PermissionRecieved instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {tdx_response.IUser_PermissionRecieved=} [properties] Properties to set
         * @returns {tdx_response.User_PermissionRecieved} User_PermissionRecieved instance
         */
        User_PermissionRecieved.create = function create(properties) {
            return new User_PermissionRecieved(properties);
        };

        /**
         * Encodes the specified User_PermissionRecieved message. Does not implicitly {@link tdx_response.User_PermissionRecieved.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {tdx_response.IUser_PermissionRecieved} message User_PermissionRecieved message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_PermissionRecieved.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.roles != null && message.roles.length)
                for (let i = 0; i < message.roles.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.roles[i]);
            if (message.teams != null && message.teams.length)
                for (let i = 0; i < message.teams.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.teams[i]);
            return writer;
        };

        /**
         * Encodes the specified User_PermissionRecieved message, length delimited. Does not implicitly {@link tdx_response.User_PermissionRecieved.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {tdx_response.IUser_PermissionRecieved} message User_PermissionRecieved message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_PermissionRecieved.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_PermissionRecieved message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_PermissionRecieved} User_PermissionRecieved
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_PermissionRecieved.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_PermissionRecieved();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.roles && message.roles.length))
                            message.roles = [];
                        message.roles.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.teams && message.teams.length))
                            message.teams = [];
                        message.teams.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_PermissionRecieved message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_PermissionRecieved} User_PermissionRecieved
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_PermissionRecieved.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_PermissionRecieved message.
         * @function verify
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_PermissionRecieved.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.roles != null && message.hasOwnProperty("roles")) {
                if (!Array.isArray(message.roles))
                    return "roles: array expected";
                for (let i = 0; i < message.roles.length; ++i)
                    if (!$util.isString(message.roles[i]))
                        return "roles: string[] expected";
            }
            if (message.teams != null && message.hasOwnProperty("teams")) {
                if (!Array.isArray(message.teams))
                    return "teams: array expected";
                for (let i = 0; i < message.teams.length; ++i)
                    if (!$util.isString(message.teams[i]))
                        return "teams: string[] expected";
            }
            return null;
        };

        /**
         * Creates a User_PermissionRecieved message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_PermissionRecieved} User_PermissionRecieved
         */
        User_PermissionRecieved.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_PermissionRecieved)
                return object;
            let message = new $root.tdx_response.User_PermissionRecieved();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.roles) {
                if (!Array.isArray(object.roles))
                    throw TypeError(".tdx_response.User_PermissionRecieved.roles: array expected");
                message.roles = [];
                for (let i = 0; i < object.roles.length; ++i)
                    message.roles[i] = String(object.roles[i]);
            }
            if (object.teams) {
                if (!Array.isArray(object.teams))
                    throw TypeError(".tdx_response.User_PermissionRecieved.teams: array expected");
                message.teams = [];
                for (let i = 0; i < object.teams.length; ++i)
                    message.teams[i] = String(object.teams[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a User_PermissionRecieved message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {tdx_response.User_PermissionRecieved} message User_PermissionRecieved
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_PermissionRecieved.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.roles = [];
                object.teams = [];
            }
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.roles && message.roles.length) {
                object.roles = [];
                for (let j = 0; j < message.roles.length; ++j)
                    object.roles[j] = message.roles[j];
            }
            if (message.teams && message.teams.length) {
                object.teams = [];
                for (let j = 0; j < message.teams.length; ++j)
                    object.teams[j] = message.teams[j];
            }
            return object;
        };

        /**
         * Converts this User_PermissionRecieved to JSON.
         * @function toJSON
         * @memberof tdx_response.User_PermissionRecieved
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_PermissionRecieved.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_PermissionRecieved
         * @function getTypeUrl
         * @memberof tdx_response.User_PermissionRecieved
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_PermissionRecieved.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_PermissionRecieved";
        };

        return User_PermissionRecieved;
    })();

    tdx_response.User_DeniedAttempts = (function() {

        /**
         * Properties of a User_DeniedAttempts.
         * @memberof tdx_response
         * @interface IUser_DeniedAttempts
         * @property {tdx_response.Status|null} [status] User_DeniedAttempts status
         * @property {Array.<tdx_response.User_DeniedAttempts.IItem>|null} [items] User_DeniedAttempts items
         */

        /**
         * Constructs a new User_DeniedAttempts.
         * @memberof tdx_response
         * @classdesc Represents a User_DeniedAttempts.
         * @implements IUser_DeniedAttempts
         * @constructor
         * @param {tdx_response.IUser_DeniedAttempts=} [properties] Properties to set
         */
        function User_DeniedAttempts(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_DeniedAttempts status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_DeniedAttempts
         * @instance
         */
        User_DeniedAttempts.prototype.status = 0;

        /**
         * User_DeniedAttempts items.
         * @member {Array.<tdx_response.User_DeniedAttempts.IItem>} items
         * @memberof tdx_response.User_DeniedAttempts
         * @instance
         */
        User_DeniedAttempts.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_DeniedAttempts instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {tdx_response.IUser_DeniedAttempts=} [properties] Properties to set
         * @returns {tdx_response.User_DeniedAttempts} User_DeniedAttempts instance
         */
        User_DeniedAttempts.create = function create(properties) {
            return new User_DeniedAttempts(properties);
        };

        /**
         * Encodes the specified User_DeniedAttempts message. Does not implicitly {@link tdx_response.User_DeniedAttempts.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {tdx_response.IUser_DeniedAttempts} message User_DeniedAttempts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_DeniedAttempts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_DeniedAttempts.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_DeniedAttempts message, length delimited. Does not implicitly {@link tdx_response.User_DeniedAttempts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {tdx_response.IUser_DeniedAttempts} message User_DeniedAttempts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_DeniedAttempts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_DeniedAttempts message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_DeniedAttempts} User_DeniedAttempts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_DeniedAttempts.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_DeniedAttempts();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_DeniedAttempts.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_DeniedAttempts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_DeniedAttempts} User_DeniedAttempts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_DeniedAttempts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_DeniedAttempts message.
         * @function verify
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_DeniedAttempts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_DeniedAttempts.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_DeniedAttempts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_DeniedAttempts} User_DeniedAttempts
         */
        User_DeniedAttempts.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_DeniedAttempts)
                return object;
            let message = new $root.tdx_response.User_DeniedAttempts();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_DeniedAttempts.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_DeniedAttempts.items: object expected");
                    message.items[i] = $root.tdx_response.User_DeniedAttempts.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_DeniedAttempts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {tdx_response.User_DeniedAttempts} message User_DeniedAttempts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_DeniedAttempts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_DeniedAttempts.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_DeniedAttempts to JSON.
         * @function toJSON
         * @memberof tdx_response.User_DeniedAttempts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_DeniedAttempts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_DeniedAttempts
         * @function getTypeUrl
         * @memberof tdx_response.User_DeniedAttempts
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_DeniedAttempts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_DeniedAttempts";
        };

        User_DeniedAttempts.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_DeniedAttempts
             * @interface IItem
             * @property {string|null} [operation] Item operation
             * @property {number|Long|null} [timestamp] Item timestamp
             * @property {string|null} [message] Item message
             * @property {string|null} [objectPath] Item objectPath
             * @property {string|null} [ipAddress] Item ipAddress
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_DeniedAttempts
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_DeniedAttempts.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item operation.
             * @member {string} operation
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @instance
             */
            Item.prototype.operation = "";

            /**
             * Item timestamp.
             * @member {number|Long} timestamp
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @instance
             */
            Item.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item message.
             * @member {string} message
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @instance
             */
            Item.prototype.message = "";

            /**
             * Item objectPath.
             * @member {string} objectPath
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @instance
             */
            Item.prototype.objectPath = "";

            /**
             * Item ipAddress.
             * @member {string} ipAddress
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @instance
             */
            Item.prototype.ipAddress = "";

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {tdx_response.User_DeniedAttempts.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_DeniedAttempts.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_DeniedAttempts.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {tdx_response.User_DeniedAttempts.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.operation);
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.timestamp);
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
                if (message.objectPath != null && Object.hasOwnProperty.call(message, "objectPath"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.objectPath);
                if (message.ipAddress != null && Object.hasOwnProperty.call(message, "ipAddress"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.ipAddress);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_DeniedAttempts.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {tdx_response.User_DeniedAttempts.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_DeniedAttempts.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_DeniedAttempts.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.operation = reader.string();
                            break;
                        }
                    case 2: {
                            message.timestamp = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.message = reader.string();
                            break;
                        }
                    case 4: {
                            message.objectPath = reader.string();
                            break;
                        }
                    case 5: {
                            message.ipAddress = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_DeniedAttempts.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                    if (!$util.isString(message.objectPath))
                        return "objectPath: string expected";
                if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                    if (!$util.isString(message.ipAddress))
                        return "ipAddress: string expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_DeniedAttempts.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_DeniedAttempts.Item)
                    return object;
                let message = new $root.tdx_response.User_DeniedAttempts.Item();
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                if (object.message != null)
                    message.message = String(object.message);
                if (object.objectPath != null)
                    message.objectPath = String(object.objectPath);
                if (object.ipAddress != null)
                    message.ipAddress = String(object.ipAddress);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {tdx_response.User_DeniedAttempts.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.operation = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    object.message = "";
                    object.objectPath = "";
                    object.ipAddress = "";
                }
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                    object.objectPath = message.objectPath;
                if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                    object.ipAddress = message.ipAddress;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_DeniedAttempts.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_DeniedAttempts.Item";
            };

            return Item;
        })();

        return User_DeniedAttempts;
    })();

    tdx_response.User_RiskScore = (function() {

        /**
         * Properties of a User_RiskScore.
         * @memberof tdx_response
         * @interface IUser_RiskScore
         * @property {tdx_response.Status|null} [status] User_RiskScore status
         * @property {Array.<tdx_response.User_RiskScore.IItem>|null} [items] User_RiskScore items
         */

        /**
         * Constructs a new User_RiskScore.
         * @memberof tdx_response
         * @classdesc Represents a User_RiskScore.
         * @implements IUser_RiskScore
         * @constructor
         * @param {tdx_response.IUser_RiskScore=} [properties] Properties to set
         */
        function User_RiskScore(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_RiskScore status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_RiskScore
         * @instance
         */
        User_RiskScore.prototype.status = 0;

        /**
         * User_RiskScore items.
         * @member {Array.<tdx_response.User_RiskScore.IItem>} items
         * @memberof tdx_response.User_RiskScore
         * @instance
         */
        User_RiskScore.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_RiskScore instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {tdx_response.IUser_RiskScore=} [properties] Properties to set
         * @returns {tdx_response.User_RiskScore} User_RiskScore instance
         */
        User_RiskScore.create = function create(properties) {
            return new User_RiskScore(properties);
        };

        /**
         * Encodes the specified User_RiskScore message. Does not implicitly {@link tdx_response.User_RiskScore.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {tdx_response.IUser_RiskScore} message User_RiskScore message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_RiskScore.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_RiskScore.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_RiskScore message, length delimited. Does not implicitly {@link tdx_response.User_RiskScore.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {tdx_response.IUser_RiskScore} message User_RiskScore message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_RiskScore.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_RiskScore message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_RiskScore} User_RiskScore
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_RiskScore.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_RiskScore();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_RiskScore.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_RiskScore message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_RiskScore} User_RiskScore
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_RiskScore.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_RiskScore message.
         * @function verify
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_RiskScore.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_RiskScore.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_RiskScore message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_RiskScore} User_RiskScore
         */
        User_RiskScore.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_RiskScore)
                return object;
            let message = new $root.tdx_response.User_RiskScore();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_RiskScore.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_RiskScore.items: object expected");
                    message.items[i] = $root.tdx_response.User_RiskScore.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_RiskScore message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {tdx_response.User_RiskScore} message User_RiskScore
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_RiskScore.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_RiskScore.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_RiskScore to JSON.
         * @function toJSON
         * @memberof tdx_response.User_RiskScore
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_RiskScore.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_RiskScore
         * @function getTypeUrl
         * @memberof tdx_response.User_RiskScore
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_RiskScore.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_RiskScore";
        };

        User_RiskScore.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_RiskScore
             * @interface IItem
             * @property {number|Long|null} [totalEvents] Item totalEvents
             * @property {string|null} [signal] Item signal
             * @property {number|Long|null} [count] Item count
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_RiskScore
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_RiskScore.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item totalEvents.
             * @member {number|Long} totalEvents
             * @memberof tdx_response.User_RiskScore.Item
             * @instance
             */
            Item.prototype.totalEvents = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item signal.
             * @member {string} signal
             * @memberof tdx_response.User_RiskScore.Item
             * @instance
             */
            Item.prototype.signal = "";

            /**
             * Item count.
             * @member {number|Long} count
             * @memberof tdx_response.User_RiskScore.Item
             * @instance
             */
            Item.prototype.count = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {tdx_response.User_RiskScore.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_RiskScore.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_RiskScore.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {tdx_response.User_RiskScore.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.totalEvents != null && Object.hasOwnProperty.call(message, "totalEvents"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.totalEvents);
                if (message.signal != null && Object.hasOwnProperty.call(message, "signal"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.signal);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.count);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_RiskScore.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {tdx_response.User_RiskScore.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_RiskScore.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_RiskScore.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.totalEvents = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.signal = reader.string();
                            break;
                        }
                    case 3: {
                            message.count = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_RiskScore.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.totalEvents != null && message.hasOwnProperty("totalEvents"))
                    if (!$util.isInteger(message.totalEvents) && !(message.totalEvents && $util.isInteger(message.totalEvents.low) && $util.isInteger(message.totalEvents.high)))
                        return "totalEvents: integer|Long expected";
                if (message.signal != null && message.hasOwnProperty("signal"))
                    if (!$util.isString(message.signal))
                        return "signal: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                        return "count: integer|Long expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_RiskScore.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_RiskScore.Item)
                    return object;
                let message = new $root.tdx_response.User_RiskScore.Item();
                if (object.totalEvents != null)
                    if ($util.Long)
                        (message.totalEvents = $util.Long.fromValue(object.totalEvents)).unsigned = true;
                    else if (typeof object.totalEvents === "string")
                        message.totalEvents = parseInt(object.totalEvents, 10);
                    else if (typeof object.totalEvents === "number")
                        message.totalEvents = object.totalEvents;
                    else if (typeof object.totalEvents === "object")
                        message.totalEvents = new $util.LongBits(object.totalEvents.low >>> 0, object.totalEvents.high >>> 0).toNumber(true);
                if (object.signal != null)
                    message.signal = String(object.signal);
                if (object.count != null)
                    if ($util.Long)
                        (message.count = $util.Long.fromValue(object.count)).unsigned = true;
                    else if (typeof object.count === "string")
                        message.count = parseInt(object.count, 10);
                    else if (typeof object.count === "number")
                        message.count = object.count;
                    else if (typeof object.count === "object")
                        message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {tdx_response.User_RiskScore.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.totalEvents = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.totalEvents = options.longs === String ? "0" : 0;
                    object.signal = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.count = options.longs === String ? "0" : 0;
                }
                if (message.totalEvents != null && message.hasOwnProperty("totalEvents"))
                    if (typeof message.totalEvents === "number")
                        object.totalEvents = options.longs === String ? String(message.totalEvents) : message.totalEvents;
                    else
                        object.totalEvents = options.longs === String ? $util.Long.prototype.toString.call(message.totalEvents) : options.longs === Number ? new $util.LongBits(message.totalEvents.low >>> 0, message.totalEvents.high >>> 0).toNumber(true) : message.totalEvents;
                if (message.signal != null && message.hasOwnProperty("signal"))
                    object.signal = message.signal;
                if (message.count != null && message.hasOwnProperty("count"))
                    if (typeof message.count === "number")
                        object.count = options.longs === String ? String(message.count) : message.count;
                    else
                        object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber(true) : message.count;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_RiskScore.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_RiskScore.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_RiskScore.Item";
            };

            return Item;
        })();

        return User_RiskScore;
    })();

    tdx_response.User_TopContributingSignals = (function() {

        /**
         * Properties of a User_TopContributingSignals.
         * @memberof tdx_response
         * @interface IUser_TopContributingSignals
         * @property {tdx_response.Status|null} [status] User_TopContributingSignals status
         * @property {Array.<tdx_response.User_TopContributingSignals.IItem>|null} [items] User_TopContributingSignals items
         */

        /**
         * Constructs a new User_TopContributingSignals.
         * @memberof tdx_response
         * @classdesc Represents a User_TopContributingSignals.
         * @implements IUser_TopContributingSignals
         * @constructor
         * @param {tdx_response.IUser_TopContributingSignals=} [properties] Properties to set
         */
        function User_TopContributingSignals(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_TopContributingSignals status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_TopContributingSignals
         * @instance
         */
        User_TopContributingSignals.prototype.status = 0;

        /**
         * User_TopContributingSignals items.
         * @member {Array.<tdx_response.User_TopContributingSignals.IItem>} items
         * @memberof tdx_response.User_TopContributingSignals
         * @instance
         */
        User_TopContributingSignals.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_TopContributingSignals instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {tdx_response.IUser_TopContributingSignals=} [properties] Properties to set
         * @returns {tdx_response.User_TopContributingSignals} User_TopContributingSignals instance
         */
        User_TopContributingSignals.create = function create(properties) {
            return new User_TopContributingSignals(properties);
        };

        /**
         * Encodes the specified User_TopContributingSignals message. Does not implicitly {@link tdx_response.User_TopContributingSignals.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {tdx_response.IUser_TopContributingSignals} message User_TopContributingSignals message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TopContributingSignals.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_TopContributingSignals.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_TopContributingSignals message, length delimited. Does not implicitly {@link tdx_response.User_TopContributingSignals.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {tdx_response.IUser_TopContributingSignals} message User_TopContributingSignals message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TopContributingSignals.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_TopContributingSignals message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_TopContributingSignals} User_TopContributingSignals
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TopContributingSignals.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_TopContributingSignals();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_TopContributingSignals.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_TopContributingSignals message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_TopContributingSignals} User_TopContributingSignals
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TopContributingSignals.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_TopContributingSignals message.
         * @function verify
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_TopContributingSignals.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_TopContributingSignals.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_TopContributingSignals message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_TopContributingSignals} User_TopContributingSignals
         */
        User_TopContributingSignals.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_TopContributingSignals)
                return object;
            let message = new $root.tdx_response.User_TopContributingSignals();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_TopContributingSignals.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_TopContributingSignals.items: object expected");
                    message.items[i] = $root.tdx_response.User_TopContributingSignals.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_TopContributingSignals message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {tdx_response.User_TopContributingSignals} message User_TopContributingSignals
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_TopContributingSignals.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_TopContributingSignals.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_TopContributingSignals to JSON.
         * @function toJSON
         * @memberof tdx_response.User_TopContributingSignals
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_TopContributingSignals.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_TopContributingSignals
         * @function getTypeUrl
         * @memberof tdx_response.User_TopContributingSignals
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_TopContributingSignals.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_TopContributingSignals";
        };

        User_TopContributingSignals.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_TopContributingSignals
             * @interface IItem
             * @property {number|Long|null} [priorPeriodEvents] Item priorPeriodEvents
             * @property {number|Long|null} [currentPeriodEvents] Item currentPeriodEvents
             * @property {boolean|null} [dormantBecameActive] Item dormantBecameActive
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_TopContributingSignals
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_TopContributingSignals.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item priorPeriodEvents.
             * @member {number|Long} priorPeriodEvents
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @instance
             */
            Item.prototype.priorPeriodEvents = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item currentPeriodEvents.
             * @member {number|Long} currentPeriodEvents
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @instance
             */
            Item.prototype.currentPeriodEvents = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item dormantBecameActive.
             * @member {boolean} dormantBecameActive
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @instance
             */
            Item.prototype.dormantBecameActive = false;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {tdx_response.User_TopContributingSignals.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_TopContributingSignals.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_TopContributingSignals.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {tdx_response.User_TopContributingSignals.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.priorPeriodEvents != null && Object.hasOwnProperty.call(message, "priorPeriodEvents"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.priorPeriodEvents);
                if (message.currentPeriodEvents != null && Object.hasOwnProperty.call(message, "currentPeriodEvents"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.currentPeriodEvents);
                if (message.dormantBecameActive != null && Object.hasOwnProperty.call(message, "dormantBecameActive"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.dormantBecameActive);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_TopContributingSignals.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {tdx_response.User_TopContributingSignals.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_TopContributingSignals.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_TopContributingSignals.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.priorPeriodEvents = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.currentPeriodEvents = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.dormantBecameActive = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_TopContributingSignals.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.priorPeriodEvents != null && message.hasOwnProperty("priorPeriodEvents"))
                    if (!$util.isInteger(message.priorPeriodEvents) && !(message.priorPeriodEvents && $util.isInteger(message.priorPeriodEvents.low) && $util.isInteger(message.priorPeriodEvents.high)))
                        return "priorPeriodEvents: integer|Long expected";
                if (message.currentPeriodEvents != null && message.hasOwnProperty("currentPeriodEvents"))
                    if (!$util.isInteger(message.currentPeriodEvents) && !(message.currentPeriodEvents && $util.isInteger(message.currentPeriodEvents.low) && $util.isInteger(message.currentPeriodEvents.high)))
                        return "currentPeriodEvents: integer|Long expected";
                if (message.dormantBecameActive != null && message.hasOwnProperty("dormantBecameActive"))
                    if (typeof message.dormantBecameActive !== "boolean")
                        return "dormantBecameActive: boolean expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_TopContributingSignals.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_TopContributingSignals.Item)
                    return object;
                let message = new $root.tdx_response.User_TopContributingSignals.Item();
                if (object.priorPeriodEvents != null)
                    if ($util.Long)
                        (message.priorPeriodEvents = $util.Long.fromValue(object.priorPeriodEvents)).unsigned = true;
                    else if (typeof object.priorPeriodEvents === "string")
                        message.priorPeriodEvents = parseInt(object.priorPeriodEvents, 10);
                    else if (typeof object.priorPeriodEvents === "number")
                        message.priorPeriodEvents = object.priorPeriodEvents;
                    else if (typeof object.priorPeriodEvents === "object")
                        message.priorPeriodEvents = new $util.LongBits(object.priorPeriodEvents.low >>> 0, object.priorPeriodEvents.high >>> 0).toNumber(true);
                if (object.currentPeriodEvents != null)
                    if ($util.Long)
                        (message.currentPeriodEvents = $util.Long.fromValue(object.currentPeriodEvents)).unsigned = true;
                    else if (typeof object.currentPeriodEvents === "string")
                        message.currentPeriodEvents = parseInt(object.currentPeriodEvents, 10);
                    else if (typeof object.currentPeriodEvents === "number")
                        message.currentPeriodEvents = object.currentPeriodEvents;
                    else if (typeof object.currentPeriodEvents === "object")
                        message.currentPeriodEvents = new $util.LongBits(object.currentPeriodEvents.low >>> 0, object.currentPeriodEvents.high >>> 0).toNumber(true);
                if (object.dormantBecameActive != null)
                    message.dormantBecameActive = Boolean(object.dormantBecameActive);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {tdx_response.User_TopContributingSignals.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.priorPeriodEvents = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.priorPeriodEvents = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.currentPeriodEvents = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.currentPeriodEvents = options.longs === String ? "0" : 0;
                    object.dormantBecameActive = false;
                }
                if (message.priorPeriodEvents != null && message.hasOwnProperty("priorPeriodEvents"))
                    if (typeof message.priorPeriodEvents === "number")
                        object.priorPeriodEvents = options.longs === String ? String(message.priorPeriodEvents) : message.priorPeriodEvents;
                    else
                        object.priorPeriodEvents = options.longs === String ? $util.Long.prototype.toString.call(message.priorPeriodEvents) : options.longs === Number ? new $util.LongBits(message.priorPeriodEvents.low >>> 0, message.priorPeriodEvents.high >>> 0).toNumber(true) : message.priorPeriodEvents;
                if (message.currentPeriodEvents != null && message.hasOwnProperty("currentPeriodEvents"))
                    if (typeof message.currentPeriodEvents === "number")
                        object.currentPeriodEvents = options.longs === String ? String(message.currentPeriodEvents) : message.currentPeriodEvents;
                    else
                        object.currentPeriodEvents = options.longs === String ? $util.Long.prototype.toString.call(message.currentPeriodEvents) : options.longs === Number ? new $util.LongBits(message.currentPeriodEvents.low >>> 0, message.currentPeriodEvents.high >>> 0).toNumber(true) : message.currentPeriodEvents;
                if (message.dormantBecameActive != null && message.hasOwnProperty("dormantBecameActive"))
                    object.dormantBecameActive = message.dormantBecameActive;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_TopContributingSignals.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_TopContributingSignals.Item";
            };

            return Item;
        })();

        return User_TopContributingSignals;
    })();

    tdx_response.User_Anomalies = (function() {

        /**
         * Properties of a User_Anomalies.
         * @memberof tdx_response
         * @interface IUser_Anomalies
         * @property {tdx_response.Status|null} [status] User_Anomalies status
         * @property {Array.<tdx_response.User_Anomalies.IItem>|null} [items] User_Anomalies items
         */

        /**
         * Constructs a new User_Anomalies.
         * @memberof tdx_response
         * @classdesc Represents a User_Anomalies.
         * @implements IUser_Anomalies
         * @constructor
         * @param {tdx_response.IUser_Anomalies=} [properties] Properties to set
         */
        function User_Anomalies(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_Anomalies status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_Anomalies
         * @instance
         */
        User_Anomalies.prototype.status = 0;

        /**
         * User_Anomalies items.
         * @member {Array.<tdx_response.User_Anomalies.IItem>} items
         * @memberof tdx_response.User_Anomalies
         * @instance
         */
        User_Anomalies.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_Anomalies instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {tdx_response.IUser_Anomalies=} [properties] Properties to set
         * @returns {tdx_response.User_Anomalies} User_Anomalies instance
         */
        User_Anomalies.create = function create(properties) {
            return new User_Anomalies(properties);
        };

        /**
         * Encodes the specified User_Anomalies message. Does not implicitly {@link tdx_response.User_Anomalies.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {tdx_response.IUser_Anomalies} message User_Anomalies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Anomalies.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_Anomalies.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_Anomalies message, length delimited. Does not implicitly {@link tdx_response.User_Anomalies.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {tdx_response.IUser_Anomalies} message User_Anomalies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Anomalies.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_Anomalies message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_Anomalies} User_Anomalies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Anomalies.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_Anomalies();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_Anomalies.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_Anomalies message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_Anomalies} User_Anomalies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Anomalies.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_Anomalies message.
         * @function verify
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_Anomalies.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_Anomalies.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_Anomalies message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_Anomalies} User_Anomalies
         */
        User_Anomalies.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_Anomalies)
                return object;
            let message = new $root.tdx_response.User_Anomalies();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_Anomalies.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_Anomalies.items: object expected");
                    message.items[i] = $root.tdx_response.User_Anomalies.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_Anomalies message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {tdx_response.User_Anomalies} message User_Anomalies
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_Anomalies.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_Anomalies.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_Anomalies to JSON.
         * @function toJSON
         * @memberof tdx_response.User_Anomalies
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_Anomalies.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_Anomalies
         * @function getTypeUrl
         * @memberof tdx_response.User_Anomalies
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_Anomalies.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_Anomalies";
        };

        User_Anomalies.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_Anomalies
             * @interface IItem
             * @property {string|null} [anomalyType] Item anomalyType
             * @property {number|Long|null} [startTime] Item startTime
             * @property {number|Long|null} [endTime] Item endTime
             * @property {number|Long|null} [count] Item count
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_Anomalies
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_Anomalies.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item anomalyType.
             * @member {string} anomalyType
             * @memberof tdx_response.User_Anomalies.Item
             * @instance
             */
            Item.prototype.anomalyType = "";

            /**
             * Item startTime.
             * @member {number|Long} startTime
             * @memberof tdx_response.User_Anomalies.Item
             * @instance
             */
            Item.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item endTime.
             * @member {number|Long} endTime
             * @memberof tdx_response.User_Anomalies.Item
             * @instance
             */
            Item.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item count.
             * @member {number|Long} count
             * @memberof tdx_response.User_Anomalies.Item
             * @instance
             */
            Item.prototype.count = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {tdx_response.User_Anomalies.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_Anomalies.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_Anomalies.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {tdx_response.User_Anomalies.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.anomalyType != null && Object.hasOwnProperty.call(message, "anomalyType"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.anomalyType);
                if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.startTime);
                if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.endTime);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.count);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_Anomalies.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {tdx_response.User_Anomalies.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_Anomalies.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_Anomalies.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.anomalyType = reader.string();
                            break;
                        }
                    case 2: {
                            message.startTime = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.endTime = reader.uint64();
                            break;
                        }
                    case 4: {
                            message.count = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_Anomalies.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.anomalyType != null && message.hasOwnProperty("anomalyType"))
                    if (!$util.isString(message.anomalyType))
                        return "anomalyType: string expected";
                if (message.startTime != null && message.hasOwnProperty("startTime"))
                    if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                        return "startTime: integer|Long expected";
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                        return "endTime: integer|Long expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                        return "count: integer|Long expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_Anomalies.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_Anomalies.Item)
                    return object;
                let message = new $root.tdx_response.User_Anomalies.Item();
                if (object.anomalyType != null)
                    message.anomalyType = String(object.anomalyType);
                if (object.startTime != null)
                    if ($util.Long)
                        (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                    else if (typeof object.startTime === "string")
                        message.startTime = parseInt(object.startTime, 10);
                    else if (typeof object.startTime === "number")
                        message.startTime = object.startTime;
                    else if (typeof object.startTime === "object")
                        message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
                if (object.endTime != null)
                    if ($util.Long)
                        (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                    else if (typeof object.endTime === "string")
                        message.endTime = parseInt(object.endTime, 10);
                    else if (typeof object.endTime === "number")
                        message.endTime = object.endTime;
                    else if (typeof object.endTime === "object")
                        message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
                if (object.count != null)
                    if ($util.Long)
                        (message.count = $util.Long.fromValue(object.count)).unsigned = true;
                    else if (typeof object.count === "string")
                        message.count = parseInt(object.count, 10);
                    else if (typeof object.count === "number")
                        message.count = object.count;
                    else if (typeof object.count === "object")
                        message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {tdx_response.User_Anomalies.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.anomalyType = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.startTime = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.endTime = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.count = options.longs === String ? "0" : 0;
                }
                if (message.anomalyType != null && message.hasOwnProperty("anomalyType"))
                    object.anomalyType = message.anomalyType;
                if (message.startTime != null && message.hasOwnProperty("startTime"))
                    if (typeof message.startTime === "number")
                        object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                    else
                        object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    if (typeof message.endTime === "number")
                        object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                    else
                        object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
                if (message.count != null && message.hasOwnProperty("count"))
                    if (typeof message.count === "number")
                        object.count = options.longs === String ? String(message.count) : message.count;
                    else
                        object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber(true) : message.count;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_Anomalies.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_Anomalies.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_Anomalies.Item";
            };

            return Item;
        })();

        return User_Anomalies;
    })();

    tdx_response.User_Overview = (function() {

        /**
         * Properties of a User_Overview.
         * @memberof tdx_response
         * @interface IUser_Overview
         * @property {tdx_response.Status|null} [status] User_Overview status
         * @property {Array.<tdx_response.User_Overview.IItem>|null} [items] User_Overview items
         */

        /**
         * Constructs a new User_Overview.
         * @memberof tdx_response
         * @classdesc Represents a User_Overview.
         * @implements IUser_Overview
         * @constructor
         * @param {tdx_response.IUser_Overview=} [properties] Properties to set
         */
        function User_Overview(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_Overview status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_Overview
         * @instance
         */
        User_Overview.prototype.status = 0;

        /**
         * User_Overview items.
         * @member {Array.<tdx_response.User_Overview.IItem>} items
         * @memberof tdx_response.User_Overview
         * @instance
         */
        User_Overview.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_Overview instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_Overview
         * @static
         * @param {tdx_response.IUser_Overview=} [properties] Properties to set
         * @returns {tdx_response.User_Overview} User_Overview instance
         */
        User_Overview.create = function create(properties) {
            return new User_Overview(properties);
        };

        /**
         * Encodes the specified User_Overview message. Does not implicitly {@link tdx_response.User_Overview.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_Overview
         * @static
         * @param {tdx_response.IUser_Overview} message User_Overview message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Overview.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_Overview.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_Overview message, length delimited. Does not implicitly {@link tdx_response.User_Overview.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_Overview
         * @static
         * @param {tdx_response.IUser_Overview} message User_Overview message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_Overview.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_Overview message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_Overview
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_Overview} User_Overview
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Overview.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_Overview();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_Overview.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_Overview message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_Overview
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_Overview} User_Overview
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_Overview.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_Overview message.
         * @function verify
         * @memberof tdx_response.User_Overview
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_Overview.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_Overview.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_Overview message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_Overview
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_Overview} User_Overview
         */
        User_Overview.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_Overview)
                return object;
            let message = new $root.tdx_response.User_Overview();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_Overview.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_Overview.items: object expected");
                    message.items[i] = $root.tdx_response.User_Overview.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_Overview message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_Overview
         * @static
         * @param {tdx_response.User_Overview} message User_Overview
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_Overview.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_Overview.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_Overview to JSON.
         * @function toJSON
         * @memberof tdx_response.User_Overview
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_Overview.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_Overview
         * @function getTypeUrl
         * @memberof tdx_response.User_Overview
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_Overview.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_Overview";
        };

        User_Overview.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_Overview
             * @interface IItem
             * @property {number|Long|null} [activeUsers] Item activeUsers
             * @property {number|Long|null} [locations] Item locations
             * @property {string|null} [teamName] Item teamName
             * @property {string|null} [roleName] Item roleName
             * @property {string|null} [dormantUser] Item dormantUser
             * @property {number|Long|null} [eventsCount] Item eventsCount
             * @property {number|Long|null} [downloadedBytes] Item downloadedBytes
             * @property {number|Long|null} [uploadedBytes] Item uploadedBytes
             * @property {number|Long|null} [filesTouched] Item filesTouched
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_Overview
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_Overview.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item activeUsers.
             * @member {number|Long} activeUsers
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.activeUsers = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item locations.
             * @member {number|Long} locations
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.locations = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item teamName.
             * @member {string} teamName
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.teamName = "";

            /**
             * Item roleName.
             * @member {string} roleName
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.roleName = "";

            /**
             * Item dormantUser.
             * @member {string} dormantUser
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.dormantUser = "";

            /**
             * Item eventsCount.
             * @member {number|Long} eventsCount
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.eventsCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item downloadedBytes.
             * @member {number|Long} downloadedBytes
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.downloadedBytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item uploadedBytes.
             * @member {number|Long} uploadedBytes
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.uploadedBytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item filesTouched.
             * @member {number|Long} filesTouched
             * @memberof tdx_response.User_Overview.Item
             * @instance
             */
            Item.prototype.filesTouched = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {tdx_response.User_Overview.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_Overview.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_Overview.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {tdx_response.User_Overview.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.activeUsers != null && Object.hasOwnProperty.call(message, "activeUsers"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.activeUsers);
                if (message.locations != null && Object.hasOwnProperty.call(message, "locations"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.locations);
                if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.teamName);
                if (message.roleName != null && Object.hasOwnProperty.call(message, "roleName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.roleName);
                if (message.dormantUser != null && Object.hasOwnProperty.call(message, "dormantUser"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.dormantUser);
                if (message.eventsCount != null && Object.hasOwnProperty.call(message, "eventsCount"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.eventsCount);
                if (message.downloadedBytes != null && Object.hasOwnProperty.call(message, "downloadedBytes"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.downloadedBytes);
                if (message.uploadedBytes != null && Object.hasOwnProperty.call(message, "uploadedBytes"))
                    writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.uploadedBytes);
                if (message.filesTouched != null && Object.hasOwnProperty.call(message, "filesTouched"))
                    writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.filesTouched);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_Overview.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {tdx_response.User_Overview.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_Overview.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_Overview.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.activeUsers = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.locations = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.teamName = reader.string();
                            break;
                        }
                    case 4: {
                            message.roleName = reader.string();
                            break;
                        }
                    case 5: {
                            message.dormantUser = reader.string();
                            break;
                        }
                    case 6: {
                            message.eventsCount = reader.uint64();
                            break;
                        }
                    case 7: {
                            message.downloadedBytes = reader.uint64();
                            break;
                        }
                    case 8: {
                            message.uploadedBytes = reader.uint64();
                            break;
                        }
                    case 9: {
                            message.filesTouched = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_Overview.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.activeUsers != null && message.hasOwnProperty("activeUsers"))
                    if (!$util.isInteger(message.activeUsers) && !(message.activeUsers && $util.isInteger(message.activeUsers.low) && $util.isInteger(message.activeUsers.high)))
                        return "activeUsers: integer|Long expected";
                if (message.locations != null && message.hasOwnProperty("locations"))
                    if (!$util.isInteger(message.locations) && !(message.locations && $util.isInteger(message.locations.low) && $util.isInteger(message.locations.high)))
                        return "locations: integer|Long expected";
                if (message.teamName != null && message.hasOwnProperty("teamName"))
                    if (!$util.isString(message.teamName))
                        return "teamName: string expected";
                if (message.roleName != null && message.hasOwnProperty("roleName"))
                    if (!$util.isString(message.roleName))
                        return "roleName: string expected";
                if (message.dormantUser != null && message.hasOwnProperty("dormantUser"))
                    if (!$util.isString(message.dormantUser))
                        return "dormantUser: string expected";
                if (message.eventsCount != null && message.hasOwnProperty("eventsCount"))
                    if (!$util.isInteger(message.eventsCount) && !(message.eventsCount && $util.isInteger(message.eventsCount.low) && $util.isInteger(message.eventsCount.high)))
                        return "eventsCount: integer|Long expected";
                if (message.downloadedBytes != null && message.hasOwnProperty("downloadedBytes"))
                    if (!$util.isInteger(message.downloadedBytes) && !(message.downloadedBytes && $util.isInteger(message.downloadedBytes.low) && $util.isInteger(message.downloadedBytes.high)))
                        return "downloadedBytes: integer|Long expected";
                if (message.uploadedBytes != null && message.hasOwnProperty("uploadedBytes"))
                    if (!$util.isInteger(message.uploadedBytes) && !(message.uploadedBytes && $util.isInteger(message.uploadedBytes.low) && $util.isInteger(message.uploadedBytes.high)))
                        return "uploadedBytes: integer|Long expected";
                if (message.filesTouched != null && message.hasOwnProperty("filesTouched"))
                    if (!$util.isInteger(message.filesTouched) && !(message.filesTouched && $util.isInteger(message.filesTouched.low) && $util.isInteger(message.filesTouched.high)))
                        return "filesTouched: integer|Long expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_Overview.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_Overview.Item)
                    return object;
                let message = new $root.tdx_response.User_Overview.Item();
                if (object.activeUsers != null)
                    if ($util.Long)
                        (message.activeUsers = $util.Long.fromValue(object.activeUsers)).unsigned = true;
                    else if (typeof object.activeUsers === "string")
                        message.activeUsers = parseInt(object.activeUsers, 10);
                    else if (typeof object.activeUsers === "number")
                        message.activeUsers = object.activeUsers;
                    else if (typeof object.activeUsers === "object")
                        message.activeUsers = new $util.LongBits(object.activeUsers.low >>> 0, object.activeUsers.high >>> 0).toNumber(true);
                if (object.locations != null)
                    if ($util.Long)
                        (message.locations = $util.Long.fromValue(object.locations)).unsigned = true;
                    else if (typeof object.locations === "string")
                        message.locations = parseInt(object.locations, 10);
                    else if (typeof object.locations === "number")
                        message.locations = object.locations;
                    else if (typeof object.locations === "object")
                        message.locations = new $util.LongBits(object.locations.low >>> 0, object.locations.high >>> 0).toNumber(true);
                if (object.teamName != null)
                    message.teamName = String(object.teamName);
                if (object.roleName != null)
                    message.roleName = String(object.roleName);
                if (object.dormantUser != null)
                    message.dormantUser = String(object.dormantUser);
                if (object.eventsCount != null)
                    if ($util.Long)
                        (message.eventsCount = $util.Long.fromValue(object.eventsCount)).unsigned = true;
                    else if (typeof object.eventsCount === "string")
                        message.eventsCount = parseInt(object.eventsCount, 10);
                    else if (typeof object.eventsCount === "number")
                        message.eventsCount = object.eventsCount;
                    else if (typeof object.eventsCount === "object")
                        message.eventsCount = new $util.LongBits(object.eventsCount.low >>> 0, object.eventsCount.high >>> 0).toNumber(true);
                if (object.downloadedBytes != null)
                    if ($util.Long)
                        (message.downloadedBytes = $util.Long.fromValue(object.downloadedBytes)).unsigned = true;
                    else if (typeof object.downloadedBytes === "string")
                        message.downloadedBytes = parseInt(object.downloadedBytes, 10);
                    else if (typeof object.downloadedBytes === "number")
                        message.downloadedBytes = object.downloadedBytes;
                    else if (typeof object.downloadedBytes === "object")
                        message.downloadedBytes = new $util.LongBits(object.downloadedBytes.low >>> 0, object.downloadedBytes.high >>> 0).toNumber(true);
                if (object.uploadedBytes != null)
                    if ($util.Long)
                        (message.uploadedBytes = $util.Long.fromValue(object.uploadedBytes)).unsigned = true;
                    else if (typeof object.uploadedBytes === "string")
                        message.uploadedBytes = parseInt(object.uploadedBytes, 10);
                    else if (typeof object.uploadedBytes === "number")
                        message.uploadedBytes = object.uploadedBytes;
                    else if (typeof object.uploadedBytes === "object")
                        message.uploadedBytes = new $util.LongBits(object.uploadedBytes.low >>> 0, object.uploadedBytes.high >>> 0).toNumber(true);
                if (object.filesTouched != null)
                    if ($util.Long)
                        (message.filesTouched = $util.Long.fromValue(object.filesTouched)).unsigned = true;
                    else if (typeof object.filesTouched === "string")
                        message.filesTouched = parseInt(object.filesTouched, 10);
                    else if (typeof object.filesTouched === "number")
                        message.filesTouched = object.filesTouched;
                    else if (typeof object.filesTouched === "object")
                        message.filesTouched = new $util.LongBits(object.filesTouched.low >>> 0, object.filesTouched.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {tdx_response.User_Overview.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.activeUsers = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.activeUsers = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.locations = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.locations = options.longs === String ? "0" : 0;
                    object.teamName = "";
                    object.roleName = "";
                    object.dormantUser = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.eventsCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.eventsCount = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.downloadedBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.downloadedBytes = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.uploadedBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.uploadedBytes = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.filesTouched = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.filesTouched = options.longs === String ? "0" : 0;
                }
                if (message.activeUsers != null && message.hasOwnProperty("activeUsers"))
                    if (typeof message.activeUsers === "number")
                        object.activeUsers = options.longs === String ? String(message.activeUsers) : message.activeUsers;
                    else
                        object.activeUsers = options.longs === String ? $util.Long.prototype.toString.call(message.activeUsers) : options.longs === Number ? new $util.LongBits(message.activeUsers.low >>> 0, message.activeUsers.high >>> 0).toNumber(true) : message.activeUsers;
                if (message.locations != null && message.hasOwnProperty("locations"))
                    if (typeof message.locations === "number")
                        object.locations = options.longs === String ? String(message.locations) : message.locations;
                    else
                        object.locations = options.longs === String ? $util.Long.prototype.toString.call(message.locations) : options.longs === Number ? new $util.LongBits(message.locations.low >>> 0, message.locations.high >>> 0).toNumber(true) : message.locations;
                if (message.teamName != null && message.hasOwnProperty("teamName"))
                    object.teamName = message.teamName;
                if (message.roleName != null && message.hasOwnProperty("roleName"))
                    object.roleName = message.roleName;
                if (message.dormantUser != null && message.hasOwnProperty("dormantUser"))
                    object.dormantUser = message.dormantUser;
                if (message.eventsCount != null && message.hasOwnProperty("eventsCount"))
                    if (typeof message.eventsCount === "number")
                        object.eventsCount = options.longs === String ? String(message.eventsCount) : message.eventsCount;
                    else
                        object.eventsCount = options.longs === String ? $util.Long.prototype.toString.call(message.eventsCount) : options.longs === Number ? new $util.LongBits(message.eventsCount.low >>> 0, message.eventsCount.high >>> 0).toNumber(true) : message.eventsCount;
                if (message.downloadedBytes != null && message.hasOwnProperty("downloadedBytes"))
                    if (typeof message.downloadedBytes === "number")
                        object.downloadedBytes = options.longs === String ? String(message.downloadedBytes) : message.downloadedBytes;
                    else
                        object.downloadedBytes = options.longs === String ? $util.Long.prototype.toString.call(message.downloadedBytes) : options.longs === Number ? new $util.LongBits(message.downloadedBytes.low >>> 0, message.downloadedBytes.high >>> 0).toNumber(true) : message.downloadedBytes;
                if (message.uploadedBytes != null && message.hasOwnProperty("uploadedBytes"))
                    if (typeof message.uploadedBytes === "number")
                        object.uploadedBytes = options.longs === String ? String(message.uploadedBytes) : message.uploadedBytes;
                    else
                        object.uploadedBytes = options.longs === String ? $util.Long.prototype.toString.call(message.uploadedBytes) : options.longs === Number ? new $util.LongBits(message.uploadedBytes.low >>> 0, message.uploadedBytes.high >>> 0).toNumber(true) : message.uploadedBytes;
                if (message.filesTouched != null && message.hasOwnProperty("filesTouched"))
                    if (typeof message.filesTouched === "number")
                        object.filesTouched = options.longs === String ? String(message.filesTouched) : message.filesTouched;
                    else
                        object.filesTouched = options.longs === String ? $util.Long.prototype.toString.call(message.filesTouched) : options.longs === Number ? new $util.LongBits(message.filesTouched.low >>> 0, message.filesTouched.high >>> 0).toNumber(true) : message.filesTouched;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_Overview.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_Overview.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_Overview.Item";
            };

            return Item;
        })();

        return User_Overview;
    })();

    tdx_response.User_TimeHeatmap = (function() {

        /**
         * Properties of a User_TimeHeatmap.
         * @memberof tdx_response
         * @interface IUser_TimeHeatmap
         * @property {tdx_response.Status|null} [status] User_TimeHeatmap status
         * @property {Array.<tdx_response.User_TimeHeatmap.IItem>|null} [items] User_TimeHeatmap items
         */

        /**
         * Constructs a new User_TimeHeatmap.
         * @memberof tdx_response
         * @classdesc Represents a User_TimeHeatmap.
         * @implements IUser_TimeHeatmap
         * @constructor
         * @param {tdx_response.IUser_TimeHeatmap=} [properties] Properties to set
         */
        function User_TimeHeatmap(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User_TimeHeatmap status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.User_TimeHeatmap
         * @instance
         */
        User_TimeHeatmap.prototype.status = 0;

        /**
         * User_TimeHeatmap items.
         * @member {Array.<tdx_response.User_TimeHeatmap.IItem>} items
         * @memberof tdx_response.User_TimeHeatmap
         * @instance
         */
        User_TimeHeatmap.prototype.items = $util.emptyArray;

        /**
         * Creates a new User_TimeHeatmap instance using the specified properties.
         * @function create
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {tdx_response.IUser_TimeHeatmap=} [properties] Properties to set
         * @returns {tdx_response.User_TimeHeatmap} User_TimeHeatmap instance
         */
        User_TimeHeatmap.create = function create(properties) {
            return new User_TimeHeatmap(properties);
        };

        /**
         * Encodes the specified User_TimeHeatmap message. Does not implicitly {@link tdx_response.User_TimeHeatmap.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {tdx_response.IUser_TimeHeatmap} message User_TimeHeatmap message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TimeHeatmap.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_TimeHeatmap.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified User_TimeHeatmap message, length delimited. Does not implicitly {@link tdx_response.User_TimeHeatmap.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {tdx_response.IUser_TimeHeatmap} message User_TimeHeatmap message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User_TimeHeatmap.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User_TimeHeatmap message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.User_TimeHeatmap} User_TimeHeatmap
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TimeHeatmap.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_TimeHeatmap();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_TimeHeatmap.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User_TimeHeatmap message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.User_TimeHeatmap} User_TimeHeatmap
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User_TimeHeatmap.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User_TimeHeatmap message.
         * @function verify
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User_TimeHeatmap.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_TimeHeatmap.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a User_TimeHeatmap message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.User_TimeHeatmap} User_TimeHeatmap
         */
        User_TimeHeatmap.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.User_TimeHeatmap)
                return object;
            let message = new $root.tdx_response.User_TimeHeatmap();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.User_TimeHeatmap.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.User_TimeHeatmap.items: object expected");
                    message.items[i] = $root.tdx_response.User_TimeHeatmap.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a User_TimeHeatmap message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {tdx_response.User_TimeHeatmap} message User_TimeHeatmap
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User_TimeHeatmap.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_TimeHeatmap.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this User_TimeHeatmap to JSON.
         * @function toJSON
         * @memberof tdx_response.User_TimeHeatmap
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User_TimeHeatmap.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User_TimeHeatmap
         * @function getTypeUrl
         * @memberof tdx_response.User_TimeHeatmap
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User_TimeHeatmap.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.User_TimeHeatmap";
        };

        User_TimeHeatmap.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.User_TimeHeatmap
             * @interface IItem
             * @property {number|null} [dow] Item dow
             * @property {number|null} [hour] Item hour
             * @property {number|null} [count] Item count
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.User_TimeHeatmap
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.User_TimeHeatmap.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item dow.
             * @member {number} dow
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @instance
             */
            Item.prototype.dow = 0;

            /**
             * Item hour.
             * @member {number} hour
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @instance
             */
            Item.prototype.hour = 0;

            /**
             * Item count.
             * @member {number} count
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @instance
             */
            Item.prototype.count = 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {tdx_response.User_TimeHeatmap.IItem=} [properties] Properties to set
             * @returns {tdx_response.User_TimeHeatmap.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.User_TimeHeatmap.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {tdx_response.User_TimeHeatmap.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dow != null && Object.hasOwnProperty.call(message, "dow"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.dow);
                if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.hour);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.count);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.User_TimeHeatmap.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {tdx_response.User_TimeHeatmap.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.User_TimeHeatmap.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.User_TimeHeatmap.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.dow = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.hour = reader.uint32();
                            break;
                        }
                    case 3: {
                            message.count = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.User_TimeHeatmap.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dow != null && message.hasOwnProperty("dow"))
                    if (!$util.isInteger(message.dow))
                        return "dow: integer expected";
                if (message.hour != null && message.hasOwnProperty("hour"))
                    if (!$util.isInteger(message.hour))
                        return "hour: integer expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.User_TimeHeatmap.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.User_TimeHeatmap.Item)
                    return object;
                let message = new $root.tdx_response.User_TimeHeatmap.Item();
                if (object.dow != null)
                    message.dow = object.dow >>> 0;
                if (object.hour != null)
                    message.hour = object.hour >>> 0;
                if (object.count != null)
                    message.count = object.count >>> 0;
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {tdx_response.User_TimeHeatmap.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.dow = 0;
                    object.hour = 0;
                    object.count = 0;
                }
                if (message.dow != null && message.hasOwnProperty("dow"))
                    object.dow = message.dow;
                if (message.hour != null && message.hasOwnProperty("hour"))
                    object.hour = message.hour;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.User_TimeHeatmap.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.User_TimeHeatmap.Item";
            };

            return Item;
        })();

        return User_TimeHeatmap;
    })();

    tdx_response.Team_Members = (function() {

        /**
         * Properties of a Team_Members.
         * @memberof tdx_response
         * @interface ITeam_Members
         * @property {tdx_response.Status|null} [status] Team_Members status
         * @property {Array.<tdx_response.Team_Members.IItem>|null} [items] Team_Members items
         */

        /**
         * Constructs a new Team_Members.
         * @memberof tdx_response
         * @classdesc Represents a Team_Members.
         * @implements ITeam_Members
         * @constructor
         * @param {tdx_response.ITeam_Members=} [properties] Properties to set
         */
        function Team_Members(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_Members status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Team_Members
         * @instance
         */
        Team_Members.prototype.status = 0;

        /**
         * Team_Members items.
         * @member {Array.<tdx_response.Team_Members.IItem>} items
         * @memberof tdx_response.Team_Members
         * @instance
         */
        Team_Members.prototype.items = $util.emptyArray;

        /**
         * Creates a new Team_Members instance using the specified properties.
         * @function create
         * @memberof tdx_response.Team_Members
         * @static
         * @param {tdx_response.ITeam_Members=} [properties] Properties to set
         * @returns {tdx_response.Team_Members} Team_Members instance
         */
        Team_Members.create = function create(properties) {
            return new Team_Members(properties);
        };

        /**
         * Encodes the specified Team_Members message. Does not implicitly {@link tdx_response.Team_Members.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Team_Members
         * @static
         * @param {tdx_response.ITeam_Members} message Team_Members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_Members.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.Team_Members.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Team_Members message, length delimited. Does not implicitly {@link tdx_response.Team_Members.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Team_Members
         * @static
         * @param {tdx_response.ITeam_Members} message Team_Members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_Members.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_Members message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Team_Members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Team_Members} Team_Members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_Members.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_Members();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.Team_Members.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_Members message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Team_Members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Team_Members} Team_Members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_Members.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_Members message.
         * @function verify
         * @memberof tdx_response.Team_Members
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_Members.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.Team_Members.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Team_Members message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Team_Members
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Team_Members} Team_Members
         */
        Team_Members.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Team_Members)
                return object;
            let message = new $root.tdx_response.Team_Members();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.Team_Members.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.Team_Members.items: object expected");
                    message.items[i] = $root.tdx_response.Team_Members.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Team_Members message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Team_Members
         * @static
         * @param {tdx_response.Team_Members} message Team_Members
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_Members.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.Team_Members.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this Team_Members to JSON.
         * @function toJSON
         * @memberof tdx_response.Team_Members
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_Members.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_Members
         * @function getTypeUrl
         * @memberof tdx_response.Team_Members
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_Members.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Team_Members";
        };

        Team_Members.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.Team_Members
             * @interface IItem
             * @property {string|null} [email] Item email
             * @property {string|null} [role] Item role
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.Team_Members
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.Team_Members.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item email.
             * @member {string} email
             * @memberof tdx_response.Team_Members.Item
             * @instance
             */
            Item.prototype.email = "";

            /**
             * Item role.
             * @member {string} role
             * @memberof tdx_response.Team_Members.Item
             * @instance
             */
            Item.prototype.role = "";

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {tdx_response.Team_Members.IItem=} [properties] Properties to set
             * @returns {tdx_response.Team_Members.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.Team_Members.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {tdx_response.Team_Members.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.role);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.Team_Members.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {tdx_response.Team_Members.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.Team_Members.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_Members.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.email = reader.string();
                            break;
                        }
                    case 2: {
                            message.role = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.Team_Members.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.role != null && message.hasOwnProperty("role"))
                    if (!$util.isString(message.role))
                        return "role: string expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.Team_Members.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.Team_Members.Item)
                    return object;
                let message = new $root.tdx_response.Team_Members.Item();
                if (object.email != null)
                    message.email = String(object.email);
                if (object.role != null)
                    message.role = String(object.role);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {tdx_response.Team_Members.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.email = "";
                    object.role = "";
                }
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                if (message.role != null && message.hasOwnProperty("role"))
                    object.role = message.role;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.Team_Members.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.Team_Members.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.Team_Members.Item";
            };

            return Item;
        })();

        return Team_Members;
    })();

    tdx_response.Team_ActivityTimeline = (function() {

        /**
         * Properties of a Team_ActivityTimeline.
         * @memberof tdx_response
         * @interface ITeam_ActivityTimeline
         * @property {tdx_response.Status|null} [status] Team_ActivityTimeline status
         * @property {Array.<tdx_response.User_ActivityTimeline.IItem>|null} [items] Team_ActivityTimeline items
         */

        /**
         * Constructs a new Team_ActivityTimeline.
         * @memberof tdx_response
         * @classdesc Represents a Team_ActivityTimeline.
         * @implements ITeam_ActivityTimeline
         * @constructor
         * @param {tdx_response.ITeam_ActivityTimeline=} [properties] Properties to set
         */
        function Team_ActivityTimeline(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_ActivityTimeline status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Team_ActivityTimeline
         * @instance
         */
        Team_ActivityTimeline.prototype.status = 0;

        /**
         * Team_ActivityTimeline items.
         * @member {Array.<tdx_response.User_ActivityTimeline.IItem>} items
         * @memberof tdx_response.Team_ActivityTimeline
         * @instance
         */
        Team_ActivityTimeline.prototype.items = $util.emptyArray;

        /**
         * Creates a new Team_ActivityTimeline instance using the specified properties.
         * @function create
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {tdx_response.ITeam_ActivityTimeline=} [properties] Properties to set
         * @returns {tdx_response.Team_ActivityTimeline} Team_ActivityTimeline instance
         */
        Team_ActivityTimeline.create = function create(properties) {
            return new Team_ActivityTimeline(properties);
        };

        /**
         * Encodes the specified Team_ActivityTimeline message. Does not implicitly {@link tdx_response.Team_ActivityTimeline.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {tdx_response.ITeam_ActivityTimeline} message Team_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_ActivityTimeline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_ActivityTimeline.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Team_ActivityTimeline message, length delimited. Does not implicitly {@link tdx_response.Team_ActivityTimeline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {tdx_response.ITeam_ActivityTimeline} message Team_ActivityTimeline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_ActivityTimeline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_ActivityTimeline message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Team_ActivityTimeline} Team_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_ActivityTimeline.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_ActivityTimeline();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_ActivityTimeline.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_ActivityTimeline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Team_ActivityTimeline} Team_ActivityTimeline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_ActivityTimeline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_ActivityTimeline message.
         * @function verify
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_ActivityTimeline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_ActivityTimeline.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Team_ActivityTimeline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Team_ActivityTimeline} Team_ActivityTimeline
         */
        Team_ActivityTimeline.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Team_ActivityTimeline)
                return object;
            let message = new $root.tdx_response.Team_ActivityTimeline();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.Team_ActivityTimeline.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.Team_ActivityTimeline.items: object expected");
                    message.items[i] = $root.tdx_response.User_ActivityTimeline.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Team_ActivityTimeline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {tdx_response.Team_ActivityTimeline} message Team_ActivityTimeline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_ActivityTimeline.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_ActivityTimeline.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this Team_ActivityTimeline to JSON.
         * @function toJSON
         * @memberof tdx_response.Team_ActivityTimeline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_ActivityTimeline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_ActivityTimeline
         * @function getTypeUrl
         * @memberof tdx_response.Team_ActivityTimeline
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_ActivityTimeline.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Team_ActivityTimeline";
        };

        return Team_ActivityTimeline;
    })();

    tdx_response.Team_FilesTouched = (function() {

        /**
         * Properties of a Team_FilesTouched.
         * @memberof tdx_response
         * @interface ITeam_FilesTouched
         * @property {tdx_response.Status|null} [status] Team_FilesTouched status
         * @property {Array.<tdx_response.User_FilesTouched.IItem>|null} [items] Team_FilesTouched items
         */

        /**
         * Constructs a new Team_FilesTouched.
         * @memberof tdx_response
         * @classdesc Represents a Team_FilesTouched.
         * @implements ITeam_FilesTouched
         * @constructor
         * @param {tdx_response.ITeam_FilesTouched=} [properties] Properties to set
         */
        function Team_FilesTouched(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_FilesTouched status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Team_FilesTouched
         * @instance
         */
        Team_FilesTouched.prototype.status = 0;

        /**
         * Team_FilesTouched items.
         * @member {Array.<tdx_response.User_FilesTouched.IItem>} items
         * @memberof tdx_response.Team_FilesTouched
         * @instance
         */
        Team_FilesTouched.prototype.items = $util.emptyArray;

        /**
         * Creates a new Team_FilesTouched instance using the specified properties.
         * @function create
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {tdx_response.ITeam_FilesTouched=} [properties] Properties to set
         * @returns {tdx_response.Team_FilesTouched} Team_FilesTouched instance
         */
        Team_FilesTouched.create = function create(properties) {
            return new Team_FilesTouched(properties);
        };

        /**
         * Encodes the specified Team_FilesTouched message. Does not implicitly {@link tdx_response.Team_FilesTouched.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {tdx_response.ITeam_FilesTouched} message Team_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_FilesTouched.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_FilesTouched.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Team_FilesTouched message, length delimited. Does not implicitly {@link tdx_response.Team_FilesTouched.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {tdx_response.ITeam_FilesTouched} message Team_FilesTouched message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_FilesTouched.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_FilesTouched message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Team_FilesTouched} Team_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_FilesTouched.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_FilesTouched();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_FilesTouched.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_FilesTouched message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Team_FilesTouched} Team_FilesTouched
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_FilesTouched.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_FilesTouched message.
         * @function verify
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_FilesTouched.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_FilesTouched.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Team_FilesTouched message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Team_FilesTouched} Team_FilesTouched
         */
        Team_FilesTouched.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Team_FilesTouched)
                return object;
            let message = new $root.tdx_response.Team_FilesTouched();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.Team_FilesTouched.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.Team_FilesTouched.items: object expected");
                    message.items[i] = $root.tdx_response.User_FilesTouched.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Team_FilesTouched message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {tdx_response.Team_FilesTouched} message Team_FilesTouched
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_FilesTouched.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_FilesTouched.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this Team_FilesTouched to JSON.
         * @function toJSON
         * @memberof tdx_response.Team_FilesTouched
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_FilesTouched.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_FilesTouched
         * @function getTypeUrl
         * @memberof tdx_response.Team_FilesTouched
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_FilesTouched.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Team_FilesTouched";
        };

        return Team_FilesTouched;
    })();

    tdx_response.Team_MembershipChanges = (function() {

        /**
         * Properties of a Team_MembershipChanges.
         * @memberof tdx_response
         * @interface ITeam_MembershipChanges
         * @property {tdx_response.Status|null} [status] Team_MembershipChanges status
         * @property {Array.<tdx_response.Team_MembershipChanges.IItem>|null} [items] Team_MembershipChanges items
         */

        /**
         * Constructs a new Team_MembershipChanges.
         * @memberof tdx_response
         * @classdesc Represents a Team_MembershipChanges.
         * @implements ITeam_MembershipChanges
         * @constructor
         * @param {tdx_response.ITeam_MembershipChanges=} [properties] Properties to set
         */
        function Team_MembershipChanges(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_MembershipChanges status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Team_MembershipChanges
         * @instance
         */
        Team_MembershipChanges.prototype.status = 0;

        /**
         * Team_MembershipChanges items.
         * @member {Array.<tdx_response.Team_MembershipChanges.IItem>} items
         * @memberof tdx_response.Team_MembershipChanges
         * @instance
         */
        Team_MembershipChanges.prototype.items = $util.emptyArray;

        /**
         * Creates a new Team_MembershipChanges instance using the specified properties.
         * @function create
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {tdx_response.ITeam_MembershipChanges=} [properties] Properties to set
         * @returns {tdx_response.Team_MembershipChanges} Team_MembershipChanges instance
         */
        Team_MembershipChanges.create = function create(properties) {
            return new Team_MembershipChanges(properties);
        };

        /**
         * Encodes the specified Team_MembershipChanges message. Does not implicitly {@link tdx_response.Team_MembershipChanges.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {tdx_response.ITeam_MembershipChanges} message Team_MembershipChanges message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_MembershipChanges.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.Team_MembershipChanges.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Team_MembershipChanges message, length delimited. Does not implicitly {@link tdx_response.Team_MembershipChanges.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {tdx_response.ITeam_MembershipChanges} message Team_MembershipChanges message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_MembershipChanges.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_MembershipChanges message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Team_MembershipChanges} Team_MembershipChanges
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_MembershipChanges.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_MembershipChanges();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.Team_MembershipChanges.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_MembershipChanges message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Team_MembershipChanges} Team_MembershipChanges
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_MembershipChanges.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_MembershipChanges message.
         * @function verify
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_MembershipChanges.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.Team_MembershipChanges.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Team_MembershipChanges message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Team_MembershipChanges} Team_MembershipChanges
         */
        Team_MembershipChanges.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Team_MembershipChanges)
                return object;
            let message = new $root.tdx_response.Team_MembershipChanges();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.Team_MembershipChanges.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.Team_MembershipChanges.items: object expected");
                    message.items[i] = $root.tdx_response.Team_MembershipChanges.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Team_MembershipChanges message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {tdx_response.Team_MembershipChanges} message Team_MembershipChanges
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_MembershipChanges.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.Team_MembershipChanges.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this Team_MembershipChanges to JSON.
         * @function toJSON
         * @memberof tdx_response.Team_MembershipChanges
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_MembershipChanges.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_MembershipChanges
         * @function getTypeUrl
         * @memberof tdx_response.Team_MembershipChanges
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_MembershipChanges.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Team_MembershipChanges";
        };

        Team_MembershipChanges.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.Team_MembershipChanges
             * @interface IItem
             * @property {number|Long|null} [timestamp] Item timestamp
             * @property {string|null} [operation] Item operation
             * @property {string|null} [userEmail] Item userEmail
             * @property {string|null} [grantedBy] Item grantedBy
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.Team_MembershipChanges
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.Team_MembershipChanges.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item timestamp.
             * @member {number|Long} timestamp
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @instance
             */
            Item.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Item operation.
             * @member {string} operation
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @instance
             */
            Item.prototype.operation = "";

            /**
             * Item userEmail.
             * @member {string} userEmail
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @instance
             */
            Item.prototype.userEmail = "";

            /**
             * Item grantedBy.
             * @member {string} grantedBy
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @instance
             */
            Item.prototype.grantedBy = "";

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {tdx_response.Team_MembershipChanges.IItem=} [properties] Properties to set
             * @returns {tdx_response.Team_MembershipChanges.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.Team_MembershipChanges.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {tdx_response.Team_MembershipChanges.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.timestamp);
                if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.operation);
                if (message.userEmail != null && Object.hasOwnProperty.call(message, "userEmail"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.userEmail);
                if (message.grantedBy != null && Object.hasOwnProperty.call(message, "grantedBy"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.grantedBy);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.Team_MembershipChanges.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {tdx_response.Team_MembershipChanges.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.Team_MembershipChanges.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_MembershipChanges.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.timestamp = reader.uint64();
                            break;
                        }
                    case 2: {
                            message.operation = reader.string();
                            break;
                        }
                    case 3: {
                            message.userEmail = reader.string();
                            break;
                        }
                    case 4: {
                            message.grantedBy = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.Team_MembershipChanges.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.operation != null && message.hasOwnProperty("operation"))
                    if (!$util.isString(message.operation))
                        return "operation: string expected";
                if (message.userEmail != null && message.hasOwnProperty("userEmail"))
                    if (!$util.isString(message.userEmail))
                        return "userEmail: string expected";
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    if (!$util.isString(message.grantedBy))
                        return "grantedBy: string expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.Team_MembershipChanges.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.Team_MembershipChanges.Item)
                    return object;
                let message = new $root.tdx_response.Team_MembershipChanges.Item();
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
                if (object.operation != null)
                    message.operation = String(object.operation);
                if (object.userEmail != null)
                    message.userEmail = String(object.userEmail);
                if (object.grantedBy != null)
                    message.grantedBy = String(object.grantedBy);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {tdx_response.Team_MembershipChanges.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    object.operation = "";
                    object.userEmail = "";
                    object.grantedBy = "";
                }
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
                if (message.operation != null && message.hasOwnProperty("operation"))
                    object.operation = message.operation;
                if (message.userEmail != null && message.hasOwnProperty("userEmail"))
                    object.userEmail = message.userEmail;
                if (message.grantedBy != null && message.hasOwnProperty("grantedBy"))
                    object.grantedBy = message.grantedBy;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.Team_MembershipChanges.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.Team_MembershipChanges.Item";
            };

            return Item;
        })();

        return Team_MembershipChanges;
    })();

    tdx_response.Team_RoleIntersection = (function() {

        /**
         * Properties of a Team_RoleIntersection.
         * @memberof tdx_response
         * @interface ITeam_RoleIntersection
         * @property {tdx_response.Status|null} [status] Team_RoleIntersection status
         * @property {Array.<tdx_response.Team_RoleIntersection.IItem>|null} [items] Team_RoleIntersection items
         */

        /**
         * Constructs a new Team_RoleIntersection.
         * @memberof tdx_response
         * @classdesc Represents a Team_RoleIntersection.
         * @implements ITeam_RoleIntersection
         * @constructor
         * @param {tdx_response.ITeam_RoleIntersection=} [properties] Properties to set
         */
        function Team_RoleIntersection(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_RoleIntersection status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Team_RoleIntersection
         * @instance
         */
        Team_RoleIntersection.prototype.status = 0;

        /**
         * Team_RoleIntersection items.
         * @member {Array.<tdx_response.Team_RoleIntersection.IItem>} items
         * @memberof tdx_response.Team_RoleIntersection
         * @instance
         */
        Team_RoleIntersection.prototype.items = $util.emptyArray;

        /**
         * Creates a new Team_RoleIntersection instance using the specified properties.
         * @function create
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {tdx_response.ITeam_RoleIntersection=} [properties] Properties to set
         * @returns {tdx_response.Team_RoleIntersection} Team_RoleIntersection instance
         */
        Team_RoleIntersection.create = function create(properties) {
            return new Team_RoleIntersection(properties);
        };

        /**
         * Encodes the specified Team_RoleIntersection message. Does not implicitly {@link tdx_response.Team_RoleIntersection.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {tdx_response.ITeam_RoleIntersection} message Team_RoleIntersection message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_RoleIntersection.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.Team_RoleIntersection.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Team_RoleIntersection message, length delimited. Does not implicitly {@link tdx_response.Team_RoleIntersection.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {tdx_response.ITeam_RoleIntersection} message Team_RoleIntersection message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_RoleIntersection.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_RoleIntersection message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Team_RoleIntersection} Team_RoleIntersection
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_RoleIntersection.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_RoleIntersection();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.Team_RoleIntersection.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_RoleIntersection message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Team_RoleIntersection} Team_RoleIntersection
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_RoleIntersection.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_RoleIntersection message.
         * @function verify
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_RoleIntersection.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.Team_RoleIntersection.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Team_RoleIntersection message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Team_RoleIntersection} Team_RoleIntersection
         */
        Team_RoleIntersection.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Team_RoleIntersection)
                return object;
            let message = new $root.tdx_response.Team_RoleIntersection();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.Team_RoleIntersection.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.Team_RoleIntersection.items: object expected");
                    message.items[i] = $root.tdx_response.Team_RoleIntersection.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Team_RoleIntersection message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {tdx_response.Team_RoleIntersection} message Team_RoleIntersection
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_RoleIntersection.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.Team_RoleIntersection.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this Team_RoleIntersection to JSON.
         * @function toJSON
         * @memberof tdx_response.Team_RoleIntersection
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_RoleIntersection.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_RoleIntersection
         * @function getTypeUrl
         * @memberof tdx_response.Team_RoleIntersection
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_RoleIntersection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Team_RoleIntersection";
        };

        Team_RoleIntersection.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof tdx_response.Team_RoleIntersection
             * @interface IItem
             * @property {string|null} [role] Item role
             * @property {number|null} [memberCount] Item memberCount
             */

            /**
             * Constructs a new Item.
             * @memberof tdx_response.Team_RoleIntersection
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {tdx_response.Team_RoleIntersection.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item role.
             * @member {string} role
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @instance
             */
            Item.prototype.role = "";

            /**
             * Item memberCount.
             * @member {number} memberCount
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @instance
             */
            Item.prototype.memberCount = 0;

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {tdx_response.Team_RoleIntersection.IItem=} [properties] Properties to set
             * @returns {tdx_response.Team_RoleIntersection.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link tdx_response.Team_RoleIntersection.Item.verify|verify} messages.
             * @function encode
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {tdx_response.Team_RoleIntersection.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.role);
                if (message.memberCount != null && Object.hasOwnProperty.call(message, "memberCount"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.memberCount);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link tdx_response.Team_RoleIntersection.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {tdx_response.Team_RoleIntersection.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {tdx_response.Team_RoleIntersection.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_RoleIntersection.Item();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.role = reader.string();
                            break;
                        }
                    case 2: {
                            message.memberCount = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {tdx_response.Team_RoleIntersection.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.role != null && message.hasOwnProperty("role"))
                    if (!$util.isString(message.role))
                        return "role: string expected";
                if (message.memberCount != null && message.hasOwnProperty("memberCount"))
                    if (!$util.isInteger(message.memberCount))
                        return "memberCount: integer expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {tdx_response.Team_RoleIntersection.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.tdx_response.Team_RoleIntersection.Item)
                    return object;
                let message = new $root.tdx_response.Team_RoleIntersection.Item();
                if (object.role != null)
                    message.role = String(object.role);
                if (object.memberCount != null)
                    message.memberCount = object.memberCount >>> 0;
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {tdx_response.Team_RoleIntersection.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.role = "";
                    object.memberCount = 0;
                }
                if (message.role != null && message.hasOwnProperty("role"))
                    object.role = message.role;
                if (message.memberCount != null && message.hasOwnProperty("memberCount"))
                    object.memberCount = message.memberCount;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Item
             * @function getTypeUrl
             * @memberof tdx_response.Team_RoleIntersection.Item
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Item.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/tdx_response.Team_RoleIntersection.Item";
            };

            return Item;
        })();

        return Team_RoleIntersection;
    })();

    tdx_response.Team_SharingActions = (function() {

        /**
         * Properties of a Team_SharingActions.
         * @memberof tdx_response
         * @interface ITeam_SharingActions
         * @property {tdx_response.Status|null} [status] Team_SharingActions status
         * @property {Array.<tdx_response.User_SharingActions.IItem>|null} [items] Team_SharingActions items
         */

        /**
         * Constructs a new Team_SharingActions.
         * @memberof tdx_response
         * @classdesc Represents a Team_SharingActions.
         * @implements ITeam_SharingActions
         * @constructor
         * @param {tdx_response.ITeam_SharingActions=} [properties] Properties to set
         */
        function Team_SharingActions(properties) {
            this.items = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team_SharingActions status.
         * @member {tdx_response.Status} status
         * @memberof tdx_response.Team_SharingActions
         * @instance
         */
        Team_SharingActions.prototype.status = 0;

        /**
         * Team_SharingActions items.
         * @member {Array.<tdx_response.User_SharingActions.IItem>} items
         * @memberof tdx_response.Team_SharingActions
         * @instance
         */
        Team_SharingActions.prototype.items = $util.emptyArray;

        /**
         * Creates a new Team_SharingActions instance using the specified properties.
         * @function create
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {tdx_response.ITeam_SharingActions=} [properties] Properties to set
         * @returns {tdx_response.Team_SharingActions} Team_SharingActions instance
         */
        Team_SharingActions.create = function create(properties) {
            return new Team_SharingActions(properties);
        };

        /**
         * Encodes the specified Team_SharingActions message. Does not implicitly {@link tdx_response.Team_SharingActions.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {tdx_response.ITeam_SharingActions} message Team_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_SharingActions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.items != null && message.items.length)
                for (let i = 0; i < message.items.length; ++i)
                    $root.tdx_response.User_SharingActions.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Team_SharingActions message, length delimited. Does not implicitly {@link tdx_response.Team_SharingActions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {tdx_response.ITeam_SharingActions} message Team_SharingActions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team_SharingActions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team_SharingActions message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Team_SharingActions} Team_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_SharingActions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Team_SharingActions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.tdx_response.User_SharingActions.Item.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team_SharingActions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Team_SharingActions} Team_SharingActions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team_SharingActions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team_SharingActions message.
         * @function verify
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team_SharingActions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 100:
                case 19:
                    break;
                }
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (let i = 0; i < message.items.length; ++i) {
                    let error = $root.tdx_response.User_SharingActions.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Team_SharingActions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Team_SharingActions} Team_SharingActions
         */
        Team_SharingActions.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Team_SharingActions)
                return object;
            let message = new $root.tdx_response.Team_SharingActions();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            case "SQL_ERROR":
            case 19:
                message.status = 19;
                break;
            }
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".tdx_response.Team_SharingActions.items: array expected");
                message.items = [];
                for (let i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".tdx_response.Team_SharingActions.items: object expected");
                    message.items[i] = $root.tdx_response.User_SharingActions.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Team_SharingActions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {tdx_response.Team_SharingActions} message Team_SharingActions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team_SharingActions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.tdx_response.Status[message.status] === undefined ? message.status : $root.tdx_response.Status[message.status] : message.status;
            if (message.items && message.items.length) {
                object.items = [];
                for (let j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.tdx_response.User_SharingActions.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this Team_SharingActions to JSON.
         * @function toJSON
         * @memberof tdx_response.Team_SharingActions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team_SharingActions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team_SharingActions
         * @function getTypeUrl
         * @memberof tdx_response.Team_SharingActions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team_SharingActions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Team_SharingActions";
        };

        return Team_SharingActions;
    })();

    tdx_response.Response = (function() {

        /**
         * Properties of a Response.
         * @memberof tdx_response
         * @interface IResponse
         * @property {number|Long|null} [id] Response id
         * @property {tdx_response.IListLogsFromQuery|null} [listLogs] Response listLogs
         * @property {tdx_response.ICreateAlert|null} [createAlert] Response createAlert
         * @property {tdx_response.IDeleteAlert|null} [deleteAlert] Response deleteAlert
         * @property {tdx_response.IListAlerts|null} [listAlerts] Response listAlerts
         * @property {tdx_response.IUpdateAlert|null} [updateAlert] Response updateAlert
         * @property {tdx_response.IGetLedgerRange|null} [getLedgerRange] Response getLedgerRange
         * @property {tdx_response.IGetAuditLog|null} [getAuditLog] Response getAuditLog
         * @property {tdx_response.IGetConsistencyProof|null} [getConsistencyProof] Response getConsistencyProof
         * @property {tdx_response.IGetInclusionProof|null} [getInclusionProof] Response getInclusionProof
         * @property {tdx_response.IGetChunkFromYSentinel|null} [getChunkFromYSentinel] Response getChunkFromYSentinel
         * @property {tdx_response.IStartConversion|null} [startConversion] Response startConversion
         * @property {tdx_response.IOperationCountOverTime|null} [operationCountOverTime] Response operationCountOverTime
         * @property {tdx_response.ITopMovers|null} [topMovers] Response topMovers
         * @property {tdx_response.IStorageDistribution|null} [storageDistribution] Response storageDistribution
         * @property {tdx_response.IAccessByLocation|null} [accessByLocation] Response accessByLocation
         * @property {tdx_response.IExternalShareTopUsers|null} [externalShareTopUsers] Response externalShareTopUsers
         * @property {tdx_response.IOverview_OffHoursRatio|null} [overviewOffHoursRatio] Response overviewOffHoursRatio
         * @property {tdx_response.IGetRemovedUsersFromLogs|null} [getRemovedUsersFromLogs] Response getRemovedUsersFromLogs
         * @property {tdx_response.IGetRemovedTeamsFromLogs|null} [getRemovedTeamsFromLogs] Response getRemovedTeamsFromLogs
         * @property {tdx_response.IUser_ActivityTimeline|null} [userActivityTimeline] Response userActivityTimeline
         * @property {tdx_response.IUser_CountriesAccessedFrom|null} [user_CountriesAccessedFrom] Response user_CountriesAccessedFrom
         * @property {tdx_response.IUser_OpCount|null} [user_OpCount] Response user_OpCount
         * @property {tdx_response.IUser_WriteActivity|null} [user_WriteActivity] Response user_WriteActivity
         * @property {tdx_response.IUser_StorageBreakdown|null} [user_StorageBreakdown] Response user_StorageBreakdown
         * @property {tdx_response.IUser_FilesTouched|null} [user_FilesTouched] Response user_FilesTouched
         * @property {tdx_response.IUser_SharingActions|null} [user_SharingActions] Response user_SharingActions
         * @property {tdx_response.IUser_PermissionRecieved|null} [user_PermissionRecieved] Response user_PermissionRecieved
         * @property {tdx_response.IUser_DeniedAttempts|null} [user_DeniedAttempts] Response user_DeniedAttempts
         * @property {tdx_response.IUser_RiskScore|null} [user_RiskScore] Response user_RiskScore
         * @property {tdx_response.IUser_TopContributingSignals|null} [user_TopContributingSignals] Response user_TopContributingSignals
         * @property {tdx_response.IUser_Anomalies|null} [user_Anomalies] Response user_Anomalies
         * @property {tdx_response.IUser_Overview|null} [user_Overview] Response user_Overview
         * @property {tdx_response.IFileDetails|null} [fileDetails] Response fileDetails
         * @property {tdx_response.IFileSummary|null} [fileSummary] Response fileSummary
         * @property {tdx_response.ILifecycleEvents|null} [lifecycleEvents] Response lifecycleEvents
         * @property {tdx_response.IVersionHistory|null} [versionHistory] Response versionHistory
         * @property {tdx_response.IShares|null} [shares] Response shares
         * @property {tdx_response.IPathHistory|null} [pathHistory] Response pathHistory
         * @property {tdx_response.IActorStats|null} [actorStats] Response actorStats
         * @property {tdx_response.ICountryStats|null} [countryStats] Response countryStats
         * @property {tdx_response.IUser_TimeHeatmap|null} [userTimeHeatmap] Response userTimeHeatmap
         * @property {tdx_response.ITeam_Members|null} [teamMembers] Response teamMembers
         * @property {tdx_response.ITeam_ActivityTimeline|null} [teamActivityTimeline] Response teamActivityTimeline
         * @property {tdx_response.ITeam_FilesTouched|null} [teamFilesTouched] Response teamFilesTouched
         * @property {tdx_response.ITeam_MembershipChanges|null} [teamMembershipChanges] Response teamMembershipChanges
         * @property {tdx_response.ITeam_RoleIntersection|null} [teamRoleIntersection] Response teamRoleIntersection
         * @property {tdx_response.IListFilesForDashboard|null} [listFilesForDashboard] Response listFilesForDashboard
         * @property {tdx_response.ITeam_SharingActions|null} [teamSharingActions] Response teamSharingActions
         * @property {tdx_response.ICollaborationFlow|null} [collaborationFlow] Response collaborationFlow
         */

        /**
         * Constructs a new Response.
         * @memberof tdx_response
         * @classdesc Represents a Response.
         * @implements IResponse
         * @constructor
         * @param {tdx_response.IResponse=} [properties] Properties to set
         */
        function Response(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Response id.
         * @member {number|Long|null|undefined} id
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.id = null;

        /**
         * Response listLogs.
         * @member {tdx_response.IListLogsFromQuery|null|undefined} listLogs
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.listLogs = null;

        /**
         * Response createAlert.
         * @member {tdx_response.ICreateAlert|null|undefined} createAlert
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.createAlert = null;

        /**
         * Response deleteAlert.
         * @member {tdx_response.IDeleteAlert|null|undefined} deleteAlert
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.deleteAlert = null;

        /**
         * Response listAlerts.
         * @member {tdx_response.IListAlerts|null|undefined} listAlerts
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.listAlerts = null;

        /**
         * Response updateAlert.
         * @member {tdx_response.IUpdateAlert|null|undefined} updateAlert
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.updateAlert = null;

        /**
         * Response getLedgerRange.
         * @member {tdx_response.IGetLedgerRange|null|undefined} getLedgerRange
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.getLedgerRange = null;

        /**
         * Response getAuditLog.
         * @member {tdx_response.IGetAuditLog|null|undefined} getAuditLog
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.getAuditLog = null;

        /**
         * Response getConsistencyProof.
         * @member {tdx_response.IGetConsistencyProof|null|undefined} getConsistencyProof
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.getConsistencyProof = null;

        /**
         * Response getInclusionProof.
         * @member {tdx_response.IGetInclusionProof|null|undefined} getInclusionProof
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.getInclusionProof = null;

        /**
         * Response getChunkFromYSentinel.
         * @member {tdx_response.IGetChunkFromYSentinel|null|undefined} getChunkFromYSentinel
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.getChunkFromYSentinel = null;

        /**
         * Response startConversion.
         * @member {tdx_response.IStartConversion|null|undefined} startConversion
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.startConversion = null;

        /**
         * Response operationCountOverTime.
         * @member {tdx_response.IOperationCountOverTime|null|undefined} operationCountOverTime
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.operationCountOverTime = null;

        /**
         * Response topMovers.
         * @member {tdx_response.ITopMovers|null|undefined} topMovers
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.topMovers = null;

        /**
         * Response storageDistribution.
         * @member {tdx_response.IStorageDistribution|null|undefined} storageDistribution
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.storageDistribution = null;

        /**
         * Response accessByLocation.
         * @member {tdx_response.IAccessByLocation|null|undefined} accessByLocation
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.accessByLocation = null;

        /**
         * Response externalShareTopUsers.
         * @member {tdx_response.IExternalShareTopUsers|null|undefined} externalShareTopUsers
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.externalShareTopUsers = null;

        /**
         * Response overviewOffHoursRatio.
         * @member {tdx_response.IOverview_OffHoursRatio|null|undefined} overviewOffHoursRatio
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.overviewOffHoursRatio = null;

        /**
         * Response getRemovedUsersFromLogs.
         * @member {tdx_response.IGetRemovedUsersFromLogs|null|undefined} getRemovedUsersFromLogs
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.getRemovedUsersFromLogs = null;

        /**
         * Response getRemovedTeamsFromLogs.
         * @member {tdx_response.IGetRemovedTeamsFromLogs|null|undefined} getRemovedTeamsFromLogs
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.getRemovedTeamsFromLogs = null;

        /**
         * Response userActivityTimeline.
         * @member {tdx_response.IUser_ActivityTimeline|null|undefined} userActivityTimeline
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.userActivityTimeline = null;

        /**
         * Response user_CountriesAccessedFrom.
         * @member {tdx_response.IUser_CountriesAccessedFrom|null|undefined} user_CountriesAccessedFrom
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_CountriesAccessedFrom = null;

        /**
         * Response user_OpCount.
         * @member {tdx_response.IUser_OpCount|null|undefined} user_OpCount
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_OpCount = null;

        /**
         * Response user_WriteActivity.
         * @member {tdx_response.IUser_WriteActivity|null|undefined} user_WriteActivity
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_WriteActivity = null;

        /**
         * Response user_StorageBreakdown.
         * @member {tdx_response.IUser_StorageBreakdown|null|undefined} user_StorageBreakdown
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_StorageBreakdown = null;

        /**
         * Response user_FilesTouched.
         * @member {tdx_response.IUser_FilesTouched|null|undefined} user_FilesTouched
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_FilesTouched = null;

        /**
         * Response user_SharingActions.
         * @member {tdx_response.IUser_SharingActions|null|undefined} user_SharingActions
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_SharingActions = null;

        /**
         * Response user_PermissionRecieved.
         * @member {tdx_response.IUser_PermissionRecieved|null|undefined} user_PermissionRecieved
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_PermissionRecieved = null;

        /**
         * Response user_DeniedAttempts.
         * @member {tdx_response.IUser_DeniedAttempts|null|undefined} user_DeniedAttempts
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_DeniedAttempts = null;

        /**
         * Response user_RiskScore.
         * @member {tdx_response.IUser_RiskScore|null|undefined} user_RiskScore
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_RiskScore = null;

        /**
         * Response user_TopContributingSignals.
         * @member {tdx_response.IUser_TopContributingSignals|null|undefined} user_TopContributingSignals
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_TopContributingSignals = null;

        /**
         * Response user_Anomalies.
         * @member {tdx_response.IUser_Anomalies|null|undefined} user_Anomalies
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_Anomalies = null;

        /**
         * Response user_Overview.
         * @member {tdx_response.IUser_Overview|null|undefined} user_Overview
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.user_Overview = null;

        /**
         * Response fileDetails.
         * @member {tdx_response.IFileDetails|null|undefined} fileDetails
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.fileDetails = null;

        /**
         * Response fileSummary.
         * @member {tdx_response.IFileSummary|null|undefined} fileSummary
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.fileSummary = null;

        /**
         * Response lifecycleEvents.
         * @member {tdx_response.ILifecycleEvents|null|undefined} lifecycleEvents
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.lifecycleEvents = null;

        /**
         * Response versionHistory.
         * @member {tdx_response.IVersionHistory|null|undefined} versionHistory
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.versionHistory = null;

        /**
         * Response shares.
         * @member {tdx_response.IShares|null|undefined} shares
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.shares = null;

        /**
         * Response pathHistory.
         * @member {tdx_response.IPathHistory|null|undefined} pathHistory
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.pathHistory = null;

        /**
         * Response actorStats.
         * @member {tdx_response.IActorStats|null|undefined} actorStats
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.actorStats = null;

        /**
         * Response countryStats.
         * @member {tdx_response.ICountryStats|null|undefined} countryStats
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.countryStats = null;

        /**
         * Response userTimeHeatmap.
         * @member {tdx_response.IUser_TimeHeatmap|null|undefined} userTimeHeatmap
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.userTimeHeatmap = null;

        /**
         * Response teamMembers.
         * @member {tdx_response.ITeam_Members|null|undefined} teamMembers
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.teamMembers = null;

        /**
         * Response teamActivityTimeline.
         * @member {tdx_response.ITeam_ActivityTimeline|null|undefined} teamActivityTimeline
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.teamActivityTimeline = null;

        /**
         * Response teamFilesTouched.
         * @member {tdx_response.ITeam_FilesTouched|null|undefined} teamFilesTouched
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.teamFilesTouched = null;

        /**
         * Response teamMembershipChanges.
         * @member {tdx_response.ITeam_MembershipChanges|null|undefined} teamMembershipChanges
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.teamMembershipChanges = null;

        /**
         * Response teamRoleIntersection.
         * @member {tdx_response.ITeam_RoleIntersection|null|undefined} teamRoleIntersection
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.teamRoleIntersection = null;

        /**
         * Response listFilesForDashboard.
         * @member {tdx_response.IListFilesForDashboard|null|undefined} listFilesForDashboard
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.listFilesForDashboard = null;

        /**
         * Response teamSharingActions.
         * @member {tdx_response.ITeam_SharingActions|null|undefined} teamSharingActions
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.teamSharingActions = null;

        /**
         * Response collaborationFlow.
         * @member {tdx_response.ICollaborationFlow|null|undefined} collaborationFlow
         * @memberof tdx_response.Response
         * @instance
         */
        Response.prototype.collaborationFlow = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * Response _id.
         * @member {"id"|undefined} _id
         * @memberof tdx_response.Response
         * @instance
         */
        Object.defineProperty(Response.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Response Operation.
         * @member {"listLogs"|"createAlert"|"deleteAlert"|"listAlerts"|"updateAlert"|"getLedgerRange"|"getAuditLog"|"getConsistencyProof"|"getInclusionProof"|"getChunkFromYSentinel"|"startConversion"|"operationCountOverTime"|"topMovers"|"storageDistribution"|"accessByLocation"|"externalShareTopUsers"|"overviewOffHoursRatio"|"getRemovedUsersFromLogs"|"getRemovedTeamsFromLogs"|"userActivityTimeline"|"user_CountriesAccessedFrom"|"user_OpCount"|"user_WriteActivity"|"user_StorageBreakdown"|"user_FilesTouched"|"user_SharingActions"|"user_PermissionRecieved"|"user_DeniedAttempts"|"user_RiskScore"|"user_TopContributingSignals"|"user_Anomalies"|"user_Overview"|"fileDetails"|"fileSummary"|"lifecycleEvents"|"versionHistory"|"shares"|"pathHistory"|"actorStats"|"countryStats"|"userTimeHeatmap"|"teamMembers"|"teamActivityTimeline"|"teamFilesTouched"|"teamMembershipChanges"|"teamRoleIntersection"|"listFilesForDashboard"|"teamSharingActions"|"collaborationFlow"|undefined} Operation
         * @memberof tdx_response.Response
         * @instance
         */
        Object.defineProperty(Response.prototype, "Operation", {
            get: $util.oneOfGetter($oneOfFields = ["listLogs", "createAlert", "deleteAlert", "listAlerts", "updateAlert", "getLedgerRange", "getAuditLog", "getConsistencyProof", "getInclusionProof", "getChunkFromYSentinel", "startConversion", "operationCountOverTime", "topMovers", "storageDistribution", "accessByLocation", "externalShareTopUsers", "overviewOffHoursRatio", "getRemovedUsersFromLogs", "getRemovedTeamsFromLogs", "userActivityTimeline", "user_CountriesAccessedFrom", "user_OpCount", "user_WriteActivity", "user_StorageBreakdown", "user_FilesTouched", "user_SharingActions", "user_PermissionRecieved", "user_DeniedAttempts", "user_RiskScore", "user_TopContributingSignals", "user_Anomalies", "user_Overview", "fileDetails", "fileSummary", "lifecycleEvents", "versionHistory", "shares", "pathHistory", "actorStats", "countryStats", "userTimeHeatmap", "teamMembers", "teamActivityTimeline", "teamFilesTouched", "teamMembershipChanges", "teamRoleIntersection", "listFilesForDashboard", "teamSharingActions", "collaborationFlow"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Response instance using the specified properties.
         * @function create
         * @memberof tdx_response.Response
         * @static
         * @param {tdx_response.IResponse=} [properties] Properties to set
         * @returns {tdx_response.Response} Response instance
         */
        Response.create = function create(properties) {
            return new Response(properties);
        };

        /**
         * Encodes the specified Response message. Does not implicitly {@link tdx_response.Response.verify|verify} messages.
         * @function encode
         * @memberof tdx_response.Response
         * @static
         * @param {tdx_response.IResponse} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
            if (message.listLogs != null && Object.hasOwnProperty.call(message, "listLogs"))
                $root.tdx_response.ListLogsFromQuery.encode(message.listLogs, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.createAlert != null && Object.hasOwnProperty.call(message, "createAlert"))
                $root.tdx_response.CreateAlert.encode(message.createAlert, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.deleteAlert != null && Object.hasOwnProperty.call(message, "deleteAlert"))
                $root.tdx_response.DeleteAlert.encode(message.deleteAlert, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.listAlerts != null && Object.hasOwnProperty.call(message, "listAlerts"))
                $root.tdx_response.ListAlerts.encode(message.listAlerts, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.updateAlert != null && Object.hasOwnProperty.call(message, "updateAlert"))
                $root.tdx_response.UpdateAlert.encode(message.updateAlert, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.getLedgerRange != null && Object.hasOwnProperty.call(message, "getLedgerRange"))
                $root.tdx_response.GetLedgerRange.encode(message.getLedgerRange, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.getAuditLog != null && Object.hasOwnProperty.call(message, "getAuditLog"))
                $root.tdx_response.GetAuditLog.encode(message.getAuditLog, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.getConsistencyProof != null && Object.hasOwnProperty.call(message, "getConsistencyProof"))
                $root.tdx_response.GetConsistencyProof.encode(message.getConsistencyProof, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.getInclusionProof != null && Object.hasOwnProperty.call(message, "getInclusionProof"))
                $root.tdx_response.GetInclusionProof.encode(message.getInclusionProof, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.getChunkFromYSentinel != null && Object.hasOwnProperty.call(message, "getChunkFromYSentinel"))
                $root.tdx_response.GetChunkFromYSentinel.encode(message.getChunkFromYSentinel, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.startConversion != null && Object.hasOwnProperty.call(message, "startConversion"))
                $root.tdx_response.StartConversion.encode(message.startConversion, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.storageDistribution != null && Object.hasOwnProperty.call(message, "storageDistribution"))
                $root.tdx_response.StorageDistribution.encode(message.storageDistribution, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.operationCountOverTime != null && Object.hasOwnProperty.call(message, "operationCountOverTime"))
                $root.tdx_response.OperationCountOverTime.encode(message.operationCountOverTime, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.accessByLocation != null && Object.hasOwnProperty.call(message, "accessByLocation"))
                $root.tdx_response.AccessByLocation.encode(message.accessByLocation, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.topMovers != null && Object.hasOwnProperty.call(message, "topMovers"))
                $root.tdx_response.TopMovers.encode(message.topMovers, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.externalShareTopUsers != null && Object.hasOwnProperty.call(message, "externalShareTopUsers"))
                $root.tdx_response.ExternalShareTopUsers.encode(message.externalShareTopUsers, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.getRemovedUsersFromLogs != null && Object.hasOwnProperty.call(message, "getRemovedUsersFromLogs"))
                $root.tdx_response.GetRemovedUsersFromLogs.encode(message.getRemovedUsersFromLogs, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
            if (message.getRemovedTeamsFromLogs != null && Object.hasOwnProperty.call(message, "getRemovedTeamsFromLogs"))
                $root.tdx_response.GetRemovedTeamsFromLogs.encode(message.getRemovedTeamsFromLogs, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            if (message.userActivityTimeline != null && Object.hasOwnProperty.call(message, "userActivityTimeline"))
                $root.tdx_response.User_ActivityTimeline.encode(message.userActivityTimeline, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
            if (message.user_CountriesAccessedFrom != null && Object.hasOwnProperty.call(message, "user_CountriesAccessedFrom"))
                $root.tdx_response.User_CountriesAccessedFrom.encode(message.user_CountriesAccessedFrom, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
            if (message.user_OpCount != null && Object.hasOwnProperty.call(message, "user_OpCount"))
                $root.tdx_response.User_OpCount.encode(message.user_OpCount, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
            if (message.user_WriteActivity != null && Object.hasOwnProperty.call(message, "user_WriteActivity"))
                $root.tdx_response.User_WriteActivity.encode(message.user_WriteActivity, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
            if (message.user_StorageBreakdown != null && Object.hasOwnProperty.call(message, "user_StorageBreakdown"))
                $root.tdx_response.User_StorageBreakdown.encode(message.user_StorageBreakdown, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
            if (message.user_FilesTouched != null && Object.hasOwnProperty.call(message, "user_FilesTouched"))
                $root.tdx_response.User_FilesTouched.encode(message.user_FilesTouched, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
            if (message.user_SharingActions != null && Object.hasOwnProperty.call(message, "user_SharingActions"))
                $root.tdx_response.User_SharingActions.encode(message.user_SharingActions, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
            if (message.user_PermissionRecieved != null && Object.hasOwnProperty.call(message, "user_PermissionRecieved"))
                $root.tdx_response.User_PermissionRecieved.encode(message.user_PermissionRecieved, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
            if (message.user_DeniedAttempts != null && Object.hasOwnProperty.call(message, "user_DeniedAttempts"))
                $root.tdx_response.User_DeniedAttempts.encode(message.user_DeniedAttempts, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
            if (message.user_RiskScore != null && Object.hasOwnProperty.call(message, "user_RiskScore"))
                $root.tdx_response.User_RiskScore.encode(message.user_RiskScore, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
            if (message.user_TopContributingSignals != null && Object.hasOwnProperty.call(message, "user_TopContributingSignals"))
                $root.tdx_response.User_TopContributingSignals.encode(message.user_TopContributingSignals, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
            if (message.user_Anomalies != null && Object.hasOwnProperty.call(message, "user_Anomalies"))
                $root.tdx_response.User_Anomalies.encode(message.user_Anomalies, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
            if (message.user_Overview != null && Object.hasOwnProperty.call(message, "user_Overview"))
                $root.tdx_response.User_Overview.encode(message.user_Overview, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
            if (message.fileDetails != null && Object.hasOwnProperty.call(message, "fileDetails"))
                $root.tdx_response.FileDetails.encode(message.fileDetails, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
            if (message.fileSummary != null && Object.hasOwnProperty.call(message, "fileSummary"))
                $root.tdx_response.FileSummary.encode(message.fileSummary, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
            if (message.lifecycleEvents != null && Object.hasOwnProperty.call(message, "lifecycleEvents"))
                $root.tdx_response.LifecycleEvents.encode(message.lifecycleEvents, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
            if (message.versionHistory != null && Object.hasOwnProperty.call(message, "versionHistory"))
                $root.tdx_response.VersionHistory.encode(message.versionHistory, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
            if (message.shares != null && Object.hasOwnProperty.call(message, "shares"))
                $root.tdx_response.Shares.encode(message.shares, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
            if (message.pathHistory != null && Object.hasOwnProperty.call(message, "pathHistory"))
                $root.tdx_response.PathHistory.encode(message.pathHistory, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
            if (message.actorStats != null && Object.hasOwnProperty.call(message, "actorStats"))
                $root.tdx_response.ActorStats.encode(message.actorStats, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
            if (message.countryStats != null && Object.hasOwnProperty.call(message, "countryStats"))
                $root.tdx_response.CountryStats.encode(message.countryStats, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
            if (message.userTimeHeatmap != null && Object.hasOwnProperty.call(message, "userTimeHeatmap"))
                $root.tdx_response.User_TimeHeatmap.encode(message.userTimeHeatmap, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
            if (message.teamMembers != null && Object.hasOwnProperty.call(message, "teamMembers"))
                $root.tdx_response.Team_Members.encode(message.teamMembers, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
            if (message.teamActivityTimeline != null && Object.hasOwnProperty.call(message, "teamActivityTimeline"))
                $root.tdx_response.Team_ActivityTimeline.encode(message.teamActivityTimeline, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
            if (message.teamFilesTouched != null && Object.hasOwnProperty.call(message, "teamFilesTouched"))
                $root.tdx_response.Team_FilesTouched.encode(message.teamFilesTouched, writer.uint32(/* id 44, wireType 2 =*/354).fork()).ldelim();
            if (message.teamMembershipChanges != null && Object.hasOwnProperty.call(message, "teamMembershipChanges"))
                $root.tdx_response.Team_MembershipChanges.encode(message.teamMembershipChanges, writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
            if (message.teamRoleIntersection != null && Object.hasOwnProperty.call(message, "teamRoleIntersection"))
                $root.tdx_response.Team_RoleIntersection.encode(message.teamRoleIntersection, writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
            if (message.listFilesForDashboard != null && Object.hasOwnProperty.call(message, "listFilesForDashboard"))
                $root.tdx_response.ListFilesForDashboard.encode(message.listFilesForDashboard, writer.uint32(/* id 47, wireType 2 =*/378).fork()).ldelim();
            if (message.teamSharingActions != null && Object.hasOwnProperty.call(message, "teamSharingActions"))
                $root.tdx_response.Team_SharingActions.encode(message.teamSharingActions, writer.uint32(/* id 48, wireType 2 =*/386).fork()).ldelim();
            if (message.overviewOffHoursRatio != null && Object.hasOwnProperty.call(message, "overviewOffHoursRatio"))
                $root.tdx_response.Overview_OffHoursRatio.encode(message.overviewOffHoursRatio, writer.uint32(/* id 49, wireType 2 =*/394).fork()).ldelim();
            if (message.collaborationFlow != null && Object.hasOwnProperty.call(message, "collaborationFlow"))
                $root.tdx_response.CollaborationFlow.encode(message.collaborationFlow, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Response message, length delimited. Does not implicitly {@link tdx_response.Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof tdx_response.Response
         * @static
         * @param {tdx_response.IResponse} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Response message from the specified reader or buffer.
         * @function decode
         * @memberof tdx_response.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {tdx_response.Response} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.tdx_response.Response();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.uint64();
                        break;
                    }
                case 2: {
                        message.listLogs = $root.tdx_response.ListLogsFromQuery.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.createAlert = $root.tdx_response.CreateAlert.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.deleteAlert = $root.tdx_response.DeleteAlert.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.listAlerts = $root.tdx_response.ListAlerts.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.updateAlert = $root.tdx_response.UpdateAlert.decode(reader, reader.uint32());
                        break;
                    }
                case 7: {
                        message.getLedgerRange = $root.tdx_response.GetLedgerRange.decode(reader, reader.uint32());
                        break;
                    }
                case 8: {
                        message.getAuditLog = $root.tdx_response.GetAuditLog.decode(reader, reader.uint32());
                        break;
                    }
                case 9: {
                        message.getConsistencyProof = $root.tdx_response.GetConsistencyProof.decode(reader, reader.uint32());
                        break;
                    }
                case 10: {
                        message.getInclusionProof = $root.tdx_response.GetInclusionProof.decode(reader, reader.uint32());
                        break;
                    }
                case 11: {
                        message.getChunkFromYSentinel = $root.tdx_response.GetChunkFromYSentinel.decode(reader, reader.uint32());
                        break;
                    }
                case 12: {
                        message.startConversion = $root.tdx_response.StartConversion.decode(reader, reader.uint32());
                        break;
                    }
                case 14: {
                        message.operationCountOverTime = $root.tdx_response.OperationCountOverTime.decode(reader, reader.uint32());
                        break;
                    }
                case 16: {
                        message.topMovers = $root.tdx_response.TopMovers.decode(reader, reader.uint32());
                        break;
                    }
                case 13: {
                        message.storageDistribution = $root.tdx_response.StorageDistribution.decode(reader, reader.uint32());
                        break;
                    }
                case 15: {
                        message.accessByLocation = $root.tdx_response.AccessByLocation.decode(reader, reader.uint32());
                        break;
                    }
                case 17: {
                        message.externalShareTopUsers = $root.tdx_response.ExternalShareTopUsers.decode(reader, reader.uint32());
                        break;
                    }
                case 49: {
                        message.overviewOffHoursRatio = $root.tdx_response.Overview_OffHoursRatio.decode(reader, reader.uint32());
                        break;
                    }
                case 18: {
                        message.getRemovedUsersFromLogs = $root.tdx_response.GetRemovedUsersFromLogs.decode(reader, reader.uint32());
                        break;
                    }
                case 19: {
                        message.getRemovedTeamsFromLogs = $root.tdx_response.GetRemovedTeamsFromLogs.decode(reader, reader.uint32());
                        break;
                    }
                case 20: {
                        message.userActivityTimeline = $root.tdx_response.User_ActivityTimeline.decode(reader, reader.uint32());
                        break;
                    }
                case 21: {
                        message.user_CountriesAccessedFrom = $root.tdx_response.User_CountriesAccessedFrom.decode(reader, reader.uint32());
                        break;
                    }
                case 22: {
                        message.user_OpCount = $root.tdx_response.User_OpCount.decode(reader, reader.uint32());
                        break;
                    }
                case 23: {
                        message.user_WriteActivity = $root.tdx_response.User_WriteActivity.decode(reader, reader.uint32());
                        break;
                    }
                case 24: {
                        message.user_StorageBreakdown = $root.tdx_response.User_StorageBreakdown.decode(reader, reader.uint32());
                        break;
                    }
                case 25: {
                        message.user_FilesTouched = $root.tdx_response.User_FilesTouched.decode(reader, reader.uint32());
                        break;
                    }
                case 26: {
                        message.user_SharingActions = $root.tdx_response.User_SharingActions.decode(reader, reader.uint32());
                        break;
                    }
                case 27: {
                        message.user_PermissionRecieved = $root.tdx_response.User_PermissionRecieved.decode(reader, reader.uint32());
                        break;
                    }
                case 28: {
                        message.user_DeniedAttempts = $root.tdx_response.User_DeniedAttempts.decode(reader, reader.uint32());
                        break;
                    }
                case 29: {
                        message.user_RiskScore = $root.tdx_response.User_RiskScore.decode(reader, reader.uint32());
                        break;
                    }
                case 30: {
                        message.user_TopContributingSignals = $root.tdx_response.User_TopContributingSignals.decode(reader, reader.uint32());
                        break;
                    }
                case 31: {
                        message.user_Anomalies = $root.tdx_response.User_Anomalies.decode(reader, reader.uint32());
                        break;
                    }
                case 32: {
                        message.user_Overview = $root.tdx_response.User_Overview.decode(reader, reader.uint32());
                        break;
                    }
                case 33: {
                        message.fileDetails = $root.tdx_response.FileDetails.decode(reader, reader.uint32());
                        break;
                    }
                case 34: {
                        message.fileSummary = $root.tdx_response.FileSummary.decode(reader, reader.uint32());
                        break;
                    }
                case 35: {
                        message.lifecycleEvents = $root.tdx_response.LifecycleEvents.decode(reader, reader.uint32());
                        break;
                    }
                case 36: {
                        message.versionHistory = $root.tdx_response.VersionHistory.decode(reader, reader.uint32());
                        break;
                    }
                case 37: {
                        message.shares = $root.tdx_response.Shares.decode(reader, reader.uint32());
                        break;
                    }
                case 38: {
                        message.pathHistory = $root.tdx_response.PathHistory.decode(reader, reader.uint32());
                        break;
                    }
                case 39: {
                        message.actorStats = $root.tdx_response.ActorStats.decode(reader, reader.uint32());
                        break;
                    }
                case 40: {
                        message.countryStats = $root.tdx_response.CountryStats.decode(reader, reader.uint32());
                        break;
                    }
                case 41: {
                        message.userTimeHeatmap = $root.tdx_response.User_TimeHeatmap.decode(reader, reader.uint32());
                        break;
                    }
                case 42: {
                        message.teamMembers = $root.tdx_response.Team_Members.decode(reader, reader.uint32());
                        break;
                    }
                case 43: {
                        message.teamActivityTimeline = $root.tdx_response.Team_ActivityTimeline.decode(reader, reader.uint32());
                        break;
                    }
                case 44: {
                        message.teamFilesTouched = $root.tdx_response.Team_FilesTouched.decode(reader, reader.uint32());
                        break;
                    }
                case 45: {
                        message.teamMembershipChanges = $root.tdx_response.Team_MembershipChanges.decode(reader, reader.uint32());
                        break;
                    }
                case 46: {
                        message.teamRoleIntersection = $root.tdx_response.Team_RoleIntersection.decode(reader, reader.uint32());
                        break;
                    }
                case 47: {
                        message.listFilesForDashboard = $root.tdx_response.ListFilesForDashboard.decode(reader, reader.uint32());
                        break;
                    }
                case 48: {
                        message.teamSharingActions = $root.tdx_response.Team_SharingActions.decode(reader, reader.uint32());
                        break;
                    }
                case 50: {
                        message.collaborationFlow = $root.tdx_response.CollaborationFlow.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof tdx_response.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {tdx_response.Response} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Response message.
         * @function verify
         * @memberof tdx_response.Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Response.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.id != null && message.hasOwnProperty("id")) {
                properties._id = 1;
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            }
            if (message.listLogs != null && message.hasOwnProperty("listLogs")) {
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.ListLogsFromQuery.verify(message.listLogs);
                    if (error)
                        return "listLogs." + error;
                }
            }
            if (message.createAlert != null && message.hasOwnProperty("createAlert")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.CreateAlert.verify(message.createAlert);
                    if (error)
                        return "createAlert." + error;
                }
            }
            if (message.deleteAlert != null && message.hasOwnProperty("deleteAlert")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.DeleteAlert.verify(message.deleteAlert);
                    if (error)
                        return "deleteAlert." + error;
                }
            }
            if (message.listAlerts != null && message.hasOwnProperty("listAlerts")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.ListAlerts.verify(message.listAlerts);
                    if (error)
                        return "listAlerts." + error;
                }
            }
            if (message.updateAlert != null && message.hasOwnProperty("updateAlert")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.UpdateAlert.verify(message.updateAlert);
                    if (error)
                        return "updateAlert." + error;
                }
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.GetLedgerRange.verify(message.getLedgerRange);
                    if (error)
                        return "getLedgerRange." + error;
                }
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.GetAuditLog.verify(message.getAuditLog);
                    if (error)
                        return "getAuditLog." + error;
                }
            }
            if (message.getConsistencyProof != null && message.hasOwnProperty("getConsistencyProof")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.GetConsistencyProof.verify(message.getConsistencyProof);
                    if (error)
                        return "getConsistencyProof." + error;
                }
            }
            if (message.getInclusionProof != null && message.hasOwnProperty("getInclusionProof")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.GetInclusionProof.verify(message.getInclusionProof);
                    if (error)
                        return "getInclusionProof." + error;
                }
            }
            if (message.getChunkFromYSentinel != null && message.hasOwnProperty("getChunkFromYSentinel")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.GetChunkFromYSentinel.verify(message.getChunkFromYSentinel);
                    if (error)
                        return "getChunkFromYSentinel." + error;
                }
            }
            if (message.startConversion != null && message.hasOwnProperty("startConversion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.StartConversion.verify(message.startConversion);
                    if (error)
                        return "startConversion." + error;
                }
            }
            if (message.operationCountOverTime != null && message.hasOwnProperty("operationCountOverTime")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.OperationCountOverTime.verify(message.operationCountOverTime);
                    if (error)
                        return "operationCountOverTime." + error;
                }
            }
            if (message.topMovers != null && message.hasOwnProperty("topMovers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.TopMovers.verify(message.topMovers);
                    if (error)
                        return "topMovers." + error;
                }
            }
            if (message.storageDistribution != null && message.hasOwnProperty("storageDistribution")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.StorageDistribution.verify(message.storageDistribution);
                    if (error)
                        return "storageDistribution." + error;
                }
            }
            if (message.accessByLocation != null && message.hasOwnProperty("accessByLocation")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.AccessByLocation.verify(message.accessByLocation);
                    if (error)
                        return "accessByLocation." + error;
                }
            }
            if (message.externalShareTopUsers != null && message.hasOwnProperty("externalShareTopUsers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.ExternalShareTopUsers.verify(message.externalShareTopUsers);
                    if (error)
                        return "externalShareTopUsers." + error;
                }
            }
            if (message.overviewOffHoursRatio != null && message.hasOwnProperty("overviewOffHoursRatio")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Overview_OffHoursRatio.verify(message.overviewOffHoursRatio);
                    if (error)
                        return "overviewOffHoursRatio." + error;
                }
            }
            if (message.getRemovedUsersFromLogs != null && message.hasOwnProperty("getRemovedUsersFromLogs")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.GetRemovedUsersFromLogs.verify(message.getRemovedUsersFromLogs);
                    if (error)
                        return "getRemovedUsersFromLogs." + error;
                }
            }
            if (message.getRemovedTeamsFromLogs != null && message.hasOwnProperty("getRemovedTeamsFromLogs")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.GetRemovedTeamsFromLogs.verify(message.getRemovedTeamsFromLogs);
                    if (error)
                        return "getRemovedTeamsFromLogs." + error;
                }
            }
            if (message.userActivityTimeline != null && message.hasOwnProperty("userActivityTimeline")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_ActivityTimeline.verify(message.userActivityTimeline);
                    if (error)
                        return "userActivityTimeline." + error;
                }
            }
            if (message.user_CountriesAccessedFrom != null && message.hasOwnProperty("user_CountriesAccessedFrom")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_CountriesAccessedFrom.verify(message.user_CountriesAccessedFrom);
                    if (error)
                        return "user_CountriesAccessedFrom." + error;
                }
            }
            if (message.user_OpCount != null && message.hasOwnProperty("user_OpCount")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_OpCount.verify(message.user_OpCount);
                    if (error)
                        return "user_OpCount." + error;
                }
            }
            if (message.user_WriteActivity != null && message.hasOwnProperty("user_WriteActivity")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_WriteActivity.verify(message.user_WriteActivity);
                    if (error)
                        return "user_WriteActivity." + error;
                }
            }
            if (message.user_StorageBreakdown != null && message.hasOwnProperty("user_StorageBreakdown")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_StorageBreakdown.verify(message.user_StorageBreakdown);
                    if (error)
                        return "user_StorageBreakdown." + error;
                }
            }
            if (message.user_FilesTouched != null && message.hasOwnProperty("user_FilesTouched")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_FilesTouched.verify(message.user_FilesTouched);
                    if (error)
                        return "user_FilesTouched." + error;
                }
            }
            if (message.user_SharingActions != null && message.hasOwnProperty("user_SharingActions")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_SharingActions.verify(message.user_SharingActions);
                    if (error)
                        return "user_SharingActions." + error;
                }
            }
            if (message.user_PermissionRecieved != null && message.hasOwnProperty("user_PermissionRecieved")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_PermissionRecieved.verify(message.user_PermissionRecieved);
                    if (error)
                        return "user_PermissionRecieved." + error;
                }
            }
            if (message.user_DeniedAttempts != null && message.hasOwnProperty("user_DeniedAttempts")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_DeniedAttempts.verify(message.user_DeniedAttempts);
                    if (error)
                        return "user_DeniedAttempts." + error;
                }
            }
            if (message.user_RiskScore != null && message.hasOwnProperty("user_RiskScore")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_RiskScore.verify(message.user_RiskScore);
                    if (error)
                        return "user_RiskScore." + error;
                }
            }
            if (message.user_TopContributingSignals != null && message.hasOwnProperty("user_TopContributingSignals")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_TopContributingSignals.verify(message.user_TopContributingSignals);
                    if (error)
                        return "user_TopContributingSignals." + error;
                }
            }
            if (message.user_Anomalies != null && message.hasOwnProperty("user_Anomalies")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_Anomalies.verify(message.user_Anomalies);
                    if (error)
                        return "user_Anomalies." + error;
                }
            }
            if (message.user_Overview != null && message.hasOwnProperty("user_Overview")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_Overview.verify(message.user_Overview);
                    if (error)
                        return "user_Overview." + error;
                }
            }
            if (message.fileDetails != null && message.hasOwnProperty("fileDetails")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.FileDetails.verify(message.fileDetails);
                    if (error)
                        return "fileDetails." + error;
                }
            }
            if (message.fileSummary != null && message.hasOwnProperty("fileSummary")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.FileSummary.verify(message.fileSummary);
                    if (error)
                        return "fileSummary." + error;
                }
            }
            if (message.lifecycleEvents != null && message.hasOwnProperty("lifecycleEvents")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.LifecycleEvents.verify(message.lifecycleEvents);
                    if (error)
                        return "lifecycleEvents." + error;
                }
            }
            if (message.versionHistory != null && message.hasOwnProperty("versionHistory")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.VersionHistory.verify(message.versionHistory);
                    if (error)
                        return "versionHistory." + error;
                }
            }
            if (message.shares != null && message.hasOwnProperty("shares")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Shares.verify(message.shares);
                    if (error)
                        return "shares." + error;
                }
            }
            if (message.pathHistory != null && message.hasOwnProperty("pathHistory")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.PathHistory.verify(message.pathHistory);
                    if (error)
                        return "pathHistory." + error;
                }
            }
            if (message.actorStats != null && message.hasOwnProperty("actorStats")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.ActorStats.verify(message.actorStats);
                    if (error)
                        return "actorStats." + error;
                }
            }
            if (message.countryStats != null && message.hasOwnProperty("countryStats")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.CountryStats.verify(message.countryStats);
                    if (error)
                        return "countryStats." + error;
                }
            }
            if (message.userTimeHeatmap != null && message.hasOwnProperty("userTimeHeatmap")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.User_TimeHeatmap.verify(message.userTimeHeatmap);
                    if (error)
                        return "userTimeHeatmap." + error;
                }
            }
            if (message.teamMembers != null && message.hasOwnProperty("teamMembers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Team_Members.verify(message.teamMembers);
                    if (error)
                        return "teamMembers." + error;
                }
            }
            if (message.teamActivityTimeline != null && message.hasOwnProperty("teamActivityTimeline")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Team_ActivityTimeline.verify(message.teamActivityTimeline);
                    if (error)
                        return "teamActivityTimeline." + error;
                }
            }
            if (message.teamFilesTouched != null && message.hasOwnProperty("teamFilesTouched")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Team_FilesTouched.verify(message.teamFilesTouched);
                    if (error)
                        return "teamFilesTouched." + error;
                }
            }
            if (message.teamMembershipChanges != null && message.hasOwnProperty("teamMembershipChanges")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Team_MembershipChanges.verify(message.teamMembershipChanges);
                    if (error)
                        return "teamMembershipChanges." + error;
                }
            }
            if (message.teamRoleIntersection != null && message.hasOwnProperty("teamRoleIntersection")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Team_RoleIntersection.verify(message.teamRoleIntersection);
                    if (error)
                        return "teamRoleIntersection." + error;
                }
            }
            if (message.listFilesForDashboard != null && message.hasOwnProperty("listFilesForDashboard")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.ListFilesForDashboard.verify(message.listFilesForDashboard);
                    if (error)
                        return "listFilesForDashboard." + error;
                }
            }
            if (message.teamSharingActions != null && message.hasOwnProperty("teamSharingActions")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.Team_SharingActions.verify(message.teamSharingActions);
                    if (error)
                        return "teamSharingActions." + error;
                }
            }
            if (message.collaborationFlow != null && message.hasOwnProperty("collaborationFlow")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.tdx_response.CollaborationFlow.verify(message.collaborationFlow);
                    if (error)
                        return "collaborationFlow." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof tdx_response.Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {tdx_response.Response} Response
         */
        Response.fromObject = function fromObject(object) {
            if (object instanceof $root.tdx_response.Response)
                return object;
            let message = new $root.tdx_response.Response();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.listLogs != null) {
                if (typeof object.listLogs !== "object")
                    throw TypeError(".tdx_response.Response.listLogs: object expected");
                message.listLogs = $root.tdx_response.ListLogsFromQuery.fromObject(object.listLogs);
            }
            if (object.createAlert != null) {
                if (typeof object.createAlert !== "object")
                    throw TypeError(".tdx_response.Response.createAlert: object expected");
                message.createAlert = $root.tdx_response.CreateAlert.fromObject(object.createAlert);
            }
            if (object.deleteAlert != null) {
                if (typeof object.deleteAlert !== "object")
                    throw TypeError(".tdx_response.Response.deleteAlert: object expected");
                message.deleteAlert = $root.tdx_response.DeleteAlert.fromObject(object.deleteAlert);
            }
            if (object.listAlerts != null) {
                if (typeof object.listAlerts !== "object")
                    throw TypeError(".tdx_response.Response.listAlerts: object expected");
                message.listAlerts = $root.tdx_response.ListAlerts.fromObject(object.listAlerts);
            }
            if (object.updateAlert != null) {
                if (typeof object.updateAlert !== "object")
                    throw TypeError(".tdx_response.Response.updateAlert: object expected");
                message.updateAlert = $root.tdx_response.UpdateAlert.fromObject(object.updateAlert);
            }
            if (object.getLedgerRange != null) {
                if (typeof object.getLedgerRange !== "object")
                    throw TypeError(".tdx_response.Response.getLedgerRange: object expected");
                message.getLedgerRange = $root.tdx_response.GetLedgerRange.fromObject(object.getLedgerRange);
            }
            if (object.getAuditLog != null) {
                if (typeof object.getAuditLog !== "object")
                    throw TypeError(".tdx_response.Response.getAuditLog: object expected");
                message.getAuditLog = $root.tdx_response.GetAuditLog.fromObject(object.getAuditLog);
            }
            if (object.getConsistencyProof != null) {
                if (typeof object.getConsistencyProof !== "object")
                    throw TypeError(".tdx_response.Response.getConsistencyProof: object expected");
                message.getConsistencyProof = $root.tdx_response.GetConsistencyProof.fromObject(object.getConsistencyProof);
            }
            if (object.getInclusionProof != null) {
                if (typeof object.getInclusionProof !== "object")
                    throw TypeError(".tdx_response.Response.getInclusionProof: object expected");
                message.getInclusionProof = $root.tdx_response.GetInclusionProof.fromObject(object.getInclusionProof);
            }
            if (object.getChunkFromYSentinel != null) {
                if (typeof object.getChunkFromYSentinel !== "object")
                    throw TypeError(".tdx_response.Response.getChunkFromYSentinel: object expected");
                message.getChunkFromYSentinel = $root.tdx_response.GetChunkFromYSentinel.fromObject(object.getChunkFromYSentinel);
            }
            if (object.startConversion != null) {
                if (typeof object.startConversion !== "object")
                    throw TypeError(".tdx_response.Response.startConversion: object expected");
                message.startConversion = $root.tdx_response.StartConversion.fromObject(object.startConversion);
            }
            if (object.operationCountOverTime != null) {
                if (typeof object.operationCountOverTime !== "object")
                    throw TypeError(".tdx_response.Response.operationCountOverTime: object expected");
                message.operationCountOverTime = $root.tdx_response.OperationCountOverTime.fromObject(object.operationCountOverTime);
            }
            if (object.topMovers != null) {
                if (typeof object.topMovers !== "object")
                    throw TypeError(".tdx_response.Response.topMovers: object expected");
                message.topMovers = $root.tdx_response.TopMovers.fromObject(object.topMovers);
            }
            if (object.storageDistribution != null) {
                if (typeof object.storageDistribution !== "object")
                    throw TypeError(".tdx_response.Response.storageDistribution: object expected");
                message.storageDistribution = $root.tdx_response.StorageDistribution.fromObject(object.storageDistribution);
            }
            if (object.accessByLocation != null) {
                if (typeof object.accessByLocation !== "object")
                    throw TypeError(".tdx_response.Response.accessByLocation: object expected");
                message.accessByLocation = $root.tdx_response.AccessByLocation.fromObject(object.accessByLocation);
            }
            if (object.externalShareTopUsers != null) {
                if (typeof object.externalShareTopUsers !== "object")
                    throw TypeError(".tdx_response.Response.externalShareTopUsers: object expected");
                message.externalShareTopUsers = $root.tdx_response.ExternalShareTopUsers.fromObject(object.externalShareTopUsers);
            }
            if (object.overviewOffHoursRatio != null) {
                if (typeof object.overviewOffHoursRatio !== "object")
                    throw TypeError(".tdx_response.Response.overviewOffHoursRatio: object expected");
                message.overviewOffHoursRatio = $root.tdx_response.Overview_OffHoursRatio.fromObject(object.overviewOffHoursRatio);
            }
            if (object.getRemovedUsersFromLogs != null) {
                if (typeof object.getRemovedUsersFromLogs !== "object")
                    throw TypeError(".tdx_response.Response.getRemovedUsersFromLogs: object expected");
                message.getRemovedUsersFromLogs = $root.tdx_response.GetRemovedUsersFromLogs.fromObject(object.getRemovedUsersFromLogs);
            }
            if (object.getRemovedTeamsFromLogs != null) {
                if (typeof object.getRemovedTeamsFromLogs !== "object")
                    throw TypeError(".tdx_response.Response.getRemovedTeamsFromLogs: object expected");
                message.getRemovedTeamsFromLogs = $root.tdx_response.GetRemovedTeamsFromLogs.fromObject(object.getRemovedTeamsFromLogs);
            }
            if (object.userActivityTimeline != null) {
                if (typeof object.userActivityTimeline !== "object")
                    throw TypeError(".tdx_response.Response.userActivityTimeline: object expected");
                message.userActivityTimeline = $root.tdx_response.User_ActivityTimeline.fromObject(object.userActivityTimeline);
            }
            if (object.user_CountriesAccessedFrom != null) {
                if (typeof object.user_CountriesAccessedFrom !== "object")
                    throw TypeError(".tdx_response.Response.user_CountriesAccessedFrom: object expected");
                message.user_CountriesAccessedFrom = $root.tdx_response.User_CountriesAccessedFrom.fromObject(object.user_CountriesAccessedFrom);
            }
            if (object.user_OpCount != null) {
                if (typeof object.user_OpCount !== "object")
                    throw TypeError(".tdx_response.Response.user_OpCount: object expected");
                message.user_OpCount = $root.tdx_response.User_OpCount.fromObject(object.user_OpCount);
            }
            if (object.user_WriteActivity != null) {
                if (typeof object.user_WriteActivity !== "object")
                    throw TypeError(".tdx_response.Response.user_WriteActivity: object expected");
                message.user_WriteActivity = $root.tdx_response.User_WriteActivity.fromObject(object.user_WriteActivity);
            }
            if (object.user_StorageBreakdown != null) {
                if (typeof object.user_StorageBreakdown !== "object")
                    throw TypeError(".tdx_response.Response.user_StorageBreakdown: object expected");
                message.user_StorageBreakdown = $root.tdx_response.User_StorageBreakdown.fromObject(object.user_StorageBreakdown);
            }
            if (object.user_FilesTouched != null) {
                if (typeof object.user_FilesTouched !== "object")
                    throw TypeError(".tdx_response.Response.user_FilesTouched: object expected");
                message.user_FilesTouched = $root.tdx_response.User_FilesTouched.fromObject(object.user_FilesTouched);
            }
            if (object.user_SharingActions != null) {
                if (typeof object.user_SharingActions !== "object")
                    throw TypeError(".tdx_response.Response.user_SharingActions: object expected");
                message.user_SharingActions = $root.tdx_response.User_SharingActions.fromObject(object.user_SharingActions);
            }
            if (object.user_PermissionRecieved != null) {
                if (typeof object.user_PermissionRecieved !== "object")
                    throw TypeError(".tdx_response.Response.user_PermissionRecieved: object expected");
                message.user_PermissionRecieved = $root.tdx_response.User_PermissionRecieved.fromObject(object.user_PermissionRecieved);
            }
            if (object.user_DeniedAttempts != null) {
                if (typeof object.user_DeniedAttempts !== "object")
                    throw TypeError(".tdx_response.Response.user_DeniedAttempts: object expected");
                message.user_DeniedAttempts = $root.tdx_response.User_DeniedAttempts.fromObject(object.user_DeniedAttempts);
            }
            if (object.user_RiskScore != null) {
                if (typeof object.user_RiskScore !== "object")
                    throw TypeError(".tdx_response.Response.user_RiskScore: object expected");
                message.user_RiskScore = $root.tdx_response.User_RiskScore.fromObject(object.user_RiskScore);
            }
            if (object.user_TopContributingSignals != null) {
                if (typeof object.user_TopContributingSignals !== "object")
                    throw TypeError(".tdx_response.Response.user_TopContributingSignals: object expected");
                message.user_TopContributingSignals = $root.tdx_response.User_TopContributingSignals.fromObject(object.user_TopContributingSignals);
            }
            if (object.user_Anomalies != null) {
                if (typeof object.user_Anomalies !== "object")
                    throw TypeError(".tdx_response.Response.user_Anomalies: object expected");
                message.user_Anomalies = $root.tdx_response.User_Anomalies.fromObject(object.user_Anomalies);
            }
            if (object.user_Overview != null) {
                if (typeof object.user_Overview !== "object")
                    throw TypeError(".tdx_response.Response.user_Overview: object expected");
                message.user_Overview = $root.tdx_response.User_Overview.fromObject(object.user_Overview);
            }
            if (object.fileDetails != null) {
                if (typeof object.fileDetails !== "object")
                    throw TypeError(".tdx_response.Response.fileDetails: object expected");
                message.fileDetails = $root.tdx_response.FileDetails.fromObject(object.fileDetails);
            }
            if (object.fileSummary != null) {
                if (typeof object.fileSummary !== "object")
                    throw TypeError(".tdx_response.Response.fileSummary: object expected");
                message.fileSummary = $root.tdx_response.FileSummary.fromObject(object.fileSummary);
            }
            if (object.lifecycleEvents != null) {
                if (typeof object.lifecycleEvents !== "object")
                    throw TypeError(".tdx_response.Response.lifecycleEvents: object expected");
                message.lifecycleEvents = $root.tdx_response.LifecycleEvents.fromObject(object.lifecycleEvents);
            }
            if (object.versionHistory != null) {
                if (typeof object.versionHistory !== "object")
                    throw TypeError(".tdx_response.Response.versionHistory: object expected");
                message.versionHistory = $root.tdx_response.VersionHistory.fromObject(object.versionHistory);
            }
            if (object.shares != null) {
                if (typeof object.shares !== "object")
                    throw TypeError(".tdx_response.Response.shares: object expected");
                message.shares = $root.tdx_response.Shares.fromObject(object.shares);
            }
            if (object.pathHistory != null) {
                if (typeof object.pathHistory !== "object")
                    throw TypeError(".tdx_response.Response.pathHistory: object expected");
                message.pathHistory = $root.tdx_response.PathHistory.fromObject(object.pathHistory);
            }
            if (object.actorStats != null) {
                if (typeof object.actorStats !== "object")
                    throw TypeError(".tdx_response.Response.actorStats: object expected");
                message.actorStats = $root.tdx_response.ActorStats.fromObject(object.actorStats);
            }
            if (object.countryStats != null) {
                if (typeof object.countryStats !== "object")
                    throw TypeError(".tdx_response.Response.countryStats: object expected");
                message.countryStats = $root.tdx_response.CountryStats.fromObject(object.countryStats);
            }
            if (object.userTimeHeatmap != null) {
                if (typeof object.userTimeHeatmap !== "object")
                    throw TypeError(".tdx_response.Response.userTimeHeatmap: object expected");
                message.userTimeHeatmap = $root.tdx_response.User_TimeHeatmap.fromObject(object.userTimeHeatmap);
            }
            if (object.teamMembers != null) {
                if (typeof object.teamMembers !== "object")
                    throw TypeError(".tdx_response.Response.teamMembers: object expected");
                message.teamMembers = $root.tdx_response.Team_Members.fromObject(object.teamMembers);
            }
            if (object.teamActivityTimeline != null) {
                if (typeof object.teamActivityTimeline !== "object")
                    throw TypeError(".tdx_response.Response.teamActivityTimeline: object expected");
                message.teamActivityTimeline = $root.tdx_response.Team_ActivityTimeline.fromObject(object.teamActivityTimeline);
            }
            if (object.teamFilesTouched != null) {
                if (typeof object.teamFilesTouched !== "object")
                    throw TypeError(".tdx_response.Response.teamFilesTouched: object expected");
                message.teamFilesTouched = $root.tdx_response.Team_FilesTouched.fromObject(object.teamFilesTouched);
            }
            if (object.teamMembershipChanges != null) {
                if (typeof object.teamMembershipChanges !== "object")
                    throw TypeError(".tdx_response.Response.teamMembershipChanges: object expected");
                message.teamMembershipChanges = $root.tdx_response.Team_MembershipChanges.fromObject(object.teamMembershipChanges);
            }
            if (object.teamRoleIntersection != null) {
                if (typeof object.teamRoleIntersection !== "object")
                    throw TypeError(".tdx_response.Response.teamRoleIntersection: object expected");
                message.teamRoleIntersection = $root.tdx_response.Team_RoleIntersection.fromObject(object.teamRoleIntersection);
            }
            if (object.listFilesForDashboard != null) {
                if (typeof object.listFilesForDashboard !== "object")
                    throw TypeError(".tdx_response.Response.listFilesForDashboard: object expected");
                message.listFilesForDashboard = $root.tdx_response.ListFilesForDashboard.fromObject(object.listFilesForDashboard);
            }
            if (object.teamSharingActions != null) {
                if (typeof object.teamSharingActions !== "object")
                    throw TypeError(".tdx_response.Response.teamSharingActions: object expected");
                message.teamSharingActions = $root.tdx_response.Team_SharingActions.fromObject(object.teamSharingActions);
            }
            if (object.collaborationFlow != null) {
                if (typeof object.collaborationFlow !== "object")
                    throw TypeError(".tdx_response.Response.collaborationFlow: object expected");
                message.collaborationFlow = $root.tdx_response.CollaborationFlow.fromObject(object.collaborationFlow);
            }
            return message;
        };

        /**
         * Creates a plain object from a Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof tdx_response.Response
         * @static
         * @param {tdx_response.Response} message Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.id != null && message.hasOwnProperty("id")) {
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (options.oneofs)
                    object._id = "id";
            }
            if (message.listLogs != null && message.hasOwnProperty("listLogs")) {
                object.listLogs = $root.tdx_response.ListLogsFromQuery.toObject(message.listLogs, options);
                if (options.oneofs)
                    object.Operation = "listLogs";
            }
            if (message.createAlert != null && message.hasOwnProperty("createAlert")) {
                object.createAlert = $root.tdx_response.CreateAlert.toObject(message.createAlert, options);
                if (options.oneofs)
                    object.Operation = "createAlert";
            }
            if (message.deleteAlert != null && message.hasOwnProperty("deleteAlert")) {
                object.deleteAlert = $root.tdx_response.DeleteAlert.toObject(message.deleteAlert, options);
                if (options.oneofs)
                    object.Operation = "deleteAlert";
            }
            if (message.listAlerts != null && message.hasOwnProperty("listAlerts")) {
                object.listAlerts = $root.tdx_response.ListAlerts.toObject(message.listAlerts, options);
                if (options.oneofs)
                    object.Operation = "listAlerts";
            }
            if (message.updateAlert != null && message.hasOwnProperty("updateAlert")) {
                object.updateAlert = $root.tdx_response.UpdateAlert.toObject(message.updateAlert, options);
                if (options.oneofs)
                    object.Operation = "updateAlert";
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                object.getLedgerRange = $root.tdx_response.GetLedgerRange.toObject(message.getLedgerRange, options);
                if (options.oneofs)
                    object.Operation = "getLedgerRange";
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                object.getAuditLog = $root.tdx_response.GetAuditLog.toObject(message.getAuditLog, options);
                if (options.oneofs)
                    object.Operation = "getAuditLog";
            }
            if (message.getConsistencyProof != null && message.hasOwnProperty("getConsistencyProof")) {
                object.getConsistencyProof = $root.tdx_response.GetConsistencyProof.toObject(message.getConsistencyProof, options);
                if (options.oneofs)
                    object.Operation = "getConsistencyProof";
            }
            if (message.getInclusionProof != null && message.hasOwnProperty("getInclusionProof")) {
                object.getInclusionProof = $root.tdx_response.GetInclusionProof.toObject(message.getInclusionProof, options);
                if (options.oneofs)
                    object.Operation = "getInclusionProof";
            }
            if (message.getChunkFromYSentinel != null && message.hasOwnProperty("getChunkFromYSentinel")) {
                object.getChunkFromYSentinel = $root.tdx_response.GetChunkFromYSentinel.toObject(message.getChunkFromYSentinel, options);
                if (options.oneofs)
                    object.Operation = "getChunkFromYSentinel";
            }
            if (message.startConversion != null && message.hasOwnProperty("startConversion")) {
                object.startConversion = $root.tdx_response.StartConversion.toObject(message.startConversion, options);
                if (options.oneofs)
                    object.Operation = "startConversion";
            }
            if (message.storageDistribution != null && message.hasOwnProperty("storageDistribution")) {
                object.storageDistribution = $root.tdx_response.StorageDistribution.toObject(message.storageDistribution, options);
                if (options.oneofs)
                    object.Operation = "storageDistribution";
            }
            if (message.operationCountOverTime != null && message.hasOwnProperty("operationCountOverTime")) {
                object.operationCountOverTime = $root.tdx_response.OperationCountOverTime.toObject(message.operationCountOverTime, options);
                if (options.oneofs)
                    object.Operation = "operationCountOverTime";
            }
            if (message.accessByLocation != null && message.hasOwnProperty("accessByLocation")) {
                object.accessByLocation = $root.tdx_response.AccessByLocation.toObject(message.accessByLocation, options);
                if (options.oneofs)
                    object.Operation = "accessByLocation";
            }
            if (message.topMovers != null && message.hasOwnProperty("topMovers")) {
                object.topMovers = $root.tdx_response.TopMovers.toObject(message.topMovers, options);
                if (options.oneofs)
                    object.Operation = "topMovers";
            }
            if (message.externalShareTopUsers != null && message.hasOwnProperty("externalShareTopUsers")) {
                object.externalShareTopUsers = $root.tdx_response.ExternalShareTopUsers.toObject(message.externalShareTopUsers, options);
                if (options.oneofs)
                    object.Operation = "externalShareTopUsers";
            }
            if (message.getRemovedUsersFromLogs != null && message.hasOwnProperty("getRemovedUsersFromLogs")) {
                object.getRemovedUsersFromLogs = $root.tdx_response.GetRemovedUsersFromLogs.toObject(message.getRemovedUsersFromLogs, options);
                if (options.oneofs)
                    object.Operation = "getRemovedUsersFromLogs";
            }
            if (message.getRemovedTeamsFromLogs != null && message.hasOwnProperty("getRemovedTeamsFromLogs")) {
                object.getRemovedTeamsFromLogs = $root.tdx_response.GetRemovedTeamsFromLogs.toObject(message.getRemovedTeamsFromLogs, options);
                if (options.oneofs)
                    object.Operation = "getRemovedTeamsFromLogs";
            }
            if (message.userActivityTimeline != null && message.hasOwnProperty("userActivityTimeline")) {
                object.userActivityTimeline = $root.tdx_response.User_ActivityTimeline.toObject(message.userActivityTimeline, options);
                if (options.oneofs)
                    object.Operation = "userActivityTimeline";
            }
            if (message.user_CountriesAccessedFrom != null && message.hasOwnProperty("user_CountriesAccessedFrom")) {
                object.user_CountriesAccessedFrom = $root.tdx_response.User_CountriesAccessedFrom.toObject(message.user_CountriesAccessedFrom, options);
                if (options.oneofs)
                    object.Operation = "user_CountriesAccessedFrom";
            }
            if (message.user_OpCount != null && message.hasOwnProperty("user_OpCount")) {
                object.user_OpCount = $root.tdx_response.User_OpCount.toObject(message.user_OpCount, options);
                if (options.oneofs)
                    object.Operation = "user_OpCount";
            }
            if (message.user_WriteActivity != null && message.hasOwnProperty("user_WriteActivity")) {
                object.user_WriteActivity = $root.tdx_response.User_WriteActivity.toObject(message.user_WriteActivity, options);
                if (options.oneofs)
                    object.Operation = "user_WriteActivity";
            }
            if (message.user_StorageBreakdown != null && message.hasOwnProperty("user_StorageBreakdown")) {
                object.user_StorageBreakdown = $root.tdx_response.User_StorageBreakdown.toObject(message.user_StorageBreakdown, options);
                if (options.oneofs)
                    object.Operation = "user_StorageBreakdown";
            }
            if (message.user_FilesTouched != null && message.hasOwnProperty("user_FilesTouched")) {
                object.user_FilesTouched = $root.tdx_response.User_FilesTouched.toObject(message.user_FilesTouched, options);
                if (options.oneofs)
                    object.Operation = "user_FilesTouched";
            }
            if (message.user_SharingActions != null && message.hasOwnProperty("user_SharingActions")) {
                object.user_SharingActions = $root.tdx_response.User_SharingActions.toObject(message.user_SharingActions, options);
                if (options.oneofs)
                    object.Operation = "user_SharingActions";
            }
            if (message.user_PermissionRecieved != null && message.hasOwnProperty("user_PermissionRecieved")) {
                object.user_PermissionRecieved = $root.tdx_response.User_PermissionRecieved.toObject(message.user_PermissionRecieved, options);
                if (options.oneofs)
                    object.Operation = "user_PermissionRecieved";
            }
            if (message.user_DeniedAttempts != null && message.hasOwnProperty("user_DeniedAttempts")) {
                object.user_DeniedAttempts = $root.tdx_response.User_DeniedAttempts.toObject(message.user_DeniedAttempts, options);
                if (options.oneofs)
                    object.Operation = "user_DeniedAttempts";
            }
            if (message.user_RiskScore != null && message.hasOwnProperty("user_RiskScore")) {
                object.user_RiskScore = $root.tdx_response.User_RiskScore.toObject(message.user_RiskScore, options);
                if (options.oneofs)
                    object.Operation = "user_RiskScore";
            }
            if (message.user_TopContributingSignals != null && message.hasOwnProperty("user_TopContributingSignals")) {
                object.user_TopContributingSignals = $root.tdx_response.User_TopContributingSignals.toObject(message.user_TopContributingSignals, options);
                if (options.oneofs)
                    object.Operation = "user_TopContributingSignals";
            }
            if (message.user_Anomalies != null && message.hasOwnProperty("user_Anomalies")) {
                object.user_Anomalies = $root.tdx_response.User_Anomalies.toObject(message.user_Anomalies, options);
                if (options.oneofs)
                    object.Operation = "user_Anomalies";
            }
            if (message.user_Overview != null && message.hasOwnProperty("user_Overview")) {
                object.user_Overview = $root.tdx_response.User_Overview.toObject(message.user_Overview, options);
                if (options.oneofs)
                    object.Operation = "user_Overview";
            }
            if (message.fileDetails != null && message.hasOwnProperty("fileDetails")) {
                object.fileDetails = $root.tdx_response.FileDetails.toObject(message.fileDetails, options);
                if (options.oneofs)
                    object.Operation = "fileDetails";
            }
            if (message.fileSummary != null && message.hasOwnProperty("fileSummary")) {
                object.fileSummary = $root.tdx_response.FileSummary.toObject(message.fileSummary, options);
                if (options.oneofs)
                    object.Operation = "fileSummary";
            }
            if (message.lifecycleEvents != null && message.hasOwnProperty("lifecycleEvents")) {
                object.lifecycleEvents = $root.tdx_response.LifecycleEvents.toObject(message.lifecycleEvents, options);
                if (options.oneofs)
                    object.Operation = "lifecycleEvents";
            }
            if (message.versionHistory != null && message.hasOwnProperty("versionHistory")) {
                object.versionHistory = $root.tdx_response.VersionHistory.toObject(message.versionHistory, options);
                if (options.oneofs)
                    object.Operation = "versionHistory";
            }
            if (message.shares != null && message.hasOwnProperty("shares")) {
                object.shares = $root.tdx_response.Shares.toObject(message.shares, options);
                if (options.oneofs)
                    object.Operation = "shares";
            }
            if (message.pathHistory != null && message.hasOwnProperty("pathHistory")) {
                object.pathHistory = $root.tdx_response.PathHistory.toObject(message.pathHistory, options);
                if (options.oneofs)
                    object.Operation = "pathHistory";
            }
            if (message.actorStats != null && message.hasOwnProperty("actorStats")) {
                object.actorStats = $root.tdx_response.ActorStats.toObject(message.actorStats, options);
                if (options.oneofs)
                    object.Operation = "actorStats";
            }
            if (message.countryStats != null && message.hasOwnProperty("countryStats")) {
                object.countryStats = $root.tdx_response.CountryStats.toObject(message.countryStats, options);
                if (options.oneofs)
                    object.Operation = "countryStats";
            }
            if (message.userTimeHeatmap != null && message.hasOwnProperty("userTimeHeatmap")) {
                object.userTimeHeatmap = $root.tdx_response.User_TimeHeatmap.toObject(message.userTimeHeatmap, options);
                if (options.oneofs)
                    object.Operation = "userTimeHeatmap";
            }
            if (message.teamMembers != null && message.hasOwnProperty("teamMembers")) {
                object.teamMembers = $root.tdx_response.Team_Members.toObject(message.teamMembers, options);
                if (options.oneofs)
                    object.Operation = "teamMembers";
            }
            if (message.teamActivityTimeline != null && message.hasOwnProperty("teamActivityTimeline")) {
                object.teamActivityTimeline = $root.tdx_response.Team_ActivityTimeline.toObject(message.teamActivityTimeline, options);
                if (options.oneofs)
                    object.Operation = "teamActivityTimeline";
            }
            if (message.teamFilesTouched != null && message.hasOwnProperty("teamFilesTouched")) {
                object.teamFilesTouched = $root.tdx_response.Team_FilesTouched.toObject(message.teamFilesTouched, options);
                if (options.oneofs)
                    object.Operation = "teamFilesTouched";
            }
            if (message.teamMembershipChanges != null && message.hasOwnProperty("teamMembershipChanges")) {
                object.teamMembershipChanges = $root.tdx_response.Team_MembershipChanges.toObject(message.teamMembershipChanges, options);
                if (options.oneofs)
                    object.Operation = "teamMembershipChanges";
            }
            if (message.teamRoleIntersection != null && message.hasOwnProperty("teamRoleIntersection")) {
                object.teamRoleIntersection = $root.tdx_response.Team_RoleIntersection.toObject(message.teamRoleIntersection, options);
                if (options.oneofs)
                    object.Operation = "teamRoleIntersection";
            }
            if (message.listFilesForDashboard != null && message.hasOwnProperty("listFilesForDashboard")) {
                object.listFilesForDashboard = $root.tdx_response.ListFilesForDashboard.toObject(message.listFilesForDashboard, options);
                if (options.oneofs)
                    object.Operation = "listFilesForDashboard";
            }
            if (message.teamSharingActions != null && message.hasOwnProperty("teamSharingActions")) {
                object.teamSharingActions = $root.tdx_response.Team_SharingActions.toObject(message.teamSharingActions, options);
                if (options.oneofs)
                    object.Operation = "teamSharingActions";
            }
            if (message.overviewOffHoursRatio != null && message.hasOwnProperty("overviewOffHoursRatio")) {
                object.overviewOffHoursRatio = $root.tdx_response.Overview_OffHoursRatio.toObject(message.overviewOffHoursRatio, options);
                if (options.oneofs)
                    object.Operation = "overviewOffHoursRatio";
            }
            if (message.collaborationFlow != null && message.hasOwnProperty("collaborationFlow")) {
                object.collaborationFlow = $root.tdx_response.CollaborationFlow.toObject(message.collaborationFlow, options);
                if (options.oneofs)
                    object.Operation = "collaborationFlow";
            }
            return object;
        };

        /**
         * Converts this Response to JSON.
         * @function toJSON
         * @memberof tdx_response.Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Response
         * @function getTypeUrl
         * @memberof tdx_response.Response
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/tdx_response.Response";
        };

        return Response;
    })();

    return tdx_response;
})();

export { $root as default };
